
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3137"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3137"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iuB9z", function(module, exports) {

$parcel$export(module.exports, "Application", () => (parcelRequire("bja9j")).Application);
$parcel$export(module.exports, "Filter", () => (parcelRequire("9gqyK")).Filter);
$parcel$export(module.exports, "Matrix", () => (parcelRequire("eY4rt")).Matrix);
$parcel$export(module.exports, "Point", () => (parcelRequire("1HooC")).Point);
$parcel$export(module.exports, "Rectangle", () => (parcelRequire("fM4Mk")).Rectangle);
$parcel$export(module.exports, "GlProgram", () => (parcelRequire("fK92B")).GlProgram);
$parcel$export(module.exports, "GpuProgram", () => (parcelRequire("6j7wq")).GpuProgram);
$parcel$export(module.exports, "Texture", () => (parcelRequire("bLlTJ")).Texture);
$parcel$export(module.exports, "TexturePool", () => (parcelRequire("3Xbp7")).TexturePool);
$parcel$export(module.exports, "TextureStyle", () => (parcelRequire("aFPUT")).TextureStyle);
$parcel$export(module.exports, "Container", () => (parcelRequire("eicwU")).Container);
$parcel$export(module.exports, "Graphics", () => (parcelRequire("3cebA")).Graphics);
$parcel$export(module.exports, "Particle", () => (parcelRequire("iDQjg")).Particle);
$parcel$export(module.exports, "ParticleContainer", () => (parcelRequire("9F5i8")).ParticleContainer);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("4rhnu")).Sprite);
$parcel$export(module.exports, "deprecation", () => (parcelRequire("kXq8E")).deprecation);

var $iA8uc = parcelRequire("iA8uc");

var $gNJFA = parcelRequire("gNJFA");

var $i9BKe = parcelRequire("i9BKe");
parcelRequire("7dx1H");
parcelRequire("4RJM2");













































var $bja9j = parcelRequire("bja9j");











































































































var $9gqyK = parcelRequire("9gqyK");






var $eY4rt = parcelRequire("eY4rt");





var $1HooC = parcelRequire("1HooC");





var $fM4Mk = parcelRequire("fM4Mk");
































































var $fK92B = parcelRequire("fK92B");




























































var $6j7wq = parcelRequire("6j7wq");




































































var $bLlTJ = parcelRequire("bLlTJ");



var $3Xbp7 = parcelRequire("3Xbp7");

var $aFPUT = parcelRequire("aFPUT");





var $8QN7n = parcelRequire("8QN7n");

























var $eicwU = parcelRequire("eicwU");




































var $3cebA = parcelRequire("3cebA");







































var $iDQjg = parcelRequire("iDQjg");


var $9F5i8 = parcelRequire("9F5i8");



















var $4rhnu = parcelRequire("4rhnu");



























































var $3vRz3 = parcelRequire("3vRz3");







var $kXq8E = parcelRequire("kXq8E");











"use strict";
(0, $i9BKe.extensions).add((0, $iA8uc.browserExt), (0, $gNJFA.webworkerExt));

});
parcelRegister("iA8uc", function(module, exports) {

$parcel$export(module.exports, "browserExt", () => $c220e1d99a2da004$export$a6aad6334ef58a1c);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $c220e1d99a2da004$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("ahGWf"));
    }
};

});
parcelRegister("i9BKe", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $2726d886f4171354$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $2726d886f4171354$export$cc3e2d3244e01b7f);
"use strict";
var $2726d886f4171354$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($2726d886f4171354$export$4f037c6ec2da4eeb || {});
const $2726d886f4171354$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $2726d886f4171354$export$ba4241979983e013 = (ext, defaultPriority)=>$2726d886f4171354$var$normalizeExtension(ext).priority ?? defaultPriority;
const $2726d886f4171354$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */ remove (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */ add (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b.value, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    },
    /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */ mixin (Target, ...sources) {
        for (const source of sources)Object.defineProperties(Target.prototype, Object.getOwnPropertyDescriptors(source));
    }
};

});

parcelRegister("ahGWf", function(module, exports) {
module.exports = Promise.all([
    import("d4auQ"),
    import("dCEEN")
]).then(()=>parcelRequire('gFyHJ'));

});


parcelRegister("gNJFA", function(module, exports) {

$parcel$export(module.exports, "webworkerExt", () => $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("hXF7d"));
    }
};

});
parcelRegister("hXF7d", function(module, exports) {
module.exports = Promise.all([
    import("d4auQ"),
    import("5zD7l")
]).then(()=>parcelRequire('danRq'));

});


parcelRegister("7dx1H", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $7h8HJ = parcelRequire("7h8HJ");

var $lLQso = parcelRequire("lLQso");

var $jXXId = parcelRequire("jXXId");

var $jMNJq = parcelRequire("jMNJq");

var $8xl7d = parcelRequire("8xl7d");

var $aQPld = parcelRequire("aQPld");

var $hNatJ = parcelRequire("hNatJ");
parcelRequire("8QN7n");

"use strict";
(0, $i9BKe.extensions).add((0, $7h8HJ.AlphaMask), (0, $lLQso.ColorMask), (0, $jXXId.StencilMask), (0, $hNatJ.VideoSource), (0, $aQPld.ImageSource), (0, $8xl7d.CanvasSource), (0, $jMNJq.BufferImageSource));

});
parcelRegister("7h8HJ", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $90469dbfa4a0e350$export$3c32667be409917c);

var $i9BKe = parcelRequire("i9BKe");

var $4rhnu = parcelRequire("4rhnu");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $90469dbfa4a0e350$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.inverse = false;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $4rhnu.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        if (!this.inverse) (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $4rhnu.Sprite);
    }
}
$90469dbfa4a0e350$export$3c32667be409917c.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});
parcelRegister("4rhnu", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $2ddac34a8a6af484$export$3075603db8e6204c);

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $f8J9J = parcelRequire("f8J9J");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $2ddac34a8a6af484$export$3075603db8e6204c extends (0, $b9FQU.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $bLlTJ.Texture).EMPTY){
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $bLlTJ.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "sprite";
        /** @internal */ this.batched = true;
        this._visualBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $bLlTJ.Texture)) return new $2ddac34a8a6af484$export$3075603db8e6204c(source);
        return new $2ddac34a8a6af484$export$3075603db8e6204c((0, $bLlTJ.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */ get texture() {
        return this._texture;
    }
    /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */ get visualBounds() {
        (0, $f8J9J.updateQuadBounds)(this._visualBounds, this._anchor, this._texture);
        return this._visualBounds;
    }
    /**
   * @deprecated
   * @ignore
   */ get sourceBounds() {
        (0, $kXq8E.deprecation)("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
        return this.visualBounds;
    }
    /** @private */ updateBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const bounds = this._bounds;
        const { width: width, height: height } = texture.orig;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._visualBounds = null;
        this._bounds = null;
        this._anchor = null;
        this._gpuData = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("a32F4", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $702ea64f2b15c76d$export$3755aaad3fd42e52);
"use strict";
class $702ea64f2b15c76d$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */ clone(observer) {
        return new $702ea64f2b15c76d$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
    }
    /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("bLlTJ", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $dd4e44a750d6d26c$export$5431306cf43de24a);

var $3vRz3 = parcelRequire("3vRz3");

var $2RwkA = parcelRequire("2RwkA");

var $fM4Mk = parcelRequire("fM4Mk");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $2coCi = parcelRequire("2coCi");

var $jMNJq = parcelRequire("jMNJq");

var $iA5fe = parcelRequire("iA5fe");

var $jNN6Y = parcelRequire("jNN6Y");
"use strict";
class $dd4e44a750d6d26c$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param {TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $aGJhg.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $fM4Mk.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $iA5fe.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $jNN6Y.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $2RwkA.groupD8).add(rotate, (0, $2RwkA.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $iA5fe.TextureSource)({
        label: "EMPTY"
    })
});
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY.destroy = (0, $2coCi.NOOP);
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    source: new (0, $jMNJq.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE.destroy = (0, $2coCi.NOOP);

});
parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("2RwkA", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $99d48e5a2f9844ff$export$b7bb6a2a8d203102);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $99d48e5a2f9844ff$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $99d48e5a2f9844ff$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $99d48e5a2f9844ff$var$rotationCayley = [];
const $99d48e5a2f9844ff$var$rotationMatrices = [];
const $99d48e5a2f9844ff$var$signum = Math.sign;
function $99d48e5a2f9844ff$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $99d48e5a2f9844ff$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _uy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _vx = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$vy[j]);
            const _vy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($99d48e5a2f9844ff$var$ux[k] === _ux && $99d48e5a2f9844ff$var$uy[k] === _uy && $99d48e5a2f9844ff$var$vx[k] === _vx && $99d48e5a2f9844ff$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $eY4rt.Matrix)();
        mat.set($99d48e5a2f9844ff$var$ux[i], $99d48e5a2f9844ff$var$uy[i], $99d48e5a2f9844ff$var$vx[i], $99d48e5a2f9844ff$var$vy[i], 0, 0);
        $99d48e5a2f9844ff$var$rotationMatrices.push(mat);
    }
}
$99d48e5a2f9844ff$var$init();
const $99d48e5a2f9844ff$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$99d48e5a2f9844ff$var$ux[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$99d48e5a2f9844ff$var$uy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$99d48e5a2f9844ff$var$vx[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$99d48e5a2f9844ff$var$vy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.S;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.E;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SE;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NE;
        return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $99d48e5a2f9844ff$var$rotationMatrices[$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

});
parcelRegister("eY4rt", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85);

var $aWW4e = parcelRequire("aWW4e");

var $1HooC = parcelRequire("1HooC");
"use strict";
class $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /**
     * Array representation of the matrix.
     * Only populated when `toArray()` is called.
     * @default null
     * @see {@link Matrix.toArray} For filling this array
     */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $aWW4e.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */ static get IDENTITY() {
        return $fd3f7bfaf4af3d85$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */ static get shared() {
        return $fd3f7bfaf4af3d85$var$tempMatrix.identity();
    }
}
const $fd3f7bfaf4af3d85$var$tempMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
const $fd3f7bfaf4af3d85$var$identityMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();

});
parcelRegister("aWW4e", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $635707f32e142ac4$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $635707f32e142ac4$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $635707f32e142ac4$export$870617f62e3187f1);
"use strict";
const $635707f32e142ac4$export$59ed0a0a5de1084b = Math.PI * 2;
const $635707f32e142ac4$export$3f91627dc85c5d57 = 180 / Math.PI;
const $635707f32e142ac4$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("1HooC", function(module, exports) {

$parcel$export(module.exports, "Point", () => $fdaff9f788d94485$export$baf26146a414f24a);
"use strict";
class $fdaff9f788d94485$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /**
     * Position of the point on the x axis
     * @example
     * ```ts
     * // Set x position
     * const point = new Point();
     * point.x = 100;
     *
     * // Use in calculations
     * const width = rightPoint.x - leftPoint.x;
     * ```
     */ this.x = 0;
        /**
     * Position of the point on the y axis
     * @example
     * ```ts
     * // Set y position
     * const point = new Point();
     * point.y = 200;
     *
     * // Use in calculations
     * const height = bottomPoint.y - topPoint.y;
     * ```
     */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */ clone() {
        return new $fdaff9f788d94485$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */ static get shared() {
        $fdaff9f788d94485$var$tempPoint.x = 0;
        $fdaff9f788d94485$var$tempPoint.y = 0;
        return $fdaff9f788d94485$var$tempPoint;
    }
}
const $fdaff9f788d94485$var$tempPoint = new $fdaff9f788d94485$export$baf26146a414f24a();

});



parcelRegister("fM4Mk", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $55a82579353c67d9$export$4617fb02663045ef);

var $1HooC = parcelRequire("1HooC");
"use strict";
const $55a82579353c67d9$var$tempPoints = [
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)()
];
class $55a82579353c67d9$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Rectangle(0, 0, 100, 100);
     * console.log(shape.type); // 'rectangle'
     *
     * // Use in type guards
     * if (shape.type === 'rectangle') {
     *     console.log(shape.width, shape.height);
     * }
     * ```
     * @readonly
     * @default 'rectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */ get left() {
        return this.x;
    }
    /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */ get right() {
        return this.x + this.width;
    }
    /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */ get top() {
        return this.y;
    }
    /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */ get bottom() {
        return this.y + this.height;
    }
    /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */ static get EMPTY() {
        return new $55a82579353c67d9$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $55a82579353c67d9$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const outerLeft = _x - strokeWidthOuter;
        const outerRight = _x + width + strokeWidthOuter;
        const outerTop = _y - strokeWidthOuter;
        const outerBottom = _y + height + strokeWidthOuter;
        const innerLeft = _x + strokeWidthInner;
        const innerRight = _x + width - strokeWidthInner;
        const innerTop = _y + strokeWidthInner;
        const innerBottom = _y + height - strokeWidthInner;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $55a82579353c67d9$var$tempPoints[0].set(other.left, other.top);
        const lb = $55a82579353c67d9$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $55a82579353c67d9$var$tempPoints[2].set(other.right, other.top);
        const rb = $55a82579353c67d9$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */ getBounds(out) {
        out || (out = new $55a82579353c67d9$export$4617fb02663045ef());
        out.copyFrom(this);
        return out;
    }
    /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */ containsRect(other) {
        if (this.width <= 0 || this.height <= 0) return false;
        const x1 = other.x;
        const y1 = other.y;
        const x2 = other.x + other.width;
        const y2 = other.y + other.height;
        return x1 >= this.x && x1 < this.x + this.width && y1 >= this.y && y1 < this.y + this.height && x2 >= this.x && x2 < this.x + this.width && y2 >= this.y && y2 < this.y + this.height;
    }
    /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */ set(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("aGJhg", function(module, exports) {

$parcel$export(module.exports, "uid", () => $aa9685d46d70e8a7$export$e2a22331486dcca0);
"use strict";
const $aa9685d46d70e8a7$var$uidCache = {
    default: -1
};
function $aa9685d46d70e8a7$export$e2a22331486dcca0(name = "default") {
    if ($aa9685d46d70e8a7$var$uidCache[name] === void 0) $aa9685d46d70e8a7$var$uidCache[name] = -1;
    return ++$aa9685d46d70e8a7$var$uidCache[name];
}
function $aa9685d46d70e8a7$export$220409b686c277d0() {
    for(const key in $aa9685d46d70e8a7$var$uidCache)delete $aa9685d46d70e8a7$var$uidCache[key];
}

});

parcelRegister("kXq8E", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $86481ab6f435a4d7$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $86481ab6f435a4d7$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $86481ab6f435a4d7$export$afd31d834b512e89);
"use strict";
const $86481ab6f435a4d7$var$warnings = {};
const $86481ab6f435a4d7$export$dc79da96439604f0 = "8.0.0";
const $86481ab6f435a4d7$export$e88af00f5d3e8bcc = "8.3.4";
function $86481ab6f435a4d7$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($86481ab6f435a4d7$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $86481ab6f435a4d7$var$warnings[message] = true;
}

});

parcelRegister("2coCi", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $342f4d0330a1a110$export$5702a91a6f42969f);
"use strict";
const $342f4d0330a1a110$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("jMNJq", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $38c8a704e7d4a191$export$1872462350fcb7cd);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $38c8a704e7d4a191$export$1872462350fcb7cd extends (0, $iA5fe.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$38c8a704e7d4a191$export$1872462350fcb7cd.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iA5fe", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $50e6ce3cf0e8b717$export$8498e6a2e655d3d8);

var $3vRz3 = parcelRequire("3vRz3");

var $NbSCN = parcelRequire("NbSCN");

var $dr868 = parcelRequire("dr868");

var $aGJhg = parcelRequire("aGJhg");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
const $50e6ce3cf0e8b717$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** unique id for this Texture source */ this.uid = (0, $aGJhg.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @internal
     */ this.uploadMethodId = "unknown";
        /** @internal */ this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     */ this.sampleCount = 1;
        /** The number of mip levels to generate for this texture. this is  overridden if autoGenerateMipmaps is true */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $aFPUT.TextureStyle)((0, $dr868.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution || (resolution = this._resolution);
        width || (width = this.width);
        height || (height = this.height);
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $NbSCN.isPow2)(this.pixelWidth) && (0, $NbSCN.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $50e6ce3cf0e8b717$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $50e6ce3cf0e8b717$export$8498e6a2e655d3d8 = $50e6ce3cf0e8b717$var$_TextureSource;

});
parcelRegister("NbSCN", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $445bbf816b14b66c$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $445bbf816b14b66c$export$eb50b9c078eb6ae7);
"use strict";
function $445bbf816b14b66c$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $445bbf816b14b66c$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $445bbf816b14b66c$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("dr868", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $c5dcc841d9b9a11e$export$801feaffb936a09d);
"use strict";
function $c5dcc841d9b9a11e$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("aFPUT", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $46d9af7c4b00e80a$var$idHash = /* @__PURE__ */ Object.create(null);
function $46d9af7c4b00e80a$var$createResourceIdFromString(value) {
    const id = $46d9af7c4b00e80a$var$idHash[value];
    if (id === void 0) $46d9af7c4b00e80a$var$idHash[value] = (0, $aGJhg.uid)("resource");
    return id;
}
const $46d9af7c4b00e80a$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        /** @internal */ this._resourceType = "textureSampler";
        /** @internal */ this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link TextureStyle#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link TextureStyle#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this.emit("change", this);
        this._sharedResourceId = null;
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $46d9af7c4b00e80a$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $46d9af7c4b00e80a$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5 = $46d9af7c4b00e80a$var$_TextureStyle;

});



parcelRegister("jNN6Y", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $707e20d60f27daa2$export$dbea3135e9da48cb);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $707e20d60f27daa2$var$tempMat = new (0, $eY4rt.Matrix)();
class $707e20d60f27daa2$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $eY4rt.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $707e20d60f27daa2$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($707e20d60f27daa2$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("f8J9J", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $67aa708353891905$export$558ce66aa5723f1d);
"use strict";
function $67aa708353891905$export$558ce66aa5723f1d(bounds, anchor, texture) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});

parcelRegister("b9FQU", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $950433d02344dbbb$export$19fb617b96998849);

var $7wtv9 = parcelRequire("7wtv9");

var $eicwU = parcelRequire("eicwU");
"use strict";
class $950433d02344dbbb$export$19fb617b96998849 extends (0, $eicwU.Container) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(options){
        super(options);
        /** @internal */ this.canBundle = true;
        /** @internal */ this.allowChildren = false;
        /** @internal */ this._roundPixels = 0;
        /** @internal */ this._lastUsed = -1;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        this._bounds = new (0, $7wtv9.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
    }
    /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this.updateBounds();
        this._boundsDirty = false;
        return this._bounds;
    }
    /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    /** @private */ onViewUpdate() {
        this._didViewChangeTick++;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    destroy(options) {
        super.destroy(options);
        this._bounds = null;
        for(const key in this._gpuData)this._gpuData[key].destroy?.();
        this._gpuData = null;
    }
    /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */ collectRenderablesSimple(instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        renderPipes.blendMode.setBlendMode(this, this.groupBlendMode, instructionSet);
        const rp = renderPipes;
        rp[this.renderPipeId].addRenderable(this, instructionSet);
        this.didViewUpdate = false;
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    }
}

});
parcelRegister("7wtv9", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $0b15abb3a529f09f$export$c4e9d269599ab4b4);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $0b15abb3a529f09f$var$defaultMatrix = new (0, $eY4rt.Matrix)();
class $0b15abb3a529f09f$export$c4e9d269599ab4b4 {
    /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */ constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X coordinate of the bounds.
     * Represents the leftmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set left edge
     * bounds.minX = 100;
     * ```
     * @default Infinity
     */ this.minX = Infinity;
        /**
     * The minimum Y coordinate of the bounds.
     * Represents the topmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set top edge
     * bounds.minY = 100;
     * ```
     * @default Infinity
     */ this.minY = Infinity;
        /**
     * The maximum X coordinate of the bounds.
     * Represents the rightmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set right edge
     * bounds.maxX = 200;
     * // Get width
     * const width = bounds.maxX - bounds.minX;
     * ```
     * @default -Infinity
     */ this.maxX = -Infinity;
        /**
     * The maximum Y coordinate of the bounds.
     * Represents the bottommost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set bottom edge
     * bounds.maxY = 200;
     * // Get height
     * const height = bounds.maxY - bounds.minY;
     * ```
     * @default -Infinity
     */ this.maxY = -Infinity;
        /**
     * The transformation matrix applied to this bounds object.
     * Used when calculating bounds with transforms.
     * @example
     * ```ts
     * const bounds = new Bounds();
     *
     * // Apply translation matrix
     * bounds.matrix = new Matrix()
     *     .translate(100, 100);
     *
     * // Combine transformations
     * bounds.matrix = new Matrix()
     *     .translate(50, 50)
     *     .rotate(Math.PI / 4)
     *     .scale(2, 2);
     *
     * // Use in bounds calculations
     * bounds.addFrame(0, 0, 100, 100); // Uses current matrix
     * bounds.addFrame(0, 0, 100, 100, customMatrix); // Override matrix
     * ```
     * @advanced
     */ this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $fM4Mk.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */ clone() {
        return new $0b15abb3a529f09f$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */ get left() {
        return this.minX;
    }
    /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */ get right() {
        return this.maxX;
    }
    /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */ get top() {
        return this.minY;
    }
    /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */ get bottom() {
        return this.maxY;
    }
    /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */ get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */ toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
    /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */ copyFrom(bounds) {
        this.minX = bounds.minX;
        this.minY = bounds.minY;
        this.maxX = bounds.maxX;
        this.maxY = bounds.maxY;
        return this;
    }
}

});

parcelRegister("eicwU", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $8a2b4ed6f59ce4dc$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $8a2b4ed6f59ce4dc$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $8a2b4ed6f59ce4dc$export$42a852a2b6b56249);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $j1i7q = parcelRequire("j1i7q");

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $aWW4e = parcelRequire("aWW4e");

var $a32F4 = parcelRequire("a32F4");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $9atlQ = parcelRequire("9atlQ");

var $236jP = parcelRequire("236jP");

var $49nq9 = parcelRequire("49nq9");

var $apXS2 = parcelRequire("apXS2");

var $kkVML = parcelRequire("kkVML");

var $3hzRR = parcelRequire("3hzRR");

var $8ifkW = parcelRequire("8ifkW");

var $kEqoj = parcelRequire("kEqoj");

var $ggvKl = parcelRequire("ggvKl");

var $82jXu = parcelRequire("82jXu");

var $g5iYs = parcelRequire("g5iYs");

var $1pFbO = parcelRequire("1pFbO");

var $gIPW8 = parcelRequire("gIPW8");
"use strict";
const $8a2b4ed6f59ce4dc$var$defaultSkew = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultPivot = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultScale = new (0, $a32F4.ObservablePoint)(null, 1, 1);
const $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5 = 1;
const $8a2b4ed6f59ce4dc$export$e4801e7edc7582f = 2;
const $8a2b4ed6f59ce4dc$export$83db162b74637ea = 4;
const $8a2b4ed6f59ce4dc$export$8363b5079568fbee = 8;
class $8a2b4ed6f59ce4dc$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options = {}){
        super();
        /**
     * unique id for this container
     * @internal
     */ this.uid = (0, $aGJhg.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container. Each child must be a Container or extend from it.
     *
     * The array is read-only, but its contents can be modified using Container methods.
     * @example
     * ```ts
     * // Access children
     * const firstChild = container.children[0];
     * const lastChild = container.children[container.children.length - 1];
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding children
     * @see {@link Container#removeChild} For removing children
     */ this.children = [];
        /**
     * The display object container that contains this display object.
     * This represents the parent-child relationship in the display tree.
     * @example
     * ```ts
     * // Basic parent access
     * const parent = sprite.parent;
     *
     * // Walk up the tree
     * let current = sprite;
     * while (current.parent) {
     *     console.log('Level up:', current.parent.constructor.name);
     *     current = current.parent;
     * }
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding to a parent
     * @see {@link Container#removeChild} For removing from parent
     */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /** @internal */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * This matrix represents the local transformation without any parent influence.
     * @example
     * ```ts
     * // Basic transform access
     * const localMatrix = sprite.localTransform;
     * console.log(localMatrix.toString());
     * ```
     * @readonly
     * @see {@link Container#worldTransform} For global transform
     * @see {@link Container#groupTransform} For render group transform
     */ this.localTransform = new (0, $eY4rt.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     * @advanced
     */ this.relativeGroupTransform = new (0, $eY4rt.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     * @advanced
     */ this.groupTransform = this.relativeGroupTransform;
        /**
     * Whether this object has been destroyed. If true, the object should no longer be used.
     * After an object is destroyed, all of its functionality is disabled and references are removed.
     * @example
     * ```ts
     * // Cleanup with destroy
     * sprite.destroy();
     * console.log(sprite.destroyed); // true
     * ```
     * @default false
     * @see {@link Container#destroy} For destroying objects
     */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     */ this._position = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     */ this._scale = $8a2b4ed6f59ce4dc$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     */ this._pivot = $8a2b4ed6f59ce4dc$var$defaultPivot;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     */ this._skew = $8a2b4ed6f59ce4dc$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        /** @internal */ this.localColor = 16777215;
        /** @internal */ this.localAlpha = 1;
        /** @internal */ this.groupAlpha = 1;
        // A
        /** @internal */ this.groupColor = 16777215;
        // BGR
        /** @internal */ this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /** @internal */ this.localBlendMode = "inherit";
        /** @internal */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /** @internal */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $gIPW8.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */ static mixin(source) {
        (0, $kXq8E.deprecation)("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead.");
        (0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, source);
    }
    // = 'default';
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    /** @ignore */ get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */ addChild(...children) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (renderGroup) renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            if (child.parentRenderLayer) child.parentRenderLayer.detach(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $61KiY.BigPool).get((0, $1pFbO.RenderGroup), this);
        this.groupTransform = (0, $eY4rt.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /**
   * This will disable the render group for this container.
   * @advanced
   */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $61KiY.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $eY4rt.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */ get angle() {
        return this.rotation * (0, $aWW4e.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $aWW4e.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */ get skew() {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   *  @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        return this;
    }
    /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c);
        lt.ty = position._y - (px * lt.b + py * lt.d);
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $a2eTA.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */ get tint() {
        return (0, $8ifkW.bgr2rgb)(this.localColor);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /**
   * Whether or not the object should be rendered.
   * @advanced
   */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        let oldChildren;
        if (this.children.length) oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren && oldChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
(0, $i9BKe.extensions).mixin($8a2b4ed6f59ce4dc$export$42a852a2b6b56249, (0, $236jP.childrenHelperMixin), (0, $3hzRR.getFastGlobalBoundsMixin), (0, $g5iYs.toLocalGlobalMixin), (0, $ggvKl.onRenderMixin), (0, $kEqoj.measureMixin), (0, $apXS2.effectsMixin), (0, $kkVML.findMixin), (0, $82jXu.sortMixin), (0, $j1i7q.cullingMixin), (0, $9atlQ.cacheAsTextureMixin), (0, $8ifkW.getGlobalMixin), (0, $49nq9.collectRenderablesMixin));

});
parcelRegister("a2eTA", function(module, exports) {

$parcel$export(module.exports, "Color", () => $f6a94f8017837c10$export$892596cec99bc70e);

var $erZA3 = parcelRequire("erZA3");

var $lCM3s = parcelRequire("lCM3s");
"use strict";
(0, $erZA3.extend)([
    (0, $lCM3s.default)
]);
const $f6a94f8017837c10$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */ get red() {
        return this._components[0];
    }
    /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */ get green() {
        return this._components[1];
    }
    /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */ get blue() {
        return this._components[2];
    }
    /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */ get alpha() {
        return this._components[3];
    }
    /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */ toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */ toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out || (out = this._arrayRgba);
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */ toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $erZA3.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Static shared Color instance used for utility operations. This is a singleton color object
 * that can be reused to avoid creating unnecessary Color instances.
 * > [!IMPORTANT] You should be careful when using this shared instance, as it is mutable and can be
 * > changed by any code that uses it.
 * >
 * > It is best used for one-off color operations or temporary transformations.
 * > For persistent colors, create your own Color instance instead.
 * @example
 * ```ts
 * import { Color } from 'pixi.js';
 *
 * // Use shared instance for one-off color operations
 * Color.shared.setValue(0xff0000);
 * const redHex = Color.shared.toHex();     // "#ff0000"
 * const redRgb = Color.shared.toRgbArray(); // [1, 0, 0]
 *
 * // Temporary color transformations
 * const colorNumber = Color.shared
 *     .setValue('#ff0000')     // Set to red
 *     .setAlpha(0.5)          // Make semi-transparent
 *     .premultiply(0.8)       // Apply premultiplication
 *     .toNumber();            // Convert to number
 *
 * // Chain multiple operations
 * const result = Color.shared
 *     .setValue(someColor)
 *     .multiply(tintColor)
 *     .toPremultiplied(alpha);
 * ```
 * @remarks
 * - This is a shared instance - be careful about multiple code paths using it simultaneously
 * - Use for temporary color operations to avoid allocating new Color instances
 * - The value is preserved between operations, so reset if needed
 * - For persistent colors, create your own Color instance instead
 */ $f6a94f8017837c10$var$_Color.shared = new $f6a94f8017837c10$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $f6a94f8017837c10$var$_Color._temp = new $f6a94f8017837c10$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f6a94f8017837c10$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $f6a94f8017837c10$export$892596cec99bc70e = $f6a94f8017837c10$var$_Color;

});
parcelRegister("erZA3", function(module, exports) {

$parcel$export(module.exports, "colord", () => $482ad42e73ee00b6$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $482ad42e73ee00b6$export$8b58be045bf06082);
var $482ad42e73ee00b6$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $482ad42e73ee00b6$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $482ad42e73ee00b6$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $482ad42e73ee00b6$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $482ad42e73ee00b6$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $482ad42e73ee00b6$var$a = function(r) {
    return {
        r: $482ad42e73ee00b6$var$e(r.r, 0, 255),
        g: $482ad42e73ee00b6$var$e(r.g, 0, 255),
        b: $482ad42e73ee00b6$var$e(r.b, 0, 255),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$o = function(r) {
    return {
        r: $482ad42e73ee00b6$var$n(r.r),
        g: $482ad42e73ee00b6$var$n(r.g),
        b: $482ad42e73ee00b6$var$n(r.b),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$i = /^#([0-9a-f]{3,8})$/i, $482ad42e73ee00b6$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $482ad42e73ee00b6$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $482ad42e73ee00b6$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $482ad42e73ee00b6$var$g = function(r) {
    return {
        h: $482ad42e73ee00b6$var$u(r.h),
        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
        l: $482ad42e73ee00b6$var$e(r.l, 0, 100),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$d = function(r) {
    return {
        h: $482ad42e73ee00b6$var$n(r.h),
        s: $482ad42e73ee00b6$var$n(r.s),
        l: $482ad42e73ee00b6$var$n(r.l),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$f = function(r) {
    var t, n, e;
    return $482ad42e73ee00b6$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $482ad42e73ee00b6$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $482ad42e73ee00b6$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $482ad42e73ee00b6$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$y = {
    string: [
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$v.exec(r) || $482ad42e73ee00b6$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $482ad42e73ee00b6$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $482ad42e73ee00b6$var$l.exec(t) || $482ad42e73ee00b6$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $482ad42e73ee00b6$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($482ad42e73ee00b6$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $482ad42e73ee00b6$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $482ad42e73ee00b6$var$t(n) && $482ad42e73ee00b6$var$t(e) && $482ad42e73ee00b6$var$t(u) ? $482ad42e73ee00b6$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(e) || !$482ad42e73ee00b6$var$t(u)) return null;
                var i = $482ad42e73ee00b6$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $482ad42e73ee00b6$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(a) || !$482ad42e73ee00b6$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $482ad42e73ee00b6$var$u(r.h),
                        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
                        v: $482ad42e73ee00b6$var$e(r.v, 0, 100),
                        a: $482ad42e73ee00b6$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $482ad42e73ee00b6$var$b(h);
            },
            "hsv"
        ]
    ]
}, $482ad42e73ee00b6$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$var$x = function(r) {
    return "string" == typeof r ? $482ad42e73ee00b6$var$N(r.trim(), $482ad42e73ee00b6$var$y.string) : "object" == typeof r && null !== r ? $482ad42e73ee00b6$var$N(r, $482ad42e73ee00b6$var$y.object) : [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$export$f61ac8b6f1f46202 = function(r) {
    return $482ad42e73ee00b6$var$x(r)[1];
}, $482ad42e73ee00b6$var$M = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: $482ad42e73ee00b6$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $482ad42e73ee00b6$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $482ad42e73ee00b6$var$$ = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $482ad42e73ee00b6$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $482ad42e73ee00b6$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $482ad42e73ee00b6$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $482ad42e73ee00b6$var$n($482ad42e73ee00b6$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $482ad42e73ee00b6$var$s($482ad42e73ee00b6$var$n(255 * a)) : "", "#" + $482ad42e73ee00b6$var$s(t) + $482ad42e73ee00b6$var$s(e) + $482ad42e73ee00b6$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $482ad42e73ee00b6$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $482ad42e73ee00b6$var$h(this.rgba), {
            h: $482ad42e73ee00b6$var$n(r.h),
            s: $482ad42e73ee00b6$var$n(r.s),
            v: $482ad42e73ee00b6$var$n(r.v),
            a: $482ad42e73ee00b6$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $482ad42e73ee00b6$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $482ad42e73ee00b6$var$c(this.rgba);
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $482ad42e73ee00b6$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $482ad42e73ee00b6$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $482ad42e73ee00b6$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $482ad42e73ee00b6$export$4d30ed660ff08d0 ? r : new $482ad42e73ee00b6$export$4d30ed660ff08d0(r);
}, $482ad42e73ee00b6$var$S = [], $482ad42e73ee00b6$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $482ad42e73ee00b6$var$S.indexOf(r) < 0 && (r($482ad42e73ee00b6$export$4d30ed660ff08d0, $482ad42e73ee00b6$var$y), $482ad42e73ee00b6$var$S.push(r));
    });
}, $482ad42e73ee00b6$export$4385e60b38654f68 = function() {
    return new $482ad42e73ee00b6$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("lCM3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1f6e6e10c0717$export$2e2bcd8739ae039);
function $4bf1f6e6e10c0717$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("j1i7q", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $b5b40e006e048a91$export$dce76d4f0fd249ed);
"use strict";
const $b5b40e006e048a91$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("61KiY", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $9483424e2013bba4$export$8249372279066210);

var $5Xsoh = parcelRequire("5Xsoh");
"use strict";
class $9483424e2013bba4$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $5Xsoh.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
}
const $9483424e2013bba4$export$8249372279066210 = new $9483424e2013bba4$export$866836a21808b71c();

});
parcelRegister("5Xsoh", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $ce33839780b5f2f3$export$14963ee5c8637e11);
"use strict";
class $ce33839780b5f2f3$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else item = new this._classType();
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool - mainly used for debugging! */ clear() {
        this._pool.length = 0;
        this._index = 0;
    }
}

});


parcelRegister("9atlQ", function(module, exports) {

$parcel$export(module.exports, "cacheAsTextureMixin", () => $a8b261c324971086$export$9660f593b1298e75);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $a8b261c324971086$export$9660f593b1298e75 = {
    get isCachedAsTexture () {
        return !!this.renderGroup?.isCachedAsTexture;
    },
    cacheAsTexture (val1) {
        if (typeof val1 === "boolean" && val1 === false) this.disableRenderGroup();
        else {
            this.enableRenderGroup();
            this.renderGroup.enableCacheAsTexture(val1 === true ? {} : val1);
        }
    },
    updateCacheTexture () {
        this.renderGroup?.updateCacheTexture();
    },
    get cacheAsBitmap () {
        return this.isCachedAsTexture;
    },
    set cacheAsBitmap (val){
        (0, $kXq8E.deprecation)("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
        this.cacheAsTexture(val);
    }
};

});

parcelRegister("236jP", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $0d8e0eeab3189cd3$export$64cca9f0c2df174a);

var $33PVi = parcelRequire("33PVi");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $0d8e0eeab3189cd3$export$64cca9f0c2df174a = {
    allowChildren: true,
    removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $33PVi.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                const child = removed[i];
                child.parentRenderLayer?.detach(child);
                this.emit("childRemoved", child, this, i);
                removed[i].emit("removed", this);
            }
            if (removed.length > 0) this._didViewChangeTick++;
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    addChildAt (child, index) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    removeFromParent () {
        this.parent?.removeChild(this);
    },
    reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    }
};

});
parcelRegister("33PVi", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $cefc366e7023560b$export$8d47c0e1ce445404);
"use strict";
function $cefc366e7023560b$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("49nq9", function(module, exports) {

$parcel$export(module.exports, "collectRenderablesMixin", () => $0a36b694a408d29d$export$e50be97f8cd670d0);
"use strict";
const $0a36b694a408d29d$export$e50be97f8cd670d0 = {
    collectRenderables (instructionSet, renderer, currentLayer) {
        if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild) return;
        if (this.sortableChildren) this.sortChildren();
        if (this.isSimple) this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        else if (this.renderGroup) renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
        else this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    },
    collectRenderablesSimple (instructionSet, renderer, currentLayer) {
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    },
    collectRenderablesWithEffects (instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        for(let i = 0; i < this.effects.length; i++){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.push(effect, this, instructionSet);
        }
        this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        for(let i = this.effects.length - 1; i >= 0; i--){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.pop(effect, this, instructionSet);
        }
    }
};

});

parcelRegister("apXS2", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $1d59e812d2000ae8$export$eec5e288a9d02a7c);

var $aWIPo = parcelRequire("aWIPo");

var $dZmDL = parcelRequire("dZmDL");
"use strict";
const $1d59e812d2000ae8$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _maskOptions: {
        inverse: false
    },
    _filterEffect: null,
    effects: [],
    _markStructureAsChanged () {
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
    },
    addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $dZmDL.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $dZmDL.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    get mask () {
        return this._maskEffect?.mask;
    },
    setMask (options) {
        this._maskOptions = {
            ...this._maskOptions,
            ...options
        };
        if (options.mask) this.mask = options.mask;
        this._markStructureAsChanged();
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("aWIPo", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $573d66e12a5f4185$export$d66c06ffe23037ab);
"use strict";
class $573d66e12a5f4185$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("dZmDL", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $f40a37c299623cb8$export$1eb319167fe02d04);

var $i9BKe = parcelRequire("i9BKe");

var $61KiY = parcelRequire("61KiY");
"use strict";
class $f40a37c299623cb8$export$3b0749bf144d4b29 {
    constructor(){
        /** @private */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $61KiY.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $61KiY.BigPool).return(effect);
    }
}
const $f40a37c299623cb8$export$1eb319167fe02d04 = new $f40a37c299623cb8$export$3b0749bf144d4b29();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).MaskEffect, $f40a37c299623cb8$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("kkVML", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $1ce16328dd0c7b09$export$468b0762e1bfbd64);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $1ce16328dd0c7b09$export$468b0762e1bfbd64 = {
    label: null,
    get name () {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("3hzRR", function(module, exports) {

$parcel$export(module.exports, "getFastGlobalBoundsMixin", () => $af7175d9cdd285e4$export$993f17c9646405e3);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $af7175d9cdd285e4$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $af7175d9cdd285e4$export$993f17c9646405e3 = {
    getFastGlobalBounds (factorRenderLayers, bounds) {
        bounds || (bounds = new (0, $7wtv9.Bounds)());
        bounds.clear();
        this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        bounds.applyMatrix(renderGroup.worldTransform);
        return bounds;
    },
    _getGlobalBoundsRecursive (factorRenderLayers, bounds, currentLayer) {
        let localBounds = bounds;
        if (factorRenderLayers && this.parentRenderLayer && this.parentRenderLayer !== currentLayer) return;
        if (this.localDisplayStatus !== 7 || !this.measurable) return;
        const manageEffects = !!this.effects.length;
        if (this.renderGroup || manageEffects) localBounds = (0, $5tmC8.boundsPool).get().clear();
        if (this.boundsArea) bounds.addRect(this.boundsArea, this.worldTransform);
        else {
            if (this.renderPipeId) {
                const viewBounds = this.bounds;
                localBounds.addFrame(viewBounds.minX, viewBounds.minY, viewBounds.maxX, viewBounds.maxY, this.groupTransform);
            }
            const children = this.children;
            for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
        }
        if (manageEffects) {
            let advanced = false;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            for(let i = 0; i < this.effects.length; i++)if (this.effects[i].addBounds) {
                if (!advanced) {
                    advanced = true;
                    localBounds.applyMatrix(renderGroup.worldTransform);
                }
                this.effects[i].addBounds(localBounds, true);
            }
            if (advanced) {
                localBounds.applyMatrix(renderGroup.worldTransform.copyTo($af7175d9cdd285e4$var$tempMatrix).invert());
                bounds.addBounds(localBounds, this.relativeGroupTransform);
            }
            bounds.addBounds(localBounds);
            (0, $5tmC8.boundsPool).return(localBounds);
        } else if (this.renderGroup) {
            bounds.addBounds(localBounds, this.relativeGroupTransform);
            (0, $5tmC8.boundsPool).return(localBounds);
        }
    }
};

});
parcelRegister("5tmC8", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $aaa7ee585a7b6ebc$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $aaa7ee585a7b6ebc$export$9194656040c1dc42);

var $eY4rt = parcelRequire("eY4rt");

var $5Xsoh = parcelRequire("5Xsoh");

var $7wtv9 = parcelRequire("7wtv9");
"use strict";
const $aaa7ee585a7b6ebc$export$3849005ba4dacf72 = new (0, $5Xsoh.Pool)((0, $eY4rt.Matrix));
const $aaa7ee585a7b6ebc$export$9194656040c1dc42 = new (0, $5Xsoh.Pool)((0, $7wtv9.Bounds));

});


parcelRegister("8ifkW", function(module, exports) {

$parcel$export(module.exports, "bgr2rgb", () => $cff3716760fd205e$export$110f9f26b10ddb4a);
$parcel$export(module.exports, "getGlobalMixin", () => $cff3716760fd205e$export$c7c22dc0c465d95a);

var $iskjc = parcelRequire("iskjc");

var $5tmC8 = parcelRequire("5tmC8");

var $4KYBZ = parcelRequire("4KYBZ");
"use strict";
function $cff3716760fd205e$export$110f9f26b10ddb4a(color) {
    return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const $cff3716760fd205e$export$c7c22dc0c465d95a = {
    getGlobalAlpha (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return this.renderGroup.worldAlpha;
            if (this.parentRenderGroup) return this.parentRenderGroup.worldAlpha * this.alpha;
            return this.alpha;
        }
        let alpha = this.alpha;
        let current = this.parent;
        while(current){
            alpha *= current.alpha;
            current = current.parent;
        }
        return alpha;
    },
    getGlobalTransform (matrix, skipUpdate) {
        if (skipUpdate) return matrix.copyFrom(this.worldTransform);
        this.updateLocalTransform();
        const parentTransform = (0, $iskjc.updateTransformBackwards)(this, (0, $5tmC8.matrixPool).get().identity());
        matrix.appendFrom(this.localTransform, parentTransform);
        (0, $5tmC8.matrixPool).return(parentTransform);
        return matrix;
    },
    getGlobalTint (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a(this.renderGroup.worldColor);
            if (this.parentRenderGroup) return $cff3716760fd205e$export$110f9f26b10ddb4a((0, $4KYBZ.multiplyColors)(this.localColor, this.parentRenderGroup.worldColor));
            return this.tint;
        }
        let color = this.localColor;
        let parent = this.parent;
        while(parent){
            color = (0, $4KYBZ.multiplyColors)(color, parent.localColor);
            parent = parent.parent;
        }
        return $cff3716760fd205e$export$110f9f26b10ddb4a(color);
    }
};

});
parcelRegister("iskjc", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $b2563854990e287d$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $b2563854990e287d$export$2022bc48a49dd6d2);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $b2563854990e287d$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $5tmC8.matrixPool).get().identity();
            parentTransform = $b2563854990e287d$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $eY4rt.Matrix).IDENTITY;
    $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $5tmC8.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $b2563854990e287d$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $5tmC8.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        if (target.bounds) {
            bounds.matrix = worldTransform;
            bounds.addBounds(target.bounds);
        }
        for(let i = 0; i < target.children.length; i++)$b2563854990e287d$var$_getGlobalBounds(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $5tmC8.matrixPool).return(worldTransform);
}
function $b2563854990e287d$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $b2563854990e287d$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});

parcelRegister("4KYBZ", function(module, exports) {

$parcel$export(module.exports, "multiplyColors", () => $d2dd747da74b9c5e$export$a82a3ae2e3118160);

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $d2dd747da74b9c5e$var$WHITE_BGR = 16777215;
function $d2dd747da74b9c5e$export$a82a3ae2e3118160(localBGRColor, parentBGRColor) {
    if (localBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return parentBGRColor;
    if (parentBGRColor === $d2dd747da74b9c5e$var$WHITE_BGR) return localBGRColor;
    return (0, $3N6bV.multiplyHexColors)(localBGRColor, parentBGRColor);
}

});
parcelRegister("3N6bV", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $038267701630e9a0$export$815d7ea0395de72c);
"use strict";
function $038267701630e9a0$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255 | 0;
    const g = g1 * g2 / 255 | 0;
    const b = b1 * b2 / 255 | 0;
    return (r << 16) + (g << 8) + b;
}

});



parcelRegister("kEqoj", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $4a6a8e8422db6a2e$export$285e6e72e8e62f0);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");

var $j68wk = parcelRequire("j68wk");

var $lK289 = parcelRequire("lK289");
"use strict";
const $4a6a8e8422db6a2e$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $4a6a8e8422db6a2e$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $7wtv9.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $lK289.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $j68wk.getLocalBounds)(this, localBoundsCacheData.localBounds, $4a6a8e8422db6a2e$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    getBounds (skipUpdate, bounds) {
        return (0, $iskjc.getGlobalBounds)(this, skipUpdate, bounds || new (0, $7wtv9.Bounds)());
    }
};

});
parcelRegister("j68wk", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $653ce529dcaa332d$export$ffaf4f504c4c5c9c);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $653ce529dcaa332d$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $eY4rt.Matrix).IDENTITY);
    $653ce529dcaa332d$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $653ce529dcaa332d$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            bounds.addBounds(target.bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$653ce529dcaa332d$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    (0, $5tmC8.matrixPool).return(relativeTransform);
}

});

parcelRegister("lK289", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $6ac8d139665df8ac$export$fd5aadbd3827bcf1);
"use strict";
function $6ac8d139665df8ac$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $6ac8d139665df8ac$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("ggvKl", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $63981d12ee78567e$export$2a5246d1114cb81d);
"use strict";
const $63981d12ee78567e$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("82jXu", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $8864252dd84a6b69$export$eb4acdd9f4781aed);
"use strict";
const $8864252dd84a6b69$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    sortDirty: false,
    sortableChildren: false,
    get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($8864252dd84a6b69$var$sortChildren);
    }
};
function $8864252dd84a6b69$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("g5iYs", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $6a95391942e887de$export$38fa7a987602e8dd);

var $1HooC = parcelRequire("1HooC");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
const $6a95391942e887de$export$38fa7a987602e8dd = {
    getGlobalPosition (point = new (0, $1HooC.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    toGlobal (position, point, skipUpdate = false) {
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.apply(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    },
    toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        const globalMatrix = this.getGlobalTransform((0, $5tmC8.matrixPool).get(), skipUpdate);
        point = globalMatrix.applyInverse(position, point);
        (0, $5tmC8.matrixPool).return(globalMatrix);
        return point;
    }
};

});

parcelRegister("1pFbO", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $5a621eb8e375b2c4$export$94d273f8d74f2a5);

var $eY4rt = parcelRequire("eY4rt");

var $dK5Jn = parcelRequire("dK5Jn");

var $3Xbp7 = parcelRequire("3Xbp7");
"use strict";
class $5a621eb8e375b2c4$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $eY4rt.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        this.gcTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $dK5Jn.InstructionSet)();
        this._onRenderContainers = [];
        /**
     * Indicates if the cached texture needs to be updated.
     * @default true
     */ this.textureNeedsUpdate = true;
        /**
     * Indicates if the container should be cached as a texture.
     * @default false
     */ this.isCachedAsTexture = false;
        this._matrixDirty = 7;
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child._updateFlags = 15;
            this.addChild(child);
        }
    }
    enableCacheAsTexture(options = {}) {
        this.textureOptions = options;
        this.isCachedAsTexture = true;
        this.textureNeedsUpdate = true;
    }
    disableCacheAsTexture() {
        this.isCachedAsTexture = false;
        if (this.texture) {
            (0, $3Xbp7.TexturePool).returnTexture(this.texture);
            this.texture = null;
        }
    }
    updateCacheTexture() {
        this.textureNeedsUpdate = true;
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
        this.disableCacheAsTexture();
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    updateRenderable(renderable) {
        if (renderable.globalDisplayStatus < 7) return;
        this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
        renderable.didViewUpdate = false;
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender(renderer) {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender(renderer);
    }
    destroy() {
        this.disableCacheAsTexture();
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    invalidateMatrices() {
        this._matrixDirty = 7;
    }
    /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */ get inverseWorldTransform() {
        if ((this._matrixDirty & 1) === 0) return this._inverseWorldTransform;
        this._matrixDirty &= -2;
        this._inverseWorldTransform || (this._inverseWorldTransform = new (0, $eY4rt.Matrix)());
        return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
    }
    /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */ get textureOffsetInverseTransform() {
        if ((this._matrixDirty & 2) === 0) return this._textureOffsetInverseTransform;
        this._matrixDirty &= -3;
        this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new (0, $eY4rt.Matrix)());
        return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(-this._textureBounds.x, -this._textureBounds.y);
    }
    /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */ get inverseParentTextureTransform() {
        if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
        this._matrixDirty &= -5;
        const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
        if (parentCacheAsTexture) {
            this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new (0, $eY4rt.Matrix)());
            return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(-parentCacheAsTexture._textureBounds.x, -parentCacheAsTexture._textureBounds.y);
        }
        return this.worldTransform;
    }
    /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */ get cacheToLocalTransform() {
        if (!this._parentCacheAsTextureRenderGroup) return null;
        return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
    }
}

});
parcelRegister("dK5Jn", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $a69ff318b1fa7c86$export$2946bd01f10dd922);

var $aGJhg = parcelRequire("aGJhg");
"use strict";
class $a69ff318b1fa7c86$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $aGJhg.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        /** used by the garbage collector to track when the instruction set was last used */ this.gcTick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});

parcelRegister("3Xbp7", function(module, exports) {

$parcel$export(module.exports, "TexturePool", () => $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2);

var $NbSCN = parcelRequire("NbSCN");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
let $0b9fa50ced13ccd0$var$count = 0;
class $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this.textureStyle = new (0, $aFPUT.TextureStyle)(this.textureOptions);
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */ createTexture(pixelWidth, pixelHeight, antialias) {
        const textureSource = new (0, $iA5fe.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: false
        });
        return new (0, $bLlTJ.Texture)({
            source: textureSource,
            label: `texturePool_${$0b9fa50ced13ccd0$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $NbSCN.nextPow2)(po2Width);
        po2Height = (0, $NbSCN.nextPow2)(po2Height);
        const key = (po2Width << 17) + (po2Height << 1) + (antialias ? 1 : 0);
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Place a render texture back into the pool. Optionally reset the style of the texture to the default texture style.
   * useful if you modified the style of the texture after getting it from the pool.
   * @param renderTexture - The renderTexture to free
   * @param resetStyle - Whether to reset the style of the texture to the default texture style
   */ returnTexture(renderTexture, resetStyle = false) {
        const key = this._poolKeyHash[renderTexture.uid];
        if (resetStyle) renderTexture.source.style = this.textureStyle;
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $0b9fa50ced13ccd0$export$686d8ddcd5ee6cd2 = new $0b9fa50ced13ccd0$export$f5c6a2d8ed21d1d();

});


parcelRegister("gIPW8", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $83c57e61d47d996f$export$59d0441a278e5935);
"use strict";
function $83c57e61d47d996f$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("jzlb7", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $cd1eadd0f2fb679c$export$12af48852c6ac574);

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");
"use strict";
const $cd1eadd0f2fb679c$var$tempBounds = new (0, $7wtv9.Bounds)();
function $cd1eadd0f2fb679c$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $cd1eadd0f2fb679c$var$tempBounds;
    mask.measurable = true;
    (0, $iskjc.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("4vXk0", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $6df4144b7f405909$export$7416ac774b1f1a33);

var $j68wk = parcelRequire("j68wk");

var $5tmC8 = parcelRequire("5tmC8");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $6df4144b7f405909$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $5tmC8.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $5tmC8.matrixPool).get().identity();
    const relativeMask = $6df4144b7f405909$var$getMatrixRelativeToParent(mask, localRoot, tempMatrix);
    (0, $j68wk.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $5tmC8.matrixPool).return(tempMatrix);
    (0, $5tmC8.boundsPool).return(boundsToMask);
}
function $6df4144b7f405909$var$getMatrixRelativeToParent(target, root, matrix) {
    if (!target) {
        (0, $hUCK4.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $6df4144b7f405909$var$getMatrixRelativeToParent(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});
parcelRegister("hUCK4", function(module, exports) {

$parcel$export(module.exports, "warn", () => $ffdcd240d931c2ea$export$c106dd0671a0fc2d);
"use strict";
let $ffdcd240d931c2ea$var$warnCount = 0;
const $ffdcd240d931c2ea$var$maxWarnings = 500;
function $ffdcd240d931c2ea$export$c106dd0671a0fc2d(...args) {
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) return;
    $ffdcd240d931c2ea$var$warnCount++;
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});



parcelRegister("lLQso", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $2625cf12b5a3b5e5$export$1e2a2c76374c2542);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $2625cf12b5a3b5e5$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$2625cf12b5a3b5e5$export$1e2a2c76374c2542.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("jXXId", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $e8890ea82735e7dd$export$abd85894695764cb);

var $i9BKe = parcelRequire("i9BKe");

var $eicwU = parcelRequire("eicwU");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $e8890ea82735e7dd$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $eicwU.Container);
    }
}
$e8890ea82735e7dd$export$abd85894695764cb.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("8xl7d", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $adfc96265c7ca69d$export$ca65ccf5708c6a0c);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $adfc96265c7ca69d$export$ca65ccf5708c6a0c extends (0, $iA5fe.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $iCGeI.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity && "style" in this.resource) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$adfc96265c7ca69d$export$ca65ccf5708c6a0c.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iCGeI", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $bfbe44ab70ab7a53$export$d988306fa84f7b44);

var $9OKiP = parcelRequire("9OKiP");
"use strict";
let $bfbe44ab70ab7a53$var$currentAdapter = (0, $9OKiP.BrowserAdapter);
const $bfbe44ab70ab7a53$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $bfbe44ab70ab7a53$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $bfbe44ab70ab7a53$var$currentAdapter = adapter;
    }
};

});
parcelRegister("9OKiP", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $ed1c5172c2eee607$export$e467cc3399500025);
"use strict";
const $ed1c5172c2eee607$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("aQPld", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $ac4c5539d7b1f960$export$280e9a68c3ffd919);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $ac4c5539d7b1f960$export$280e9a68c3ffd919 extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$ac4c5539d7b1f960$export$280e9a68c3ffd919.extension = (0, $i9BKe.ExtensionType).TextureSource;

});

parcelRegister("hNatJ", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $4dc351acd421ceef$export$f3a17123d80000c5);

var $i9BKe = parcelRequire("i9BKe");

var $4J7WL = parcelRequire("4J7WL");

var $7blVu = parcelRequire("7blVu");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
const $4dc351acd421ceef$var$_VideoSource = class _VideoSource extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $4J7WL.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $7blVu.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$4dc351acd421ceef$var$_VideoSource.extension = (0, $i9BKe.ExtensionType).TextureSource;
/** The default options for video sources. */ $4dc351acd421ceef$var$_VideoSource.defaultOptions = {
    ...(0, $iA5fe.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $4dc351acd421ceef$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $4dc351acd421ceef$export$f3a17123d80000c5 = $4dc351acd421ceef$var$_VideoSource;

});
parcelRegister("4J7WL", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $2bf8d15685054100$export$39c54bcc89dcee11);

var $cQMLP = parcelRequire("cQMLP");

var $bJH8Y = parcelRequire("bJH8Y");
"use strict";
const $2bf8d15685054100$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method {@link Ticker#start|start}
     * automatically when a listener is added.
     * @example
     * ```ts
     * // Default behavior (manual start)
     * const ticker = new Ticker();
     * ticker.autoStart = false;
     * ticker.add(() => {
     *     // Won't run until ticker.start() is called
     * });
     *
     * // Auto-start behavior
     * const autoTicker = new Ticker();
     * autoTicker.autoStart = true;
     * autoTicker.add(() => {
     *     // Runs immediately when added
     * });
     * ```
     * @default false
     * @see {@link Ticker#start} For manually starting the ticker
     * @see {@link Ticker#stop} For manually stopping the ticker
     */ this.autoStart = false;
        /**
     * Scalar time value from last frame to this frame.
     * Used for frame-based animations and updates.
     *
     * This value is capped by setting {@link Ticker#minFPS|minFPS}
     * and is scaled with {@link Ticker#speed|speed}.
     * > [!NOTE] The cap may be exceeded by scaling.
     * @example
     * ```ts
     * // Basic animation
     * ticker.add((ticker) => {
     *     // Rotate sprite by 0.1 radians per frame, scaled by deltaTime
     *     sprite.rotation += 0.1 * ticker.deltaTime;
     * });
     * ```
     */ this.deltaTime = 1;
        /**
     * The last time {@link Ticker#update|update} was invoked.
     * Used for calculating time deltas between frames.
     *
     * This value is also reset internally outside of invoking
     * update, but only when a new animation frame is requested.
     *
     * If the platform supports DOMHighResTimeStamp,
     * this value will have a precision of 1 µs.
     * @example
     * ```ts
     * // Basic timing check
     * ticker.add(() => {
     *     const timeSinceStart = performance.now() - ticker.lastTime;
     *     console.log(`Time running: ${timeSinceStart}ms`);
     * });
     * ```
     */ this.lastTime = -1;
        /**
     * Factor of current {@link Ticker#deltaTime|deltaTime}.
     * Used to scale time for slow motion or fast-forward effects.
     * @example
     * ```ts
     * // Basic speed adjustment
     * ticker.speed = 0.5; // Half speed (slow motion)
     * ticker.speed = 2.0; // Double speed (fast forward)
     *
     * // Temporary speed changes
     * function slowMotion() {
     *     const normalSpeed = ticker.speed;
     *     ticker.speed = 0.2;
     *     setTimeout(() => {
     *         ticker.speed = normalSpeed;
     *     }, 1000);
     * }
     * ```
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     *
     * `true` if {@link Ticker#start|start} has been called.
     * `false` if {@link Ticker#stop|Stop} has been called.
     *
     * While `false`, this value may change to `true` in the
     * event of {@link Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     * @example
     * ```ts
     * // Check ticker state
     * const ticker = new Ticker();
     * console.log(ticker.started); // false
     *
     * // Start and verify
     * ticker.start();
     * console.log(ticker.started); // true
     * ```
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $bJH8Y.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /** Conditionally cancels a pending animation frame. */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @example
   * ```ts
   * // Basic update handler
   * ticker.add((ticker) => {
   *     // Update every frame
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   * });
   *
   * // With specific context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   *
   * // With priority
   * ticker.add(
   *     (ticker) => {
   *         // Runs before normal priority updates
   *         physics.update(ticker.deltaTime);
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#addOnce} For one-time handlers
   * @see {@link Ticker#remove} For removing handlers
   */ add(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */ addOnce(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on minFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on maxFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frame rate in frames per millisecond.
 * Used for converting deltaTime to a scalar time delta.
 * @example
 * ```ts
 * // Default is 0.06 (60 FPS)
 * console.log(Ticker.targetFPMS); // 0.06
 *
 * // Calculate target frame duration
 * const frameDuration = 1 / Ticker.targetFPMS; // ≈ 16.67ms
 *
 * // Use in custom timing calculations
 * const deltaTime = elapsedMS * Ticker.targetFPMS;
 * ```
 * @remarks
 * - Default is 0.06 (equivalent to 60 FPS)
 * - Used in deltaTime calculations
 * - Affects all ticker instances
 * @default 0.06
 * @see {@link Ticker#deltaTime} For time scaling
 * @see {@link Ticker#FPS} For actual frame rate
 */ $2bf8d15685054100$var$_Ticker.targetFPMS = 0.06;
let $2bf8d15685054100$export$39c54bcc89dcee11 = $2bf8d15685054100$var$_Ticker;

});
parcelRegister("cQMLP", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $d091949369ecd400$export$688aaf132ba9b379);
"use strict";
var $d091949369ecd400$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($d091949369ecd400$export$688aaf132ba9b379 || {});

});

parcelRegister("bJH8Y", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $44ffb68c45a667a2$export$579021a5759a260f);
"use strict";
class $44ffb68c45a667a2$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("7blVu", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $1603b82fc2121ba0$export$8df68d58aae31877);
"use strict";
let $1603b82fc2121ba0$var$promise;
async function $1603b82fc2121ba0$export$8df68d58aae31877() {
    $1603b82fc2121ba0$var$promise ?? ($1603b82fc2121ba0$var$promise = (async ()=>{
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $1603b82fc2121ba0$var$promise;
}

});


parcelRegister("8QN7n", function(module, exports) {

var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $da9f248d33f9f2f1$var$sources = [];
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).TextureSource, $da9f248d33f9f2f1$var$sources);
function $da9f248d33f9f2f1$export$688bcf31fbf7eb15(options = {}) {
    return $da9f248d33f9f2f1$var$textureSourceFrom(options);
}
function $da9f248d33f9f2f1$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $da9f248d33f9f2f1$var$sources.length; i++){
        const Source = $da9f248d33f9f2f1$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $da9f248d33f9f2f1$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $2IhKp.Cache).has(resource)) return (0, $2IhKp.Cache).get(resource);
    const texture = new (0, $bLlTJ.Texture)({
        source: $da9f248d33f9f2f1$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $2IhKp.Cache).has(resource)) (0, $2IhKp.Cache).remove(resource);
    });
    if (!skipCache) (0, $2IhKp.Cache).set(resource, texture);
    return texture;
}
function $da9f248d33f9f2f1$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $2IhKp.Cache).get(id);
    else if (id instanceof (0, $iA5fe.TextureSource)) return new (0, $bLlTJ.Texture)({
        source: id
    });
    return $da9f248d33f9f2f1$export$3b748ed6327ec85b(id, skipCache);
}
(0, $bLlTJ.Texture).from = $da9f248d33f9f2f1$export$4266177d9730bb1;
(0, $iA5fe.TextureSource).from = $da9f248d33f9f2f1$var$textureSourceFrom;

});
parcelRegister("2IhKp", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3d19110becfaeec3$export$94affb487e701bf2);

var $hUCK4 = parcelRequire("hUCK4");

var $3CHiv = parcelRequire("3CHiv");
"use strict";
class $3d19110becfaeec3$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $3CHiv.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $hUCK4.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /**
   * All loader parsers registered
   * @advanced
   */ get parsers() {
        return this._parsers;
    }
}
const $3d19110becfaeec3$export$94affb487e701bf2 = new $3d19110becfaeec3$var$CacheClass();

});
parcelRegister("3CHiv", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $93954259b3f62d4e$export$b01be8e180bf3d9b);
"use strict";
const $93954259b3f62d4e$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("4RJM2", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $8PDkK = parcelRequire("8PDkK");
"use strict";
(0, $i9BKe.extensions).add((0, $8PDkK.spritesheetAsset));

});
parcelRegister("8PDkK", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $a322641177c54ad8$export$46dcda4f1cdd80fe);

var $iEtN5 = parcelRequire("iEtN5");

var $8kCsw = parcelRequire("8kCsw");

var $5Oad7 = parcelRequire("5Oad7");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");

var $lzfZe = parcelRequire("lzfZe");

var $58WFl = parcelRequire("58WFl");
"use strict";
const $a322641177c54ad8$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $a322641177c54ad8$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $lzfZe.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $a322641177c54ad8$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $a322641177c54ad8$export$46dcda4f1cdd80fe = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $58WFl.Spritesheet),
        getCacheableAssets: (keys, asset)=>$a322641177c54ad8$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $i9BKe.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $a322641177c54ad8$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $lzfZe.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, textureOptions: // if user need to use custom filename (not from jsonFile.meta.image)
            textureOptions, cachePrefix: // if user need to set texture options on texture
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $lzfZe.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $bLlTJ.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $5Oad7.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    {
                        src: imagePath,
                        data: textureOptions
                    }
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $58WFl.Spritesheet)({
                texture: texture.source,
                data: asset,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $5Oad7.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            textureOptions: textureOptions,
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("iEtN5", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $29ed14ceb032dea6$export$820ed6348c4f2750);
"use strict";
var $29ed14ceb032dea6$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($29ed14ceb032dea6$export$820ed6348c4f2750 || {});

});

parcelRegister("8kCsw", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $23cc1cafdfe05125$export$8b4c839865b08288);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $8F3vm = parcelRequire("8F3vm");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $23cc1cafdfe05125$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $3CHiv.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $hUCK4.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $hUCK4.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $3CHiv.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: loadParser } = asset;
            const srcsToUse = (0, $3CHiv.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $8F3vm.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        loadParser = src2.loadParser ?? loadParser;
                        formattedAsset = {
                            ...formattedAsset,
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: loadParser
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $4DmkB.isSingleItem)(bundleIds);
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $4DmkB.isSingleItem)(keys);
        keys = (0, $3CHiv.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[i];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $lzfZe.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.format = format ?? formattedAsset.format ?? $23cc1cafdfe05125$export$4bb0ea38086a2ed5(formattedAsset.src);
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $23cc1cafdfe05125$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $23cc1cafdfe05125$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("lzfZe", function(module, exports) {

$parcel$export(module.exports, "path", () => $3c67d20d89e3898c$export$bb654e07daaf8c3a);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
function $3c67d20d89e3898c$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $3c67d20d89e3898c$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $3c67d20d89e3898c$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $3c67d20d89e3898c$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($3c67d20d89e3898c$var$escapeRegExp(find), "g"), replace);
}
function $3c67d20d89e3898c$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $3c67d20d89e3898c$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */ toPosix (path2) {
        return $3c67d20d89e3898c$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ getProtocol (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $3c67d20d89e3898c$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $iCGeI.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $3c67d20d89e3898c$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */ normalize (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $3c67d20d89e3898c$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ isAbsolute (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $3c67d20d89e3898c$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */ dirname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ rootname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */ basename (path2, ext) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (ext) $3c67d20d89e3898c$var$assertPath(ext);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */ extname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */ parse (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("8F3vm", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $fde1bf5bcf60c2d9$export$738117acc6638004);
"use strict";
function $fde1bf5bcf60c2d9$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $fde1bf5bcf60c2d9$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $fde1bf5bcf60c2d9$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $fde1bf5bcf60c2d9$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("4DmkB", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $f373b2ad881b3255$export$16a80d27953452d4);
"use strict";
const $f373b2ad881b3255$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("5Oad7", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $273b4a26d8a43536$export$f57b97ef8be10dda);
"use strict";
const $273b4a26d8a43536$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("58WFl", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $9c38ec259f91df14$export$674d2eb4debbef0c);

var $fM4Mk = parcelRequire("fM4Mk");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $9c38ec259f91df14$var$_Spritesheet = class _Spritesheet {
    /** @ignore */ constructor(optionsOrTexture, arg1){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        let options = optionsOrTexture;
        if (optionsOrTexture?.source instanceof (0, $iA5fe.TextureSource)) options = {
            texture: optionsOrTexture,
            data: arg1
        };
        const { texture: texture, data: data, cachePrefix: cachePrefix = "" } = options;
        this.cachePrefix = cachePrefix;
        this._texture = texture instanceof (0, $bLlTJ.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $fM4Mk.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $fM4Mk.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $bLlTJ.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/**
 * The maximum number of Textures to build per process.
 * @advanced
 */ $9c38ec259f91df14$var$_Spritesheet.BATCH_SIZE = 1e3;
let $9c38ec259f91df14$export$674d2eb4debbef0c = $9c38ec259f91df14$var$_Spritesheet;

});



parcelRegister("bja9j", function(module, exports) {

$parcel$export(module.exports, "Application", () => $2202931bfc9ee5c9$export$16975c34e60e1e61);

var $i9BKe = parcelRequire("i9BKe");

var $lmtTM = parcelRequire("lmtTM");

var $eicwU = parcelRequire("eicwU");

var $gVtOu = parcelRequire("gVtOu");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $2202931bfc9ee5c9$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $eicwU.Container)();
        if (args[0] !== void 0) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $lmtTM.autoDetectRenderer)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $2202931bfc9ee5c9$var$_Application._plugins = [];
let $2202931bfc9ee5c9$export$16975c34e60e1e61 = $2202931bfc9ee5c9$var$_Application;
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).Application, $2202931bfc9ee5c9$export$16975c34e60e1e61._plugins);
(0, $i9BKe.extensions).add((0, $gVtOu.ApplicationInitHook));

});
parcelRegister("lmtTM", function(module, exports) {

$parcel$export(module.exports, "autoDetectRenderer", () => $bf7ca24d384e2f55$export$3583b92ab8150eb6);

var $jknZI = parcelRequire("jknZI");

var $3MeAf = parcelRequire("3MeAf");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
const $bf7ca24d384e2f55$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $bf7ca24d384e2f55$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $bf7ca24d384e2f55$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $bf7ca24d384e2f55$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $3MeAf.isWebGPUSupported)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("d7l7p"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $jknZI.isWebGLSupported)(options.failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("5jFkb"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}

});
parcelRegister("jknZI", function(module, exports) {

$parcel$export(module.exports, "isWebGLSupported", () => $21de405eafa0c0bb$export$83dc396b76015322);

var $iCGeI = parcelRequire("iCGeI");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
let $21de405eafa0c0bb$var$_isWebGLSupported;
function $21de405eafa0c0bb$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($21de405eafa0c0bb$var$_isWebGLSupported !== void 0) return $21de405eafa0c0bb$var$_isWebGLSupported;
    $21de405eafa0c0bb$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $iCGeI.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $21de405eafa0c0bb$var$_isWebGLSupported;
}

});
parcelRegister("3UUq4", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $453fded98f054a94$export$58ab3ed211eed562);

var $a2eTA = parcelRequire("a2eTA");

var $aEImn = parcelRequire("aEImn");

var $eicwU = parcelRequire("eicwU");

var $cJHPn = parcelRequire("cJHPn");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");


var $hFYOq = parcelRequire("hFYOq");

var $gtbjr = parcelRequire("gtbjr");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $453fded98f054a94$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $453fded98f054a94$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** @internal */ this.uid = (0, $aGJhg.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$453fded98f054a94$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $aEImn.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $eicwU.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $a2eTA.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $hFYOq.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $a2eTA.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $a2eTA.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $gtbjr.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $cJHPn.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $453fded98f054a94$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $453fded98f054a94$export$58ab3ed211eed562 = $453fded98f054a94$var$_AbstractRenderer;

});
parcelRegister("aEImn", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $326e7279631cea1a$export$3b30260a318c769f);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $326e7279631cea1a$var$environments = [];
(0, $i9BKe.extensions).handleByNamedList((0, $i9BKe.ExtensionType).Environment, $326e7279631cea1a$var$environments);
async function $326e7279631cea1a$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $326e7279631cea1a$var$environments.length; i++){
        const env = $326e7279631cea1a$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $326e7279631cea1a$export$72225172dd907279(add) {
    return $326e7279631cea1a$export$3b30260a318c769f(!add);
}

});

parcelRegister("cJHPn", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $d88536e9c61409d6$export$70c0711f29adc5cf);
"use strict";
let $d88536e9c61409d6$var$unsafeEval;
function $d88536e9c61409d6$export$70c0711f29adc5cf() {
    if (typeof $d88536e9c61409d6$var$unsafeEval === "boolean") return $d88536e9c61409d6$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $d88536e9c61409d6$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $d88536e9c61409d6$var$unsafeEval = false;
    }
    return $d88536e9c61409d6$var$unsafeEval;
}

});

parcelRegister("hFYOq", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $bdcaad22b468ed1b$export$6c4d37c7f376a1de);
"use strict";
var $bdcaad22b468ed1b$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($bdcaad22b468ed1b$export$6c4d37c7f376a1de || {});

});

parcelRegister("gtbjr", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $299af1a7d2dd4105$export$ff5f2fe687fe3979);
"use strict";
class $299af1a7d2dd4105$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});



parcelRegister("3MeAf", function(module, exports) {

$parcel$export(module.exports, "isWebGPUSupported", () => $7cb4832c2de4c977$export$216169f30082c873);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $7cb4832c2de4c977$var$_isWebGPUSupported;
async function $7cb4832c2de4c977$export$216169f30082c873(options = {}) {
    if ($7cb4832c2de4c977$var$_isWebGPUSupported !== void 0) return $7cb4832c2de4c977$var$_isWebGPUSupported;
    $7cb4832c2de4c977$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $iCGeI.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $7cb4832c2de4c977$var$_isWebGPUSupported;
}

});

parcelRegister("d7l7p", function(module, exports) {
module.exports = Promise.all([
    import("4Zt2U"),
    import("aNM0B")
]).then(()=>parcelRequire('aIpib'));

});

parcelRegister("5jFkb", function(module, exports) {
module.exports = Promise.all([
    import("4Zt2U"),
    import("7EYKF")
]).then(()=>parcelRequire('kpxDv'));

});


parcelRegister("gVtOu", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $eaa9a2f5d114568e$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $eaa9a2f5d114568e$export$5fba6e443d2fb64);

var $i9BKe = parcelRequire("i9BKe");

var $7hfrt = parcelRequire("7hfrt");
"use strict";
class $eaa9a2f5d114568e$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $7hfrt.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $eaa9a2f5d114568e$export$918f3e4d2b801859.extension = (0, $i9BKe.ExtensionType).Application;
class $eaa9a2f5d114568e$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $7hfrt.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $eaa9a2f5d114568e$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("7hfrt", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $6c3dc1ec0fb181c1$export$a4ad2735b021c132);

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $6c3dc1ec0fb181c1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $6c3dc1ec0fb181c1$export$a4ad2735b021c132 = "8.10.2";

});



parcelRegister("9gqyK", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $09184df3be98be8e$export$ec91da630f36d5ea);

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $5iDyo = parcelRequire("5iDyo");

var $2Aebl = parcelRequire("2Aebl");
"use strict";
const $09184df3be98be8e$var$_Filter = class _Filter extends (0, $5iDyo.Shader) {
    /**
   * @param options - The optional parameters of this filter.
   */ constructor(options){
        options = {
            ..._Filter.defaultOptions,
            ...options
        };
        super(options);
        /** If enabled is true the filter is applied, if false it will not. */ this.enabled = true;
        /**
     * The gpu state the filter requires to render.
     * @internal
     */ this._state = (0, $2Aebl.State).for2d();
        this.blendMode = options.blendMode;
        this.padding = options.padding;
        if (typeof options.antialias === "boolean") this.antialias = options.antialias ? "on" : "off";
        else this.antialias = options.antialias;
        this.resolution = options.resolution;
        this.blendRequired = options.blendRequired;
        this.clipToViewport = options.clipToViewport;
        this.addResource("uTexture", 0, 1);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ apply(filterManager, input, output, clearMode) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Get the blend mode of the filter.
   * @default "normal"
   */ get blendMode() {
        return this._state.blendMode;
    }
    /** Sets the blend mode of the filter. */ set blendMode(value) {
        this._state.blendMode = value;
    }
    /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */ static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $6j7wq.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $fK92B.GlProgram).from(gl);
        return new _Filter({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
};
/** The default filter settings */ $09184df3be98be8e$var$_Filter.defaultOptions = {
    blendMode: "normal",
    resolution: 1,
    padding: 0,
    antialias: "off",
    blendRequired: false,
    clipToViewport: true
};
let $09184df3be98be8e$export$ec91da630f36d5ea = $09184df3be98be8e$var$_Filter;

});
parcelRegister("fK92B", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $5a1cd4acf4c2252d$export$64881d9ea0a969d7);

var $9kWs1 = parcelRequire("9kWs1");

var $c1vp1 = parcelRequire("c1vp1");

var $iCp49 = parcelRequire("iCp49");

var $67Nsh = parcelRequire("67Nsh");

var $3Hbxe = parcelRequire("3Hbxe");

var $aUAMu = parcelRequire("aUAMu");

var $500fb = parcelRequire("500fb");
"use strict";
const $5a1cd4acf4c2252d$var$processes = {
    stripVersion: // strips any version headers..
    $500fb.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $67Nsh.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $iCp49.addProgramDefines,
    setProgramName: // add the program name to the shader
    $aUAMu.setProgramName,
    insertVersion: // add the version string to the shader header
    $3Hbxe.insertVersion
};
const $5a1cd4acf4c2252d$var$programCache = /* @__PURE__ */ Object.create(null);
const $5a1cd4acf4c2252d$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $c1vp1.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($5a1cd4acf4c2252d$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $5a1cd4acf4c2252d$var$processes[processKey](fragment, processOptions, true);
            vertex = $5a1cd4acf4c2252d$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this.transformFeedbackVaryings = options.transformFeedbackVaryings;
        this._key = (0, $9kWs1.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$5a1cd4acf4c2252d$var$programCache[key]) $5a1cd4acf4c2252d$var$programCache[key] = new _GlProgram(options);
        return $5a1cd4acf4c2252d$var$programCache[key];
    }
};
/** The default options used by the program. */ $5a1cd4acf4c2252d$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $5a1cd4acf4c2252d$export$64881d9ea0a969d7 = $5a1cd4acf4c2252d$var$_GlProgram;

});
parcelRegister("9kWs1", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $0601e88d616c38d4$export$1e452c36dfe36a93);
"use strict";
const $0601e88d616c38d4$var$idCounts = /* @__PURE__ */ Object.create(null);
const $0601e88d616c38d4$var$idHash = /* @__PURE__ */ Object.create(null);
function $0601e88d616c38d4$export$1e452c36dfe36a93(value, groupId) {
    let id = $0601e88d616c38d4$var$idHash[value];
    if (id === void 0) {
        if ($0601e88d616c38d4$var$idCounts[groupId] === void 0) $0601e88d616c38d4$var$idCounts[groupId] = 1;
        $0601e88d616c38d4$var$idHash[value] = id = $0601e88d616c38d4$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("c1vp1", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $e905b7e6e5b75a20$export$428c38e64838140);

var $ckKKH = parcelRequire("ckKKH");
"use strict";
let $e905b7e6e5b75a20$var$maxFragmentPrecision;
function $e905b7e6e5b75a20$export$428c38e64838140() {
    if (!$e905b7e6e5b75a20$var$maxFragmentPrecision) {
        $e905b7e6e5b75a20$var$maxFragmentPrecision = "mediump";
        const gl = (0, $ckKKH.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $e905b7e6e5b75a20$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $e905b7e6e5b75a20$var$maxFragmentPrecision;
}

});
parcelRegister("ckKKH", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $a517f2c0dcfb1c3f$export$f034b2d55f8df08b);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $a517f2c0dcfb1c3f$var$context;
function $a517f2c0dcfb1c3f$export$f034b2d55f8df08b() {
    if (!$a517f2c0dcfb1c3f$var$context || $a517f2c0dcfb1c3f$var$context?.isContextLost()) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        $a517f2c0dcfb1c3f$var$context = canvas.getContext("webgl", {});
    }
    return $a517f2c0dcfb1c3f$var$context;
}

});


parcelRegister("iCp49", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $ab141df14b998d07$export$fba00ea8bc676dd1);
"use strict";
function $ab141df14b998d07$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("67Nsh", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $bda6ccefc0c5ab42$export$899bdffb1b617f8b);
"use strict";
function $bda6ccefc0c5ab42$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("3Hbxe", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $82be6e3df1c54b73$export$df5409633d2e06a0);
"use strict";
function $82be6e3df1c54b73$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("aUAMu", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $de2ea14e21161fdc$export$fcd35f5a80d5e29b);
"use strict";
const $de2ea14e21161fdc$var$fragmentNameCache = {};
const $de2ea14e21161fdc$var$VertexNameCache = {};
function $de2ea14e21161fdc$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $de2ea14e21161fdc$var$fragmentNameCache : $de2ea14e21161fdc$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("500fb", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $d98e8e318b45168f$export$f71406e7a553e9e5);
"use strict";
function $d98e8e318b45168f$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("6j7wq", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $8e9bc14aafd75f61$export$b7a31a3cdd61870);

var $9kWs1 = parcelRequire("9kWs1");

var $7j3L3 = parcelRequire("7j3L3");

var $ceyhm = parcelRequire("ceyhm");

var $eebg6 = parcelRequire("eebg6");

var $gwiyt = parcelRequire("gwiyt");

var $ftyd4 = parcelRequire("ftyd4");
"use strict";
const $8e9bc14aafd75f61$var$programCache = /* @__PURE__ */ Object.create(null);
class $8e9bc14aafd75f61$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /** @internal */ this._layoutKey = 0;
        /** @internal */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $ftyd4.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $gwiyt.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $eebg6.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $9kWs1.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $7j3L3.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$8e9bc14aafd75f61$var$programCache[key]) $8e9bc14aafd75f61$var$programCache[key] = new $8e9bc14aafd75f61$export$b7a31a3cdd61870(options);
        return $8e9bc14aafd75f61$var$programCache[key];
    }
}

});
parcelRegister("7j3L3", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $a83de38b8d80c92b$export$b0efe5f01c53f69f);

var $kavUV = parcelRequire("kavUV");
"use strict";
const $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
function $a83de38b8d80c92b$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const mainVertStart = source.indexOf(`fn ${entryPoint}`);
    if (mainVertStart !== -1) {
        const arrowFunctionStart = source.indexOf("->", mainVertStart);
        if (arrowFunctionStart !== -1) {
            const functionArgsSubstring = source.substring(mainVertStart, arrowFunctionStart);
            const inputsRegex = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
            let match;
            while((match = inputsRegex.exec(functionArgsSubstring)) !== null){
                const format = $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
                results[match[2]] = {
                    location: parseInt(match[1], 10),
                    format: format,
                    stride: (0, $kavUV.getAttributeInfoFromFormat)(format).stride,
                    offset: 0,
                    instance: false,
                    start: 0
                };
            }
        }
    }
    return results;
}

});
parcelRegister("kavUV", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $b94249370f97e371$export$4da509c30cc6be33);
"use strict";
const $b94249370f97e371$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $b94249370f97e371$export$4da509c30cc6be33(format) {
    return $b94249370f97e371$var$attributeFormatData[format] ?? $b94249370f97e371$var$attributeFormatData.float32;
}

});


parcelRegister("ceyhm", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $ea3e5b1ac2f96ec2$export$368e99a200562975);
"use strict";
function $ea3e5b1ac2f96ec2$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*(\w+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>group.type === name)) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("eebg6", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $6d1e03a3e3cda982$export$950011c0dc347495);

var $aR3rf = parcelRequire("aR3rf");
"use strict";
function $6d1e03a3e3cda982$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).VERTEX | (0, $aR3rf.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
    }
    return layout;
}

});
parcelRegister("aR3rf", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $06e6106f9171a2e8$export$34a0cafc5a97ef31);
"use strict";
var $06e6106f9171a2e8$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($06e6106f9171a2e8$export$34a0cafc5a97ef31 || {});

});


parcelRegister("gwiyt", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $292f21f6c3cd9e17$export$6a0f9650f9d4f875);
"use strict";
function $292f21f6c3cd9e17$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("ftyd4", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $f605447e20cc6f1a$export$5f344e20ddfaa2d6);
"use strict";
function $f605447e20cc6f1a$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("5iDyo", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $26072a826565afe8$export$462bb059fed9d9e5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $fK92B = parcelRequire("fK92B");

var $awcfo = parcelRequire("awcfo");

var $6j7wq = parcelRequire("6j7wq");

var $2bK9z = parcelRequire("2bK9z");

var $cryyq = parcelRequire("cryyq");
"use strict";
class $26072a826565afe8$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options){
        super();
        /** A unique identifier for the shader */ this.uid = (0, $aGJhg.uid)("shader");
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $awcfo.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $cryyq.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $awcfo.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $awcfo.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $6j7wq.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $fK92B.GlProgram).from(gl);
        return new $26072a826565afe8$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("awcfo", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $6cadf620a92ebba7$export$6f452ee382def63c);
"use strict";
class $6cadf620a92ebba7$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   */ _touch(tick) {
        const resources = this.resources;
        for(const i in resources)resources[i]._touched = tick;
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) {
            const resources = this.resources;
            for(const i in resources)if (resources[i] === resource) resources[i] = null;
        } else this._updateKey();
    }
}

});

parcelRegister("2bK9z", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $d9ac1633e306ebfe$export$2ca8315eebe81c3d);
"use strict";
var $d9ac1633e306ebfe$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($d9ac1633e306ebfe$export$2ca8315eebe81c3d || {});

});

parcelRegister("cryyq", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5);

var $aGJhg = parcelRequire("aGJhg");

var $9kWs1 = parcelRequire("9kWs1");

var $jhfqN = parcelRequire("jhfqN");

var $ezKtQ = parcelRequire("ezKtQ");
"use strict";
const $9136c1ea7e89e2b5$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("uniform");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "uniformGroup";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $jhfqN.UNIFORM_TYPES_MAP)[uniformData.type]) throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $jhfqN.UNIFORM_TYPES_VALUES).join(", ")}`);
            uniformData.value ?? (uniformData.value = (0, $ezKtQ.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $9kWs1.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $9136c1ea7e89e2b5$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5 = $9136c1ea7e89e2b5$var$_UniformGroup;

});
parcelRegister("jhfqN", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $d4900ea566bb062d$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $d4900ea566bb062d$export$97ddd6675231876e);
"use strict";
const $d4900ea566bb062d$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>",
    "vec2<i32>",
    "vec3<i32>",
    "vec4<i32>"
];
const $d4900ea566bb062d$export$97ddd6675231876e = $d4900ea566bb062d$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("ezKtQ", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $aa11a20cb06f2781$export$7febdb6905805c3d);
"use strict";
function $aa11a20cb06f2781$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("2Aebl", function(module, exports) {

$parcel$export(module.exports, "State", () => $f68a91b4254cec58$export$7254cc27399e90bd);
"use strict";
const $f68a91b4254cec58$var$blendModeIds = {
    normal: 0,
    add: 1,
    multiply: 2,
    screen: 3,
    overlay: 4,
    erase: 5,
    "normal-npm": 6,
    "add-npm": 7,
    "screen-npm": 8,
    min: 9,
    max: 10
};
const $f68a91b4254cec58$var$BLEND = 0;
const $f68a91b4254cec58$var$OFFSET = 1;
const $f68a91b4254cec58$var$CULLING = 2;
const $f68a91b4254cec58$var$DEPTH_TEST = 3;
const $f68a91b4254cec58$var$WINDING = 4;
const $f68a91b4254cec58$var$DEPTH_MASK = 5;
const $f68a91b4254cec58$var$_State = class _State {
    constructor(){
        this.data = 0;
        this.blendMode = "normal";
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$BLEND) !== value) this.data ^= 1 << $f68a91b4254cec58$var$BLEND;
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$OFFSET) !== value) this.data ^= 1 << $f68a91b4254cec58$var$OFFSET;
    }
    /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */ set cullMode(value) {
        if (value === "none") {
            this.culling = false;
            return;
        }
        this.culling = true;
        this.clockwiseFrontFace = value === "front";
    }
    get cullMode() {
        if (!this.culling) return "none";
        return this.clockwiseFrontFace ? "front" : "back";
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$CULLING) !== value) this.data ^= 1 << $f68a91b4254cec58$var$CULLING;
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_TEST) !== value) this.data ^= 1 << $f68a91b4254cec58$var$DEPTH_TEST;
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$DEPTH_MASK) !== value) this.data ^= 1 << $f68a91b4254cec58$var$DEPTH_MASK;
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $f68a91b4254cec58$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $f68a91b4254cec58$var$WINDING) !== value) this.data ^= 1 << $f68a91b4254cec58$var$WINDING;
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== "none";
        this._blendMode = value;
        this._blendModeId = $f68a91b4254cec58$var$blendModeIds[value] || 0;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */ static for2d() {
        const state = new _State();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
};
$f68a91b4254cec58$var$_State.default2d = $f68a91b4254cec58$var$_State.for2d();
let $f68a91b4254cec58$export$7254cc27399e90bd = $f68a91b4254cec58$var$_State;

});


parcelRegister("3cebA", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $1b5e4ef3a1ed4a4a$export$29d3e417456abdad);

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");

var $8aC7P = parcelRequire("8aC7P");
"use strict";
class $1b5e4ef3a1ed4a4a$export$29d3e417456abdad extends (0, $b9FQU.ViewContainer) {
    /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $8aC7P.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        /** @internal */ this.renderPipeId = "graphics";
        if (!context) this._context = this._ownedContext = new (0, $8aC7P.GraphicsContext)();
        else this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.didViewUpdate = true;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        this._context.off("update", this.onViewUpdate, this);
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */ get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */ updateBounds() {}
    /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */ clone(deep = false) {
        if (deep) return new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        if (color !== void 0) fillStyle.color = color;
        if (alpha !== void 0) fillStyle.alpha = alpha;
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});
parcelRegister("8aC7P", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $5d1287b36eb70f7f$export$cde35afe8b5f985);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $1HooC = parcelRequire("1HooC");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $7wtv9 = parcelRequire("7wtv9");

var $c9xxq = parcelRequire("c9xxq");

var $6ph3G = parcelRequire("6ph3G");

var $6mQKv = parcelRequire("6mQKv");
"use strict";
const $5d1287b36eb70f7f$var$tmpPoint = new (0, $1HooC.Point)();
const $5d1287b36eb70f7f$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $5d1287b36eb70f7f$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /**
     * unique id for this graphics context
     * @internal
     */ this.uid = (0, $aGJhg.uid)("graphicsContext");
        /** @internal */ this.dirty = true;
        /** The batch mode for this graphics context. It can be 'auto', 'batch', or 'no-batch'. */ this.batchMode = "auto";
        /** @internal */ this.instructions = [];
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        this._transform = new (0, $eY4rt.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $6mQKv.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint ? (0, $a2eTA.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $1HooC.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $6mQKv.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $6ph3G.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $5d1287b36eb70f7f$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($5d1287b36eb70f7f$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
        this._boundsDirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const alignment = data.style.alignment;
                const outerPadding = data.style.width * (1 - alignment);
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - outerPadding, _bounds.minY - outerPadding, _bounds.maxX + outerPadding, _bounds.maxY + outerPadding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $5d1287b36eb70f7f$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else {
                    const strokeStyle = style;
                    hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
                }
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        this._stateStack.length = 0;
        this._transform = null;
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local"
};
/** The default stroke style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local",
    /** If the stroke is a pixel line. */ pixelLine: false
};
let $5d1287b36eb70f7f$export$cde35afe8b5f985 = $5d1287b36eb70f7f$var$_GraphicsContext;

});
parcelRegister("c9xxq", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $0663b1de1906f348$export$7e54506375634c19);

var $1HooC = parcelRequire("1HooC");

var $aGJhg = parcelRequire("aGJhg");

var $hUCK4 = parcelRequire("hUCK4");

var $b2eG6 = parcelRequire("b2eG6");

var $ein11 = parcelRequire("ein11");
"use strict";
class $0663b1de1906f348$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */ constructor(instructions, signed = false){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $aGJhg.uid)("graphicsPath");
        this._dirty = true;
        this.checkForHoles = signed;
        if (typeof instructions === "string") (0, $b2eG6.parseSVGPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $ein11.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius || (innerRadius = radius / 2);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $0663b1de1906f348$export$7e54506375634c19();
        newGraphicsPath2D.checkForHoles = this.checkForHoles;
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $0663b1de1906f348$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $0663b1de1906f348$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $0663b1de1906f348$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $hUCK4.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $0663b1de1906f348$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("b2eG6", function(module, exports) {

$parcel$export(module.exports, "parseSVGPath", () => $aa8e6738d1d86e9a$export$33813e954ab16e32);

var $8DJYa = parcelRequire("8DJYa");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $aa8e6738d1d86e9a$export$33813e954ab16e32(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($8DJYa)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], // First control point
                data[3], data[4], // Second control point
                lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], // First control point
                lastX + data[3], lastY + data[4], // Second control point
                lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "Z":
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $hUCK4.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("8DJYa", function(module, exports) {
module.exports = $64a59fcc91535eb3$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $64a59fcc91535eb3$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $64a59fcc91535eb3$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $64a59fcc91535eb3$var$parse(path) {
    var data = [];
    path.replace($64a59fcc91535eb3$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $64a59fcc91535eb3$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $64a59fcc91535eb3$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $64a59fcc91535eb3$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $64a59fcc91535eb3$var$length[type])));
        }
    });
    return data;
}
var $64a59fcc91535eb3$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $64a59fcc91535eb3$var$parseValues(args) {
    var numbers = args.match($64a59fcc91535eb3$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("ein11", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $664ff60a6792361f$export$148534a3c727230b);

var $h7nJT = parcelRequire("h7nJT");

var $9hswb = parcelRequire("9hswb");

var $hbpIN = parcelRequire("hbpIN");

var $fM4Mk = parcelRequire("fM4Mk");

var $7u40a = parcelRequire("7u40a");

var $7wtv9 = parcelRequire("7wtv9");

var $lI2iN = parcelRequire("lI2iN");

var $eRV6E = parcelRequire("eRV6E");

var $aiLPr = parcelRequire("aiLPr");

var $boMdH = parcelRequire("boMdH");

var $jjbCG = parcelRequire("jjbCG");

var $9ad7k = parcelRequire("9ad7k");
"use strict";
const $664ff60a6792361f$var$tempRectangle = new (0, $fM4Mk.Rectangle)();
class $664ff60a6792361f$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
        this.signed = graphicsPath2D.checkForHoles;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $aiLPr.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $boMdH.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $jjbCG.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $lI2iN.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $eRV6E.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        const shapePrimitives = this.shapePrimitives;
        const start = shapePrimitives.length;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        if (path.checkForHoles && shapePrimitives.length - start > 1) {
            let mainShape = null;
            for(let i = start; i < shapePrimitives.length; i++){
                const shapePrimitive = shapePrimitives[i];
                if (shapePrimitive.shape.type === "polygon") {
                    const polygon = shapePrimitive.shape;
                    const mainPolygon = mainShape?.shape;
                    if (mainPolygon && mainPolygon.containsPolygon(polygon)) {
                        mainShape.holes || (mainShape.holes = []);
                        mainShape.holes.push(shapePrimitive);
                        shapePrimitives.copyWithin(i, i + 1);
                        shapePrimitives.length--;
                        i--;
                    } else mainShape = shapePrimitive;
                }
            }
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $fM4Mk.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $h7nJT.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $hbpIN.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = startAngle - i * delta;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $9ad7k.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $9ad7k.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $9hswb.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $7u40a.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $hbpIN.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $hbpIN.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($664ff60a6792361f$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("h7nJT", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f9e7c5f8c3846477$export$c89a927ffc67e6fa);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $f9e7c5f8c3846477$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks.
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Circle(0, 0, 50);
     * console.log(shape.type); // 'circle'
     *
     * // Use in type guards
     * if (shape.type === 'circle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @remarks
     * - Used for shape type checking
     * - More efficient than instanceof
     * - Read-only property
     * @readonly
     * @default 'circle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     * @see {@link ShapePrimitive} For shape interface
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */ clone() {
        return new $f9e7c5f8c3846477$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, width, alignment = 0.5) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const radius = this.radius;
        const outerWidth = (1 - alignment) * width;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("9hswb", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $985c1ca392a56bd1$export$80b0269ab108fa11);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $985c1ca392a56bd1$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Ellipse(0, 0, 50, 25);
     * console.log(shape.type); // 'ellipse'
     *
     * // Use in type guards
     * if (shape.type === 'ellipse') {
     *     console.log(shape.halfWidth, shape.halfHeight);
     * }
     * ```
     * @readonly
     * @default 'ellipse'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */ clone() {
        return new $985c1ca392a56bd1$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const strokeOuterWidth = strokeWidth * (1 - alignment);
        const strokeInnerWidth = strokeWidth - strokeOuterWidth;
        const innerHorizontal = halfWidth - strokeInnerWidth;
        const innerVertical = halfHeight - strokeInnerWidth;
        const outerHorizontal = halfWidth + strokeOuterWidth;
        const outerVertical = halfHeight + strokeOuterWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
        const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("hbpIN", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $11dc5aebdc9b56ee$export$7d31b617c820d435);

var $4sAiw = parcelRequire("4sAiw");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
let $11dc5aebdc9b56ee$var$tempRect;
let $11dc5aebdc9b56ee$var$tempRect2;
class $11dc5aebdc9b56ee$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Polygon([0, 0, 100, 0, 50, 100]);
     * console.log(shape.type); // 'polygon'
     *
     * // Use in type guards
     * if (shape.type === 'polygon') {
     *     // TypeScript knows this is a Polygon
     *     console.log(shape.points.length);
     * }
     * ```
     * @readonly
     * @default 'polygon'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */ isClockwise() {
        let area = 0;
        const points = this.points;
        const length = points.length;
        for(let i = 0; i < length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % length];
            const y2 = points[(i + 3) % length];
            area += (x2 - x1) * (y2 + y1);
        }
        return area < 0;
    }
    /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */ containsPolygon(polygon) {
        const thisBounds = this.getBounds($11dc5aebdc9b56ee$var$tempRect);
        const otherBounds = polygon.getBounds($11dc5aebdc9b56ee$var$tempRect2);
        if (!thisBounds.containsRect(otherBounds)) return false;
        const points = polygon.points;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!this.contains(x, y)) return false;
        }
        return true;
    }
    /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */ clone() {
        const points = this.points.slice();
        const polygon = new $11dc5aebdc9b56ee$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 0);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 1);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const strokeWidthSquared = strokeWidth * strokeWidth;
        const rightWidthSquared = strokeWidthSquared * (1 - alignment);
        const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSquared = (0, $4sAiw.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            const sign = Math.sign((x2 - x1) * (y - y1) - (y2 - y1) * (x - x1));
            if (distanceSquared <= (sign < 0 ? leftWidthSquared : rightWidthSquared)) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon
   * @readonly
   */ get x() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */ get y() {
        return this.points[this.points.length - 1];
    }
}

});
parcelRegister("4sAiw", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $95fee67952e97042$export$db32ff20ff695a);
"use strict";
function $95fee67952e97042$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("7u40a", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $019041c7bdb3bf3e$export$d55ab2e3dc5a4263);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $019041c7bdb3bf3e$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class $019041c7bdb3bf3e$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new RoundedRectangle(0, 0, 100, 100, 20);
     * console.log(shape.type); // 'roundedRectangle'
     *
     * // Use in type guards
     * if (shape.type === 'roundedRectangle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @readonly
     * @default 'roundedRectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $fM4Mk.Rectangle)());
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $019041c7bdb3bf3e$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 0);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 1);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (0 = inner, 0.5 = centered, 1 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */ strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - strokeWidthOuter && pX <= x + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - strokeWidthOuter && pY <= y + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter) || pX < innerX && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("lI2iN", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $4a51fd8da05fe222$export$7dab5eac414ecba2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $4a51fd8da05fe222$var$RECURSION_LIMIT = 8;
const $4a51fd8da05fe222$var$FLT_EPSILON = 11920929e-14;
const $4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON = 1;
const $4a51fd8da05fe222$var$curveAngleToleranceEpsilon = 0.01;
const $4a51fd8da05fe222$var$mAngleTolerance = 0;
const $4a51fd8da05fe222$var$mCuspLimit = 0;
function $4a51fd8da05fe222$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $4a51fd8da05fe222$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $4a51fd8da05fe222$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $4a51fd8da05fe222$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON && d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $4a51fd8da05fe222$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $4a51fd8da05fe222$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("hFzkv", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $119fb8487ef4f791$export$f2f3ca33e4c65172);

var $i9BKe = parcelRequire("i9BKe");

var $beJMG = parcelRequire("beJMG");

var $5RxDh = parcelRequire("5RxDh");

var $dK5Jn = parcelRequire("dK5Jn");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $1mKkK = parcelRequire("1mKkK");
"use strict";
class $119fb8487ef4f791$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
}
class $119fb8487ef4f791$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.instructions = new (0, $dK5Jn.InstructionSet)();
    }
    init(maxTextures) {
        this.batcher = new (0, $5RxDh.DefaultBatcher)({
            maxTextures: maxTextures
        });
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
}
const $119fb8487ef4f791$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(renderer){
        // the root context batches, used to either make a batch or geometry
        // all graphics use this as a base
        this._gpuContextHash = {};
        // used for non-batchable graphics
        this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
        renderer.renderableGC.addManagedHash(this, "_gpuContextHash");
        renderer.renderableGC.addManagedHash(this, "_graphicsDataContextHash");
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        return this._graphicsDataContextHash[context.uid] || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        let gpuContext = this._gpuContextHash[context.uid] || this._initContext(context);
        if (context.dirty) {
            if (gpuContext) this._cleanGraphicsContextData(context);
            else gpuContext = this._initContext(context);
            (0, $1mKkK.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            else gpuContext.isBatchable = true;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        return this._gpuContextHash[context.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $61KiY.BigPool).get($119fb8487ef4f791$export$9b6a6c5b37fc8f49, {
            maxTextures: this._renderer.limits.maxBatchableTextures
        });
        const { batches: batches, geometryData: geometryData } = this._gpuContextHash[context.uid];
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $beJMG.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count, this._renderer.limits.maxBatchableTextures);
        }
        this._graphicsDataContextHash[context.uid] = graphicsData;
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $119fb8487ef4f791$export$e3e348c254036d55();
        gpuContext.context = context;
        this._gpuContextHash[context.uid] = gpuContext;
        context.on("destroy", this.onGraphicsContextDestroy, this);
        return this._gpuContextHash[context.uid];
    }
    onGraphicsContextDestroy(context) {
        this._cleanGraphicsContextData(context);
        context.off("destroy", this.onGraphicsContextDestroy, this);
        this._gpuContextHash[context.uid] = null;
    }
    _cleanGraphicsContextData(context) {
        const gpuContext = this._gpuContextHash[context.uid];
        if (!gpuContext.isBatchable) {
            if (this._graphicsDataContextHash[context.uid]) {
                (0, $61KiY.BigPool).return(this.getContextRenderData(context));
                this._graphicsDataContextHash[context.uid] = null;
            }
        }
        if (gpuContext.batches) gpuContext.batches.forEach((batch)=>{
            (0, $61KiY.BigPool).return(batch);
        });
    }
    destroy() {
        for(const i in this._gpuContextHash)if (this._gpuContextHash[i]) this.onGraphicsContextDestroy(this._gpuContextHash[i].context);
    }
};
/** @ignore */ $119fb8487ef4f791$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem,
        (0, $i9BKe.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $119fb8487ef4f791$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $119fb8487ef4f791$export$f2f3ca33e4c65172 = $119fb8487ef4f791$var$_GraphicsContextSystem;

});
parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("5RxDh", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $122ab179875de631$export$34bf80542893bcb);

var $i9BKe = parcelRequire("i9BKe");

var $4rmMq = parcelRequire("4rmMq");

var $6Ogkc = parcelRequire("6Ogkc");

var $bBMVz = parcelRequire("bBMVz");
"use strict";
let $122ab179875de631$var$defaultShader = null;
const $122ab179875de631$var$_DefaultBatcher = class _DefaultBatcher extends (0, $4rmMq.Batcher) {
    constructor(options){
        super(options);
        this.geometry = new (0, $6Ogkc.BatchGeometry)();
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
        $122ab179875de631$var$defaultShader ?? ($122ab179875de631$var$defaultShader = new (0, $bBMVz.DefaultShader)(options.maxTextures));
        this.shader = $122ab179875de631$var$defaultShader;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
};
/** @ignore */ $122ab179875de631$var$_DefaultBatcher.extension = {
    type: [
        (0, $i9BKe.ExtensionType).Batcher
    ],
    name: "default"
};
let $122ab179875de631$export$34bf80542893bcb = $122ab179875de631$var$_DefaultBatcher;

});
parcelRegister("4rmMq", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $71f140885a3d3890$export$704b12ddc1dacdd2);

var $aGJhg = parcelRequire("aGJhg");

var $aaUE3 = parcelRequire("aaUE3");

var $kXq8E = parcelRequire("kXq8E");

var $1tfR4 = parcelRequire("1tfR4");

var $eN26f = parcelRequire("eN26f");

var $1EHMq = parcelRequire("1EHMq");

var $bRzRK = parcelRequire("bRzRK");
"use strict";
class $71f140885a3d3890$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $bRzRK.BatchTextureArray)();
        this.blendMode = "normal";
        this.topology = "triangle-strip";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
    }
}
const $71f140885a3d3890$var$batchPool = [];
let $71f140885a3d3890$var$batchPoolIndex = 0;
function $71f140885a3d3890$var$getBatchFromPool() {
    return $71f140885a3d3890$var$batchPoolIndex > 0 ? $71f140885a3d3890$var$batchPool[--$71f140885a3d3890$var$batchPoolIndex] : new $71f140885a3d3890$export$33b107562567fc47();
}
function $71f140885a3d3890$var$returnBatchToPool(batch) {
    $71f140885a3d3890$var$batchPool[$71f140885a3d3890$var$batchPoolIndex++] = batch;
}
let $71f140885a3d3890$var$BATCH_TICK = 0;
const $71f140885a3d3890$var$_Batcher = class _Batcher {
    constructor(options){
        /** unique id for this batcher */ this.uid = (0, $aGJhg.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        if (!options.maxTextures) {
            (0, $kXq8E.deprecation)("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options");
            options.maxTextures = (0, $1EHMq.getMaxTexturesPerBatch)();
        }
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $aaUE3.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $71f140885a3d3890$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $eN26f.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        let topology = firstElement.topology;
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $eN26f.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
            if (source._batchTick === $71f140885a3d3890$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                continue;
            }
            source._batchTick = $71f140885a3d3890$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                topology = element.topology;
                batch = $71f140885a3d3890$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                ++$71f140885a3d3890$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action);
            start = size;
            ++$71f140885a3d3890$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.topology = topology;
        batch.start = indexStart;
        batch.size = indexSize;
        ++$71f140885a3d3890$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $aaUE3.ViewableBuffer)(newSize);
        (0, $1tfR4.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $1tfR4.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    destroy() {
        for(let i = 0; i < this.batches.length; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        for(let i = 0; i < this._elements.length; i++)this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$71f140885a3d3890$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $71f140885a3d3890$export$704b12ddc1dacdd2 = $71f140885a3d3890$var$_Batcher;

});
parcelRegister("aaUE3", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $d6aafa25b0389ff9$export$4fdbf0662aa3047a);
"use strict";
class $d6aafa25b0389ff9$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this.uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("1tfR4", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $3976cf47510ef1a5$export$c691b0c42debe682);
"use strict";
function $3976cf47510ef1a5$export$c691b0c42debe682(sourceBuffer, destinationBuffer) {
    const lengthDouble = sourceBuffer.byteLength / 8 | 0;
    const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
    const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
    destinationFloat64View.set(sourceFloat64View);
    const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
    if (remainingBytes > 0) {
        const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
        const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
        destinationUint8View.set(sourceUint8View);
    }
}

});

parcelRegister("eN26f", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $3b017cb7131d92fc$export$ab2fc5cf3fe899fe);

var $eE5Ke = parcelRequire("eE5Ke");
"use strict";
function $3b017cb7131d92fc$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $eE5Ke.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("eE5Ke", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $16526f00f7b0e2b9$export$c250b85d73a91bdf);
"use strict";
const $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $16526f00f7b0e2b9$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
    return STENCIL_MODES2;
})($16526f00f7b0e2b9$export$c250b85d73a91bdf || {});

});


parcelRegister("1EHMq", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $b5d07f8bc89d7387$export$313b92466c30ee73);

var $ckKKH = parcelRequire("ckKKH");

var $awsWF = parcelRequire("awsWF");
"use strict";
let $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = null;
function $b5d07f8bc89d7387$export$313b92466c30ee73() {
    if ($b5d07f8bc89d7387$var$maxTexturesPerBatchCache) return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
    const gl = (0, $ckKKH.getTestContext)();
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = (0, $awsWF.checkMaxIfStatementsInShader)($b5d07f8bc89d7387$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
}

});
parcelRegister("awsWF", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $717b67827b6a1bc1$export$fb6ad4e758d74cc0);
"use strict";
const $717b67827b6a1bc1$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $717b67827b6a1bc1$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $717b67827b6a1bc1$var$fragTemplate.replace(/%forloop%/gi, $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});


parcelRegister("bRzRK", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $a96c3003620e8697$export$aa760e0febf1a758);
"use strict";
class $a96c3003620e8697$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("6Ogkc", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $ec424808c68c925d$export$449e8d355fd68e43);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");

var $cOnev = parcelRequire("cOnev");
"use strict";
const $ec424808c68c925d$var$placeHolderBufferData = new Float32Array(1);
const $ec424808c68c925d$var$placeHolderIndexData = new Uint32Array(1);
class $ec424808c68c925d$export$449e8d355fd68e43 extends (0, $cOnev.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lvEAL", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9841377a483d1ce7$export$a143d493d941bafc);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
class $9841377a483d1ce7$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** @internal */ this._updateID = 1;
        this._dataInt32 = null;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size ?? (size = data?.byteLength);
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    get dataInt32() {
        if (!this._dataInt32) this._dataInt32 = new Int32Array(this.data.buffer);
        return this._dataInt32;
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $1UZ6r.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $1UZ6r.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $1UZ6r.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        this._dataInt32 = null;
        if (!oldData || oldData.length !== value.length) {
            if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $aGJhg.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("1UZ6r", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $f4c8f2641f61e66f$export$f8deb2be8632fd10);
"use strict";
var $f4c8f2641f61e66f$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($f4c8f2641f61e66f$export$f8deb2be8632fd10 || {});

});


parcelRegister("cOnev", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $f72e7cebaee4d192$export$2db6c17465f94a2);

var $3vRz3 = parcelRequire("3vRz3");

var $7wtv9 = parcelRequire("7wtv9");

var $aGJhg = parcelRequire("aGJhg");

var $lvEAL = parcelRequire("lvEAL");

var $zwuDY = parcelRequire("zwuDY");

var $dYcXX = parcelRequire("dYcXX");
"use strict";
function $f72e7cebaee4d192$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lvEAL.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $zwuDY.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $f72e7cebaee4d192$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options = {}){
        super();
        /** The unique id of the geometry. */ this.uid = (0, $aGJhg.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        this.buffers = [];
        this.attributes = {};
        if (attributes) for(const i in attributes)this.addAttribute(i, attributes[i]);
        this.instanceCount = options.instanceCount ?? 1;
        if (indexBuffer) this.addIndex(indexBuffer);
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */ addAttribute(name, attributeOption) {
        const attribute = $f72e7cebaee4d192$var$ensureIsAttribute(attributeOption);
        const bufferIndex = this.buffers.indexOf(attribute.buffer);
        if (bufferIndex === -1) {
            this.buffers.push(attribute.buffer);
            attribute.buffer.on("update", this.onBufferUpdate, this);
            attribute.buffer.on("change", this.onBufferUpdate, this);
        }
        this.attributes[name] = attribute;
    }
    /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */ addIndex(indexBuffer) {
        this.indexBuffer = (0, $zwuDY.ensureIsBuffer)(indexBuffer, true);
        this.buffers.push(this.indexBuffer);
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $dYcXX.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("zwuDY", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $c27f8a68b3d31b3f$export$e02adcb3cf335e03);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
function $c27f8a68b3d31b3f$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lvEAL.Buffer))) {
        let usage = index ? (0, $1UZ6r.BufferUsage).INDEX : (0, $1UZ6r.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lvEAL.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("dYcXX", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $547d4a1f0305efcb$export$ca8be28ec6402f29);
"use strict";
function $547d4a1f0305efcb$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("bBMVz", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $5546e8c9dd716d36$export$5ee16216350ebcbc);

var $3JBHn = parcelRequire("3JBHn");

var $cNnNT = parcelRequire("cNnNT");

var $ikSZA = parcelRequire("ikSZA");

var $kSpdC = parcelRequire("kSpdC");

var $10zIa = parcelRequire("10zIa");

var $5iDyo = parcelRequire("5iDyo");
"use strict";
class $5546e8c9dd716d36$export$5ee16216350ebcbc extends (0, $5iDyo.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $3JBHn.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBitGl),
                (0, $ikSZA.generateTextureBatchBitGl)(maxTextures),
                (0, $kSpdC.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $3JBHn.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBit),
                (0, $ikSZA.generateTextureBatchBit)(maxTextures),
                (0, $kSpdC.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $10zIa.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
}

});
parcelRegister("3JBHn", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $52144493f15d3fff$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $52144493f15d3fff$export$477b8252c7ecdf2);

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $i8pLT = parcelRequire("i8pLT");

var $jOJh1 = parcelRequire("jOJh1");

var $8hMvn = parcelRequire("8hMvn");
"use strict";
function $52144493f15d3fff$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $i8pLT.compileHighShader)({
        template: {
            fragment: (0, $jOJh1.fragmentGPUTemplate),
            vertex: (0, $jOJh1.vertexGPUTemplate)
        },
        bits: [
            (0, $8hMvn.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $6j7wq.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $52144493f15d3fff$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $fK92B.GlProgram)({
        name: name,
        ...(0, $i8pLT.compileHighShaderGl)({
            template: {
                vertex: (0, $jOJh1.vertexGlTemplate),
                fragment: (0, $jOJh1.fragmentGlTemplate)
            },
            bits: [
                (0, $8hMvn.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("i8pLT", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $9ef573d9dfae5a48$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $9ef573d9dfae5a48$export$ff7039b165d48f97);

var $9zLXd = parcelRequire("9zLXd");

var $jJet4 = parcelRequire("jJet4");

var $ak3Em = parcelRequire("ak3Em");

var $9hCqF = parcelRequire("9hCqF");

var $9Zsfg = parcelRequire("9Zsfg");
"use strict";
const $9ef573d9dfae5a48$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $9ef573d9dfae5a48$var$bitCacheMap = /* @__PURE__ */ new Map();
let $9ef573d9dfae5a48$var$CACHE_UID = 0;
function $9ef573d9dfae5a48$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits);
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(template.vertex, template.fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $ak3Em.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $9hCqF.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $ak3Em.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $9ef573d9dfae5a48$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$9ef573d9dfae5a48$var$bitCacheMap.has(highFragment)) $9ef573d9dfae5a48$var$bitCacheMap.set(highFragment, $9ef573d9dfae5a48$var$CACHE_UID++);
        return $9ef573d9dfae5a48$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $jJet4.compileHooks)(vertex);
    const fragmentParts = (0, $jJet4.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $9zLXd.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $9zLXd.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $9Zsfg.injectBits)(vertex, vertexParts),
        fragment: (0, $9Zsfg.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("9zLXd", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $c36d60e017699465$export$38c21fb192fe3d9);

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $c36d60e017699465$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $hUCK4.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("jJet4", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $e10d3f89fc808d5a$export$17705ba43ca63936);
"use strict";
const $e10d3f89fc808d5a$var$findHooksRx = /\{\{(.*?)\}\}/g;
function $e10d3f89fc808d5a$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($e10d3f89fc808d5a$var$findHooksRx)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("ak3Em", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $76be63c34b98a2b0$export$aa47df9391ef0455);
"use strict";
function $76be63c34b98a2b0$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $76be63c34b98a2b0$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $76be63c34b98a2b0$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $76be63c34b98a2b0$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("9hCqF", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $eeb3f3dfbb29bd14$export$ae19cc473c7ab18);
"use strict";
function $eeb3f3dfbb29bd14$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $eeb3f3dfbb29bd14$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $eeb3f3dfbb29bd14$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $eeb3f3dfbb29bd14$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $eeb3f3dfbb29bd14$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $eeb3f3dfbb29bd14$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$eeb3f3dfbb29bd14$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
            ${results.sort().map((inValue)=>` ${$eeb3f3dfbb29bd14$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("9Zsfg", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $650fee7fffdacf4b$export$83c47c7340456c75);
"use strict";
function $650fee7fffdacf4b$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("jOJh1", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $f723d8c01fbb4e07$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $f723d8c01fbb4e07$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $f723d8c01fbb4e07$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $f723d8c01fbb4e07$export$3f7784dd6a13ff5a);
"use strict";
const $f723d8c01fbb4e07$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $f723d8c01fbb4e07$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $f723d8c01fbb4e07$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $f723d8c01fbb4e07$export$3f7784dd6a13ff5a = /* glsl */ `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`;

});

parcelRegister("8hMvn", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $d20cb1ce683ff173$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsBitGl", () => $d20cb1ce683ff173$export$38608853d4735d51);
"use strict";
const $d20cb1ce683ff173$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $d20cb1ce683ff173$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $d20cb1ce683ff173$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("cNnNT", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $39898bd73b5669c2$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $39898bd73b5669c2$export$93189e9821cf4459);
"use strict";
const $39898bd73b5669c2$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $39898bd73b5669c2$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("ikSZA", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $da5fa72bb41a0724$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $da5fa72bb41a0724$export$204e46d9a7a4f835);
"use strict";
const $da5fa72bb41a0724$var$textureBatchBitGpuCache = {};
function $da5fa72bb41a0724$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$aff2d36945cda647(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$da5fa72bb41a0724$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$da5fa72bb41a0724$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures];
}
const $da5fa72bb41a0724$var$textureBatchBitGlCache = {};
function $da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$204e46d9a7a4f835(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("kSpdC", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $2b55e281ef9e6651$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $2b55e281ef9e6651$export$222909710f39cc5);
"use strict";
const $2b55e281ef9e6651$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $2b55e281ef9e6651$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("10zIa", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe);

var $cryyq = parcelRequire("cryyq");
"use strict";
const $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash = {};
function $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $cryyq.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});



parcelRegister("1mKkK", function(module, exports) {

$parcel$export(module.exports, "buildContextBatches", () => $2ba674c6e42be2fb$export$e3c00f31a053d231);

var $i9BKe = parcelRequire("i9BKe");

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $kVCUp = parcelRequire("kVCUp");

var $9Co9Q = parcelRequire("9Co9Q");

var $bLlTJ = parcelRequire("bLlTJ");

var $61KiY = parcelRequire("61KiY");

var $xZ5a3 = parcelRequire("xZ5a3");

var $dY2iR = parcelRequire("dY2iR");

var $46SPq = parcelRequire("46SPq");

var $7pahp = parcelRequire("7pahp");

var $ei7YJ = parcelRequire("ei7YJ");

var $7DIxn = parcelRequire("7DIxn");

var $iAUCq = parcelRequire("iAUCq");

var $34u7a = parcelRequire("34u7a");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $2ba674c6e42be2fb$export$ab760b0d495e92a1 = {};
(0, $i9BKe.extensions).handleByMap((0, $i9BKe.ExtensionType).ShapeBuilder, $2ba674c6e42be2fb$export$ab760b0d495e92a1);
(0, $i9BKe.extensions).add((0, $7DIxn.buildRectangle), (0, $ei7YJ.buildPolygon), (0, $iAUCq.buildTriangle), (0, $dY2iR.buildCircle), (0, $dY2iR.buildEllipse), (0, $dY2iR.buildRoundedRectangle));
const $2ba674c6e42be2fb$var$tempRect = new (0, $fM4Mk.Rectangle)();
const $2ba674c6e42be2fb$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
function $2ba674c6e42be2fb$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $2ba674c6e42be2fb$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $2ba674c6e42be2fb$var$addShapePathToGeometryData(hole.shapePath, style, true, batches, geometryData);
            if (hole) shapePath.shapePrimitives[shapePath.shapePrimitives.length - 1].holes = hole.shapePath.shapePrimitives;
            $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData);
        }
    }
}
function $2ba674c6e42be2fb$var$addTextureToGeometryData(data, batches, geometryData) {
    const points = [];
    const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1.rectangle;
    const rect = $2ba674c6e42be2fb$var$tempRect;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    if (!build.build(rect, points)) return;
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const texture = data.image;
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix, holes: holes })=>{
        const points = [];
        const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1[shape.type];
        if (!build.build(shape, points)) return;
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        let topology = "triangle-list";
        if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
        if (!isStroke) {
            if (holes) {
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $2ba674c6e42be2fb$var$getHoleArrays(holes);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $2E1jb.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            if (!lineStyle.pixelLine) (0, $46SPq.buildLine)(points, lineStyle, false, close, vertices, indices);
            else {
                (0, $7pahp.buildPixelLine)(points, close, vertices, indices);
                topology = "line-list";
            }
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $bLlTJ.Texture).WHITE) {
            const textureMatrix = (0, $34u7a.generateTextureMatrix)($2ba674c6e42be2fb$var$tempTextureMatrix, style, shape, matrix);
            (0, $kVCUp.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $kVCUp.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        graphicsBatch.topology = topology;
        batches.push(graphicsBatch);
    });
}
function $2ba674c6e42be2fb$var$getHoleArrays(holePrimitives) {
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $2ba674c6e42be2fb$export$ab760b0d495e92a1[holePrimitive.type];
        if (holeBuilder.build(holePrimitive, holePoints)) holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("kVCUp", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $1606ccc0770732ec$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $1606ccc0770732ec$export$580e3d8462b9fe52);
"use strict";
function $1606ccc0770732ec$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $1606ccc0770732ec$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("9Co9Q", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $74e682a1604b3625$export$cbe36b8a8d6e3d3);
"use strict";
function $74e682a1604b3625$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset || (offset = 0);
    stride || (stride = 2);
    size || (size = vertices.length / stride - offset);
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("xZ5a3", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $3f80d08e0b9378c5$export$91d2a08bbf21546b);

var $eY4rt = parcelRequire("eY4rt");

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $3f80d08e0b9378c5$var$identityMatrix = new (0, $eY4rt.Matrix)();
class $3f80d08e0b9378c5$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.topology = "triangle-list";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.renderable && this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $3N6bV.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $3f80d08e0b9378c5$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
        gpuBuffer.topology = this.topology;
    }
    reset() {
        this.applyTransform = true;
        this.renderable = null;
        this.topology = "triangle-list";
    }
}

});

parcelRegister("dY2iR", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $791ed7b81fe09d67$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $791ed7b81fe09d67$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $791ed7b81fe09d67$export$4b54fce47d2ae7f4);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $791ed7b81fe09d67$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            rx = ry = circle.radius;
            if (rx <= 0) return false;
            x = circle.x;
            y = circle.y;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            if (rx <= 0 || ry <= 0) return false;
            x = ellipse.x;
            y = ellipse.y;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (dx < 0 || dy < 0) return false;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return false;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return true;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $791ed7b81fe09d67$export$d35b00c6ec9534ca = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $791ed7b81fe09d67$export$4b54fce47d2ae7f4 = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("46SPq", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $9fc8551677af3cf1$export$45986ccf08e93b0b);

var $1HooC = parcelRequire("1HooC");

var $d1s7O = parcelRequire("d1s7O");

var $168p3 = parcelRequire("168p3");
"use strict";
function $9fc8551677af3cf1$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $9fc8551677af3cf1$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $9fc8551677af3cf1$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $168p3.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $1HooC.Point)(points[0], points[1]);
    const lastPoint = new (0, $1HooC.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $d1s7O.curveEps) * (0, $d1s7O.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("d1s7O", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $5f88c52b3933a72f$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $5f88c52b3933a72f$export$51a946149243709);
"use strict";
const $5f88c52b3933a72f$export$7159a7c43f12984 = 1e-4;
const $5f88c52b3933a72f$export$51a946149243709 = 1e-4;

});

parcelRegister("168p3", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $19281094736c08bb$export$38856eae80d480e1);
"use strict";
function $19281094736c08bb$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("7pahp", function(module, exports) {

$parcel$export(module.exports, "buildPixelLine", () => $1882f668f31d317e$export$44c058937667e9f0);

var $d1s7O = parcelRequire("d1s7O");
"use strict";
function $1882f668f31d317e$export$44c058937667e9f0(points, closed, vertices, indices) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const fx = points[0];
    const fy = points[1];
    const lx = points[points.length - 2];
    const ly = points[points.length - 1];
    const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
    const verts = vertices;
    const length = points.length / 2;
    const indexStart = verts.length / 2;
    for(let i = 0; i < length; i++){
        verts.push(points[i * 2]);
        verts.push(points[i * 2 + 1]);
    }
    for(let i = 0; i < length - 1; i++)indices.push(indexStart + i, indexStart + i + 1);
    if (closePath) indices.push(indexStart + length - 1, indexStart);
}

});

parcelRegister("ei7YJ", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $7f823fd9a95a0bf4$export$4c2d12f7b210f357);

var $i9BKe = parcelRequire("i9BKe");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $7f823fd9a95a0bf4$var$emptyArray = [];
const $7f823fd9a95a0bf4$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $2E1jb.triangulateWithHoles)(points, $7f823fd9a95a0bf4$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("2E1jb", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $0c79f6b53084d415$export$5a241bf9c2c3d94b);

var $e9PUX = parcelRequire("e9PUX");
"use strict";
function $0c79f6b53084d415$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, $e9PUX.earcut)(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("e9PUX", function(module, exports) {

$parcel$export(module.exports, "earcut", () => $04328aff3292927e$export$71a1409458eaaf0d);

var $2jYVZ = parcelRequire("2jYVZ");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $04328aff3292927e$export$71a1409458eaaf0d = (0, $2jYVZ.default).default || (0, $2jYVZ.default);

});
parcelRegister("2jYVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b0c9f6ca9bef72e$export$2e2bcd8739ae039);
function $1b0c9f6ca9bef72e$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    const bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($1b0c9f6ca9bef72e$var$equals(hole, p)) return p;
    do {
        if ($1b0c9f6ca9bef72e$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    const o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    const o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    const o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    const o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    const a2 = $1b0c9f6ca9bef72e$var$createNode(a.i, a.x, a.y), b2 = $1b0c9f6ca9bef72e$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    const p = $1b0c9f6ca9bef72e$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $1b0c9f6ca9bef72e$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $1b0c9f6ca9bef72e$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}

});




parcelRegister("7DIxn", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $1d4b4832ec6feb5d$export$cbe813d11f2192b2);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $1d4b4832ec6feb5d$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width > 0 && height > 0)) return false;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("iAUCq", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $14f13b7de979604e$export$8eb75cb9f614d270);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $14f13b7de979604e$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("34u7a", function(module, exports) {

$parcel$export(module.exports, "generateTextureMatrix", () => $72972982d23c75da$export$1e9b9e463121b388);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");

var $gwwtL = parcelRequire("gwwtL");
"use strict";
const $72972982d23c75da$var$tempTextureMatrix = new (0, $eY4rt.Matrix)();
const $72972982d23c75da$var$tempRect = new (0, $fM4Mk.Rectangle)();
function $72972982d23c75da$export$1e9b9e463121b388(out, style, shape, matrix) {
    const textureMatrix = style.matrix ? out.copyFrom(style.matrix).invert() : out.identity();
    if (style.textureSpace === "local") {
        const bounds = shape.getBounds($72972982d23c75da$var$tempRect);
        if (style.width) bounds.pad(style.width);
        const { x: tx, y: ty } = bounds;
        const sx = 1 / bounds.width;
        const sy = 1 / bounds.height;
        const mTx = -tx * sx;
        const mTy = -ty * sy;
        const a1 = textureMatrix.a;
        const b1 = textureMatrix.b;
        const c1 = textureMatrix.c;
        const d1 = textureMatrix.d;
        textureMatrix.a *= sx;
        textureMatrix.b *= sx;
        textureMatrix.c *= sy;
        textureMatrix.d *= sy;
        textureMatrix.tx = mTx * a1 + mTy * c1 + textureMatrix.tx;
        textureMatrix.ty = mTx * b1 + mTy * d1 + textureMatrix.ty;
    } else {
        textureMatrix.translate(style.texture.frame.x, style.texture.frame.y);
        textureMatrix.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
    }
    const sourceStyle = style.texture.source.style;
    if (!(style.fill instanceof (0, $gwwtL.FillGradient)) && sourceStyle.addressMode === "clamp-to-edge") {
        sourceStyle.addressMode = "repeat";
        sourceStyle.update();
    }
    if (matrix) textureMatrix.append($72972982d23c75da$var$tempTextureMatrix.copyFrom(matrix).invert());
    return textureMatrix;
}

});
parcelRegister("gwwtL", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $339e160815705dba$export$722a6ea8c60ca86);

var $a2eTA = parcelRequire("a2eTA");

var $iCGeI = parcelRequire("iCGeI");

var $eY4rt = parcelRequire("eY4rt");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $dr868 = parcelRequire("dr868");
"use strict";
const $339e160815705dba$var$emptyColorStops = [
    {
        offset: 0,
        color: "white"
    },
    {
        offset: 1,
        color: "black"
    }
];
const $339e160815705dba$var$_FillGradient = class _FillGradient {
    constructor(...args){
        /**
     * Unique identifier for this gradient instance
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillGradient");
        /** Type of gradient - currently only supports 'linear' */ this.type = "linear";
        /** Array of color stops defining the gradient */ this.colorStops = [];
        let options = $339e160815705dba$var$ensureGradientOptions(args);
        const defaults = options.type === "radial" ? _FillGradient.defaultRadialOptions : _FillGradient.defaultLinearOptions;
        options = {
            ...defaults,
            ...(0, $dr868.definedProps)(options)
        };
        this._textureSize = options.textureSize;
        this._wrapMode = options.wrapMode;
        if (options.type === "radial") {
            this.center = options.center;
            this.outerCenter = options.outerCenter ?? this.center;
            this.innerRadius = options.innerRadius;
            this.outerRadius = options.outerRadius;
            this.scale = options.scale;
            this.rotation = options.rotation;
        } else {
            this.start = options.start;
            this.end = options.end;
        }
        this.textureSpace = options.textureSpace;
        this.type = options.type;
        options.colorStops.forEach((stop)=>{
            this.addColorStop(stop.offset, stop.color);
        });
    }
    /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */ addColorStop(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: (0, $a2eTA.Color).shared.setValue(color).toHexa()
        });
        return this;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildLinearGradient() {
        if (this.texture) return;
        let { x: x0, y: y0 } = this.start;
        let { x: x1, y: y1 } = this.end;
        let dx = x1 - x0;
        let dy = y1 - y0;
        const flip = dx < 0 || dy < 0;
        if (this._wrapMode === "clamp-to-edge") {
            if (dx < 0) {
                const temp = x0;
                x0 = x1;
                x1 = temp;
                dx *= -1;
            }
            if (dy < 0) {
                const temp = y0;
                y0 = y1;
                y1 = temp;
                dy *= -1;
            }
        }
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, 1);
        const gradient = !flip ? context.createLinearGradient(0, 0, this._textureSize, 0) : context.createLinearGradient(this._textureSize, 0, 0, 0);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = gradient;
        context.fillRect(0, 0, defaultSize, 1);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        const m = new (0, $eY4rt.Matrix)();
        m.scale(dist / defaultSize, 1);
        m.rotate(angle);
        m.translate(x0, y0);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildGradient() {
        if (this.type === "linear") this.buildLinearGradient();
        else this.buildRadialGradient();
    }
    /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildRadialGradient() {
        if (this.texture) return;
        const colorStops = this.colorStops.length ? this.colorStops : $339e160815705dba$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $339e160815705dba$var$getCanvas(defaultSize, defaultSize);
        const { x: x0, y: y0 } = this.center;
        const { x: x1, y: y1 } = this.outerCenter;
        const r0 = this.innerRadius;
        const r1 = this.outerRadius;
        const ox = x1 - r1;
        const oy = y1 - r1;
        const scale = defaultSize / (r1 * 2);
        const cx = (x0 - ox) * scale;
        const cy = (y0 - oy) * scale;
        const gradient = context.createRadialGradient(cx, cy, r0 * scale, (x1 - ox) * scale, (y1 - oy) * scale, r1 * scale);
        $339e160815705dba$var$addColorStops(gradient, colorStops);
        context.fillStyle = colorStops[colorStops.length - 1].color;
        context.fillRect(0, 0, defaultSize, defaultSize);
        context.fillStyle = gradient;
        context.translate(cx, cy);
        context.rotate(this.rotation);
        context.scale(1, this.scale);
        context.translate(-cx, -cy);
        context.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const m = new (0, $eY4rt.Matrix)();
        m.scale(1 / scale, 1 / scale);
        m.translate(ox, oy);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Gets a unique key representing the current state of the gradient.
   * Used internally for caching.
   * @returns Unique string key
   */ get styleKey() {
        return this.uid;
    }
    destroy() {
        this.texture?.destroy(true);
        this.texture = null;
    }
};
/** Default options for creating a gradient fill */ $339e160815705dba$var$_FillGradient.defaultLinearOptions = {
    start: {
        x: 0,
        y: 0
    },
    end: {
        x: 0,
        y: 1
    },
    colorStops: [],
    textureSpace: "local",
    type: "linear",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
/** Default options for creating a radial gradient fill */ $339e160815705dba$var$_FillGradient.defaultRadialOptions = {
    center: {
        x: 0.5,
        y: 0.5
    },
    innerRadius: 0,
    outerRadius: 0.5,
    colorStops: [],
    scale: 1,
    textureSpace: "local",
    type: "radial",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
let $339e160815705dba$export$722a6ea8c60ca86 = $339e160815705dba$var$_FillGradient;
function $339e160815705dba$var$addColorStops(gradient, colorStops) {
    for(let i = 0; i < colorStops.length; i++){
        const stop = colorStops[i];
        gradient.addColorStop(stop.offset, stop.color);
    }
}
function $339e160815705dba$var$getCanvas(width, height) {
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(width, height);
    const context = canvas.getContext("2d");
    return {
        canvas: canvas,
        context: context
    };
}
function $339e160815705dba$var$ensureGradientOptions(args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || args[1]) {
        (0, $kXq8E.deprecation)("8.5.2", `use options object instead`);
        options = {
            type: "linear",
            start: {
                x: args[0],
                y: args[1]
            },
            end: {
                x: args[2],
                y: args[3]
            },
            textureSpace: args[4],
            textureSize: args[5] ?? $339e160815705dba$export$722a6ea8c60ca86.defaultLinearOptions.textureSize
        };
    }
    return options;
}

});





parcelRegister("eRV6E", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $39a9db3afcc2f789$export$d53ce9debfe7a6c2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $39a9db3afcc2f789$var$RECURSION_LIMIT = 8;
const $39a9db3afcc2f789$var$FLT_EPSILON = 11920929e-14;
const $39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON = 1;
const $39a9db3afcc2f789$var$curveAngleToleranceEpsilon = 0.01;
const $39a9db3afcc2f789$var$mAngleTolerance = 0;
function $39a9db3afcc2f789$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $39a9db3afcc2f789$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $39a9db3afcc2f789$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $39a9db3afcc2f789$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $39a9db3afcc2f789$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($39a9db3afcc2f789$var$mAngleTolerance < $39a9db3afcc2f789$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $39a9db3afcc2f789$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $39a9db3afcc2f789$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $39a9db3afcc2f789$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("aiLPr", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $4598c98f5bbae757$export$ed8eebdc6998f0f6);
"use strict";
function $4598c98f5bbae757$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("boMdH", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $35a2eb588826e37c$export$d46b7933b415e02f);

var $aiLPr = parcelRequire("aiLPr");
"use strict";
function $35a2eb588826e37c$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $aiLPr.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("jjbCG", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $d859b1787749b4c9$export$71ccaa6dca53075e);

var $lI2iN = parcelRequire("lI2iN");
"use strict";
const $d859b1787749b4c9$var$TAU = Math.PI * 2;
const $d859b1787749b4c9$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $d859b1787749b4c9$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $d859b1787749b4c9$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $d859b1787749b4c9$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $d859b1787749b4c9$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $d859b1787749b4c9$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $d859b1787749b4c9$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $d859b1787749b4c9$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $d859b1787749b4c9$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $d859b1787749b4c9$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $d859b1787749b4c9$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $d859b1787749b4c9$var$out);
    let { ang1: ang1, ang2: ang2 } = $d859b1787749b4c9$var$out;
    const { centerX: centerX, centerY: centerY } = $d859b1787749b4c9$var$out;
    let ratio = Math.abs(ang2) / ($d859b1787749b4c9$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $d859b1787749b4c9$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $d859b1787749b4c9$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $d859b1787749b4c9$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $d859b1787749b4c9$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $lI2iN.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("9ad7k", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $9769dc3699a7c802$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $9769dc3699a7c802$export$cf503f371c53af9e);
"use strict";
function $9769dc3699a7c802$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $9769dc3699a7c802$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("6ph3G", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $ff733ce48c045e93$export$2cc2aaca18109aab);

var $hUCK4 = parcelRequire("hUCK4");

var $c9xxq = parcelRequire("c9xxq");

var $lwWDT = parcelRequire("lwWDT");

var $66BsB = parcelRequire("66BsB");

var $cEiD3 = parcelRequire("cEiD3");
"use strict";
function $ff733ce48c045e93$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        defs: {},
        path: new (0, $c9xxq.GraphicsPath)()
    };
    (0, $lwWDT.parseSVGDefinitions)(svg, session);
    const children = svg.children;
    const { fillStyle: fillStyle, strokeStyle: strokeStyle } = (0, $cEiD3.parseSVGStyle)(svg, session);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.nodeName.toLowerCase() === "defs") continue;
        $ff733ce48c045e93$var$renderChildren(child, session, fillStyle, strokeStyle);
    }
    return graphicsContext;
}
function $ff733ce48c045e93$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = (0, $cEiD3.parseSVGStyle)(svg, session);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    const noStyle = !fillStyle && !strokeStyle;
    if (noStyle) fillStyle = {
        color: 0
    };
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            d = svg.getAttribute("d");
            if (svg.getAttribute("fill-rule") === "evenodd") (0, $hUCK4.warn)("SVG Evenodd fill rule not supported, your svg may render incorrectly");
            graphicsPath = new (0, $c9xxq.GraphicsPath)(d, true);
            session.context.path(graphicsPath);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "circle":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            r = (0, $66BsB.parseSVGFloatAttribute)(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "rect":
            x = (0, $66BsB.parseSVGFloatAttribute)(svg, "x", 0);
            y = (0, $66BsB.parseSVGFloatAttribute)(svg, "y", 0);
            width = (0, $66BsB.parseSVGFloatAttribute)(svg, "width", 0);
            height = (0, $66BsB.parseSVGFloatAttribute)(svg, "height", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "ellipse":
            cx = (0, $66BsB.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $66BsB.parseSVGFloatAttribute)(svg, "cy", 0);
            rx = (0, $66BsB.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $66BsB.parseSVGFloatAttribute)(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "line":
            x1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x1", 0);
            y1 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y1", 0);
            x2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "x2", 0);
            y2 = (0, $66BsB.parseSVGFloatAttribute)(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "g":
        case "svg":
            break;
        default:
            (0, $hUCK4.warn)(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    if (noStyle) fillStyle = null;
    for(let i = 0; i < children.length; i++)$ff733ce48c045e93$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}

});
parcelRegister("lwWDT", function(module, exports) {

$parcel$export(module.exports, "parseSVGDefinitions", () => $2ade0f5beda11c2d$export$d578aced17ea3023);

var $a2eTA = parcelRequire("a2eTA");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $66BsB = parcelRequire("66BsB");
"use strict";
function $2ade0f5beda11c2d$export$d578aced17ea3023(svg, session) {
    const definitions = svg.querySelectorAll("defs");
    for(let i = 0; i < definitions.length; i++){
        const definition = definitions[i];
        for(let j = 0; j < definition.children.length; j++){
            const child = definition.children[j];
            switch(child.nodeName.toLowerCase()){
                case "lineargradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseLinearGradient(child);
                    break;
                case "radialgradient":
                    session.defs[child.id] = $2ade0f5beda11c2d$var$parseRadialGradient(child);
                    break;
                default:
                    break;
            }
        }
    }
}
function $2ade0f5beda11c2d$var$parseLinearGradient(child) {
    const x0 = (0, $66BsB.parseSVGFloatAttribute)(child, "x1", 0);
    const y0 = (0, $66BsB.parseSVGFloatAttribute)(child, "y1", 0);
    const x1 = (0, $66BsB.parseSVGFloatAttribute)(child, "x2", 1);
    const y1 = (0, $66BsB.parseSVGFloatAttribute)(child, "y2", 0);
    const gradientUnit = child.getAttribute("gradientUnits") || "objectBoundingBox";
    const gradient = new (0, $gwwtL.FillGradient)(x0, y0, x1, y1, gradientUnit === "objectBoundingBox" ? "local" : "global");
    for(let k = 0; k < child.children.length; k++){
        const stop = child.children[k];
        const offset = (0, $66BsB.parseSVGFloatAttribute)(stop, "offset", 0);
        const color = (0, $a2eTA.Color).shared.setValue(stop.getAttribute("stop-color")).toNumber();
        gradient.addColorStop(offset, color);
    }
    return gradient;
}
function $2ade0f5beda11c2d$var$parseRadialGradient(_child) {
    (0, $hUCK4.warn)("[SVG Parser] Radial gradients are not yet supported");
    return new (0, $gwwtL.FillGradient)(0, 0, 1, 0);
}

});
parcelRegister("66BsB", function(module, exports) {

$parcel$export(module.exports, "parseSVGFloatAttribute", () => $30452626b79fbc29$export$dd264bbf059b1af7);
"use strict";
function $30452626b79fbc29$export$dd264bbf059b1af7(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}

});


parcelRegister("cEiD3", function(module, exports) {

$parcel$export(module.exports, "parseSVGStyle", () => $4fc848fee6ca709e$export$394301fd4b48c7bc);

var $a2eTA = parcelRequire("a2eTA");

var $iK8wH = parcelRequire("iK8wH");
"use strict";
const $4fc848fee6ca709e$export$d1c537faaad576dd = {
    // Fill properties
    fill: {
        type: "paint",
        default: 0
    },
    // Fill color/gradient
    "fill-opacity": {
        type: "number",
        default: 1
    },
    // Fill transparency
    // Stroke properties
    stroke: {
        type: "paint",
        default: 0
    },
    // Stroke color/gradient
    "stroke-width": {
        type: "number",
        default: 1
    },
    // Width of stroke
    "stroke-opacity": {
        type: "number",
        default: 1
    },
    // Stroke transparency
    "stroke-linecap": {
        type: "string",
        default: "butt"
    },
    // End cap style: butt, round, square
    "stroke-linejoin": {
        type: "string",
        default: "miter"
    },
    // Join style: miter, round, bevel
    "stroke-miterlimit": {
        type: "number",
        default: 10
    },
    // Limit on miter join sharpness
    "stroke-dasharray": {
        type: "string",
        default: "none"
    },
    // Dash pattern
    "stroke-dashoffset": {
        type: "number",
        default: 0
    },
    // Offset for dash pattern
    // Global properties
    opacity: {
        type: "number",
        default: 1
    }
};
function $4fc848fee6ca709e$export$394301fd4b48c7bc(svg, session) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    const result = {
        strokeStyle: strokeStyle,
        fillStyle: fillStyle,
        useFill: false,
        useStroke: false
    };
    for(const key in $4fc848fee6ca709e$export$d1c537faaad576dd){
        const attribute = svg.getAttribute(key);
        if (attribute) $4fc848fee6ca709e$var$parseAttribute(session, result, key, attribute.trim());
    }
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i].trim();
            const [key, value] = stylePart.split(":");
            if ($4fc848fee6ca709e$export$d1c537faaad576dd[key]) $4fc848fee6ca709e$var$parseAttribute(session, result, key, value.trim());
        }
    }
    return {
        strokeStyle: result.useStroke ? strokeStyle : null,
        fillStyle: result.useFill ? fillStyle : null,
        useFill: result.useFill,
        useStroke: result.useStroke
    };
}
function $4fc848fee6ca709e$var$parseAttribute(session, result, id, value) {
    switch(id){
        case "stroke":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.strokeStyle.fill = session.defs[id2];
                } else result.strokeStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useStroke = true;
            }
            break;
        case "stroke-width":
            result.strokeStyle.width = Number(value);
            break;
        case "fill":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $iK8wH.extractSvgUrlId)(value);
                    result.fillStyle.fill = session.defs[id2];
                } else result.fillStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                result.useFill = true;
            }
            break;
        case "fill-opacity":
            result.fillStyle.alpha = Number(value);
            break;
        case "stroke-opacity":
            result.strokeStyle.alpha = Number(value);
            break;
        case "opacity":
            result.fillStyle.alpha = Number(value);
            result.strokeStyle.alpha = Number(value);
            break;
    }
}

});
parcelRegister("iK8wH", function(module, exports) {

$parcel$export(module.exports, "extractSvgUrlId", () => $bfccbd4b202a8863$export$c7c899a4a04107c);
"use strict";
function $bfccbd4b202a8863$export$c7c899a4a04107c(url) {
    const match = url.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
    return match ? match[1] : "";
}

});



parcelRegister("6mQKv", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $ee0f76cca9221b48$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $ee0f76cca9221b48$export$64975ed44b74a62b);

var $a2eTA = parcelRequire("a2eTA");

var $bLlTJ = parcelRequire("bLlTJ");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
function $ee0f76cca9221b48$var$isColorLike(value) {
    return (0, $a2eTA.Color).isColorLike(value);
}
function $ee0f76cca9221b48$var$isFillPattern(value) {
    return value instanceof (0, $ktCpi.FillPattern);
}
function $ee0f76cca9221b48$var$isFillGradient(value) {
    return value instanceof (0, $gwwtL.FillGradient);
}
function $ee0f76cca9221b48$var$isTexture(value) {
    return value instanceof (0, $bLlTJ.Texture);
}
function $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $a2eTA.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $bLlTJ.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle) {
    fill.texture = value;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    fill.textureSpace = value.textureSpace;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    const color = (0, $a2eTA.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    return style;
}
function $ee0f76cca9221b48$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($ee0f76cca9221b48$var$isColorLike(value)) return $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isTexture(value)) return $ee0f76cca9221b48$var$handleTexture(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillPattern(value)) return $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillGradient(value)) return $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillPattern(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillGradient(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $ee0f76cca9221b48$var$handleFillObject(objectStyle, defaultStyle);
}
function $ee0f76cca9221b48$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, pixelLine: pixelLine, ...rest } = defaultStyle;
    const fill = $ee0f76cca9221b48$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        pixelLine: pixelLine,
        ...fill
    };
}

});
parcelRegister("ktCpi", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $e9923e9fec04a606$export$3d1378c7410cd8e);

var $eY4rt = parcelRequire("eY4rt");

var $aGJhg = parcelRequire("aGJhg");
"use strict";
const $e9923e9fec04a606$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $e9923e9fec04a606$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /**
     * unique id for this fill pattern
     * @internal
     */ this.uid = (0, $aGJhg.uid)("fillPattern");
        /** The transform matrix applied to the pattern */ this.transform = new (0, $eY4rt.Matrix)();
        this._styleKey = null;
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeV;
        }
    }
    /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */ setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._styleKey = null;
    }
    /**
   * Gets a unique key representing the current state of the pattern.
   * Used internally for caching.
   * @returns Unique string key
   */ get styleKey() {
        if (this._styleKey) return this._styleKey;
        this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`;
        return this._styleKey;
    }
}

});




parcelRegister("iDQjg", function(module, exports) {

$parcel$export(module.exports, "Particle", () => $7143f8a8e4ab91fe$export$c36c68baa13912a5);

var $a2eTA = parcelRequire("a2eTA");

var $bLlTJ = parcelRequire("bLlTJ");

var $8ifkW = parcelRequire("8ifkW");

var $gIPW8 = parcelRequire("gIPW8");
"use strict";
const $7143f8a8e4ab91fe$var$_Particle = class _Particle {
    constructor(options){
        if (options instanceof (0, $bLlTJ.Texture)) {
            this.texture = options;
            (0, $gIPW8.assignWithIgnore)(this, _Particle.defaultOptions, {});
        } else {
            const combined = {
                ..._Particle.defaultOptions,
                ...options
            };
            (0, $gIPW8.assignWithIgnore)(this, combined, {});
        }
    }
    /**
   * The transparency of the particle. Values range from 0 (fully transparent)
   * to 1 (fully opaque). Values outside this range are clamped.
   * @example
   * ```ts
   * // Create a semi-transparent particle
   * const particle = new Particle({
   *     texture: Texture.from('particle.png'),
   *     alpha: 0.5
   * });
   *
   * // Fade out
   * particle.alpha *= 0.9;
   *
   * // Fade in
   * particle.alpha = Math.min(particle.alpha + 0.1, 1);
   *
   * // Values are clamped to valid range
   * particle.alpha = 1.5; // Becomes 1.0
   * particle.alpha = -0.5; // Becomes 0.0
   *
   * // Animate transparency
   * app.ticker.add((delta) => {
   *     const time = performance.now() / 1000;
   *     particle.alpha = 0.5 + Math.sin(time) * 0.5; // Pulse between 0-1
   * });
   * ```
   * @default 1
   * @see {@link Particle#tint} For controlling particle color
   * @see {@link Particle#color} For the combined color and alpha value
   */ get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        this._alpha = Math.min(Math.max(value, 0), 1);
        this._updateColor();
    }
    /**
   * The tint color of the particle. Can be set using hex numbers or CSS color strings.
   * The tint is multiplied with the texture color to create the final particle color.
   * @example
   * ```ts
   * // Create a red particle
   * const particle = new Particle({
   *     texture: Texture.from('particle.png'),
   *     tint: 0xff0000
   * });
   *
   * // Use CSS color strings
   * particle.tint = '#00ff00';  // Green
   * particle.tint = 'blue';     // Blue
   *
   * // Animate tint color
   * app.ticker.add(() => {
   *     const time = performance.now() / 1000;
   *
   *     // Cycle through hues
   *     const hue = (time * 50) % 360;
   *     particle.tint = `hsl(${hue}, 100%, 50%)`;
   * });
   *
   * // Reset to white (no tint)
   * particle.tint = 0xffffff;
   * ```
   * @type {ColorSource} Hex number or CSS color string
   * @default 0xffffff
   * @see {@link Particle#alpha} For controlling transparency
   * @see {@link Particle#color} For the combined color and alpha value
   * @see {@link Color} For supported color formats
   */ get tint() {
        return (0, $8ifkW.bgr2rgb)(this._tint);
    }
    set tint(value) {
        if (typeof value === "number") this._tint = value;
        else this._tint = (0, $a2eTA.Color).shared.setValue(value ?? 16777215).toBgrNumber();
        this._updateColor();
    }
    _updateColor() {
        this.color = this._tint + ((this._alpha * 255 | 0) << 24);
    }
};
/**
 * Default options used when creating new particles. These values are applied when specific
 * options aren't provided in the constructor.
 * @example
 * ```ts
 * // Override defaults globally
 * Particle.defaultOptions = {
 *     ...Particle.defaultOptions,
 *     anchorX: 0.5,
 *     anchorY: 0.5,
 *     alpha: 0.8
 * };
 *
 * // New particles use modified defaults
 * const centeredParticle = new Particle(texture);
 * console.log(centeredParticle.anchorX); // 0.5
 * console.log(centeredParticle.alpha); // 0.8
 * ```
 * @see {@link ParticleOptions} For all available options
 * @see {@link Particle} For the particle implementation
 */ $7143f8a8e4ab91fe$var$_Particle.defaultOptions = {
    anchorX: 0,
    anchorY: 0,
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
    rotation: 0,
    tint: 16777215,
    alpha: 1
};
let $7143f8a8e4ab91fe$export$c36c68baa13912a5 = $7143f8a8e4ab91fe$var$_Particle;

});

parcelRegister("9F5i8", function(module, exports) {

$parcel$export(module.exports, "ParticleContainer", () => $b425caa62af94b42$export$e63bf72b2cfda112);

var $7wtv9 = parcelRequire("7wtv9");

var $b9FQU = parcelRequire("b9FQU");

var $l3ImM = parcelRequire("l3ImM");
"use strict";
const $b425caa62af94b42$var$emptyBounds = new (0, $7wtv9.Bounds)(0, 0, 0, 0);
const $b425caa62af94b42$var$_ParticleContainer = class _ParticleContainer extends (0, $b9FQU.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = {}){
        options = {
            ..._ParticleContainer.defaultOptions,
            ...options,
            dynamicProperties: {
                ..._ParticleContainer.defaultOptions.dynamicProperties,
                ...options?.dynamicProperties
            }
        };
        const { dynamicProperties: dynamicProperties, shader: shader, roundPixels: roundPixels, texture: texture, particles: particles, ...rest } = options;
        super({
            label: "ParticleContainer",
            ...rest
        });
        /**
     * The unique identifier for the render pipe of this ParticleContainer.
     * @internal
     */ this.renderPipeId = "particle";
        /** @internal */ this.batched = false;
        /**
     * Indicates if the children of this ParticleContainer have changed and need to be updated.
     * @internal
     */ this._childrenDirty = false;
        this.texture = texture || null;
        this.shader = shader;
        this._properties = {};
        for(const key in 0, $l3ImM.particleData){
            const property = (0, $l3ImM.particleData)[key];
            const dynamic = dynamicProperties[key];
            this._properties[key] = {
                ...property,
                dynamic: dynamic
            };
        }
        this.allowChildren = true;
        this.roundPixels = roundPixels ?? false;
        this.particleChildren = particles ?? [];
    }
    /**
   * Adds one or more particles to the container. The particles will be rendered using the container's shared texture
   * and properties. When adding multiple particles, they must all share the same base texture.
   * @example
   * ```ts
   * const container = new ParticleContainer();
   *
   * // Add a single particle
   * const particle = new Particle(Assets.get('particleTexture'));
   * container.addParticle(particle);
   *
   * // Add multiple particles at once
   * const particles = [
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture'))
   * ];
   *
   * container.addParticle(...particles);
   * ```
   * @param children - The Particle(s) to add to the container
   * @returns The first particle that was added, for method chaining
   * @see {@link ParticleContainer#texture} For setting the shared texture
   * @see {@link ParticleContainer#update} For updating after modifications
   */ addParticle(...children) {
        for(let i = 0; i < children.length; i++)this.particleChildren.push(children[i]);
        this.onViewUpdate();
        return children[0];
    }
    /**
   * Removes one or more particles from the container. The particles must already be children
   * of this container to be removed.
   * @example
   * ```ts
   * // Remove a single particle
   * container.removeParticle(particle1);
   *
   * // Remove multiple particles at once
   * container.removeParticle(particle2, particle3);
   * ```
   * @param children - The Particle(s) to remove from the container
   * @returns The first particle that was removed, for method chaining
   * @see {@link ParticleContainer#particleChildren} For accessing all particles
   * @see {@link ParticleContainer#removeParticles} For removing particles by index
   * @see {@link ParticleContainer#removeParticleAt} For removing a particle at a specific index
   */ removeParticle(...children) {
        let didRemove = false;
        for(let i = 0; i < children.length; i++){
            const index = this.particleChildren.indexOf(children[i]);
            if (index > -1) {
                this.particleChildren.splice(index, 1);
                didRemove = true;
            }
        }
        if (didRemove) this.onViewUpdate();
        return children[0];
    }
    /**
   * Updates the particle container's internal state. Call this method after manually modifying
   * the particleChildren array or when changing static properties of particles.
   * @example
   * ```ts
   * // Batch modify particles
   * container.particleChildren.push(...particles);
   * container.update(); // Required after direct array modification
   *
   * // Update static properties
   * container.particleChildren.forEach(particle => {
   *     particle.position.set(
   *         Math.random() * 800,
   *         Math.random() * 600
   *     );
   * });
   * container.update(); // Required after changing static positions
   * ```
   * @see {@link ParticleProperties} For configuring dynamic vs static properties
   * @see {@link ParticleContainer#particleChildren} For direct array access
   */ update() {
        this._childrenDirty = true;
    }
    onViewUpdate() {
        this._childrenDirty = true;
        super.onViewUpdate();
    }
    /**
   * Returns a static empty bounds object since ParticleContainer does not calculate bounds automatically
   * for performance reasons. Use the `boundsArea` property to manually set container bounds.
   * @example
   * ```ts
   * const container = new ParticleContainer({
   *     texture: Texture.from('particle.png')
   * });
   *
   * // Default bounds are empty
   * console.log(container.bounds); // Bounds(0, 0, 0, 0)
   *
   * // Set manual bounds for the particle area
   * container.boundsArea = {
   *     minX: 0,
   *     minY: 0,
   *     maxX: 800,
   *     maxY: 600
   * };
   * ```
   * @readonly
   * @returns {Bounds} An empty bounds object (0,0,0,0)
   * @see {@link Container#boundsArea} For manually setting container bounds
   * @see {@link Bounds} For bounds object structure
   */ get bounds() {
        return $b425caa62af94b42$var$emptyBounds;
    }
    /** @private */ updateBounds() {}
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * particleContainer.destroy();
   * particleContainer.destroy(true);
   * particleContainer.destroy({ texture: true, textureSource: true, children: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            const texture = this.texture ?? this.particleChildren[0]?.texture;
            if (texture) texture.destroy(destroyTextureSource);
        }
        this.texture = null;
        this.shader?.destroy();
    }
    /**
   * Removes all particles from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed particles
   */ removeParticles(beginIndex, endIndex) {
        beginIndex ?? (beginIndex = 0);
        endIndex ?? (endIndex = this.particleChildren.length);
        const children = this.particleChildren.splice(beginIndex, endIndex - beginIndex);
        this.onViewUpdate();
        return children;
    }
    /**
   * Removes a particle from the specified index position.
   * @param index - The index to get the particle from
   * @returns The particle that was removed.
   */ removeParticleAt(index) {
        const child = this.particleChildren.splice(index, 1);
        this.onViewUpdate();
        return child[0];
    }
    /**
   * Adds a particle to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the particle is already in this container, it will be moved to the specified index.
   * @param {Container} child - The particle to add.
   * @param {number} index - The absolute index where the particle will be positioned at the end of the operation.
   * @returns {Container} The particle that was added.
   */ addParticleAt(child, index) {
        this.particleChildren.splice(index, 0, child);
        this.onViewUpdate();
        return child;
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChild(..._children) {
        throw new Error("ParticleContainer.addChild() is not available. Please use ParticleContainer.addParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChild(..._children) {
        throw new Error("ParticleContainer.removeChild() is not available. Please use ParticleContainer.removeParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticles()` instead.
   * @param {number} [_beginIndex]
   * @param {number} [_endIndex]
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildren(_beginIndex, _endIndex) {
        throw new Error("ParticleContainer.removeChildren() is not available. Please use ParticleContainer.removeParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildAt(_index) {
        throw new Error("ParticleContainer.removeChildAt() is not available. Please use ParticleContainer.removeParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildAt(_index) {
        throw new Error("ParticleContainer.getChildAt() is not available. Please use ParticleContainer.getParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.setParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ setChildIndex(_child, _index) {
        throw new Error("ParticleContainer.setChildIndex() is not available. Please use ParticleContainer.setParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildIndex(_child) {
        throw new Error("ParticleContainer.getChildIndex() is not available. Please use ParticleContainer.getParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticleAt()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChildAt(_child, _index) {
        throw new Error("ParticleContainer.addChildAt() is not available. Please use ParticleContainer.addParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.swapParticles()` instead.
   * @param {ContainerChild} _child
   * @param {ContainerChild} _child2
   * @ignore
   */ swapChildren(_child, _child2) {
        throw new Error("ParticleContainer.swapChildren() is not available. Please use ParticleContainer.swapParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChild(..._child) {
        throw new Error("ParticleContainer.reparentChild() is not available with the particle container");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @param _index - The index to reparent the child to
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChildAt(_child, _index) {
        throw new Error("ParticleContainer.reparentChildAt() is not available with the particle container");
    }
};
/**
 * Defines the default options for creating a ParticleContainer.
 * @example
 * ```ts
 * // Change defaults globally
 * ParticleContainer.defaultOptions = {
 *     dynamicProperties: {
 *         position: true,  // Update positions each frame
 *         rotation: true,  // Update rotations each frame
 *         vertex: false,   // Static vertices
 *         uvs: false,      // Static texture coordinates
 *         color: false     // Static colors
 *     },
 *     roundPixels: true // Enable pixel rounding for crisp rendering
 * };
 * ```
 * @property {Record<string, boolean>} dynamicProperties - Specifies which properties are dynamic.
 * @property {boolean} roundPixels - Indicates if pixels should be  rounded.
 */ $b425caa62af94b42$var$_ParticleContainer.defaultOptions = {
    /** Specifies which properties are dynamic. */ dynamicProperties: {
        /** Indicates if vertex positions are dynamic. */ vertex: false,
        /** Indicates if particle positions are dynamic. */ position: true,
        /** Indicates if particle rotations are dynamic. */ rotation: false,
        /** Indicates if UV coordinates are dynamic. */ uvs: false,
        /** Indicates if particle colors are dynamic. */ color: false
    },
    /** Indicates if pixels should be rounded for rendering. */ roundPixels: false
};
let $b425caa62af94b42$export$e63bf72b2cfda112 = $b425caa62af94b42$var$_ParticleContainer;

});
parcelRegister("l3ImM", function(module, exports) {

$parcel$export(module.exports, "particleData", () => $dc30c934e05d5c6c$export$a7ffd1f9edff60c0);
"use strict";
const $dc30c934e05d5c6c$export$a7ffd1f9edff60c0 = {
    vertex: {
        attributeName: "aVertex",
        format: "float32x2",
        code: `
            const texture = p.texture;
            const sx = p.scaleX;
            const sy = p.scaleY;
            const ax = p.anchorX;
            const ay = p.anchorY;
            const trim = texture.trim;
            const orig = texture.orig;

            if (trim)
            {
                w1 = trim.x - (ax * orig.width);
                w0 = w1 + trim.width;

                h1 = trim.y - (ay * orig.height);
                h0 = h1 + trim.height;
            }
            else
            {
                w1 = -ax * (orig.width);
                w0 = w1 + orig.width;

                h1 = -ay * (orig.height);
                h0 = h1 + orig.height;
            }

            f32v[offset] = w1 * sx;
            f32v[offset + 1] = h1 * sy;

            f32v[offset + stride] = w0 * sx;
            f32v[offset + stride + 1] = h1 * sy;

            f32v[offset + (stride * 2)] = w0 * sx;
            f32v[offset + (stride * 2) + 1] = h0 * sy;

            f32v[offset + (stride * 3)] = w1 * sx;
            f32v[offset + (stride * 3) + 1] = h0 * sy;
        `,
        dynamic: false
    },
    // positionData
    position: {
        attributeName: "aPosition",
        format: "float32x2",
        code: `
            var x = p.x;
            var y = p.y;

            f32v[offset] = x;
            f32v[offset + 1] = y;

            f32v[offset + stride] = x;
            f32v[offset + stride + 1] = y;

            f32v[offset + (stride * 2)] = x;
            f32v[offset + (stride * 2) + 1] = y;

            f32v[offset + (stride * 3)] = x;
            f32v[offset + (stride * 3) + 1] = y;
        `,
        dynamic: true
    },
    // rotationData
    rotation: {
        attributeName: "aRotation",
        format: "float32",
        code: `
            var rotation = p.rotation;

            f32v[offset] = rotation;
            f32v[offset + stride] = rotation;
            f32v[offset + (stride * 2)] = rotation;
            f32v[offset + (stride * 3)] = rotation;
        `,
        dynamic: false
    },
    // uvsData
    uvs: {
        attributeName: "aUV",
        format: "float32x2",
        code: `
            var uvs = p.texture.uvs;

            f32v[offset] = uvs.x0;
            f32v[offset + 1] = uvs.y0;

            f32v[offset + stride] = uvs.x1;
            f32v[offset + stride + 1] = uvs.y1;

            f32v[offset + (stride * 2)] = uvs.x2;
            f32v[offset + (stride * 2) + 1] = uvs.y2;

            f32v[offset + (stride * 3)] = uvs.x3;
            f32v[offset + (stride * 3) + 1] = uvs.y3;
        `,
        dynamic: false
    },
    // tintData
    color: {
        attributeName: "aColor",
        format: "unorm8x4",
        code: `
            const c = p.color;

            u32v[offset] = c;
            u32v[offset + stride] = c;
            u32v[offset + (stride * 2)] = c;
            u32v[offset + (stride * 3)] = c;
        `,
        dynamic: false
    }
};

});



parcelRegister("hA6FJ", function(module, exports) {

$parcel$export(module.exports, "Colors", () => $a4f0dd072ed4d447$export$c537fa0d021d010b);
$parcel$export(module.exports, "Typography", () => $a4f0dd072ed4d447$export$1c6175f3aa4394b7);
$parcel$export(module.exports, "Spacing", () => $a4f0dd072ed4d447$export$a39947a896defee6);
$parcel$export(module.exports, "LineArt", () => $a4f0dd072ed4d447$export$baffdc141f48470e);
/**
 * Utopia Must Dance - Design Constants
 *
 * Central repository for all visual design values including colors, typography,
 * spacing, and other design tokens. This ensures consistency across the entire
 * game and makes it easy to maintain the vector graphics arcade aesthetic.
 *
 * ## Usage Examples
 *
 * ### Colors
 * ```typescript
 * import { Colors } from '../config/DesignConstants';
 *
 * this.sprite.stroke({ color: Colors.RED, width: 2 });
 * this.sprite.fill({ color: Colors.DARK_BLUE });
 * ```
 *
 * ### Typography
 * ```typescript
 * import { Typography } from '../config/DesignConstants';
 *
 * new VectorText({
 *   text: "GAME OVER",
 *   scale: Typography.FONT_SIZE.LARGE_HEADER / 10,
 *   color: Colors.RED
 * });
 * ```
 *
 * ### Spacing
 * ```typescript
 * import { Spacing } from '../config/DesignConstants';
 *
 * this.width = textWidth + Spacing.XL;
 * this.height = textHeight + Spacing.MD;
 * ```
 *
 * ### Line Art
 * ```typescript
 * import { LineArt } from '../config/DesignConstants';
 *
 * this.sprite.stroke({
 *   color: Colors.CYAN,
 *   width: LineArt.LINE_WIDTH.STANDARD
 * });
 * ```
 */ // =============================================================================
// COLOR PALETTE
// =============================================================================
/** Color palette for the vector graphics aesthetic */ const $a4f0dd072ed4d447$export$c537fa0d021d010b = {
    WHITE: 0xffffff,
    GRAY: 0xaaaaaa,
    BLACK: 0x000010,
    RED: 0xff0000,
    DARK_RED: 0xaa0000,
    CRIMSON: 0xdc143c,
    DARK_CRIMSON: 0x8b0000,
    CORAL: 0xff6347,
    DARK_CORAL: 0x8b3626,
    ORANGE: 0xff4500,
    DARK_ORANGE: 0xaa3000,
    YELLOW: 0xffff00,
    DARK_YELLOW: 0xaaaa00,
    GREEN: 0x00ff00,
    DARK_GREEN: 0x00aa00,
    CYAN: 0x00ffff,
    DARK_CYAN: 0x00aaaa,
    BLUE: 0x0080ff,
    DARK_BLUE: 0x005599,
    PINK: 0xff1493,
    DARK_PINK: 0xaa0e62,
    MAGENTA: 0xff00ff,
    DARK_MAGENTA: 0x800080,
    PURPLE: 0x8a2be2,
    DARK_PURPLE: 0x5c1d96
};
const $a4f0dd072ed4d447$export$1c6175f3aa4394b7 = {
    // Font sizes (in pixels)
    FONT_SIZE: {
        LARGE_HEADER: 32,
        MEDIUM_HEADER: 24,
        UI_TEXT: 16,
        SMALL_TEXT: 12,
        // Legacy sizes (for gradual migration)
        TITLE_LARGE: 64,
        TITLE_MEDIUM: 40,
        TITLE_STANDARD: 48,
        BUTTON_TEXT: 24,
        BODY_TEXT: 19,
        SCORE_LARGE: 24,
        SCORE_SMALL: 20
    }
};
const $a4f0dd072ed4d447$export$a39947a896defee6 = {
    XS: 4,
    SM: 8,
    MD: 16,
    LG: 24,
    XL: 32,
    XXL: 48,
    // Common layout values
    PADDING: {
        BUTTON: 16,
        BUTTON_LARGE: 24,
        CARD: 24,
        SCREEN_EDGE: 20
    },
    MARGIN: {
        BUTTON_GROUP: 16,
        SECTION: 32,
        TITLE: 32
    }
};
const $a4f0dd072ed4d447$export$baffdc141f48470e = {
    // Line weights
    LINE_WIDTH: {
        THIN: 1,
        STANDARD: 2,
        HEAVY: 3
    },
    // Corner styles
    LINE_JOIN: "round",
    LINE_CAP: "round"
};

});

parcelRegister("kdszX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c72b6b95368f7f$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");

var $gehDP = parcelRequire("gehDP");

var $e2Ri5 = parcelRequire("e2Ri5");

var $9iM1N = parcelRequire("9iM1N");

var $hiAPF = parcelRequire("hiAPF");

var $kD5ZK = parcelRequire("kD5ZK");

var $fknLd = parcelRequire("fknLd");

var $lKWt6 = parcelRequire("lKWt6");

var $8HrgI = parcelRequire("8HrgI");

var $jOKqM = parcelRequire("jOKqM");

var $ggGVw = parcelRequire("ggGVw");

var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
class $e4c72b6b95368f7f$export$2e2bcd8739ae039 {
    get io() {
        return this._io;
    }
    set io(value) {
        this._io = value;
    }
    /** TODO: Document game.camera */ get camera() {
        return this.renderer.camera;
    }
    /** The average frame duration in seconds */ get averageDt() {
        return this.slowMo / (this.averageFrameDuration * this.ticksPerSecond);
    }
    /** Manages slow motion effects in the game */ get slowMoManager() {
        return this.entities.getById("slowMoManager");
    }
    /** Multiplier of time that passes during tick */ get slowMo() {
        return this._slowMo;
    }
    set slowMo(value) {
        if (value != this._slowMo) {
            this._slowMo = value;
            this.dispatch("slowMoChanged", {
                slowMo: this._slowMo
            });
        }
    }
    /**
   * Create a new Game.
   * NOTE: You must call .init() before actually using the game.
   */ constructor({ audio: audio, ticksPerSecond: ticksPerSecond = 120, world: world, slowMoRampSpeed: slowMoRampSpeed = 8.0 } = {}){
        /** Readonly. Whether or not the game is paused */ this.paused = false;
        /** Readonly. Number of frames that have gone by */ this.framenumber = 0;
        /** Readonly. Number of ticks that have gone by */ this.ticknumber = 0;
        /** The timestamp when the last frame started */ this.lastFrameTime = window.performance.now();
        /** Total amount of game time that has elapsed */ this.elapsedTime = 0;
        /** Total amount of game time that has elapsed while not paused */ this.elapsedUnpausedTime = 0;
        /** Keep track of how long each frame is taking on average */ this.averageFrameDuration = 1 / 60;
        this._slowMo = 1.0;
        /** Add an entity to the game. */ this.addEntity = (entity)=>{
            entity.game = this;
            if (entity.onAdd) entity.onAdd({
                game: this
            });
            // If the entity was destroyed during it's onAdd, we shouldn't add it
            if (!entity.game) return entity;
            this.entities.add(entity);
            this.io.addHandler(entity);
            if (entity.body) {
                entity.body.owner = entity;
                this.world.addBody(entity.body);
            }
            if (entity.bodies) for (const body of entity.bodies){
                body.owner = entity;
                this.world.addBody(body);
            }
            if (entity.springs) for (const spring of entity.springs)this.world.addSpring(spring);
            if (entity.constraints) for (const constraint of entity.constraints)this.world.addConstraint(constraint);
            if (entity.sprite) {
                this.renderer.addSprite(entity.sprite);
                entity.sprite.owner = entity;
            }
            if (entity.sprites) for (const sprite of entity.sprites){
                this.renderer.addSprite(sprite);
                sprite.owner = entity;
            }
            if (entity.onResize) entity.onResize({
                size: this.renderer.getSize()
            });
            if (entity.children) {
                for (const child of entity.children)if (!child.game) this.addEntity(child);
            }
            if (entity.onAfterAdded) entity.onAfterAdded({
                game: this
            });
            return entity;
        };
        this.timeToSimulate = 0.0;
        this.iterationsRemaining = 0.0;
        // Handle beginning of collision between things.
        // Fired during narrowphase.
        this.beginContact = (contactInfo)=>{
            this.contactList.beginContact(contactInfo);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onBeginContact) ownerA.onBeginContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB,
                    contactEquations: contactEquations
                });
                if (ownerB?.onBeginContact) ownerB.onBeginContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA,
                    contactEquations: contactEquations
                });
            }
        };
        // Handle end of collision between things.
        // Fired during narrowphase.
        this.endContact = (contactInfo)=>{
            this.contactList.endContact(contactInfo);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onEndContact) ownerA.onEndContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB
                });
                if (ownerB?.onEndContact) ownerB.onEndContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA
                });
            }
        };
        // Handle collision between things.
        // Fired after physics step.
        this.impact = (e)=>{
            const ownerA = e.bodyA.owner;
            const ownerB = e.bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onImpact) ownerA.onImpact({
                    other: ownerB
                });
                if (ownerB?.onImpact) ownerB.onImpact({
                    other: ownerA
                });
            }
        };
        /**
   * Track audio nodes created (for debugging)
   */ this.audioNodeCount = 0;
        this.entities = new (0, $fknLd.default)();
        this.entitiesToRemove = new Set();
        this.renderer = new (0, $lKWt6.GameRenderer2d)((0, $gehDP.LAYERS), (0, $gehDP.DEFAULT_LAYER), this.onResize.bind(this));
        this.ticksPerSecond = ticksPerSecond;
        this.tickDuration = 1.0 / this.ticksPerSecond;
        this.slowMoRampSpeed = slowMoRampSpeed;
        // this.world = new World({ gravity: [0, 0] });
        this.world = world ?? new (0, $jOKqM.default)({
            gravity: [
                0,
                0
            ]
        });
        this.world.on("beginContact", this.beginContact, null);
        this.world.on("endContact", this.endContact, null);
        this.world.on("impact", this.impact, null);
        this.ground = new (0, (/*@__PURE__*/$parcel$interopDefault($biKyI))).Body({
            mass: 0
        });
        this.world.addBody(this.ground);
        this.contactList = new (0, $hiAPF.default)();
        this.audio = audio ?? new AudioContext();
        this.masterGain = this.audio.createGain();
        this.masterGain.connect(this.audio.destination);
        // Load volume from localStorage
        const savedVolume = localStorage.getItem("gameVolume");
        if (savedVolume !== null) this.masterGain.gain.value = parseFloat(savedVolume);
    }
    /** Start the event loop for the game. */ async init({ rendererOptions: rendererOptions = {} } = {}) {
        await this.renderer.init(rendererOptions);
        this.io = new (0, $8HrgI.IOManager)(this.renderer.canvas);
        this.addEntity(this.renderer.camera);
        this.addEntity(new (0, $ggGVw.SlowMoManager)(this.slowMoRampSpeed));
        this.addEntity(new (0, $9iM1N.default)());
        window.requestAnimationFrame(()=>this.loop(this.lastFrameTime));
    }
    /** See pause() and unpause(). */ togglePause() {
        if (this.paused) this.unpause();
        else this.pause();
    }
    /** TODO: Document onResize */ onResize(size) {
        this.dispatch("resize", {
            size: (0, $cbsax.V)(size)
        });
    }
    /**
   * Pauses the game. This stops physics from running, calls onPause()
   * handlers, and stops updating `pausable` entities.
   */ pause() {
        if (!this.paused) {
            this.paused = true;
            this.dispatch("pause", undefined, false);
        }
    }
    /** Resumes the game and calls onUnpause() handlers. */ unpause() {
        this.paused = false;
        this.dispatch("unpause", undefined, false);
    }
    /** Dispatch an event. */ dispatch(eventName, data, respectPause = true) {
        const effectivelyPaused = respectPause && this.paused;
        for (const entity of this.entities.getHandlers(eventName))if (entity.game && !(effectivelyPaused && entity.pausable)) {
            const functionName = (0, $kD5ZK.eventHandlerName)(eventName);
            entity[functionName](data);
        }
    }
    /** Shortcut for adding multiple entities. */ addEntities(...entities) {
        for (const entity of entities)this.addEntity(entity);
        return entities;
    }
    /**
   * Remove an entity from the game.
   * The entity will actually be removed during the next removal pass.
   * This is because there are times when it's not safe to remove an entity, like in the middle of a physics step.
   */ removeEntity(entity) {
        entity.game = undefined;
        if (this.world.stepping) this.entitiesToRemove.add(entity);
        else this.cleanupEntity(entity);
        return entity;
    }
    /**
   * Removes all non-persistent entities from the game scene.
   * Only removes top-level entities (those without parents) to avoid double-cleanup.
   *
   * @param persistenceThreshold - Entities with persistence level <= this value will be removed (default: 0)
   * @example
   * // Remove all level-specific entities (Persistence.Level)
   * game.clearScene();
   *
   * // Remove level and game-specific entities (Persistence.Level and Persistence.Game)
   * game.clearScene(Persistence.Game);
   */ clearScene(persistenceThreshold = 0) {
        for (const entity of this.entities)if (entity.game && // Not already destroyed
        !this.entitiesToRemove.has(entity) && // not already about to be destroyed
        entity.persistenceLevel <= persistenceThreshold && !entity.parent // We only wanna deal with top-level things, let parents handle the rest
        ) entity.destroy();
    }
    /** The main event loop. Run one frame of the game.  */ loop(time) {
        window.requestAnimationFrame((t)=>this.loop(t));
        this.framenumber += 1;
        const lastFrameDuration = (time - this.lastFrameTime) / 1000;
        this.lastFrameTime = time;
        // TODO: This honestly doesn't work great
        // Keep a rolling average
        if (0 < lastFrameDuration && lastFrameDuration < 0.3) // Ignore weird durations because they're probably flukes from the user
        // changing to a different tab/window or loading a new level or something
        this.averageFrameDuration = (0, $jd0t2.lerp)(this.averageFrameDuration, lastFrameDuration, 0.05);
        const renderDt = 1.0 / this.getScreenFps();
        this.elapsedTime += renderDt;
        if (!this.paused) this.elapsedUnpausedTime += renderDt;
        this.slowTick(renderDt * this.slowMo);
        this.timeToSimulate += renderDt * this.slowMo;
        while(this.timeToSimulate >= this.tickDuration){
            this.timeToSimulate -= this.tickDuration;
            this.tick(this.tickDuration);
            if (!this.paused) {
                const stepDt = this.tickDuration;
                this.world.step(stepDt);
                this.cleanupEntities();
                this.contacts();
            }
        }
        this.afterPhysics();
        this.render(renderDt);
    }
    /**
   * Calculates and returns the current screen frames per second based on average frame duration.
   * @returns The current FPS rounded to the nearest integer
   */ getScreenFps() {
        const duration = this.averageFrameDuration;
        return Math.round(1.0 / duration);
    }
    /** Actually remove all the entities slated for removal from the game. */ cleanupEntities() {
        for (const entity of this.entitiesToRemove)this.cleanupEntity(entity);
        this.entitiesToRemove.clear();
    }
    cleanupEntity(entity) {
        entity.game = undefined; // This should be done by `removeEntity`, but better safe than sorry
        this.entities.remove(entity);
        this.io.removeHandler(entity);
        if (entity.body) this.world.removeBody(entity.body);
        if (entity.bodies) for (const body of entity.bodies)this.world.removeBody(body);
        if (entity.springs) for (const spring of entity.springs)this.world.removeSpring(spring);
        if (entity.constraints) for (const constraint of entity.constraints)this.world.removeConstraint(constraint);
        if (entity.sprite) {
            this.renderer.removeSprite(entity.sprite);
            entity.sprite.destroy();
        }
        if (entity.sprites) for (const sprite of entity.sprites){
            this.renderer.removeSprite(sprite);
            sprite.destroy();
        }
        if (entity.onDestroy) entity.onDestroy({
            game: this
        });
    }
    /** Called before physics. */ tick(dt) {
        this.ticknumber += 1;
        this.dispatch("beforeTick", dt);
        this.dispatch("tick", dt);
    }
    /** Called before normal ticks */ slowTick(dt) {
        this.dispatch("slowTick", dt);
    }
    /** Called after physics. */ afterPhysics() {
        this.cleanupEntities();
        this.dispatch("afterPhysics", undefined);
    }
    /** Called before actually rendering. */ render(dt) {
        this.cleanupEntities();
        this.dispatch("render", dt);
        this.dispatch("lateRender", dt);
        this.renderer.render();
    }
    contacts() {
        for (const contactInfo of this.contactList.getContacts()){
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            if (ownerA?.onContacting) ownerA.onContacting({
                other: ownerB,
                otherShape: shapeB,
                thisShape: shapeA,
                contactEquations: contactEquations
            });
            if (ownerB?.onContacting) ownerB.onContacting({
                other: ownerA,
                otherShape: shapeA,
                thisShape: shapeB,
                contactEquations: contactEquations
            });
        }
    }
    /**
   * Get count of audio nodes created
   */ getAudioNodeCount() {
        return this.audioNodeCount;
    }
    /**
   * Increment audio node counter (called by sound generators)
   */ incrementAudioNodeCount() {
        this.audioNodeCount++;
    }
    /**
   * Debug method to log memory usage statistics.
   * Call this periodically to monitor for memory leaks.
   */ logMemoryStats() {
        console.log("=== Game Memory Stats ===");
        console.log(`Entities: ${this.entities.all.size}`);
        console.log(`Entities to remove: ${this.entitiesToRemove.size}`);
        console.log(`Contacts: ${this.contactList.getContacts().length}`);
        console.log(`Sprites: ${this.renderer.spriteCount}`);
        console.log(`Physics bodies: ${this.world.bodies.length}`);
        console.log(`Audio nodes created: ${this.audioNodeCount}`);
        console.log(`Frame number: ${this.framenumber}`);
        // Check if performance.memory is available (Chromium-based browsers)
        if ("memory" in performance) {
            const memory = performance.memory;
            console.log(`Used JS heap: ${(memory.usedJSHeapSize / 1024 / 1024).toFixed(2)} MB`);
            console.log(`Total JS heap: ${(memory.totalJSHeapSize / 1024 / 1024).toFixed(2)} MB`);
            console.log(`Heap limit: ${(memory.jsHeapSizeLimit / 1024 / 1024).toFixed(2)} MB`);
        }
        console.log("========================");
    }
    /**
   * Cleans up all game resources. Should be called when the game is no longer needed.
   * This prevents memory leaks when closing/refreshing the browser tab.
   */ destroy() {
        // Remove all entities
        this.clearScene((0, $e2Ri5.PersistenceLevel).Game);
        // Clean up renderer
        this.renderer.destroy();
        // Clean up IO manager
        this.io.destroy();
        // Close audio context
        if (this.audio.state !== "closed") this.audio.close();
    }
}

});
parcelRegister("biKyI", function(module, exports) {
// Export p2 classes












































var $83a57dc453139d82$var$p2 = module.exports = {
    AABB: (parcelRequire("hkl1e")),
    AngleLockEquation: (parcelRequire("5PEF1")),
    Body: (parcelRequire("e7hLo")),
    Broadphase: (parcelRequire("dQgku")),
    Capsule: (parcelRequire("4flMw")),
    Circle: (parcelRequire("OJ0UJ")),
    Constraint: (parcelRequire("3iby4")),
    ContactEquation: (parcelRequire("cSwh0")),
    ContactEquationPool: (parcelRequire("8P1Fq")),
    ContactMaterial: (parcelRequire("hzM8V")),
    Convex: (parcelRequire("clDtn")),
    DistanceConstraint: (parcelRequire("2pi2h")),
    Equation: (parcelRequire("f0tQu")),
    EventEmitter: (parcelRequire("5POlg")),
    FrictionEquation: (parcelRequire("jNxse")),
    FrictionEquationPool: (parcelRequire("gwWMZ")),
    GearConstraint: (parcelRequire("bb1X1")),
    GSSolver: (parcelRequire("hejTV")),
    Heightfield: (parcelRequire("6Xtot")),
    Line: (parcelRequire("d7wN7")),
    LockConstraint: (parcelRequire("48dNO")),
    Material: (parcelRequire("kfn8e")),
    Narrowphase: (parcelRequire("3QUo8")),
    NaiveBroadphase: (parcelRequire("8e56j")),
    Particle: (parcelRequire("fwNHk")),
    Plane: (parcelRequire("hNAi3")),
    Pool: (parcelRequire("kaNFS")),
    RevoluteConstraint: (parcelRequire("fc4SC")),
    PrismaticConstraint: (parcelRequire("1u9oZ")),
    Ray: (parcelRequire("l9ZUH")),
    RaycastResult: (parcelRequire("ZlKj0")),
    Box: (parcelRequire("62ywx")),
    RotationalVelocityEquation: (parcelRequire("5vxRN")),
    SAPBroadphase: (parcelRequire("konik")),
    Shape: (parcelRequire("k7z01")),
    Solver: (parcelRequire("aZxNS")),
    Spring: (parcelRequire("94u9A")),
    TopDownVehicle: (parcelRequire("3TW5l")),
    LinearSpring: (parcelRequire("8ZZ8g")),
    RotationalSpring: (parcelRequire("B7IZE")),
    Utils: (parcelRequire("dMz05")),
    World: (parcelRequire("hGmj1")),
    vec2: (parcelRequire("2Ys9z")),
    version: (parcelRequire("hIDwd")).version
};
Object.defineProperty($83a57dc453139d82$var$p2, 'Rectangle', {
    get: function() {
        console.warn('The Rectangle class has been renamed to Box.');
        return this.Box;
    }
});

});
parcelRegister("hkl1e", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $c9d49bd36db95cd5$var$AABB;
/**
 * Axis aligned bounding box class.
 * @class AABB
 * @constructor
 * @param {Object}  [options]
 * @param {Array}   [options.upperBound]
 * @param {Array}   [options.lowerBound]
 */ function $c9d49bd36db95cd5$var$AABB(options) {
    /**
     * The lower bound of the bounding box.
     * @property lowerBound
     * @type {Array}
     */ this.lowerBound = $2Ys9z.create();
    if (options && options.lowerBound) $2Ys9z.copy(this.lowerBound, options.lowerBound);
    /**
     * The upper bound of the bounding box.
     * @property upperBound
     * @type {Array}
     */ this.upperBound = $2Ys9z.create();
    if (options && options.upperBound) $2Ys9z.copy(this.upperBound, options.upperBound);
}
var $c9d49bd36db95cd5$var$tmp = $2Ys9z.create();
/**
 * Set the AABB bounds from a set of points, transformed by the given position and angle.
 * @method setFromPoints
 * @param {Array} points An array of vec2's.
 * @param {Array} position
 * @param {number} angle
 * @param {number} skinSize Some margin to be added to the AABB.
 */ $c9d49bd36db95cd5$var$AABB.prototype.setFromPoints = function(points, position, angle, skinSize) {
    var l = this.lowerBound, u = this.upperBound;
    if (typeof angle !== "number") angle = 0;
    // Set to the first point
    if (angle !== 0) $2Ys9z.rotate(l, points[0], angle);
    else $2Ys9z.copy(l, points[0]);
    $2Ys9z.copy(u, l);
    // Compute cosines and sines just once
    var cosAngle = Math.cos(angle), sinAngle = Math.sin(angle);
    for(var i = 1; i < points.length; i++){
        var p = points[i];
        if (angle !== 0) {
            var x = p[0], y = p[1];
            $c9d49bd36db95cd5$var$tmp[0] = cosAngle * x - sinAngle * y;
            $c9d49bd36db95cd5$var$tmp[1] = sinAngle * x + cosAngle * y;
            p = $c9d49bd36db95cd5$var$tmp;
        }
        for(var j = 0; j < 2; j++){
            if (p[j] > u[j]) u[j] = p[j];
            if (p[j] < l[j]) l[j] = p[j];
        }
    }
    // Add offset
    if (position) {
        $2Ys9z.add(this.lowerBound, this.lowerBound, position);
        $2Ys9z.add(this.upperBound, this.upperBound, position);
    }
    if (skinSize) {
        this.lowerBound[0] -= skinSize;
        this.lowerBound[1] -= skinSize;
        this.upperBound[0] += skinSize;
        this.upperBound[1] += skinSize;
    }
};
/**
 * Copy bounds from an AABB to this AABB
 * @method copy
 * @param  {AABB} aabb
 */ $c9d49bd36db95cd5$var$AABB.prototype.copy = function(aabb) {
    $2Ys9z.copy(this.lowerBound, aabb.lowerBound);
    $2Ys9z.copy(this.upperBound, aabb.upperBound);
};
/**
 * Extend this AABB so that it covers the given AABB too.
 * @method extend
 * @param  {AABB} aabb
 */ $c9d49bd36db95cd5$var$AABB.prototype.extend = function(aabb) {
    // Loop over x and y
    var i = 2;
    while(i--){
        // Extend lower bound
        var l = aabb.lowerBound[i];
        if (this.lowerBound[i] > l) this.lowerBound[i] = l;
        // Upper
        var u = aabb.upperBound[i];
        if (this.upperBound[i] < u) this.upperBound[i] = u;
    }
};
/**
 * Returns true if the given AABB overlaps this AABB.
 * @method overlaps
 * @param  {AABB} aabb
 * @return {Boolean}
 */ $c9d49bd36db95cd5$var$AABB.prototype.overlaps = function(aabb) {
    var l1 = this.lowerBound, u1 = this.upperBound, l2 = aabb.lowerBound, u2 = aabb.upperBound;
    //      l2        u2
    //      |---------|
    // |--------|
    // l1       u1
    return (l2[0] <= u1[0] && u1[0] <= u2[0] || l1[0] <= u2[0] && u2[0] <= u1[0]) && (l2[1] <= u1[1] && u1[1] <= u2[1] || l1[1] <= u2[1] && u2[1] <= u1[1]);
};
/**
 * @method containsPoint
 * @param  {Array} point
 * @return {boolean}
 */ $c9d49bd36db95cd5$var$AABB.prototype.containsPoint = function(point) {
    var l = this.lowerBound, u = this.upperBound;
    return l[0] <= point[0] && point[0] <= u[0] && l[1] <= point[1] && point[1] <= u[1];
};
/**
 * Check if the AABB is hit by a ray.
 * @method overlapsRay
 * @param  {Ray} ray
 * @return {number} -1 if no hit, a number between 0 and 1 if hit.
 */ $c9d49bd36db95cd5$var$AABB.prototype.overlapsRay = function(ray) {
    var t = 0;
    // ray.direction is unit direction vector of ray
    var dirFracX = 1 / ray.direction[0];
    var dirFracY = 1 / ray.direction[1];
    // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
    var t1 = (this.lowerBound[0] - ray.from[0]) * dirFracX;
    var t2 = (this.upperBound[0] - ray.from[0]) * dirFracX;
    var t3 = (this.lowerBound[1] - ray.from[1]) * dirFracY;
    var t4 = (this.upperBound[1] - ray.from[1]) * dirFracY;
    var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)));
    var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)));
    // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behing us
    if (tmax < 0) //t = tmax;
    return -1;
    // if tmin > tmax, ray doesn't intersect AABB
    if (tmin > tmax) //t = tmax;
    return -1;
    return tmin;
};

});
parcelRegister("2Ys9z", function(module, exports) {
/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ /**
 * The vec2 object from glMatrix, with some extensions and some removed methods. See http://glmatrix.net.
 * @class vec2
 */ var $22a7061001f45300$var$vec2 = module.exports = {};

var $dMz05 = parcelRequire("dMz05");
/**
 * Make a cross product and only return the z component
 * @method crossLength
 * @static
 * @param  {Array} a
 * @param  {Array} b
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossLength = function(a, b) {
    return a[0] * b[1] - a[1] * b[0];
};
/**
 * Cross product between a vector and the Z component of a vector
 * @method crossVZ
 * @static
 * @param  {Array} out
 * @param  {Array} vec
 * @param  {Number} zcomp
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossVZ = function(out, vec, zcomp) {
    $22a7061001f45300$var$vec2.rotate(out, vec, -Math.PI / 2); // Rotate according to the right hand rule
    $22a7061001f45300$var$vec2.scale(out, out, zcomp); // Scale with z
    return out;
};
/**
 * Cross product between a vector and the Z component of a vector
 * @method crossZV
 * @static
 * @param  {Array} out
 * @param  {Number} zcomp
 * @param  {Array} vec
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossZV = function(out, zcomp, vec) {
    $22a7061001f45300$var$vec2.rotate(out, vec, Math.PI / 2); // Rotate according to the right hand rule
    $22a7061001f45300$var$vec2.scale(out, out, zcomp); // Scale with z
    return out;
};
/**
 * Rotate a vector by an angle
 * @method rotate
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 */ $22a7061001f45300$var$vec2.rotate = function(out, a, angle) {
    if (angle !== 0) {
        var c = Math.cos(angle), s = Math.sin(angle), x = a[0], y = a[1];
        out[0] = c * x - s * y;
        out[1] = s * x + c * y;
    } else {
        out[0] = a[0];
        out[1] = a[1];
    }
};
/**
 * Rotate a vector 90 degrees clockwise
 * @method rotate90cw
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 */ $22a7061001f45300$var$vec2.rotate90cw = function(out, a) {
    var x = a[0];
    var y = a[1];
    out[0] = y;
    out[1] = -x;
};
/**
 * Transform a point position to local frame.
 * @method toLocalFrame
 * @param  {Array} out
 * @param  {Array} worldPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.toLocalFrame = function(out, worldPoint, framePosition, frameAngle) {
    $22a7061001f45300$var$vec2.copy(out, worldPoint);
    $22a7061001f45300$var$vec2.sub(out, out, framePosition);
    $22a7061001f45300$var$vec2.rotate(out, out, -frameAngle);
};
/**
 * Transform a point position to global frame.
 * @method toGlobalFrame
 * @param  {Array} out
 * @param  {Array} localPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.toGlobalFrame = function(out, localPoint, framePosition, frameAngle) {
    $22a7061001f45300$var$vec2.copy(out, localPoint);
    $22a7061001f45300$var$vec2.rotate(out, out, frameAngle);
    $22a7061001f45300$var$vec2.add(out, out, framePosition);
};
/**
 * Transform a vector to local frame.
 * @method vectorToLocalFrame
 * @param  {Array} out
 * @param  {Array} worldVector
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.vectorToLocalFrame = function(out, worldVector, frameAngle) {
    $22a7061001f45300$var$vec2.rotate(out, worldVector, -frameAngle);
};
/**
 * Transform a point position to global frame.
 * @method toGlobalFrame
 * @param  {Array} out
 * @param  {Array} localVector
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.vectorToGlobalFrame = function(out, localVector, frameAngle) {
    $22a7061001f45300$var$vec2.rotate(out, localVector, frameAngle);
};
/**
 * Compute centroid of a triangle spanned by vectors a,b,c. See http://easycalculation.com/analytical/learn-centroid.php
 * @method centroid
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return  {Array} The out object
 */ $22a7061001f45300$var$vec2.centroid = function(out, a, b, c) {
    $22a7061001f45300$var$vec2.add(out, a, b);
    $22a7061001f45300$var$vec2.add(out, out, c);
    $22a7061001f45300$var$vec2.scale(out, out, 1 / 3);
    return out;
};
/**
 * Creates a new, empty vec2
 * @static
 * @method create
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.create = function() {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = 0;
    out[1] = 0;
    return out;
};
/**
 * Creates a new vec2 initialized with values from an existing vector
 * @static
 * @method clone
 * @param {Array} a vector to clone
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.clone = function(a) {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Creates a new vec2 initialized with the given values
 * @static
 * @method fromValues
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.fromValues = function(x, y) {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Copy the values from one vec2 to another
 * @static
 * @method copy
 * @param {Array} out the receiving vector
 * @param {Array} a the source vector
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Set the components of a vec2 to the given values
 * @static
 * @method set
 * @param {Array} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.set = function(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Adds two vec2's
 * @static
 * @method add
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
};
/**
 * Subtracts two vec2's
 * @static
 * @method subtract
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
};
/**
 * Alias for vec2.subtract
 * @static
 * @method sub
 */ $22a7061001f45300$var$vec2.sub = $22a7061001f45300$var$vec2.subtract;
/**
 * Multiplies two vec2's
 * @static
 * @method multiply
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
};
/**
 * Alias for vec2.multiply
 * @static
 * @method mul
 */ $22a7061001f45300$var$vec2.mul = $22a7061001f45300$var$vec2.multiply;
/**
 * Divides two vec2's
 * @static
 * @method divide
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
};
/**
 * Alias for vec2.divide
 * @static
 * @method div
 */ $22a7061001f45300$var$vec2.div = $22a7061001f45300$var$vec2.divide;
/**
 * Scales a vec2 by a scalar number
 * @static
 * @method scale
 * @param {Array} out the receiving vector
 * @param {Array} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
};
/**
 * Calculates the euclidian distance between two vec2's
 * @static
 * @method distance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} distance between a and b
 */ $22a7061001f45300$var$vec2.distance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for vec2.distance
 * @static
 * @method dist
 */ $22a7061001f45300$var$vec2.dist = $22a7061001f45300$var$vec2.distance;
/**
 * Calculates the squared euclidian distance between two vec2's
 * @static
 * @method squaredDistance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} squared distance between a and b
 */ $22a7061001f45300$var$vec2.squaredDistance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
};
/**
 * Alias for vec2.squaredDistance
 * @static
 * @method sqrDist
 */ $22a7061001f45300$var$vec2.sqrDist = $22a7061001f45300$var$vec2.squaredDistance;
/**
 * Calculates the length of a vec2
 * @static
 * @method length
 * @param {Array} a vector to calculate length of
 * @return {Number} length of a
 */ $22a7061001f45300$var$vec2.length = function(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for vec2.length
 * @method len
 * @static
 */ $22a7061001f45300$var$vec2.len = $22a7061001f45300$var$vec2.length;
/**
 * Calculates the squared length of a vec2
 * @static
 * @method squaredLength
 * @param {Array} a vector to calculate squared length of
 * @return {Number} squared length of a
 */ $22a7061001f45300$var$vec2.squaredLength = function(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
};
/**
 * Alias for vec2.squaredLength
 * @static
 * @method sqrLen
 */ $22a7061001f45300$var$vec2.sqrLen = $22a7061001f45300$var$vec2.squaredLength;
/**
 * Negates the components of a vec2
 * @static
 * @method negate
 * @param {Array} out the receiving vector
 * @param {Array} a vector to negate
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
};
/**
 * Normalize a vec2
 * @static
 * @method normalize
 * @param {Array} out the receiving vector
 * @param {Array} a vector to normalize
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.normalize = function(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
};
/**
 * Calculates the dot product of two vec2's
 * @static
 * @method dot
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} dot product of a and b
 */ $22a7061001f45300$var$vec2.dot = function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
};
/**
 * Returns a string representation of a vector
 * @static
 * @method str
 * @param {Array} vec vector to represent as a string
 * @return {String} string representation of the vector
 */ $22a7061001f45300$var$vec2.str = function(a) {
    return 'vec2(' + a[0] + ', ' + a[1] + ')';
};
/**
 * Linearly interpolate/mix two vectors.
 * @static
 * @method lerp
 * @param {Array} out
 * @param {Array} a First vector
 * @param {Array} b Second vector
 * @param {number} t Lerp factor
 */ $22a7061001f45300$var$vec2.lerp = function(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
};
/**
 * Reflect a vector along a normal.
 * @static
 * @method reflect
 * @param {Array} out
 * @param {Array} vector
 * @param {Array} normal
 */ $22a7061001f45300$var$vec2.reflect = function(out, vector, normal) {
    var dot = vector[0] * normal[0] + vector[1] * normal[1];
    out[0] = vector[0] - 2 * normal[0] * dot;
    out[1] = vector[1] - 2 * normal[1] * dot;
};
/**
 * Get the intersection point between two line segments.
 * @static
 * @method getLineSegmentsIntersection
 * @param  {Array} out
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {boolean} True if there was an intersection, otherwise false.
 */ $22a7061001f45300$var$vec2.getLineSegmentsIntersection = function(out, p0, p1, p2, p3) {
    var t = $22a7061001f45300$var$vec2.getLineSegmentsIntersectionFraction(p0, p1, p2, p3);
    if (t < 0) return false;
    else {
        out[0] = p0[0] + t * (p1[0] - p0[0]);
        out[1] = p0[1] + t * (p1[1] - p0[1]);
        return true;
    }
};
/**
 * Get the intersection fraction between two line segments. If successful, the intersection is at p0 + t * (p1 - p0)
 * @static
 * @method getLineSegmentsIntersectionFraction
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {number} A number between 0 and 1 if there was an intersection, otherwise -1.
 */ $22a7061001f45300$var$vec2.getLineSegmentsIntersectionFraction = function(p0, p1, p2, p3) {
    var s1_x = p1[0] - p0[0];
    var s1_y = p1[1] - p0[1];
    var s2_x = p3[0] - p2[0];
    var s2_y = p3[1] - p2[1];
    var s, t;
    s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
    t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) return t;
    return -1; // No collision
};

});
parcelRegister("dMz05", function(module, exports) {
/* global P2_ARRAY_TYPE */ module.exports = $a08ae86a856e7e9e$var$Utils;
/**
 * Misc utility functions
 * @class Utils
 * @constructor
 */ function $a08ae86a856e7e9e$var$Utils() {}
/**
 * Append the values in array b to the array a. See <a href="http://stackoverflow.com/questions/1374126/how-to-append-an-array-to-an-existing-javascript-array/1374131#1374131">this</a> for an explanation.
 * @method appendArray
 * @static
 * @param  {Array} a
 * @param  {Array} b
 */ $a08ae86a856e7e9e$var$Utils.appendArray = function(a, b) {
    if (b.length < 150000) a.push.apply(a, b);
    else for(var i = 0, len = b.length; i !== len; ++i)a.push(b[i]);
};
/**
 * Garbage free Array.splice(). Does not allocate a new array.
 * @method splice
 * @static
 * @param  {Array} array
 * @param  {Number} index
 * @param  {Number} howmany
 */ $a08ae86a856e7e9e$var$Utils.splice = function(array, index, howmany) {
    howmany = howmany || 1;
    for(var i = index, len = array.length - howmany; i < len; i++)array[i] = array[i + howmany];
    array.length = len;
};
/**
 * The array type to use for internal numeric computations throughout the library. Float32Array is used if it is available, but falls back on Array. If you want to set array type manually, inject it via the global variable P2_ARRAY_TYPE. See example below.
 * @static
 * @property {function} ARRAY_TYPE
 * @example
 *     <script>
 *         <!-- Inject your preferred array type before loading p2.js -->
 *         P2_ARRAY_TYPE = Array;
 *     </script>
 *     <script src="p2.js"></script>
 */ if (typeof P2_ARRAY_TYPE !== 'undefined') $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = P2_ARRAY_TYPE;
else if (typeof Float32Array !== 'undefined') $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = Float32Array;
else $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = Array;
/**
 * Extend an object with the properties of another
 * @static
 * @method extend
 * @param  {object} a
 * @param  {object} b
 */ $a08ae86a856e7e9e$var$Utils.extend = function(a, b) {
    for(var key in b)a[key] = b[key];
};
/**
 * Extend an options object with default values.
 * @static
 * @method defaults
 * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
 * @param  {object} defaults An object containing default values.
 * @return {object} The modified options object.
 */ $a08ae86a856e7e9e$var$Utils.defaults = function(options, defaults) {
    options = options || {};
    for(var key in defaults)if (!(key in options)) options[key] = defaults[key];
    return options;
};

});



parcelRegister("5PEF1", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("2Ys9z");
module.exports = $43f14183f1aefb3e$var$AngleLockEquation;
/**
 * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
 *
 * @class AngleLockEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Number} [options.angle] Angle to add to the local vector in body A.
 * @param {Number} [options.ratio] Gear ratio
 */ function $43f14183f1aefb3e$var$AngleLockEquation(bodyA, bodyB, options) {
    options = options || {};
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    this.angle = options.angle || 0;
    /**
     * The gear ratio.
     * @property {Number} ratio
     * @private
     * @see setRatio
     */ this.ratio = typeof options.ratio === "number" ? options.ratio : 1;
    this.setRatio(this.ratio);
}
$43f14183f1aefb3e$var$AngleLockEquation.prototype = new $f0tQu();
$43f14183f1aefb3e$var$AngleLockEquation.prototype.constructor = $43f14183f1aefb3e$var$AngleLockEquation;
$43f14183f1aefb3e$var$AngleLockEquation.prototype.computeGq = function() {
    return this.ratio * this.bodyA.angle - this.bodyB.angle + this.angle;
};
/**
 * Set the gear ratio for this equation
 * @method setRatio
 * @param {Number} ratio
 */ $43f14183f1aefb3e$var$AngleLockEquation.prototype.setRatio = function(ratio) {
    var G = this.G;
    G[2] = ratio;
    G[5] = -1;
    this.ratio = ratio;
};
/**
 * Set the max force for the equation.
 * @method setMaxTorque
 * @param {Number} torque
 */ $43f14183f1aefb3e$var$AngleLockEquation.prototype.setMaxTorque = function(torque) {
    this.maxForce = torque;
    this.minForce = -torque;
};

});
parcelRegister("f0tQu", function(module, exports) {
module.exports = $aece01d762aa979a$var$Equation;

var $2Ys9z = parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
parcelRequire("e7hLo");
/**
 * Base class for constraint equations.
 * @class Equation
 * @constructor
 * @param {Body} bodyA First body participating in the equation
 * @param {Body} bodyB Second body participating in the equation
 * @param {number} minForce Minimum force to apply. Default: -Number.MAX_VALUE
 * @param {number} maxForce Maximum force to apply. Default: Number.MAX_VALUE
 */ function $aece01d762aa979a$var$Equation(bodyA, bodyB, minForce, maxForce) {
    /**
     * Minimum force to apply when solving.
     * @property minForce
     * @type {Number}
     */ this.minForce = typeof minForce === "undefined" ? -Number.MAX_VALUE : minForce;
    /**
     * Max force to apply when solving.
     * @property maxForce
     * @type {Number}
     */ this.maxForce = typeof maxForce === "undefined" ? Number.MAX_VALUE : maxForce;
    /**
     * First body participating in the constraint
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second body participating in the constraint
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
    /**
     * The stiffness of this equation. Typically chosen to a large number (~1e7), but can be chosen somewhat freely to get a stable simulation.
     * @property stiffness
     * @type {Number}
     */ this.stiffness = $aece01d762aa979a$var$Equation.DEFAULT_STIFFNESS;
    /**
     * The number of time steps needed to stabilize the constraint equation. Typically between 3 and 5 time steps.
     * @property relaxation
     * @type {Number}
     */ this.relaxation = $aece01d762aa979a$var$Equation.DEFAULT_RELAXATION;
    /**
     * The Jacobian entry of this equation. 6 numbers, 3 per body (x,y,angle).
     * @property G
     * @type {Array}
     */ this.G = new $dMz05.ARRAY_TYPE(6);
    for(var i = 0; i < 6; i++)this.G[i] = 0;
    this.offset = 0;
    this.a = 0;
    this.b = 0;
    this.epsilon = 0;
    this.timeStep = 1 / 60;
    /**
     * Indicates if stiffness or relaxation was changed.
     * @property {Boolean} needsUpdate
     */ this.needsUpdate = true;
    /**
     * The resulting constraint multiplier from the last solve. This is mostly equivalent to the force produced by the constraint.
     * @property multiplier
     * @type {Number}
     */ this.multiplier = 0;
    /**
     * Relative velocity.
     * @property {Number} relativeVelocity
     */ this.relativeVelocity = 0;
    /**
     * Whether this equation is enabled or not. If true, it will be added to the solver.
     * @property {Boolean} enabled
     */ this.enabled = true;
}
$aece01d762aa979a$var$Equation.prototype.constructor = $aece01d762aa979a$var$Equation;
/**
 * The default stiffness when creating a new Equation.
 * @static
 * @property {Number} DEFAULT_STIFFNESS
 * @default 1e6
 */ $aece01d762aa979a$var$Equation.DEFAULT_STIFFNESS = 1e6;
/**
 * The default relaxation when creating a new Equation.
 * @static
 * @property {Number} DEFAULT_RELAXATION
 * @default 4
 */ $aece01d762aa979a$var$Equation.DEFAULT_RELAXATION = 4;
/**
 * Compute SPOOK parameters .a, .b and .epsilon according to the current parameters. See equations 9, 10 and 11 in the <a href="http://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf">SPOOK notes</a>.
 * @method update
 */ $aece01d762aa979a$var$Equation.prototype.update = function() {
    var k = this.stiffness, d = this.relaxation, h = this.timeStep;
    this.a = 4.0 / (h * (1 + 4 * d));
    this.b = 4.0 * d / (1 + 4 * d);
    this.epsilon = 4.0 / (h * h * k * (1 + 4 * d));
    this.needsUpdate = false;
};
/**
 * Multiply a jacobian entry with corresponding positions or velocities
 * @method gmult
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.gmult = function(G, vi, wi, vj, wj) {
    return G[0] * vi[0] + G[1] * vi[1] + G[2] * wi + G[3] * vj[0] + G[4] * vj[1] + G[5] * wj;
};
/**
 * Computes the RHS of the SPOOK equation
 * @method computeB
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeB = function(a, b, h) {
    var GW = this.computeGW();
    var Gq = this.computeGq();
    var GiMf = this.computeGiMf();
    return -Gq * a - GW * b - GiMf * h;
};
/**
 * Computes G\*q, where q are the generalized body coordinates
 * @method computeGq
 * @return {Number}
 */ var $aece01d762aa979a$var$qi = $2Ys9z.create(), $aece01d762aa979a$var$qj = $2Ys9z.create();
$aece01d762aa979a$var$Equation.prototype.computeGq = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, xi = bi.position, xj = bj.position, ai = bi.angle, aj = bj.angle;
    return this.gmult(G, $aece01d762aa979a$var$qi, ai, $aece01d762aa979a$var$qj, aj) + this.offset;
};
/**
 * Computes G\*W, where W are the body velocities
 * @method computeGW
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGW = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.velocity, vj = bj.velocity, wi = bi.angularVelocity, wj = bj.angularVelocity;
    return this.gmult(G, vi, wi, vj, wj) + this.relativeVelocity;
};
/**
 * Computes G\*Wlambda, where W are the body velocities
 * @method computeGWlambda
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGWlambda = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.vlambda, vj = bj.vlambda, wi = bi.wlambda, wj = bj.wlambda;
    return this.gmult(G, vi, wi, vj, wj);
};
/**
 * Computes G\*inv(M)\*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
 * @method computeGiMf
 * @return {Number}
 */ var $aece01d762aa979a$var$iMfi = $2Ys9z.create(), $aece01d762aa979a$var$iMfj = $2Ys9z.create();
$aece01d762aa979a$var$Equation.prototype.computeGiMf = function() {
    var bi = this.bodyA, bj = this.bodyB, fi = bi.force, ti = bi.angularForce, fj = bj.force, tj = bj.angularForce, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, G = this.G;
    $2Ys9z.scale($aece01d762aa979a$var$iMfi, fi, invMassi);
    $2Ys9z.multiply($aece01d762aa979a$var$iMfi, bi.massMultiplier, $aece01d762aa979a$var$iMfi);
    $2Ys9z.scale($aece01d762aa979a$var$iMfj, fj, invMassj);
    $2Ys9z.multiply($aece01d762aa979a$var$iMfj, bj.massMultiplier, $aece01d762aa979a$var$iMfj);
    return this.gmult(G, $aece01d762aa979a$var$iMfi, ti * invIi, $aece01d762aa979a$var$iMfj, tj * invIj);
};
/**
 * Computes G\*inv(M)\*G'
 * @method computeGiMGt
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGiMGt = function() {
    var bi = this.bodyA, bj = this.bodyB, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, G = this.G;
    return G[0] * G[0] * invMassi * bi.massMultiplier[0] + G[1] * G[1] * invMassi * bi.massMultiplier[1] + G[2] * G[2] * invIi + G[3] * G[3] * invMassj * bj.massMultiplier[0] + G[4] * G[4] * invMassj * bj.massMultiplier[1] + G[5] * G[5] * invIj;
};
var $aece01d762aa979a$var$addToWlambda_temp = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Gi = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Gj = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_ri = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_rj = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Mdiag = $2Ys9z.create();
/**
 * Add constraint velocity to the bodies.
 * @method addToWlambda
 * @param {Number} deltalambda
 */ $aece01d762aa979a$var$Equation.prototype.addToWlambda = function(deltalambda) {
    var bi = this.bodyA, bj = this.bodyB, temp = $aece01d762aa979a$var$addToWlambda_temp, Gi = $aece01d762aa979a$var$addToWlambda_Gi, Gj = $aece01d762aa979a$var$addToWlambda_Gj, ri = $aece01d762aa979a$var$addToWlambda_ri, rj = $aece01d762aa979a$var$addToWlambda_rj, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, Mdiag = $aece01d762aa979a$var$addToWlambda_Mdiag, G = this.G;
    Gi[0] = G[0];
    Gi[1] = G[1];
    Gj[0] = G[3];
    Gj[1] = G[4];
    // Add to linear velocity
    // v_lambda += inv(M) * delta_lamba * G
    $2Ys9z.scale(temp, Gi, invMassi * deltalambda);
    $2Ys9z.multiply(temp, temp, bi.massMultiplier);
    $2Ys9z.add(bi.vlambda, bi.vlambda, temp);
    // This impulse is in the offset frame
    // Also add contribution to angular
    //bi.wlambda -= vec2.crossLength(temp,ri);
    bi.wlambda += invIi * G[2] * deltalambda;
    $2Ys9z.scale(temp, Gj, invMassj * deltalambda);
    $2Ys9z.multiply(temp, temp, bj.massMultiplier);
    $2Ys9z.add(bj.vlambda, bj.vlambda, temp);
    //bj.wlambda -= vec2.crossLength(temp,rj);
    bj.wlambda += invIj * G[5] * deltalambda;
};
/**
 * Compute the denominator part of the SPOOK equation: C = G\*inv(M)\*G' + eps
 * @method computeInvC
 * @param  {Number} eps
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeInvC = function(eps) {
    return 1.0 / (this.computeGiMGt() + eps);
};

});
parcelRegister("e7hLo", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $32CtG = parcelRequire("32CtG");

var $clDtn = parcelRequire("clDtn");

var $ZlKj0 = parcelRequire("ZlKj0");

var $l9ZUH = parcelRequire("l9ZUH");

var $hkl1e = parcelRequire("hkl1e");

var $5POlg = parcelRequire("5POlg");
module.exports = $a46f7f8fe64db8b3$var$Body;
/**
 * A rigid body. Has got a center of mass, position, velocity and a number of
 * shapes that are used for collisions.
 *
 * @class Body
 * @constructor
 * @extends EventEmitter
 * @param {Object} [options]
 * @param {Array} [options.force]
 * @param {Array} [options.position]
 * @param {Array} [options.velocity]
 * @param {Boolean} [options.allowSleep]
 * @param {Boolean} [options.collisionResponse]
 * @param {Number} [options.angle=0]
 * @param {Number} [options.angularForce=0]
 * @param {Number} [options.angularVelocity=0]
 * @param {Number} [options.ccdIterations=10]
 * @param {Number} [options.ccdSpeedThreshold=-1]
 * @param {Number} [options.fixedRotation=false]
 * @param {Number} [options.gravityScale]
 * @param {Number} [options.id]
 * @param {Number} [options.mass=0] A number >= 0. If zero, the .type will be set to Body.STATIC.
 * @param {Number} [options.sleepSpeedLimit]
 * @param {Number} [options.sleepTimeLimit]
 *
 * @example
 *
 *     // Create a typical dynamic body
 *     var body = new Body({
 *         mass: 1,
 *         position: [0, 0],
 *         angle: 0,
 *         velocity: [0, 0],
 *         angularVelocity: 0
 *     });
 *
 *     // Add a circular shape to the body
 *     body.addShape(new Circle({ radius: 1 }));
 *
 *     // Add the body to the world
 *     world.addBody(body);
 */ function $a46f7f8fe64db8b3$var$Body(options) {
    options = options || {};
    $5POlg.call(this);
    /**
     * The body identifyer
     * @property id
     * @type {Number}
     */ this.id = options.id || ++$a46f7f8fe64db8b3$var$Body._idCounter;
    /**
     * The world that this body is added to. This property is set to NULL if the body is not added to any world.
     * @property world
     * @type {World}
     */ this.world = null;
    /**
     * The shapes of the body.
     *
     * @property shapes
     * @type {Array}
     */ this.shapes = [];
    /**
     * The mass of the body.
     * @property mass
     * @type {number}
     */ this.mass = options.mass || 0;
    /**
     * The inverse mass of the body.
     * @property invMass
     * @type {number}
     */ this.invMass = 0;
    /**
     * The inertia of the body around the Z axis.
     * @property inertia
     * @type {number}
     */ this.inertia = 0;
    /**
     * The inverse inertia of the body.
     * @property invInertia
     * @type {number}
     */ this.invInertia = 0;
    this.invMassSolve = 0;
    this.invInertiaSolve = 0;
    /**
     * Set to true if you want to fix the rotation of the body.
     * @property fixedRotation
     * @type {Boolean}
     */ this.fixedRotation = !!options.fixedRotation;
    /**
     * Set to true if you want to fix the body movement along the X axis. The body will still be able to move along Y.
     * @property {Boolean} fixedX
     */ this.fixedX = !!options.fixedX;
    /**
     * Set to true if you want to fix the body movement along the Y axis. The body will still be able to move along X.
     * @property {Boolean} fixedY
     */ this.fixedY = !!options.fixedY;
    /**
     * @private
     * @property {array} massMultiplier
     */ this.massMultiplier = $2Ys9z.create();
    /**
     * The position of the body
     * @property position
     * @type {Array}
     */ this.position = $2Ys9z.fromValues(0, 0);
    if (options.position) $2Ys9z.copy(this.position, options.position);
    /**
     * The interpolated position of the body. Use this for rendering.
     * @property interpolatedPosition
     * @type {Array}
     */ this.interpolatedPosition = $2Ys9z.fromValues(0, 0);
    /**
     * The interpolated angle of the body. Use this for rendering.
     * @property interpolatedAngle
     * @type {Number}
     */ this.interpolatedAngle = 0;
    /**
     * The previous position of the body.
     * @property previousPosition
     * @type {Array}
     */ this.previousPosition = $2Ys9z.fromValues(0, 0);
    /**
     * The previous angle of the body.
     * @property previousAngle
     * @type {Number}
     */ this.previousAngle = 0;
    /**
     * The current velocity of the body.
     * @property velocity
     * @type {Array}
     */ this.velocity = $2Ys9z.fromValues(0, 0);
    if (options.velocity) $2Ys9z.copy(this.velocity, options.velocity);
    /**
     * Constraint velocity that was added to the body during the last step.
     * @property vlambda
     * @type {Array}
     */ this.vlambda = $2Ys9z.fromValues(0, 0);
    /**
     * Angular constraint velocity that was added to the body during last step.
     * @property wlambda
     * @type {Array}
     */ this.wlambda = 0;
    /**
     * The angle of the body, in radians.
     * @property angle
     * @type {number}
     * @example
     *     // The angle property is not normalized to the interval 0 to 2*pi, it can be any value.
     *     // If you need a value between 0 and 2*pi, use the following function to normalize it.
     *     function normalizeAngle(angle){
     *         angle = angle % (2*Math.PI);
     *         if(angle < 0){
     *             angle += (2*Math.PI);
     *         }
     *         return angle;
     *     }
     */ this.angle = options.angle || 0;
    /**
     * The angular velocity of the body, in radians per second.
     * @property angularVelocity
     * @type {number}
     */ this.angularVelocity = options.angularVelocity || 0;
    /**
     * The force acting on the body. Since the body force (and {{#crossLink "Body/angularForce:property"}}{{/crossLink}}) will be zeroed after each step, so you need to set the force before each step.
     * @property force
     * @type {Array}
     *
     * @example
     *     // This produces a forcefield of 1 Newton in the positive x direction.
     *     for(var i=0; i<numSteps; i++){
     *         body.force[0] = 1;
     *         world.step(1/60);
     *     }
     *
     * @example
     *     // This will apply a rotational force on the body
     *     for(var i=0; i<numSteps; i++){
     *         body.angularForce = -3;
     *         world.step(1/60);
     *     }
     */ this.force = $2Ys9z.create();
    if (options.force) $2Ys9z.copy(this.force, options.force);
    /**
     * The angular force acting on the body. See {{#crossLink "Body/force:property"}}{{/crossLink}}.
     * @property angularForce
     * @type {number}
     */ this.angularForce = options.angularForce || 0;
    /**
     * The linear damping acting on the body in the velocity direction. Should be a value between 0 and 1.
     * @property damping
     * @type {Number}
     * @default 0.1
     */ this.damping = typeof options.damping === "number" ? options.damping : 0.1;
    /**
     * The angular force acting on the body. Should be a value between 0 and 1.
     * @property angularDamping
     * @type {Number}
     * @default 0.1
     */ this.angularDamping = typeof options.angularDamping === "number" ? options.angularDamping : 0.1;
    /**
     * The type of motion this body has. Should be one of: {{#crossLink "Body/STATIC:property"}}Body.STATIC{{/crossLink}}, {{#crossLink "Body/DYNAMIC:property"}}Body.DYNAMIC{{/crossLink}} and {{#crossLink "Body/KINEMATIC:property"}}Body.KINEMATIC{{/crossLink}}.
     *
     * * Static bodies do not move, and they do not respond to forces or collision.
     * * Dynamic bodies body can move and respond to collisions and forces.
     * * Kinematic bodies only moves according to its .velocity, and does not respond to collisions or force.
     *
     * @property type
     * @type {number}
     *
     * @example
     *     // Bodies are static by default. Static bodies will never move.
     *     var body = new Body();
     *     console.log(body.type == Body.STATIC); // true
     *
     * @example
     *     // By setting the mass of a body to a nonzero number, the body
     *     // will become dynamic and will move and interact with other bodies.
     *     var dynamicBody = new Body({
     *         mass : 1
     *     });
     *     console.log(dynamicBody.type == Body.DYNAMIC); // true
     *
     * @example
     *     // Kinematic bodies will only move if you change their velocity.
     *     var kinematicBody = new Body({
     *         type: Body.KINEMATIC // Type can be set via the options object.
     *     });
     */ this.type = $a46f7f8fe64db8b3$var$Body.STATIC;
    if (typeof options.type !== 'undefined') this.type = options.type;
    else if (!options.mass) this.type = $a46f7f8fe64db8b3$var$Body.STATIC;
    else this.type = $a46f7f8fe64db8b3$var$Body.DYNAMIC;
    /**
     * Bounding circle radius.
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    /**
     * Bounding box of this body.
     * @property aabb
     * @type {AABB}
     */ this.aabb = new $hkl1e();
    /**
     * Indicates if the AABB needs update. Update it with {{#crossLink "Body/updateAABB:method"}}.updateAABB(){{/crossLink}}.
     * @property aabbNeedsUpdate
     * @type {Boolean}
     * @see updateAABB
     *
     * @example
     *     // Force update the AABB
     *     body.aabbNeedsUpdate = true;
     *     body.updateAABB();
     *     console.log(body.aabbNeedsUpdate); // false
     */ this.aabbNeedsUpdate = true;
    /**
     * If true, the body will automatically fall to sleep. Note that you need to enable sleeping in the {{#crossLink "World"}}{{/crossLink}} before anything will happen.
     * @property allowSleep
     * @type {Boolean}
     * @default true
     */ this.allowSleep = options.allowSleep !== undefined ? options.allowSleep : true;
    this.wantsToSleep = false;
    /**
     * One of {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}}, {{#crossLink "Body/SLEEPY:property"}}Body.SLEEPY{{/crossLink}} and {{#crossLink "Body/SLEEPING:property"}}Body.SLEEPING{{/crossLink}}.
     *
     * The body is initially Body.AWAKE. If its velocity norm is below .sleepSpeedLimit, the sleepState will become Body.SLEEPY. If the body continues to be Body.SLEEPY for .sleepTimeLimit seconds, it will fall asleep (Body.SLEEPY).
     *
     * @property sleepState
     * @type {Number}
     * @default Body.AWAKE
     */ this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    /**
     * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
     * @property sleepSpeedLimit
     * @type {Number}
     * @default 0.2
     */ this.sleepSpeedLimit = options.sleepSpeedLimit !== undefined ? options.sleepSpeedLimit : 0.2;
    /**
     * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
     * @property sleepTimeLimit
     * @type {Number}
     * @default 1
     */ this.sleepTimeLimit = options.sleepTimeLimit !== undefined ? options.sleepTimeLimit : 1;
    /**
     * Gravity scaling factor. If you want the body to ignore gravity, set this to zero. If you want to reverse gravity, set it to -1.
     * @property {Number} gravityScale
     * @default 1
     */ this.gravityScale = options.gravityScale !== undefined ? options.gravityScale : 1;
    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this body will move through other bodies, but it will still trigger contact events, etc.
     * @property {Boolean} collisionResponse
     */ this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
    /**
     * How long the body has been sleeping.
     * @property {Number} idleTime
     */ this.idleTime = 0;
    /**
     * The last time when the body went to SLEEPY state.
     * @property {Number} timeLastSleepy
     * @private
     */ this.timeLastSleepy = 0;
    /**
     * If the body speed exceeds this threshold, CCD (continuous collision detection) will be enabled. Set it to a negative number to disable CCD completely for this body.
     * @property {number} ccdSpeedThreshold
     * @default -1
     */ this.ccdSpeedThreshold = options.ccdSpeedThreshold !== undefined ? options.ccdSpeedThreshold : -1;
    /**
     * The number of iterations that should be used when searching for the time of impact during CCD. A larger number will assure that there's a small penetration on CCD collision, but a small number will give more performance.
     * @property {number} ccdIterations
     * @default 10
     */ this.ccdIterations = options.ccdIterations !== undefined ? options.ccdIterations : 10;
    this.concavePath = null;
    this._wakeUpAfterNarrowphase = false;
    this.updateMassProperties();
}
$a46f7f8fe64db8b3$var$Body.prototype = new $5POlg();
$a46f7f8fe64db8b3$var$Body.prototype.constructor = $a46f7f8fe64db8b3$var$Body;
$a46f7f8fe64db8b3$var$Body._idCounter = 0;
/**
 * @private
 * @method updateSolveMassProperties
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateSolveMassProperties = function() {
    if (this.sleepState === $a46f7f8fe64db8b3$var$Body.SLEEPING || this.type === $a46f7f8fe64db8b3$var$Body.KINEMATIC) {
        this.invMassSolve = 0;
        this.invInertiaSolve = 0;
    } else {
        this.invMassSolve = this.invMass;
        this.invInertiaSolve = this.invInertia;
    }
};
/**
 * Set the total density of the body
 * @method setDensity
 * @param {number} density
 */ $a46f7f8fe64db8b3$var$Body.prototype.setDensity = function(density) {
    var totalArea = this.getArea();
    this.mass = totalArea * density;
    this.updateMassProperties();
};
/**
 * Get the total area of all shapes in the body
 * @method getArea
 * @return {Number}
 */ $a46f7f8fe64db8b3$var$Body.prototype.getArea = function() {
    var totalArea = 0;
    for(var i = 0; i < this.shapes.length; i++)totalArea += this.shapes[i].area;
    return totalArea;
};
/**
 * Get the AABB from the body. The AABB is updated if necessary.
 * @method getAABB
 * @return {AABB} The AABB instance (this.aabb)
 */ $a46f7f8fe64db8b3$var$Body.prototype.getAABB = function() {
    if (this.aabbNeedsUpdate) this.updateAABB();
    return this.aabb;
};
var $a46f7f8fe64db8b3$var$shapeAABB = new $hkl1e(), $a46f7f8fe64db8b3$var$tmp = $2Ys9z.create();
/**
 * Updates the AABB of the Body, and set .aabbNeedsUpdate = false.
 * @method updateAABB
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateAABB = function() {
    var shapes = this.shapes, N = shapes.length, offset = $a46f7f8fe64db8b3$var$tmp, bodyAngle = this.angle;
    for(var i = 0; i !== N; i++){
        var shape = shapes[i], angle = shape.angle + bodyAngle;
        // Get shape world offset
        $2Ys9z.rotate(offset, shape.position, bodyAngle);
        $2Ys9z.add(offset, offset, this.position);
        // Get shape AABB
        shape.computeAABB($a46f7f8fe64db8b3$var$shapeAABB, offset, angle);
        if (i === 0) this.aabb.copy($a46f7f8fe64db8b3$var$shapeAABB);
        else this.aabb.extend($a46f7f8fe64db8b3$var$shapeAABB);
    }
    this.aabbNeedsUpdate = false;
};
/**
 * Update the bounding radius of the body (this.boundingRadius). Should be done if any of the shape dimensions or positions are changed.
 * @method updateBoundingRadius
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateBoundingRadius = function() {
    var shapes = this.shapes, N = shapes.length, radius = 0;
    for(var i = 0; i !== N; i++){
        var shape = shapes[i], offset = $2Ys9z.length(shape.position), r = shape.boundingRadius;
        if (offset + r > radius) radius = offset + r;
    }
    this.boundingRadius = radius;
};
/**
 * Add a shape to the body. You can pass a local transform when adding a shape,
 * so that the shape gets an offset and angle relative to the body center of mass.
 * Will automatically update the mass properties and bounding radius.
 *
 * @method addShape
 * @param  {Shape}              shape
 * @param  {Array} [offset] Local body offset of the shape.
 * @param  {Number}             [angle]  Local body angle.
 *
 * @example
 *     var body = new Body(),
 *         shape = new Circle({ radius: 1 });
 *
 *     // Add the shape to the body, positioned in the center
 *     body.addShape(shape);
 *
 *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local x-axis.
 *     body.addShape(shape,[1,0]);
 *
 *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local y-axis, and rotated 90 degrees CCW.
 *     body.addShape(shape,[0,1],Math.PI/2);
 */ $a46f7f8fe64db8b3$var$Body.prototype.addShape = function(shape, offset, angle) {
    if (shape.body) throw new Error('A shape can only be added to one body.');
    shape.body = this;
    // Copy the offset vector
    if (offset) $2Ys9z.copy(shape.position, offset);
    else $2Ys9z.set(shape.position, 0, 0);
    shape.angle = angle || 0;
    this.shapes.push(shape);
    this.updateMassProperties();
    this.updateBoundingRadius();
    this.aabbNeedsUpdate = true;
};
/**
 * Remove a shape
 * @method removeShape
 * @param  {Shape} shape
 * @return {Boolean} True if the shape was found and removed, else false.
 */ $a46f7f8fe64db8b3$var$Body.prototype.removeShape = function(shape) {
    var idx = this.shapes.indexOf(shape);
    if (idx !== -1) {
        this.shapes.splice(idx, 1);
        this.aabbNeedsUpdate = true;
        shape.body = null;
        return true;
    } else return false;
};
/**
 * Updates .inertia, .invMass, .invInertia for this Body. Should be called when
 * changing the structure or mass of the Body.
 *
 * @method updateMassProperties
 *
 * @example
 *     body.mass += 1;
 *     body.updateMassProperties();
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateMassProperties = function() {
    if (this.type === $a46f7f8fe64db8b3$var$Body.STATIC || this.type === $a46f7f8fe64db8b3$var$Body.KINEMATIC) {
        this.mass = Number.MAX_VALUE;
        this.invMass = 0;
        this.inertia = Number.MAX_VALUE;
        this.invInertia = 0;
    } else {
        var shapes = this.shapes, N = shapes.length, m = this.mass / N, I = 0;
        if (!this.fixedRotation) {
            for(var i = 0; i < N; i++){
                var shape = shapes[i], r2 = $2Ys9z.squaredLength(shape.position), Icm = shape.computeMomentOfInertia(m);
                I += Icm + m * r2;
            }
            this.inertia = I;
            this.invInertia = I > 0 ? 1 / I : 0;
        } else {
            this.inertia = Number.MAX_VALUE;
            this.invInertia = 0;
        }
        // Inverse mass properties are easy
        this.invMass = 1 / this.mass;
        $2Ys9z.set(this.massMultiplier, this.fixedX ? 0 : 1, this.fixedY ? 0 : 1);
    }
};
var $a46f7f8fe64db8b3$var$Body_applyForce_r = $2Ys9z.create();
/**
 * Apply force to a point relative to the center of mass of the body. This could for example be a point on the RigidBody surface. Applying force this way will add to Body.force and Body.angularForce. If relativePoint is zero, the force will be applied directly on the center of mass, and the torque produced will be zero.
 * @method applyForce
 * @param {Array} force The force to add.
 * @param {Array} [relativePoint] A world point to apply the force on.
 */ $a46f7f8fe64db8b3$var$Body.prototype.applyForce = function(force, relativePoint) {
    // Add linear force
    $2Ys9z.add(this.force, this.force, force);
    if (relativePoint) {
        // Compute produced rotational force
        var rotForce = $2Ys9z.crossLength(relativePoint, force);
        // Add rotational force
        this.angularForce += rotForce;
    }
};
/**
 * Apply force to a body-local point.
 * @method applyForceLocal
 * @param  {Array} localForce The force vector to add, oriented in local body space.
 * @param  {Array} [localPoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyForce_forceWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyForce_pointWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyForce_pointLocal = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyForceLocal = function(localForce, localPoint) {
    localPoint = localPoint || $a46f7f8fe64db8b3$var$Body_applyForce_pointLocal;
    var worldForce = $a46f7f8fe64db8b3$var$Body_applyForce_forceWorld;
    var worldPoint = $a46f7f8fe64db8b3$var$Body_applyForce_pointWorld;
    this.vectorToWorldFrame(worldForce, localForce);
    this.vectorToWorldFrame(worldPoint, localPoint);
    this.applyForce(worldForce, worldPoint);
};
/**
 * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulse
 * @param  {Array} impulse The impulse vector to add, oriented in world space.
 * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyImpulse_velo = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyImpulse = function(impulseVector, relativePoint) {
    if (this.type !== $a46f7f8fe64db8b3$var$Body.DYNAMIC) return;
    // Compute produced central impulse velocity
    var velo = $a46f7f8fe64db8b3$var$Body_applyImpulse_velo;
    $2Ys9z.scale(velo, impulseVector, this.invMass);
    $2Ys9z.multiply(velo, this.massMultiplier, velo);
    // Add linear impulse
    $2Ys9z.add(this.velocity, velo, this.velocity);
    if (relativePoint) {
        // Compute produced rotational impulse velocity
        var rotVelo = $2Ys9z.crossLength(relativePoint, impulseVector);
        rotVelo *= this.invInertia;
        // Add rotational Impulse
        this.angularVelocity += rotVelo;
    }
};
/**
 * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulseLocal
 * @param  {Array} impulse The impulse vector to add, oriented in world space.
 * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyImpulse_impulseWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyImpulse_pointWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyImpulse_pointLocal = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyImpulseLocal = function(localImpulse, localPoint) {
    localPoint = localPoint || $a46f7f8fe64db8b3$var$Body_applyImpulse_pointLocal;
    var worldImpulse = $a46f7f8fe64db8b3$var$Body_applyImpulse_impulseWorld;
    var worldPoint = $a46f7f8fe64db8b3$var$Body_applyImpulse_pointWorld;
    this.vectorToWorldFrame(worldImpulse, localImpulse);
    this.vectorToWorldFrame(worldPoint, localPoint);
    this.applyImpulse(worldImpulse, worldPoint);
};
/**
 * Transform a world point to local body frame.
 * @method toLocalFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} worldPoint   The input world point
 */ $a46f7f8fe64db8b3$var$Body.prototype.toLocalFrame = function(out, worldPoint) {
    $2Ys9z.toLocalFrame(out, worldPoint, this.position, this.angle);
};
/**
 * Transform a local point to world frame.
 * @method toWorldFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} localPoint   The input local point
 */ $a46f7f8fe64db8b3$var$Body.prototype.toWorldFrame = function(out, localPoint) {
    $2Ys9z.toGlobalFrame(out, localPoint, this.position, this.angle);
};
/**
 * Transform a world point to local body frame.
 * @method vectorToLocalFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} worldVector  The input world vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.vectorToLocalFrame = function(out, worldVector) {
    $2Ys9z.vectorToLocalFrame(out, worldVector, this.angle);
};
/**
 * Transform a local point to world frame.
 * @method vectorToWorldFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} localVector  The input local vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.vectorToWorldFrame = function(out, localVector) {
    $2Ys9z.vectorToGlobalFrame(out, localVector, this.angle);
};
/**
 * Reads a polygon shape path, and assembles convex shapes from that and puts them at proper offset points.
 * @method fromPolygon
 * @param {Array} path An array of 2d vectors, e.g. [[0,0],[0,1],...] that resembles a concave or convex polygon. The shape must be simple and without holes.
 * @param {Object} [options]
 * @param {Boolean} [options.optimalDecomp=false]   Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
 * @param {Boolean} [options.skipSimpleCheck=false] Set to true if you already know that the path is not intersecting itself.
 * @param {Boolean|Number} [options.removeCollinearPoints=false] Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
 * @return {Boolean} True on success, else false.
 */ $a46f7f8fe64db8b3$var$Body.prototype.fromPolygon = function(path, options) {
    options = options || {};
    // Remove all shapes
    for(var i = this.shapes.length; i >= 0; --i)this.removeShape(this.shapes[i]);
    var p = new $32CtG.Polygon();
    p.vertices = path;
    // Make it counter-clockwise
    p.makeCCW();
    if (typeof options.removeCollinearPoints === "number") p.removeCollinearPoints(options.removeCollinearPoints);
    // Check if any line segment intersects the path itself
    if (typeof options.skipSimpleCheck === "undefined") {
        if (!p.isSimple()) return false;
    }
    // Save this path for later
    this.concavePath = p.vertices.slice(0);
    for(var i = 0; i < this.concavePath.length; i++){
        var v = [
            0,
            0
        ];
        $2Ys9z.copy(v, this.concavePath[i]);
        this.concavePath[i] = v;
    }
    // Slow or fast decomp?
    var convexes;
    if (options.optimalDecomp) convexes = p.decomp();
    else convexes = p.quickDecomp();
    var cm = $2Ys9z.create();
    // Add convexes
    for(var i = 0; i !== convexes.length; i++){
        // Create convex
        var c = new $clDtn({
            vertices: convexes[i].vertices
        });
        // Move all vertices so its center of mass is in the local center of the convex
        for(var j = 0; j !== c.vertices.length; j++){
            var v = c.vertices[j];
            $2Ys9z.sub(v, v, c.centerOfMass);
        }
        $2Ys9z.scale(cm, c.centerOfMass, 1);
        c.updateTriangles();
        c.updateCenterOfMass();
        c.updateBoundingRadius();
        // Add the shape
        this.addShape(c, cm);
    }
    this.adjustCenterOfMass();
    this.aabbNeedsUpdate = true;
    return true;
};
var $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp1 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp2 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp3 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp4 = $2Ys9z.fromValues(0, 0);
/**
 * Moves the shape offsets so their center of mass becomes the body center of mass.
 * @method adjustCenterOfMass
 */ $a46f7f8fe64db8b3$var$Body.prototype.adjustCenterOfMass = function() {
    var offset_times_area = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp2, sum = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp3, cm = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp4, totalArea = 0;
    $2Ys9z.set(sum, 0, 0);
    for(var i = 0; i !== this.shapes.length; i++){
        var s = this.shapes[i];
        $2Ys9z.scale(offset_times_area, s.position, s.area);
        $2Ys9z.add(sum, sum, offset_times_area);
        totalArea += s.area;
    }
    $2Ys9z.scale(cm, sum, 1 / totalArea);
    // Now move all shapes
    for(var i = 0; i !== this.shapes.length; i++){
        var s = this.shapes[i];
        $2Ys9z.sub(s.position, s.position, cm);
    }
    // Move the body position too
    $2Ys9z.add(this.position, this.position, cm);
    // And concave path
    for(var i = 0; this.concavePath && i < this.concavePath.length; i++)$2Ys9z.sub(this.concavePath[i], this.concavePath[i], cm);
    this.updateMassProperties();
    this.updateBoundingRadius();
};
/**
 * Sets the force on the body to zero.
 * @method setZeroForce
 */ $a46f7f8fe64db8b3$var$Body.prototype.setZeroForce = function() {
    $2Ys9z.set(this.force, 0.0, 0.0);
    this.angularForce = 0.0;
};
$a46f7f8fe64db8b3$var$Body.prototype.resetConstraintVelocity = function() {
    var b = this, vlambda = b.vlambda;
    $2Ys9z.set(vlambda, 0, 0);
    b.wlambda = 0;
};
$a46f7f8fe64db8b3$var$Body.prototype.addConstraintVelocity = function() {
    var b = this, v = b.velocity;
    $2Ys9z.add(v, v, b.vlambda);
    b.angularVelocity += b.wlambda;
};
/**
 * Apply damping, see <a href="http://code.google.com/p/bullet/issues/detail?id=74">this</a> for details.
 * @method applyDamping
 * @param  {number} dt Current time step
 */ $a46f7f8fe64db8b3$var$Body.prototype.applyDamping = function(dt) {
    if (this.type === $a46f7f8fe64db8b3$var$Body.DYNAMIC) {
        var v = this.velocity;
        $2Ys9z.scale(v, v, Math.pow(1.0 - this.damping, dt));
        this.angularVelocity *= Math.pow(1.0 - this.angularDamping, dt);
    }
};
/**
 * Wake the body up. Normally you should not need this, as the body is automatically awoken at events such as collisions.
 * Sets the sleepState to {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}} and emits the wakeUp event if the body wasn't awake before.
 * @method wakeUp
 */ $a46f7f8fe64db8b3$var$Body.prototype.wakeUp = function() {
    var s = this.sleepState;
    this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    this.idleTime = 0;
    if (s !== $a46f7f8fe64db8b3$var$Body.AWAKE) this.emit($a46f7f8fe64db8b3$var$Body.wakeUpEvent);
};
/**
 * Force body sleep
 * @method sleep
 */ $a46f7f8fe64db8b3$var$Body.prototype.sleep = function() {
    this.sleepState = $a46f7f8fe64db8b3$var$Body.SLEEPING;
    this.angularVelocity = 0;
    this.angularForce = 0;
    $2Ys9z.set(this.velocity, 0, 0);
    $2Ys9z.set(this.force, 0, 0);
    this.emit($a46f7f8fe64db8b3$var$Body.sleepEvent);
};
/**
 * Called every timestep to update internal sleep timer and change sleep state if needed.
 * @method sleepTick
 * @param {number} time The world time in seconds
 * @param {boolean} dontSleep
 * @param {number} dt
 */ $a46f7f8fe64db8b3$var$Body.prototype.sleepTick = function(time, dontSleep, dt) {
    if (!this.allowSleep || this.type === $a46f7f8fe64db8b3$var$Body.SLEEPING) return;
    this.wantsToSleep = false;
    var sleepState = this.sleepState, speedSquared = $2Ys9z.squaredLength(this.velocity) + Math.pow(this.angularVelocity, 2), speedLimitSquared = Math.pow(this.sleepSpeedLimit, 2);
    // Add to idle time
    if (speedSquared >= speedLimitSquared) {
        this.idleTime = 0;
        this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    } else {
        this.idleTime += dt;
        this.sleepState = $a46f7f8fe64db8b3$var$Body.SLEEPY;
    }
    if (this.idleTime > this.sleepTimeLimit) {
        if (!dontSleep) this.sleep();
        else this.wantsToSleep = true;
    }
};
/**
 * Check if the body is overlapping another body. Note that this method only works if the body was added to a World and if at least one step was taken.
 * @method overlaps
 * @param  {Body} body
 * @return {boolean}
 */ $a46f7f8fe64db8b3$var$Body.prototype.overlaps = function(body) {
    return this.world.overlapKeeper.bodiesAreOverlapping(this, body);
};
var $a46f7f8fe64db8b3$var$integrate_fhMinv = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$integrate_velodt = $2Ys9z.create();
/**
 * Move the body forward in time given its current velocity.
 * @method integrate
 * @param  {Number} dt
 */ $a46f7f8fe64db8b3$var$Body.prototype.integrate = function(dt) {
    var minv = this.invMass, f = this.force, pos = this.position, velo = this.velocity;
    // Save old position
    $2Ys9z.copy(this.previousPosition, this.position);
    this.previousAngle = this.angle;
    // Velocity update
    if (!this.fixedRotation) this.angularVelocity += this.angularForce * this.invInertia * dt;
    $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_fhMinv, f, dt * minv);
    $2Ys9z.multiply($a46f7f8fe64db8b3$var$integrate_fhMinv, this.massMultiplier, $a46f7f8fe64db8b3$var$integrate_fhMinv);
    $2Ys9z.add(velo, $a46f7f8fe64db8b3$var$integrate_fhMinv, velo);
    // CCD
    if (!this.integrateToTimeOfImpact(dt)) {
        // Regular position update
        $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, velo, dt);
        $2Ys9z.add(pos, pos, $a46f7f8fe64db8b3$var$integrate_velodt);
        if (!this.fixedRotation) this.angle += this.angularVelocity * dt;
    }
    this.aabbNeedsUpdate = true;
};
var $a46f7f8fe64db8b3$var$result = new $ZlKj0();
var $a46f7f8fe64db8b3$var$ray = new $l9ZUH({
    mode: $l9ZUH.ALL
});
var $a46f7f8fe64db8b3$var$direction = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$end = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$startToEnd = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$rememberPosition = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.integrateToTimeOfImpact = function(dt) {
    if (this.ccdSpeedThreshold < 0 || $2Ys9z.squaredLength(this.velocity) < Math.pow(this.ccdSpeedThreshold, 2)) return false;
    $2Ys9z.normalize($a46f7f8fe64db8b3$var$direction, this.velocity);
    $2Ys9z.scale($a46f7f8fe64db8b3$var$end, this.velocity, dt);
    $2Ys9z.add($a46f7f8fe64db8b3$var$end, $a46f7f8fe64db8b3$var$end, this.position);
    $2Ys9z.sub($a46f7f8fe64db8b3$var$startToEnd, $a46f7f8fe64db8b3$var$end, this.position);
    var startToEndAngle = this.angularVelocity * dt;
    var len = $2Ys9z.length($a46f7f8fe64db8b3$var$startToEnd);
    var timeOfImpact = 1;
    var hit;
    var that = this;
    $a46f7f8fe64db8b3$var$result.reset();
    $a46f7f8fe64db8b3$var$ray.callback = function(result) {
        if (result.body === that) return;
        hit = result.body;
        result.getHitPoint($a46f7f8fe64db8b3$var$end, $a46f7f8fe64db8b3$var$ray);
        $2Ys9z.sub($a46f7f8fe64db8b3$var$startToEnd, $a46f7f8fe64db8b3$var$end, that.position);
        timeOfImpact = $2Ys9z.length($a46f7f8fe64db8b3$var$startToEnd) / len;
        result.stop();
    };
    $2Ys9z.copy($a46f7f8fe64db8b3$var$ray.from, this.position);
    $2Ys9z.copy($a46f7f8fe64db8b3$var$ray.to, $a46f7f8fe64db8b3$var$end);
    $a46f7f8fe64db8b3$var$ray.update();
    this.world.raycast($a46f7f8fe64db8b3$var$result, $a46f7f8fe64db8b3$var$ray);
    if (!hit) return false;
    var rememberAngle = this.angle;
    $2Ys9z.copy($a46f7f8fe64db8b3$var$rememberPosition, this.position);
    // Got a start and end point. Approximate time of impact using binary search
    var iter = 0;
    var tmin = 0;
    var tmid = 0;
    var tmax = timeOfImpact;
    while(tmax >= tmin && iter < this.ccdIterations){
        iter++;
        // calculate the midpoint
        tmid = (tmax - tmin) / 2;
        // Move the body to that point
        $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, $a46f7f8fe64db8b3$var$startToEnd, timeOfImpact);
        $2Ys9z.add(this.position, $a46f7f8fe64db8b3$var$rememberPosition, $a46f7f8fe64db8b3$var$integrate_velodt);
        this.angle = rememberAngle + startToEndAngle * timeOfImpact;
        this.updateAABB();
        // check overlap
        var overlaps = this.aabb.overlaps(hit.aabb) && this.world.narrowphase.bodiesOverlap(this, hit);
        if (overlaps) // change min to search upper interval
        tmin = tmid;
        else // change max to search lower interval
        tmax = tmid;
    }
    timeOfImpact = tmid;
    $2Ys9z.copy(this.position, $a46f7f8fe64db8b3$var$rememberPosition);
    this.angle = rememberAngle;
    // move to TOI
    $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, $a46f7f8fe64db8b3$var$startToEnd, timeOfImpact);
    $2Ys9z.add(this.position, this.position, $a46f7f8fe64db8b3$var$integrate_velodt);
    if (!this.fixedRotation) this.angle += startToEndAngle * timeOfImpact;
    return true;
};
/**
 * Get velocity of a point in the body.
 * @method getVelocityAtPoint
 * @param  {Array} result A vector to store the result in
 * @param  {Array} relativePoint A world oriented vector, indicating the position of the point to get the velocity from
 * @return {Array} The result vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.getVelocityAtPoint = function(result, relativePoint) {
    $2Ys9z.crossVZ(result, relativePoint, this.angularVelocity);
    $2Ys9z.subtract(result, this.velocity, result);
    return result;
};
/**
 * @event sleepy
 */ $a46f7f8fe64db8b3$var$Body.sleepyEvent = {
    type: "sleepy"
};
/**
 * @event sleep
 */ $a46f7f8fe64db8b3$var$Body.sleepEvent = {
    type: "sleep"
};
/**
 * @event wakeup
 */ $a46f7f8fe64db8b3$var$Body.wakeUpEvent = {
    type: "wakeup"
};
/**
 * Dynamic body.
 * @property DYNAMIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.DYNAMIC = 1;
/**
 * Static body.
 * @property STATIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.STATIC = 2;
/**
 * Kinematic body.
 * @property KINEMATIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.KINEMATIC = 4;
/**
 * @property AWAKE
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.AWAKE = 0;
/**
 * @property SLEEPY
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.SLEEPY = 1;
/**
 * @property SLEEPING
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.SLEEPING = 2;

});
parcelRegister("32CtG", function(module, exports) {


module.exports = {
    Polygon: (parcelRequire("78CTm")),
    Point: (parcelRequire("7IHg3"))
};

});
parcelRegister("78CTm", function(module, exports) {

var $f7pMh = parcelRequire("f7pMh");

var $7IHg3 = parcelRequire("7IHg3");

var $apnUg = parcelRequire("apnUg");
module.exports = $532772ddca37032b$var$Polygon;
/**
 * Polygon class.
 * @class Polygon
 * @constructor
 */ function $532772ddca37032b$var$Polygon() {
    /**
     * Vertices that this polygon consists of. An array of array of numbers, example: [[0,0],[1,0],..]
     * @property vertices
     * @type {Array}
     */ this.vertices = [];
}
/**
 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
 * @method at
 * @param  {Number} i
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.at = function(i) {
    var v = this.vertices, s = v.length;
    return v[i < 0 ? i % s + s : i % s];
};
/**
 * Get first vertex
 * @method first
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.first = function() {
    return this.vertices[0];
};
/**
 * Get last vertex
 * @method last
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.last = function() {
    return this.vertices[this.vertices.length - 1];
};
/**
 * Clear the polygon data
 * @method clear
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.clear = function() {
    this.vertices.length = 0;
};
/**
 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
 * @method append
 * @param {Polygon} poly The polygon to get points from.
 * @param {Number}  from The vertex index in "poly".
 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.append = function(poly, from, to) {
    if (typeof from == "undefined") throw new Error("From is not given!");
    if (typeof to == "undefined") throw new Error("To is not given!");
    if (to - 1 < from) throw new Error("lol1");
    if (to > poly.vertices.length) throw new Error("lol2");
    if (from < 0) throw new Error("lol3");
    for(var i = from; i < to; i++)this.vertices.push(poly.vertices[i]);
};
/**
 * Make sure that the polygon vertices are ordered counter-clockwise.
 * @method makeCCW
 */ $532772ddca37032b$var$Polygon.prototype.makeCCW = function() {
    var br = 0, v = this.vertices;
    // find bottom right point
    for(var i = 1; i < this.vertices.length; ++i)if (v[i][1] < v[br][1] || v[i][1] == v[br][1] && v[i][0] > v[br][0]) br = i;
    // reverse poly if clockwise
    if (!$7IHg3.left(this.at(br - 1), this.at(br), this.at(br + 1))) this.reverse();
};
/**
 * Reverse the vertices in the polygon
 * @method reverse
 */ $532772ddca37032b$var$Polygon.prototype.reverse = function() {
    var tmp = [];
    for(var i = 0, N = this.vertices.length; i !== N; i++)tmp.push(this.vertices.pop());
    this.vertices = tmp;
};
/**
 * Check if a point in the polygon is a reflex point
 * @method isReflex
 * @param  {Number}  i
 * @return {Boolean}
 */ $532772ddca37032b$var$Polygon.prototype.isReflex = function(i) {
    return $7IHg3.right(this.at(i - 1), this.at(i), this.at(i + 1));
};
var $532772ddca37032b$var$tmpLine1 = [], $532772ddca37032b$var$tmpLine2 = [];
/**
 * Check if two vertices in the polygon can see each other
 * @method canSee
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ $532772ddca37032b$var$Polygon.prototype.canSee = function(a, b) {
    var p, dist, l1 = $532772ddca37032b$var$tmpLine1, l2 = $532772ddca37032b$var$tmpLine2;
    if ($7IHg3.leftOn(this.at(a + 1), this.at(a), this.at(b)) && $7IHg3.rightOn(this.at(a - 1), this.at(a), this.at(b))) return false;
    dist = $7IHg3.sqdist(this.at(a), this.at(b));
    for(var i = 0; i !== this.vertices.length; ++i){
        if ((i + 1) % this.vertices.length === a || i === a) continue;
        if ($7IHg3.leftOn(this.at(a), this.at(b), this.at(i + 1)) && $7IHg3.rightOn(this.at(a), this.at(b), this.at(i))) {
            l1[0] = this.at(a);
            l1[1] = this.at(b);
            l2[0] = this.at(i);
            l2[1] = this.at(i + 1);
            p = $f7pMh.lineInt(l1, l2);
            if ($7IHg3.sqdist(this.at(a), p) < dist) return false;
        }
    }
    return true;
};
/**
 * Copy the polygon from vertex i to vertex j.
 * @method copy
 * @param  {Number} i
 * @param  {Number} j
 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
 * @return {Polygon}                The resulting copy.
 */ $532772ddca37032b$var$Polygon.prototype.copy = function(i, j, targetPoly) {
    var p = targetPoly || new $532772ddca37032b$var$Polygon();
    p.clear();
    if (i < j) // Insert all vertices from i to j
    for(var k = i; k <= j; k++)p.vertices.push(this.vertices[k]);
    else {
        // Insert vertices 0 to j
        for(var k = 0; k <= j; k++)p.vertices.push(this.vertices[k]);
        // Insert vertices i to end
        for(var k = i; k < this.vertices.length; k++)p.vertices.push(this.vertices[k]);
    }
    return p;
};
/**
 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
 * @method getCutEdges
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.getCutEdges = function() {
    var min = [], tmp1 = [], tmp2 = [], tmpPoly = new $532772ddca37032b$var$Polygon();
    var nDiags = Number.MAX_VALUE;
    for(var i = 0; i < this.vertices.length; ++i)if (this.isReflex(i)) {
        for(var j = 0; j < this.vertices.length; ++j)if (this.canSee(i, j)) {
            tmp1 = this.copy(i, j, tmpPoly).getCutEdges();
            tmp2 = this.copy(j, i, tmpPoly).getCutEdges();
            for(var k = 0; k < tmp2.length; k++)tmp1.push(tmp2[k]);
            if (tmp1.length < nDiags) {
                min = tmp1;
                nDiags = tmp1.length;
                min.push([
                    this.at(i),
                    this.at(j)
                ]);
            }
        }
    }
    return min;
};
/**
 * Decomposes the polygon into one or more convex sub-Polygons.
 * @method decomp
 * @return {Array} An array or Polygon objects.
 */ $532772ddca37032b$var$Polygon.prototype.decomp = function() {
    var edges = this.getCutEdges();
    if (edges.length > 0) return this.slice(edges);
    else return [
        this
    ];
};
/**
 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
 * @method slice
 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.slice = function(cutEdges) {
    if (cutEdges.length == 0) return [
        this
    ];
    if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length == 2 && cutEdges[0][0] instanceof Array) {
        var polys = [
            this
        ];
        for(var i = 0; i < cutEdges.length; i++){
            var cutEdge = cutEdges[i];
            // Cut all polys
            for(var j = 0; j < polys.length; j++){
                var poly = polys[j];
                var result = poly.slice(cutEdge);
                if (result) {
                    // Found poly! Cut and quit
                    polys.splice(j, 1);
                    polys.push(result[0], result[1]);
                    break;
                }
            }
        }
        return polys;
    } else {
        // Was given one edge
        var cutEdge = cutEdges;
        var i = this.vertices.indexOf(cutEdge[0]);
        var j = this.vertices.indexOf(cutEdge[1]);
        if (i != -1 && j != -1) return [
            this.copy(i, j),
            this.copy(j, i)
        ];
        else return false;
    }
};
/**
 * Checks that the line segments of this polygon do not intersect each other.
 * @method isSimple
 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
 * @return {Boolean}
 * @todo Should it check all segments with all others?
 */ $532772ddca37032b$var$Polygon.prototype.isSimple = function() {
    var path = this.vertices;
    // Check
    for(var i = 0; i < path.length - 1; i++)for(var j = 0; j < i - 1; j++){
        if ($f7pMh.segmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) return false;
    }
    // Check the segment between the last and the first point to all others
    for(var i = 1; i < path.length - 2; i++){
        if ($f7pMh.segmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) return false;
    }
    return true;
};
function $532772ddca37032b$var$getIntersectionPoint(p1, p2, q1, q2, delta) {
    delta = delta || 0;
    var a1 = p2[1] - p1[1];
    var b1 = p1[0] - p2[0];
    var c1 = a1 * p1[0] + b1 * p1[1];
    var a2 = q2[1] - q1[1];
    var b2 = q1[0] - q2[0];
    var c2 = a2 * q1[0] + b2 * q1[1];
    var det = a1 * b2 - a2 * b1;
    if (!$apnUg.eq(det, 0, delta)) return [
        (b2 * c1 - b1 * c2) / det,
        (a1 * c2 - a2 * c1) / det
    ];
    else return [
        0,
        0
    ];
}
/**
 * Quickly decompose the Polygon into convex sub-polygons.
 * @method quickDecomp
 * @param  {Array} result
 * @param  {Array} [reflexVertices]
 * @param  {Array} [steinerPoints]
 * @param  {Number} [delta]
 * @param  {Number} [maxlevel]
 * @param  {Number} [level]
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.quickDecomp = function(result, reflexVertices, steinerPoints, delta, maxlevel, level) {
    maxlevel = maxlevel || 100;
    level = level || 0;
    delta = delta || 25;
    result = typeof result != "undefined" ? result : [];
    reflexVertices = reflexVertices || [];
    steinerPoints = steinerPoints || [];
    var upperInt = [
        0,
        0
    ], lowerInt = [
        0,
        0
    ], p = [
        0,
        0
    ]; // Points
    var upperDist = 0, lowerDist = 0, d = 0, closestDist = 0; // scalars
    var upperIndex = 0, lowerIndex = 0, closestIndex = 0; // Integers
    var lowerPoly = new $532772ddca37032b$var$Polygon(), upperPoly = new $532772ddca37032b$var$Polygon(); // polygons
    var poly = this, v = this.vertices;
    if (v.length < 3) return result;
    level++;
    if (level > maxlevel) {
        console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
        return result;
    }
    for(var i = 0; i < this.vertices.length; ++i)if (poly.isReflex(i)) {
        reflexVertices.push(poly.vertices[i]);
        upperDist = lowerDist = Number.MAX_VALUE;
        for(var j = 0; j < this.vertices.length; ++j){
            if ($7IHg3.left(poly.at(i - 1), poly.at(i), poly.at(j)) && $7IHg3.rightOn(poly.at(i - 1), poly.at(i), poly.at(j - 1))) {
                p = $532772ddca37032b$var$getIntersectionPoint(poly.at(i - 1), poly.at(i), poly.at(j), poly.at(j - 1)); // find the point of intersection
                if ($7IHg3.right(poly.at(i + 1), poly.at(i), p)) {
                    d = $7IHg3.sqdist(poly.vertices[i], p);
                    if (d < lowerDist) {
                        lowerDist = d;
                        lowerInt = p;
                        lowerIndex = j;
                    }
                }
            }
            if ($7IHg3.left(poly.at(i + 1), poly.at(i), poly.at(j + 1)) && $7IHg3.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
                p = $532772ddca37032b$var$getIntersectionPoint(poly.at(i + 1), poly.at(i), poly.at(j), poly.at(j + 1));
                if ($7IHg3.left(poly.at(i - 1), poly.at(i), p)) {
                    d = $7IHg3.sqdist(poly.vertices[i], p);
                    if (d < upperDist) {
                        upperDist = d;
                        upperInt = p;
                        upperIndex = j;
                    }
                }
            }
        }
        // if there are no vertices to connect to, choose a point in the middle
        if (lowerIndex == (upperIndex + 1) % this.vertices.length) {
            //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+this.vertices.length+")");
            p[0] = (lowerInt[0] + upperInt[0]) / 2;
            p[1] = (lowerInt[1] + upperInt[1]) / 2;
            steinerPoints.push(p);
            if (i < upperIndex) {
                //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
                lowerPoly.append(poly, i, upperIndex + 1);
                lowerPoly.vertices.push(p);
                upperPoly.vertices.push(p);
                if (lowerIndex != 0) //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
                upperPoly.append(poly, lowerIndex, poly.vertices.length);
                //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
                upperPoly.append(poly, 0, i + 1);
            } else {
                if (i != 0) //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
                lowerPoly.append(poly, i, poly.vertices.length);
                //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
                lowerPoly.append(poly, 0, upperIndex + 1);
                lowerPoly.vertices.push(p);
                upperPoly.vertices.push(p);
                //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
                upperPoly.append(poly, lowerIndex, i + 1);
            }
        } else {
            // connect to the closest point within the triangle
            //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+this.vertices.length+")\n");
            if (lowerIndex > upperIndex) upperIndex += this.vertices.length;
            closestDist = Number.MAX_VALUE;
            if (upperIndex < lowerIndex) return result;
            for(var j = lowerIndex; j <= upperIndex; ++j)if ($7IHg3.leftOn(poly.at(i - 1), poly.at(i), poly.at(j)) && $7IHg3.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
                d = $7IHg3.sqdist(poly.at(i), poly.at(j));
                if (d < closestDist) {
                    closestDist = d;
                    closestIndex = j % this.vertices.length;
                }
            }
            if (i < closestIndex) {
                lowerPoly.append(poly, i, closestIndex + 1);
                if (closestIndex != 0) upperPoly.append(poly, closestIndex, v.length);
                upperPoly.append(poly, 0, i + 1);
            } else {
                if (i != 0) lowerPoly.append(poly, i, v.length);
                lowerPoly.append(poly, 0, closestIndex + 1);
                upperPoly.append(poly, closestIndex, i + 1);
            }
        }
        // solve smallest poly first
        if (lowerPoly.vertices.length < upperPoly.vertices.length) {
            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
        } else {
            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
        }
        return result;
    }
    result.push(this);
    return result;
};
/**
 * Remove collinear points in the polygon.
 * @method removeCollinearPoints
 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
 * @return {Number}           The number of points removed
 */ $532772ddca37032b$var$Polygon.prototype.removeCollinearPoints = function(precision) {
    var num = 0;
    for(var i = this.vertices.length - 1; this.vertices.length > 3 && i >= 0; --i)if ($7IHg3.collinear(this.at(i - 1), this.at(i), this.at(i + 1), precision)) {
        // Remove the middle point
        this.vertices.splice(i % this.vertices.length, 1);
        i--; // Jump one point forward. Otherwise we may get a chain removal
        num++;
    }
    return num;
};

});
parcelRegister("f7pMh", function(module, exports) {

var $apnUg = parcelRequire("apnUg");
module.exports = $b01b816442074f61$var$Line;
/**
 * Container for line-related functions
 * @class Line
 */ function $b01b816442074f61$var$Line() {}
/**
 * Compute the intersection between two lines.
 * @static
 * @method lineInt
 * @param  {Array}  l1          Line vector 1
 * @param  {Array}  l2          Line vector 2
 * @param  {Number} precision   Precision to use when checking if the lines are parallel
 * @return {Array}              The intersection point.
 */ $b01b816442074f61$var$Line.lineInt = function(l1, l2, precision) {
    precision = precision || 0;
    var i = [
        0,
        0
    ]; // point
    var a1, b1, c1, a2, b2, c2, det; // scalars
    a1 = l1[1][1] - l1[0][1];
    b1 = l1[0][0] - l1[1][0];
    c1 = a1 * l1[0][0] + b1 * l1[0][1];
    a2 = l2[1][1] - l2[0][1];
    b2 = l2[0][0] - l2[1][0];
    c2 = a2 * l2[0][0] + b2 * l2[0][1];
    det = a1 * b2 - a2 * b1;
    if (!$apnUg.eq(det, 0, precision)) {
        i[0] = (b2 * c1 - b1 * c2) / det;
        i[1] = (a1 * c2 - a2 * c1) / det;
    }
    return i;
};
/**
 * Checks if two line segments intersects.
 * @method segmentsIntersect
 * @param {Array} p1 The start vertex of the first line segment.
 * @param {Array} p2 The end vertex of the first line segment.
 * @param {Array} q1 The start vertex of the second line segment.
 * @param {Array} q2 The end vertex of the second line segment.
 * @return {Boolean} True if the two line segments intersect
 */ $b01b816442074f61$var$Line.segmentsIntersect = function(p1, p2, q1, q2) {
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var da = q2[0] - q1[0];
    var db = q2[1] - q1[1];
    // segments are parallel
    if (da * dy - db * dx == 0) return false;
    var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
    var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
    return s >= 0 && s <= 1 && t >= 0 && t <= 1;
};

});
parcelRegister("apnUg", function(module, exports) {
module.exports = $793ec888c2787a2f$var$Scalar;
/**
 * Scalar functions
 * @class Scalar
 */ function $793ec888c2787a2f$var$Scalar() {}
/**
 * Check if two scalars are equal
 * @static
 * @method eq
 * @param  {Number} a
 * @param  {Number} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ $793ec888c2787a2f$var$Scalar.eq = function(a, b, precision) {
    precision = precision || 0;
    return Math.abs(a - b) < precision;
};

});


parcelRegister("7IHg3", function(module, exports) {
module.exports = $59ee32917f9611c0$var$Point;
/**
 * Point related functions
 * @class Point
 */ function $59ee32917f9611c0$var$Point() {}
/**
 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
 * @static
 * @method area
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return {Number}
 */ $59ee32917f9611c0$var$Point.area = function(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
};
$59ee32917f9611c0$var$Point.left = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) > 0;
};
$59ee32917f9611c0$var$Point.leftOn = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) >= 0;
};
$59ee32917f9611c0$var$Point.right = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) < 0;
};
$59ee32917f9611c0$var$Point.rightOn = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) <= 0;
};
var $59ee32917f9611c0$var$tmpPoint1 = [], $59ee32917f9611c0$var$tmpPoint2 = [];
/**
 * Check if three points are collinear
 * @method collinear
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
 * @return {Boolean}
 */ $59ee32917f9611c0$var$Point.collinear = function(a, b, c, thresholdAngle) {
    if (!thresholdAngle) return $59ee32917f9611c0$var$Point.area(a, b, c) == 0;
    else {
        var ab = $59ee32917f9611c0$var$tmpPoint1, bc = $59ee32917f9611c0$var$tmpPoint2;
        ab[0] = b[0] - a[0];
        ab[1] = b[1] - a[1];
        bc[0] = c[0] - b[0];
        bc[1] = c[1] - b[1];
        var dot = ab[0] * bc[0] + ab[1] * bc[1], magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]), magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]), angle = Math.acos(dot / (magA * magB));
        return angle < thresholdAngle;
    }
};
$59ee32917f9611c0$var$Point.sqdist = function(a, b) {
    var dx = b[0] - a[0];
    var dy = b[1] - a[1];
    return dx * dx + dy * dy;
};

});



parcelRegister("clDtn", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");

var $cm0Cz = parcelRequire("cm0Cz");
parcelRequire("32CtG");
module.exports = $8fd610a91dec4c33$var$Convex;
/**
 * Convex shape class.
 * @class Convex
 * @constructor
 * @extends Shape
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Array} [options.vertices] An array of vertices that span this shape. Vertices are given in counter-clockwise (CCW) direction.
 * @param {Array} [options.axes] An array of unit length vectors, representing the symmetry axes in the convex.
 * @example
 *     // Create a box
 *     var vertices = [[-1,-1], [1,-1], [1,1], [-1,1]];
 *     var convexShape = new Convex({ vertices: vertices });
 *     body.addShape(convexShape);
 */ function $8fd610a91dec4c33$var$Convex(options) {
    if (Array.isArray(arguments[0])) {
        options = {
            vertices: arguments[0],
            axes: arguments[1]
        };
        console.warn('The Convex constructor signature has changed. Please use the following format: new Convex({ vertices: [...], ... })');
    }
    options = options || {};
    /**
     * Vertices defined in the local frame.
     * @property vertices
     * @type {Array}
     */ this.vertices = [];
    // Copy the verts
    var vertices = options.vertices !== undefined ? options.vertices : [];
    for(var i = 0; i < vertices.length; i++){
        var v = $2Ys9z.create();
        $2Ys9z.copy(v, vertices[i]);
        this.vertices.push(v);
    }
    /**
     * Axes defined in the local frame.
     * @property axes
     * @type {Array}
     */ this.axes = [];
    if (options.axes) // Copy the axes
    for(var i = 0; i < options.axes.length; i++){
        var axis = $2Ys9z.create();
        $2Ys9z.copy(axis, options.axes[i]);
        this.axes.push(axis);
    }
    else // Construct axes from the vertex data
    for(var i = 0; i < this.vertices.length; i++){
        // Get the world edge
        var worldPoint0 = this.vertices[i];
        var worldPoint1 = this.vertices[(i + 1) % this.vertices.length];
        var normal = $2Ys9z.create();
        $2Ys9z.sub(normal, worldPoint1, worldPoint0);
        // Get normal - just rotate 90 degrees since vertices are given in CCW
        $2Ys9z.rotate90cw(normal, normal);
        $2Ys9z.normalize(normal, normal);
        this.axes.push(normal);
    }
    /**
     * The center of mass of the Convex
     * @property centerOfMass
     * @type {Array}
     */ this.centerOfMass = $2Ys9z.fromValues(0, 0);
    /**
     * Triangulated version of this convex. The structure is Array of 3-Arrays, and each subarray contains 3 integers, referencing the vertices.
     * @property triangles
     * @type {Array}
     */ this.triangles = [];
    if (this.vertices.length) {
        this.updateTriangles();
        this.updateCenterOfMass();
    }
    /**
     * The bounding radius of the convex
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    options.type = $k7z01.CONVEX;
    $k7z01.call(this, options);
    this.updateBoundingRadius();
    this.updateArea();
    if (this.area < 0) throw new Error("Convex vertices must be given in conter-clockwise winding.");
}
$8fd610a91dec4c33$var$Convex.prototype = new $k7z01();
$8fd610a91dec4c33$var$Convex.prototype.constructor = $8fd610a91dec4c33$var$Convex;
var $8fd610a91dec4c33$var$tmpVec1 = $2Ys9z.create();
var $8fd610a91dec4c33$var$tmpVec2 = $2Ys9z.create();
/**
 * Project a Convex onto a world-oriented axis
 * @method projectOntoAxis
 * @static
 * @param  {Array} offset
 * @param  {Array} localAxis
 * @param  {Array} result
 */ $8fd610a91dec4c33$var$Convex.prototype.projectOntoLocalAxis = function(localAxis, result) {
    var max = null, min = null, v, value, localAxis = $8fd610a91dec4c33$var$tmpVec1;
    // Get projected position of all vertices
    for(var i = 0; i < this.vertices.length; i++){
        v = this.vertices[i];
        value = $2Ys9z.dot(v, localAxis);
        if (max === null || value > max) max = value;
        if (min === null || value < min) min = value;
    }
    if (min > max) {
        var t = min;
        min = max;
        max = t;
    }
    $2Ys9z.set(result, min, max);
};
$8fd610a91dec4c33$var$Convex.prototype.projectOntoWorldAxis = function(localAxis, shapeOffset, shapeAngle, result) {
    var worldAxis = $8fd610a91dec4c33$var$tmpVec2;
    this.projectOntoLocalAxis(localAxis, result);
    // Project the position of the body onto the axis - need to add this to the result
    if (shapeAngle !== 0) $2Ys9z.rotate(worldAxis, localAxis, shapeAngle);
    else worldAxis = localAxis;
    var offset = $2Ys9z.dot(shapeOffset, worldAxis);
    $2Ys9z.set(result, result[0] + offset, result[1] + offset);
};
/**
 * Update the .triangles property
 * @method updateTriangles
 */ $8fd610a91dec4c33$var$Convex.prototype.updateTriangles = function() {
    this.triangles.length = 0;
    // Rewrite on polyk notation, array of numbers
    var polykVerts = [];
    for(var i = 0; i < this.vertices.length; i++){
        var v = this.vertices[i];
        polykVerts.push(v[0], v[1]);
    }
    // Triangulate
    var triangles = $cm0Cz.Triangulate(polykVerts);
    // Loop over all triangles, add their inertia contributions to I
    for(var i = 0; i < triangles.length; i += 3){
        var id1 = triangles[i], id2 = triangles[i + 1], id3 = triangles[i + 2];
        // Add to triangles
        this.triangles.push([
            id1,
            id2,
            id3
        ]);
    }
};
var $8fd610a91dec4c33$var$updateCenterOfMass_centroid = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_centroid_times_mass = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_a = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_b = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_c = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_ac = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_ca = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_cb = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_n = $2Ys9z.create();
/**
 * Update the .centerOfMass property.
 * @method updateCenterOfMass
 */ $8fd610a91dec4c33$var$Convex.prototype.updateCenterOfMass = function() {
    var triangles = this.triangles, verts = this.vertices, cm = this.centerOfMass, centroid = $8fd610a91dec4c33$var$updateCenterOfMass_centroid, n = $8fd610a91dec4c33$var$updateCenterOfMass_n, a = $8fd610a91dec4c33$var$updateCenterOfMass_a, b = $8fd610a91dec4c33$var$updateCenterOfMass_b, c = $8fd610a91dec4c33$var$updateCenterOfMass_c, ac = $8fd610a91dec4c33$var$updateCenterOfMass_ac, ca = $8fd610a91dec4c33$var$updateCenterOfMass_ca, cb = $8fd610a91dec4c33$var$updateCenterOfMass_cb, centroid_times_mass = $8fd610a91dec4c33$var$updateCenterOfMass_centroid_times_mass;
    $2Ys9z.set(cm, 0, 0);
    var totalArea = 0;
    for(var i = 0; i !== triangles.length; i++){
        var t = triangles[i], a = verts[t[0]], b = verts[t[1]], c = verts[t[2]];
        $2Ys9z.centroid(centroid, a, b, c);
        // Get mass for the triangle (density=1 in this case)
        // http://math.stackexchange.com/questions/80198/area-of-triangle-via-vectors
        var m = $8fd610a91dec4c33$var$Convex.triangleArea(a, b, c);
        totalArea += m;
        // Add to center of mass
        $2Ys9z.scale(centroid_times_mass, centroid, m);
        $2Ys9z.add(cm, cm, centroid_times_mass);
    }
    $2Ys9z.scale(cm, cm, 1 / totalArea);
};
/**
 * Compute the mass moment of inertia of the Convex.
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 * @see http://www.gamedev.net/topic/342822-moment-of-inertia-of-a-polygon-2d/
 */ $8fd610a91dec4c33$var$Convex.prototype.computeMomentOfInertia = function(mass) {
    var denom = 0.0, numer = 0.0, N = this.vertices.length;
    for(var j = N - 1, i = 0; i < N; j = i, i++){
        var p0 = this.vertices[j];
        var p1 = this.vertices[i];
        var a = Math.abs($2Ys9z.crossLength(p0, p1));
        var b = $2Ys9z.dot(p1, p1) + $2Ys9z.dot(p1, p0) + $2Ys9z.dot(p0, p0);
        denom += a * b;
        numer += a;
    }
    return mass / 6.0 * (denom / numer);
};
/**
 * Updates the .boundingRadius property
 * @method updateBoundingRadius
 */ $8fd610a91dec4c33$var$Convex.prototype.updateBoundingRadius = function() {
    var verts = this.vertices, r2 = 0;
    for(var i = 0; i !== verts.length; i++){
        var l2 = $2Ys9z.squaredLength(verts[i]);
        if (l2 > r2) r2 = l2;
    }
    this.boundingRadius = Math.sqrt(r2);
};
/**
 * Get the area of the triangle spanned by the three points a, b, c. The area is positive if the points are given in counter-clockwise order, otherwise negative.
 * @static
 * @method triangleArea
 * @param {Array} a
 * @param {Array} b
 * @param {Array} c
 * @return {Number}
 */ $8fd610a91dec4c33$var$Convex.triangleArea = function(a, b, c) {
    return ((b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1])) * 0.5;
};
/**
 * Update the .area
 * @method updateArea
 */ $8fd610a91dec4c33$var$Convex.prototype.updateArea = function() {
    this.updateTriangles();
    this.area = 0;
    var triangles = this.triangles, verts = this.vertices;
    for(var i = 0; i !== triangles.length; i++){
        var t = triangles[i], a = verts[t[0]], b = verts[t[1]], c = verts[t[2]];
        // Get mass for the triangle (density=1 in this case)
        var m = $8fd610a91dec4c33$var$Convex.triangleArea(a, b, c);
        this.area += m;
    }
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $8fd610a91dec4c33$var$Convex.prototype.computeAABB = function(out, position, angle) {
    out.setFromPoints(this.vertices, position, angle, 0);
};
var $8fd610a91dec4c33$var$intersectConvex_rayStart = $2Ys9z.create();
var $8fd610a91dec4c33$var$intersectConvex_rayEnd = $2Ys9z.create();
var $8fd610a91dec4c33$var$intersectConvex_normal = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $8fd610a91dec4c33$var$Convex.prototype.raycast = function(result, ray, position, angle) {
    var rayStart = $8fd610a91dec4c33$var$intersectConvex_rayStart;
    var rayEnd = $8fd610a91dec4c33$var$intersectConvex_rayEnd;
    var normal = $8fd610a91dec4c33$var$intersectConvex_normal;
    var vertices = this.vertices;
    // Transform to local shape space
    $2Ys9z.toLocalFrame(rayStart, ray.from, position, angle);
    $2Ys9z.toLocalFrame(rayEnd, ray.to, position, angle);
    var n = vertices.length;
    for(var i = 0; i < n && !result.shouldStop(ray); i++){
        var q1 = vertices[i];
        var q2 = vertices[(i + 1) % n];
        var delta = $2Ys9z.getLineSegmentsIntersectionFraction(rayStart, rayEnd, q1, q2);
        if (delta >= 0) {
            $2Ys9z.sub(normal, q2, q1);
            $2Ys9z.rotate(normal, normal, -Math.PI / 2 + angle);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, delta, normal, i);
        }
    }
};

});
parcelRegister("k7z01", function(module, exports) {
module.exports = $ea5f9c4151d0164c$var$Shape;

var $2Ys9z = parcelRequire("2Ys9z");
/**
 * Base class for shapes.
 * @class Shape
 * @constructor
 * @param {object} [options]
 * @param {array} [options.position]
 * @param {number} [options.angle=0]
 * @param {number} [options.collisionGroup=1]
 * @param {number} [options.collisionMask=1]
 * @param {boolean} [options.sensor=false]
 * @param {boolean} [options.collisionResponse=true]
 * @param {object} [options.type=0]
 */ function $ea5f9c4151d0164c$var$Shape(options) {
    options = options || {};
    /**
     * The body this shape is attached to. A shape can only be attached to a single body.
     * @property {Body} body
     */ this.body = null;
    /**
     * Body-local position of the shape.
     * @property {Array} position
     */ this.position = $2Ys9z.fromValues(0, 0);
    if (options.position) $2Ys9z.copy(this.position, options.position);
    /**
     * Body-local angle of the shape.
     * @property {number} angle
     */ this.angle = options.angle || 0;
    /**
     * The type of the shape. One of:
     *
     * * {{#crossLink "Shape/CIRCLE:property"}}Shape.CIRCLE{{/crossLink}}
     * * {{#crossLink "Shape/PARTICLE:property"}}Shape.PARTICLE{{/crossLink}}
     * * {{#crossLink "Shape/PLANE:property"}}Shape.PLANE{{/crossLink}}
     * * {{#crossLink "Shape/CONVEX:property"}}Shape.CONVEX{{/crossLink}}
     * * {{#crossLink "Shape/LINE:property"}}Shape.LINE{{/crossLink}}
     * * {{#crossLink "Shape/BOX:property"}}Shape.BOX{{/crossLink}}
     * * {{#crossLink "Shape/CAPSULE:property"}}Shape.CAPSULE{{/crossLink}}
     * * {{#crossLink "Shape/HEIGHTFIELD:property"}}Shape.HEIGHTFIELD{{/crossLink}}
     *
     * @property {number} type
     */ this.type = options.type || 0;
    /**
     * Shape object identifier.
     * @type {Number}
     * @property id
     */ this.id = $ea5f9c4151d0164c$var$Shape.idCounter++;
    /**
     * Bounding circle radius of this shape
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    /**
     * Collision group that this shape belongs to (bit mask). See <a href="http://www.aurelienribon.com/blog/2011/07/box2d-tutorial-collision-filtering/">this tutorial</a>.
     * @property collisionGroup
     * @type {Number}
     * @example
     *     // Setup bits for each available group
     *     var PLAYER = Math.pow(2,0),
     *         ENEMY =  Math.pow(2,1),
     *         GROUND = Math.pow(2,2)
     *
     *     // Put shapes into their groups
     *     player1Shape.collisionGroup = PLAYER;
     *     player2Shape.collisionGroup = PLAYER;
     *     enemyShape  .collisionGroup = ENEMY;
     *     groundShape .collisionGroup = GROUND;
     *
     *     // Assign groups that each shape collide with.
     *     // Note that the players can collide with ground and enemies, but not with other players.
     *     player1Shape.collisionMask = ENEMY | GROUND;
     *     player2Shape.collisionMask = ENEMY | GROUND;
     *     enemyShape  .collisionMask = PLAYER | GROUND;
     *     groundShape .collisionMask = PLAYER | ENEMY;
     *
     * @example
     *     // How collision check is done
     *     if(shapeA.collisionGroup & shapeB.collisionMask)!=0 && (shapeB.collisionGroup & shapeA.collisionMask)!=0){
     *         // The shapes will collide
     *     }
     */ this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : 1;
    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this shape will move through other body shapes, but it will still trigger contact events, etc.
     * @property {Boolean} collisionResponse
     */ this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
    /**
     * Collision mask of this shape. See .collisionGroup.
     * @property collisionMask
     * @type {Number}
     */ this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : 1;
    /**
     * Material to use in collisions for this Shape. If this is set to null, the world will use default material properties instead.
     * @property material
     * @type {Material}
     */ this.material = options.material || null;
    /**
     * Area of this shape.
     * @property area
     * @type {Number}
     */ this.area = 0;
    /**
     * Set to true if you want this shape to be a sensor. A sensor does not generate contacts, but it still reports contact events. This is good if you want to know if a shape is overlapping another shape, without them generating contacts.
     * @property {Boolean} sensor
     */ this.sensor = options.sensor !== undefined ? options.sensor : false;
    if (this.type) this.updateBoundingRadius();
    this.updateArea();
}
$ea5f9c4151d0164c$var$Shape.idCounter = 0;
/**
 * @static
 * @property {Number} CIRCLE
 */ $ea5f9c4151d0164c$var$Shape.CIRCLE = 1;
/**
 * @static
 * @property {Number} PARTICLE
 */ $ea5f9c4151d0164c$var$Shape.PARTICLE = 2;
/**
 * @static
 * @property {Number} PLANE
 */ $ea5f9c4151d0164c$var$Shape.PLANE = 4;
/**
 * @static
 * @property {Number} CONVEX
 */ $ea5f9c4151d0164c$var$Shape.CONVEX = 8;
/**
 * @static
 * @property {Number} LINE
 */ $ea5f9c4151d0164c$var$Shape.LINE = 16;
/**
 * @static
 * @property {Number} BOX
 */ $ea5f9c4151d0164c$var$Shape.BOX = 32;
Object.defineProperty($ea5f9c4151d0164c$var$Shape, 'RECTANGLE', {
    get: function() {
        console.warn('Shape.RECTANGLE is deprecated, use Shape.BOX instead.');
        return $ea5f9c4151d0164c$var$Shape.BOX;
    }
});
/**
 * @static
 * @property {Number} CAPSULE
 */ $ea5f9c4151d0164c$var$Shape.CAPSULE = 64;
/**
 * @static
 * @property {Number} HEIGHTFIELD
 */ $ea5f9c4151d0164c$var$Shape.HEIGHTFIELD = 128;
/**
 * Should return the moment of inertia around the Z axis of the body given the total mass. See <a href="http://en.wikipedia.org/wiki/List_of_moments_of_inertia">Wikipedia's list of moments of inertia</a>.
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number} If the inertia is infinity or if the object simply isn't possible to rotate, return 0.
 */ $ea5f9c4151d0164c$var$Shape.prototype.computeMomentOfInertia = function(mass) {};
/**
 * Returns the bounding circle radius of this shape.
 * @method updateBoundingRadius
 * @return {Number}
 */ $ea5f9c4151d0164c$var$Shape.prototype.updateBoundingRadius = function() {};
/**
 * Update the .area property of the shape.
 * @method updateArea
 */ $ea5f9c4151d0164c$var$Shape.prototype.updateArea = function() {
// To be implemented in all subclasses
};
/**
 * Compute the world axis-aligned bounding box (AABB) of this shape.
 * @method computeAABB
 * @param  {AABB} out The resulting AABB.
 * @param  {Array} position World position of the shape.
 * @param  {Number} angle World angle of the shape.
 */ $ea5f9c4151d0164c$var$Shape.prototype.computeAABB = function(out, position, angle) {
// To be implemented in each subclass
};
/**
 * Perform raycasting on this shape.
 * @method raycast
 * @param  {RayResult} result Where to store the resulting data.
 * @param  {Ray} ray The Ray that you want to use for raycasting.
 * @param  {array} position World position of the shape (the .position property will be ignored).
 * @param  {number} angle World angle of the shape (the .angle property will be ignored).
 */ $ea5f9c4151d0164c$var$Shape.prototype.raycast = function(result, ray, position, angle) {
// To be implemented in each subclass
};

});

parcelRegister("cm0Cz", function(module, exports) {
/*
        PolyK library
        url: http://polyk.ivank.net
        Released under MIT licence.

        Copyright (c) 2012 Ivan Kuckir

        Permission is hereby granted, free of charge, to any person
        obtaining a copy of this software and associated documentation
        files (the "Software"), to deal in the Software without
        restriction, including without limitation the rights to use,
        copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies of the Software, and to permit persons to whom the
        Software is furnished to do so, subject to the following
        conditions:

        The above copyright notice and this permission notice shall be
        included in all copies or substantial portions of the Software.

        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
        NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
        HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
        WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
        OTHER DEALINGS IN THE SOFTWARE.
    */ var $8fe80578290374fa$var$PolyK = {};
/*
        Is Polygon self-intersecting?

        O(n^2)
    */ /*
    PolyK.IsSimple = function(p)
    {
        var n = p.length>>1;
        if(n<4) return true;
        var a1 = new PolyK._P(), a2 = new PolyK._P();
        var b1 = new PolyK._P(), b2 = new PolyK._P();
        var c = new PolyK._P();

        for(var i=0; i<n; i++)
        {
            a1.x = p[2*i  ];
            a1.y = p[2*i+1];
            if(i==n-1)  { a2.x = p[0    ];  a2.y = p[1    ]; }
            else        { a2.x = p[2*i+2];  a2.y = p[2*i+3]; }

            for(var j=0; j<n; j++)
            {
                if(Math.abs(i-j) < 2) continue;
                if(j==n-1 && i==0) continue;
                if(i==n-1 && j==0) continue;

                b1.x = p[2*j  ];
                b1.y = p[2*j+1];
                if(j==n-1)  { b2.x = p[0    ];  b2.y = p[1    ]; }
                else        { b2.x = p[2*j+2];  b2.y = p[2*j+3]; }

                if(PolyK._GetLineIntersection(a1,a2,b1,b2,c) != null) return false;
            }
        }
        return true;
    }

    PolyK.IsConvex = function(p)
    {
        if(p.length<6) return true;
        var l = p.length - 4;
        for(var i=0; i<l; i+=2)
            if(!PolyK._convex(p[i], p[i+1], p[i+2], p[i+3], p[i+4], p[i+5])) return false;
        if(!PolyK._convex(p[l  ], p[l+1], p[l+2], p[l+3], p[0], p[1])) return false;
        if(!PolyK._convex(p[l+2], p[l+3], p[0  ], p[1  ], p[2], p[3])) return false;
        return true;
    }
    */ $8fe80578290374fa$var$PolyK.GetArea = function(p) {
    if (p.length < 6) return 0;
    var l = p.length - 2;
    var sum = 0;
    for(var i = 0; i < l; i += 2)sum += (p[i + 2] - p[i]) * (p[i + 1] + p[i + 3]);
    sum += (p[0] - p[l]) * (p[l + 1] + p[1]);
    return -sum * 0.5;
};
/*
    PolyK.GetAABB = function(p)
    {
        var minx = Infinity;
        var miny = Infinity;
        var maxx = -minx;
        var maxy = -miny;
        for(var i=0; i<p.length; i+=2)
        {
            minx = Math.min(minx, p[i  ]);
            maxx = Math.max(maxx, p[i  ]);
            miny = Math.min(miny, p[i+1]);
            maxy = Math.max(maxy, p[i+1]);
        }
        return {x:minx, y:miny, width:maxx-minx, height:maxy-miny};
    }
    */ $8fe80578290374fa$var$PolyK.Triangulate = function(p) {
    var n = p.length >> 1;
    if (n < 3) return [];
    var tgs = [];
    var avl = [];
    for(var i = 0; i < n; i++)avl.push(i);
    var i = 0;
    var al = n;
    while(al > 3){
        var i0 = avl[(i + 0) % al];
        var i1 = avl[(i + 1) % al];
        var i2 = avl[(i + 2) % al];
        var ax = p[2 * i0], ay = p[2 * i0 + 1];
        var bx = p[2 * i1], by = p[2 * i1 + 1];
        var cx = p[2 * i2], cy = p[2 * i2 + 1];
        var earFound = false;
        if ($8fe80578290374fa$var$PolyK._convex(ax, ay, bx, by, cx, cy)) {
            earFound = true;
            for(var j = 0; j < al; j++){
                var vi = avl[j];
                if (vi == i0 || vi == i1 || vi == i2) continue;
                if ($8fe80578290374fa$var$PolyK._PointInTriangle(p[2 * vi], p[2 * vi + 1], ax, ay, bx, by, cx, cy)) {
                    earFound = false;
                    break;
                }
            }
        }
        if (earFound) {
            tgs.push(i0, i1, i2);
            avl.splice((i + 1) % al, 1);
            al--;
            i = 0;
        } else if (i++ > 3 * al) break; // no convex angles :(
    }
    tgs.push(avl[0], avl[1], avl[2]);
    return tgs;
};
/*
    PolyK.ContainsPoint = function(p, px, py)
    {
        var n = p.length>>1;
        var ax, ay, bx = p[2*n-2]-px, by = p[2*n-1]-py;
        var depth = 0;
        for(var i=0; i<n; i++)
        {
            ax = bx;  ay = by;
            bx = p[2*i  ] - px;
            by = p[2*i+1] - py;
            if(ay< 0 && by< 0) continue;    // both "up" or both "donw"
            if(ay>=0 && by>=0) continue;    // both "up" or both "donw"
            if(ax< 0 && bx< 0) continue;

            var lx = ax + (bx-ax)*(-ay)/(by-ay);
            if(lx>0) depth++;
        }
        return (depth & 1) == 1;
    }

    PolyK.Slice = function(p, ax, ay, bx, by)
    {
        if(PolyK.ContainsPoint(p, ax, ay) || PolyK.ContainsPoint(p, bx, by)) return [p.slice(0)];

        var a = new PolyK._P(ax, ay);
        var b = new PolyK._P(bx, by);
        var iscs = [];  // intersections
        var ps = [];    // points
        for(var i=0; i<p.length; i+=2) ps.push(new PolyK._P(p[i], p[i+1]));

        for(var i=0; i<ps.length; i++)
        {
            var isc = new PolyK._P(0,0);
            isc = PolyK._GetLineIntersection(a, b, ps[i], ps[(i+1)%ps.length], isc);

            if(isc)
            {
                isc.flag = true;
                iscs.push(isc);
                ps.splice(i+1,0,isc);
                i++;
            }
        }
        if(iscs.length == 0) return [p.slice(0)];
        var comp = function(u,v) {return PolyK._P.dist(a,u) - PolyK._P.dist(a,v); }
        iscs.sort(comp);

        var pgs = [];
        var dir = 0;
        while(iscs.length > 0)
        {
            var n = ps.length;
            var i0 = iscs[0];
            var i1 = iscs[1];
            var ind0 = ps.indexOf(i0);
            var ind1 = ps.indexOf(i1);
            var solved = false;

            if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
            else
            {
                i0 = iscs[1];
                i1 = iscs[0];
                ind0 = ps.indexOf(i0);
                ind1 = ps.indexOf(i1);
                if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
            }
            if(solved)
            {
                dir--;
                var pgn = PolyK._getPoints(ps, ind0, ind1);
                pgs.push(pgn);
                ps = PolyK._getPoints(ps, ind1, ind0);
                i0.flag = i1.flag = false;
                iscs.splice(0,2);
                if(iscs.length == 0) pgs.push(ps);
            }
            else { dir++; iscs.reverse(); }
            if(dir>1) break;
        }
        var result = [];
        for(var i=0; i<pgs.length; i++)
        {
            var pg = pgs[i];
            var npg = [];
            for(var j=0; j<pg.length; j++) npg.push(pg[j].x, pg[j].y);
            result.push(npg);
        }
        return result;
    }

    PolyK.Raycast = function(p, x, y, dx, dy, isc)
    {
        var l = p.length - 2;
        var tp = PolyK._tp;
        var a1 = tp[0], a2 = tp[1],
        b1 = tp[2], b2 = tp[3], c = tp[4];
        a1.x = x; a1.y = y;
        a2.x = x+dx; a2.y = y+dy;

        if(isc==null) isc = {dist:0, edge:0, norm:{x:0, y:0}, refl:{x:0, y:0}};
        isc.dist = Infinity;

        for(var i=0; i<l; i+=2)
        {
            b1.x = p[i  ];  b1.y = p[i+1];
            b2.x = p[i+2];  b2.y = p[i+3];
            var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
            if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, i/2, isc);
        }
        b1.x = b2.x;  b1.y = b2.y;
        b2.x = p[0];  b2.y = p[1];
        var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
        if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, p.length/2, isc);

        return (isc.dist != Infinity) ? isc : null;
    }

    PolyK.ClosestEdge = function(p, x, y, isc)
    {
        var l = p.length - 2;
        var tp = PolyK._tp;
        var a1 = tp[0],
        b1 = tp[2], b2 = tp[3], c = tp[4];
        a1.x = x; a1.y = y;

        if(isc==null) isc = {dist:0, edge:0, point:{x:0, y:0}, norm:{x:0, y:0}};
        isc.dist = Infinity;

        for(var i=0; i<l; i+=2)
        {
            b1.x = p[i  ];  b1.y = p[i+1];
            b2.x = p[i+2];  b2.y = p[i+3];
            PolyK._pointLineDist(a1, b1, b2, i>>1, isc);
        }
        b1.x = b2.x;  b1.y = b2.y;
        b2.x = p[0];  b2.y = p[1];
        PolyK._pointLineDist(a1, b1, b2, l>>1, isc);

        var idst = 1/isc.dist;
        isc.norm.x = (x-isc.point.x)*idst;
        isc.norm.y = (y-isc.point.y)*idst;
        return isc;
    }

    PolyK._pointLineDist = function(p, a, b, edge, isc)
    {
        var x = p.x, y = p.y, x1 = a.x, y1 = a.y, x2 = b.x, y2 = b.y;

        var A = x - x1;
        var B = y - y1;
        var C = x2 - x1;
        var D = y2 - y1;

        var dot = A * C + B * D;
        var len_sq = C * C + D * D;
        var param = dot / len_sq;

        var xx, yy;

        if (param < 0 || (x1 == x2 && y1 == y2)) {
            xx = x1;
            yy = y1;
        }
        else if (param > 1) {
            xx = x2;
            yy = y2;
        }
        else {
            xx = x1 + param * C;
            yy = y1 + param * D;
        }

        var dx = x - xx;
        var dy = y - yy;
        var dst = Math.sqrt(dx * dx + dy * dy);
        if(dst<isc.dist)
        {
            isc.dist = dst;
            isc.edge = edge;
            isc.point.x = xx;
            isc.point.y = yy;
        }
    }

    PolyK._updateISC = function(dx, dy, a1, b1, b2, c, edge, isc)
    {
        var nrl = PolyK._P.dist(a1, c);
        if(nrl<isc.dist)
        {
            var ibl = 1/PolyK._P.dist(b1, b2);
            var nx = -(b2.y-b1.y)*ibl;
            var ny =  (b2.x-b1.x)*ibl;
            var ddot = 2*(dx*nx+dy*ny);
            isc.dist = nrl;
            isc.norm.x = nx;
            isc.norm.y = ny;
            isc.refl.x = -ddot*nx+dx;
            isc.refl.y = -ddot*ny+dy;
            isc.edge = edge;
        }
    }

    PolyK._getPoints = function(ps, ind0, ind1)
    {
        var n = ps.length;
        var nps = [];
        if(ind1<ind0) ind1 += n;
        for(var i=ind0; i<= ind1; i++) nps.push(ps[i%n]);
        return nps;
    }

    PolyK._firstWithFlag = function(ps, ind)
    {
        var n = ps.length;
        while(true)
        {
            ind = (ind+1)%n;
            if(ps[ind].flag) return ind;
        }
    }
    */ $8fe80578290374fa$var$PolyK._PointInTriangle = function(px, py, ax, ay, bx, by, cx, cy) {
    var v0x = cx - ax;
    var v0y = cy - ay;
    var v1x = bx - ax;
    var v1y = by - ay;
    var v2x = px - ax;
    var v2y = py - ay;
    var dot00 = v0x * v0x + v0y * v0y;
    var dot01 = v0x * v1x + v0y * v1y;
    var dot02 = v0x * v2x + v0y * v2y;
    var dot11 = v1x * v1x + v1y * v1y;
    var dot12 = v1x * v2x + v1y * v2y;
    var invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
    var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    // Check if point is in triangle
    return u >= 0 && v >= 0 && u + v < 1;
};
/*
    PolyK._RayLineIntersection = function(a1, a2, b1, b2, c)
    {
        var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
        var day = (a1.y-a2.y), dby = (b1.y-b2.y);

        var Den = dax*dby - day*dbx;
        if (Den == 0) return null;  // parallel

        var A = (a1.x * a2.y - a1.y * a2.x);
        var B = (b1.x * b2.y - b1.y * b2.x);

        var I = c;
        var iDen = 1/Den;
        I.x = ( A*dbx - dax*B ) * iDen;
        I.y = ( A*dby - day*B ) * iDen;

        if(!PolyK._InRect(I, b1, b2)) return null;
        if((day>0 && I.y>a1.y) || (day<0 && I.y<a1.y)) return null;
        if((dax>0 && I.x>a1.x) || (dax<0 && I.x<a1.x)) return null;
        return I;
    }

    PolyK._GetLineIntersection = function(a1, a2, b1, b2, c)
    {
        var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
        var day = (a1.y-a2.y), dby = (b1.y-b2.y);

        var Den = dax*dby - day*dbx;
        if (Den == 0) return null;  // parallel

        var A = (a1.x * a2.y - a1.y * a2.x);
        var B = (b1.x * b2.y - b1.y * b2.x);

        var I = c;
        I.x = ( A*dbx - dax*B ) / Den;
        I.y = ( A*dby - day*B ) / Den;

        if(PolyK._InRect(I, a1, a2) && PolyK._InRect(I, b1, b2)) return I;
        return null;
    }

    PolyK._InRect = function(a, b, c)
    {
        if  (b.x == c.x) return (a.y>=Math.min(b.y, c.y) && a.y<=Math.max(b.y, c.y));
        if  (b.y == c.y) return (a.x>=Math.min(b.x, c.x) && a.x<=Math.max(b.x, c.x));

        if(a.x >= Math.min(b.x, c.x) && a.x <= Math.max(b.x, c.x)
        && a.y >= Math.min(b.y, c.y) && a.y <= Math.max(b.y, c.y))
        return true;
        return false;
    }
    */ $8fe80578290374fa$var$PolyK._convex = function(ax, ay, bx, by, cx, cy) {
    return (ay - by) * (cx - bx) + (bx - ax) * (cy - by) >= 0;
};
/*
    PolyK._P = function(x,y)
    {
        this.x = x;
        this.y = y;
        this.flag = false;
    }
    PolyK._P.prototype.toString = function()
    {
        return "Point ["+this.x+", "+this.y+"]";
    }
    PolyK._P.dist = function(a,b)
    {
        var dx = b.x-a.x;
        var dy = b.y-a.y;
        return Math.sqrt(dx*dx + dy*dy);
    }

    PolyK._tp = [];
    for(var i=0; i<10; i++) PolyK._tp.push(new PolyK._P(0,0));
        */ module.exports = $8fe80578290374fa$var$PolyK;

});


parcelRegister("ZlKj0", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $l9ZUH = parcelRequire("l9ZUH");
module.exports = $0b8690e51f419871$var$RaycastResult;
/**
 * Storage for Ray casting hit data.
 * @class RaycastResult
 * @constructor
 */ function $0b8690e51f419871$var$RaycastResult() {
    /**
	 * The normal of the hit, oriented in world space.
	 * @property {array} normal
	 */ this.normal = $2Ys9z.create();
    /**
	 * The hit shape, or null.
	 * @property {Shape} shape
	 */ this.shape = null;
    /**
	 * The hit body, or null.
	 * @property {Body} body
	 */ this.body = null;
    /**
	 * The index of the hit triangle, if the hit shape was indexable.
	 * @property {number} faceIndex
	 * @default -1
	 */ this.faceIndex = -1;
    /**
	 * Distance to the hit, as a fraction. 0 is at the "from" point, 1 is at the "to" point. Will be set to -1 if there was no hit yet.
	 * @property {number} fraction
	 * @default -1
	 */ this.fraction = -1;
    /**
	 * If the ray should stop traversing.
	 * @readonly
	 * @property {Boolean} isStopped
	 */ this.isStopped = false;
}
/**
 * Reset all result data. Must be done before re-using the result object.
 * @method reset
 */ $0b8690e51f419871$var$RaycastResult.prototype.reset = function() {
    $2Ys9z.set(this.normal, 0, 0);
    this.shape = null;
    this.body = null;
    this.faceIndex = -1;
    this.fraction = -1;
    this.isStopped = false;
};
/**
 * Get the distance to the hit point.
 * @method getHitDistance
 * @param {Ray} ray
 */ $0b8690e51f419871$var$RaycastResult.prototype.getHitDistance = function(ray) {
    return $2Ys9z.distance(ray.from, ray.to) * this.fraction;
};
/**
 * Returns true if the ray hit something since the last reset().
 * @method hasHit
 */ $0b8690e51f419871$var$RaycastResult.prototype.hasHit = function() {
    return this.fraction !== -1;
};
/**
 * Get world hit point.
 * @method getHitPoint
 * @param {array} out
 * @param {Ray} ray
 */ $0b8690e51f419871$var$RaycastResult.prototype.getHitPoint = function(out, ray) {
    $2Ys9z.lerp(out, ray.from, ray.to, this.fraction);
};
/**
 * Can be called while iterating over hits to stop searching for hit points.
 * @method stop
 */ $0b8690e51f419871$var$RaycastResult.prototype.stop = function() {
    this.isStopped = true;
};
/**
 * @method shouldStop
 * @private
 * @param {Ray} ray
 * @return {boolean}
 */ $0b8690e51f419871$var$RaycastResult.prototype.shouldStop = function(ray) {
    return this.isStopped || this.fraction !== -1 && ray.mode === $l9ZUH.ANY;
};
/**
 * @method set
 * @private
 * @param {array} normal
 * @param {Shape} shape
 * @param {Body} body
 * @param {number} fraction
 */ $0b8690e51f419871$var$RaycastResult.prototype.set = function(normal, shape, body, fraction, faceIndex) {
    $2Ys9z.copy(this.normal, normal);
    this.shape = shape;
    this.body = body;
    this.fraction = fraction;
    this.faceIndex = faceIndex;
};

});
parcelRegister("l9ZUH", function(module, exports) {
module.exports = $f67a76f538e3ba3b$var$Ray;

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("ZlKj0");
parcelRequire("k7z01");
parcelRequire("hkl1e");
/**
 * A line with a start and end point that is used to intersect shapes. For an example, see {{#crossLink "World/raycast:method"}}World.raycast{{/crossLink}}
 * @class Ray
 * @constructor
 * @param {object} [options]
 * @param {array} [options.from]
 * @param {array} [options.to]
 * @param {boolean} [options.checkCollisionResponse=true]
 * @param {boolean} [options.skipBackfaces=false]
 * @param {number} [options.collisionMask=-1]
 * @param {number} [options.collisionGroup=-1]
 * @param {number} [options.mode=Ray.ANY]
 * @param {number} [options.callback]
 */ function $f67a76f538e3ba3b$var$Ray(options) {
    options = options || {};
    /**
     * Ray start point.
     * @property {array} from
     */ this.from = options.from ? $2Ys9z.fromValues(options.from[0], options.from[1]) : $2Ys9z.create();
    /**
     * Ray end point
     * @property {array} to
     */ this.to = options.to ? $2Ys9z.fromValues(options.to[0], options.to[1]) : $2Ys9z.create();
    /**
     * Set to true if you want the Ray to take .collisionResponse flags into account on bodies and shapes.
     * @property {Boolean} checkCollisionResponse
     */ this.checkCollisionResponse = options.checkCollisionResponse !== undefined ? options.checkCollisionResponse : true;
    /**
     * If set to true, the ray skips any hits with normal.dot(rayDirection) < 0.
     * @property {Boolean} skipBackfaces
     */ this.skipBackfaces = !!options.skipBackfaces;
    /**
     * @property {number} collisionMask
     * @default -1
     */ this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : -1;
    /**
     * @property {number} collisionGroup
     * @default -1
     */ this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : -1;
    /**
     * The intersection mode. Should be {{#crossLink "Ray/ANY:property"}}Ray.ANY{{/crossLink}}, {{#crossLink "Ray/ALL:property"}}Ray.ALL{{/crossLink}} or {{#crossLink "Ray/CLOSEST:property"}}Ray.CLOSEST{{/crossLink}}.
     * @property {number} mode
     */ this.mode = options.mode !== undefined ? options.mode : $f67a76f538e3ba3b$var$Ray.ANY;
    /**
     * Current, user-provided result callback. Will be used if mode is Ray.ALL.
     * @property {Function} callback
     */ this.callback = options.callback || function(result) {};
    /**
     * @readOnly
     * @property {array} direction
     */ this.direction = $2Ys9z.create();
    /**
     * Length of the ray
     * @readOnly
     * @property {number} length
     */ this.length = 1;
    this.update();
}
$f67a76f538e3ba3b$var$Ray.prototype.constructor = $f67a76f538e3ba3b$var$Ray;
/**
 * This raycasting mode will make the Ray traverse through all intersection points and only return the closest one.
 * @static
 * @property {Number} CLOSEST
 */ $f67a76f538e3ba3b$var$Ray.CLOSEST = 1;
/**
 * This raycasting mode will make the Ray stop when it finds the first intersection point.
 * @static
 * @property {Number} ANY
 */ $f67a76f538e3ba3b$var$Ray.ANY = 2;
/**
 * This raycasting mode will traverse all intersection points and executes a callback for each one.
 * @static
 * @property {Number} ALL
 */ $f67a76f538e3ba3b$var$Ray.ALL = 4;
/**
 * Should be called if you change the from or to point.
 * @method update
 */ $f67a76f538e3ba3b$var$Ray.prototype.update = function() {
    // Update .direction and .length
    var d = this.direction;
    $2Ys9z.sub(d, this.to, this.from);
    this.length = $2Ys9z.length(d);
    $2Ys9z.normalize(d, d);
};
/**
 * @method intersectBodies
 * @param {Array} bodies An array of Body objects.
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectBodies = function(result, bodies) {
    for(var i = 0, l = bodies.length; !result.shouldStop(this) && i < l; i++){
        var body = bodies[i];
        var aabb = body.getAABB();
        if (aabb.overlapsRay(this) >= 0 || aabb.containsPoint(this.from)) this.intersectBody(result, body);
    }
};
var $f67a76f538e3ba3b$var$intersectBody_worldPosition = $2Ys9z.create();
/**
 * Shoot a ray at a body, get back information about the hit.
 * @method intersectBody
 * @private
 * @param {Body} body
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectBody = function(result, body) {
    var checkCollisionResponse = this.checkCollisionResponse;
    if (checkCollisionResponse && !body.collisionResponse) return;
    var worldPosition = $f67a76f538e3ba3b$var$intersectBody_worldPosition;
    for(var i = 0, N = body.shapes.length; i < N; i++){
        var shape = body.shapes[i];
        if (checkCollisionResponse && !shape.collisionResponse) continue; // Skip
        if ((this.collisionGroup & shape.collisionMask) === 0 || (shape.collisionGroup & this.collisionMask) === 0) continue;
        // Get world angle and position of the shape
        $2Ys9z.rotate(worldPosition, shape.position, body.angle);
        $2Ys9z.add(worldPosition, worldPosition, body.position);
        var worldAngle = shape.angle + body.angle;
        this.intersectShape(result, shape, worldAngle, worldPosition, body);
        if (result.shouldStop(this)) break;
    }
};
/**
 * @method intersectShape
 * @private
 * @param {Shape} shape
 * @param {number} angle
 * @param {array} position
 * @param {Body} body
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectShape = function(result, shape, angle, position, body) {
    var from = this.from;
    // Checking radius
    var distance = $f67a76f538e3ba3b$var$distanceFromIntersectionSquared(from, this.direction, position);
    if (distance > shape.boundingRadius * shape.boundingRadius) return;
    this._currentBody = body;
    this._currentShape = shape;
    shape.raycast(result, this, position, angle);
    this._currentBody = this._currentShape = null;
};
/**
 * Get the AABB of the ray.
 * @method getAABB
 * @param  {AABB} aabb
 */ $f67a76f538e3ba3b$var$Ray.prototype.getAABB = function(result) {
    var to = this.to;
    var from = this.from;
    $2Ys9z.set(result.lowerBound, Math.min(to[0], from[0]), Math.min(to[1], from[1]));
    $2Ys9z.set(result.upperBound, Math.max(to[0], from[0]), Math.max(to[1], from[1]));
};
var $f67a76f538e3ba3b$var$hitPointWorld = $2Ys9z.create();
/**
 * @method reportIntersection
 * @private
 * @param  {number} fraction
 * @param  {array} normal
 * @param  {number} [faceIndex=-1]
 * @return {boolean} True if the intersections should continue
 */ $f67a76f538e3ba3b$var$Ray.prototype.reportIntersection = function(result, fraction, normal, faceIndex) {
    var from = this.from;
    var to = this.to;
    var shape = this._currentShape;
    var body = this._currentBody;
    // Skip back faces?
    if (this.skipBackfaces && $2Ys9z.dot(normal, this.direction) > 0) return;
    switch(this.mode){
        case $f67a76f538e3ba3b$var$Ray.ALL:
            result.set(normal, shape, body, fraction, faceIndex);
            this.callback(result);
            break;
        case $f67a76f538e3ba3b$var$Ray.CLOSEST:
            // Store if closer than current closest
            if (fraction < result.fraction || !result.hasHit()) result.set(normal, shape, body, fraction, faceIndex);
            break;
        case $f67a76f538e3ba3b$var$Ray.ANY:
            // Report and stop.
            result.set(normal, shape, body, fraction, faceIndex);
            break;
    }
};
var $f67a76f538e3ba3b$var$v0 = $2Ys9z.create(), $f67a76f538e3ba3b$var$intersect = $2Ys9z.create();
function $f67a76f538e3ba3b$var$distanceFromIntersectionSquared(from, direction, position) {
    // v0 is vector from from to position
    $2Ys9z.sub($f67a76f538e3ba3b$var$v0, position, from);
    var dot = $2Ys9z.dot($f67a76f538e3ba3b$var$v0, direction);
    // intersect = direction * dot + from
    $2Ys9z.scale($f67a76f538e3ba3b$var$intersect, direction, dot);
    $2Ys9z.add($f67a76f538e3ba3b$var$intersect, $f67a76f538e3ba3b$var$intersect, from);
    return $2Ys9z.squaredDistance(position, $f67a76f538e3ba3b$var$intersect);
}

});


parcelRegister("5POlg", function(module, exports) {
/**
 * Base class for objects that dispatches events.
 * @class EventEmitter
 * @constructor
 */ var $43f8c405f3231efd$var$EventEmitter = function() {};
module.exports = $43f8c405f3231efd$var$EventEmitter;
$43f8c405f3231efd$var$EventEmitter.prototype = {
    constructor: $43f8c405f3231efd$var$EventEmitter,
    /**
     * Add an event listener
     * @method on
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventEmitter} The self object, for chainability.
     */ on: function(type, listener, context) {
        listener.context = context || this;
        if (this._listeners === undefined) this._listeners = {};
        var listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
        return this;
    },
    /**
     * Check if an event listener is added
     * @method has
     * @param  {String} type
     * @param  {Function} listener
     * @return {Boolean}
     */ has: function(type, listener) {
        if (this._listeners === undefined) return false;
        var listeners = this._listeners;
        if (listener) {
            if (listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1) return true;
        } else {
            if (listeners[type] !== undefined) return true;
        }
        return false;
    },
    /**
     * Remove an event listener
     * @method off
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventEmitter} The self object, for chainability.
     */ off: function(type, listener) {
        if (this._listeners === undefined) return this;
        var listeners = this._listeners;
        var index = listeners[type].indexOf(listener);
        if (index !== -1) listeners[type].splice(index, 1);
        return this;
    },
    /**
     * Emit an event.
     * @method emit
     * @param  {Object} event
     * @param  {String} event.type
     * @return {EventEmitter} The self object, for chainability.
     */ emit: function(event) {
        if (this._listeners === undefined) return this;
        var listeners = this._listeners;
        var listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            for(var i = 0, l = listenerArray.length; i < l; i++){
                var listener = listenerArray[i];
                listener.call(listener.context, event);
            }
        }
        return this;
    }
};

});




parcelRegister("dQgku", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $a13ccc5cdbcd0111$var$Broadphase;
/**
 * Base class for broadphase implementations.
 * @class Broadphase
 * @constructor
 */ function $a13ccc5cdbcd0111$var$Broadphase(type) {
    this.type = type;
    /**
     * The resulting overlapping pairs. Will be filled with results during .getCollisionPairs().
     * @property result
     * @type {Array}
     */ this.result = [];
    /**
     * The world to search for collision pairs in. To change it, use .setWorld()
     * @property world
     * @type {World}
     * @readOnly
     */ this.world = null;
    /**
     * The bounding volume type to use in the broadphase algorithms. Should be set to Broadphase.AABB or Broadphase.BOUNDING_CIRCLE.
     * @property {Number} boundingVolumeType
     */ this.boundingVolumeType = $a13ccc5cdbcd0111$var$Broadphase.AABB;
}
/**
 * Axis aligned bounding box type.
 * @static
 * @property {Number} AABB
 */ $a13ccc5cdbcd0111$var$Broadphase.AABB = 1;
/**
 * Bounding circle type.
 * @static
 * @property {Number} BOUNDING_CIRCLE
 */ $a13ccc5cdbcd0111$var$Broadphase.BOUNDING_CIRCLE = 2;
/**
 * Set the world that we are searching for collision pairs in.
 * @method setWorld
 * @param  {World} world
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.setWorld = function(world) {
    this.world = world;
};
/**
 * Get all potential intersecting body pairs.
 * @method getCollisionPairs
 * @param  {World} world The world to search in.
 * @return {Array} An array of the bodies, ordered in pairs. Example: A result of [a,b,c,d] means that the potential pairs are: (a,b), (c,d).
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.getCollisionPairs = function(world) {};
var $a13ccc5cdbcd0111$var$dist = $2Ys9z.create();
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.boundingRadiusCheck = function(bodyA, bodyB) {
    $2Ys9z.sub($a13ccc5cdbcd0111$var$dist, bodyA.position, bodyB.position);
    var d2 = $2Ys9z.squaredLength($a13ccc5cdbcd0111$var$dist), r = bodyA.boundingRadius + bodyB.boundingRadius;
    return d2 <= r * r;
};
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.aabbCheck = function(bodyA, bodyB) {
    return bodyA.getAABB().overlaps(bodyB.getAABB());
};
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.boundingVolumeCheck = function(bodyA, bodyB) {
    var result;
    switch(this.boundingVolumeType){
        case $a13ccc5cdbcd0111$var$Broadphase.BOUNDING_CIRCLE:
            result = $a13ccc5cdbcd0111$var$Broadphase.boundingRadiusCheck(bodyA, bodyB);
            break;
        case $a13ccc5cdbcd0111$var$Broadphase.AABB:
            result = $a13ccc5cdbcd0111$var$Broadphase.aabbCheck(bodyA, bodyB);
            break;
        default:
            throw new Error('Bounding volume type not recognized: ' + this.boundingVolumeType);
    }
    return result;
};
/**
 * Check whether two bodies are allowed to collide at all.
 * @method  canCollide
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.canCollide = function(bodyA, bodyB) {
    var KINEMATIC = $e7hLo.KINEMATIC;
    var STATIC = $e7hLo.STATIC;
    // Cannot collide static bodies
    if (bodyA.type === STATIC && bodyB.type === STATIC) return false;
    // Cannot collide static vs kinematic bodies
    if (bodyA.type === KINEMATIC && bodyB.type === STATIC || bodyA.type === STATIC && bodyB.type === KINEMATIC) return false;
    // Cannot collide kinematic vs kinematic
    if (bodyA.type === KINEMATIC && bodyB.type === KINEMATIC) return false;
    // Cannot collide both sleeping bodies
    if (bodyA.sleepState === $e7hLo.SLEEPING && bodyB.sleepState === $e7hLo.SLEEPING) return false;
    // Cannot collide if one is static and the other is sleeping
    if (bodyA.sleepState === $e7hLo.SLEEPING && bodyB.type === STATIC || bodyB.sleepState === $e7hLo.SLEEPING && bodyA.type === STATIC) return false;
    return true;
};
$a13ccc5cdbcd0111$var$Broadphase.NAIVE = 1;
$a13ccc5cdbcd0111$var$Broadphase.SAP = 2;

});

parcelRegister("4flMw", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $3179757e477018e0$var$Capsule;
/**
 * Capsule shape class.
 * @class Capsule
 * @constructor
 * @extends Shape
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.length=1] The distance between the end points
 * @param {Number} [options.radius=1] Radius of the capsule
 * @example
 *     var capsuleShape = new Capsule({
 *         length: 1,
 *         radius: 2
 *     });
 *     body.addShape(capsuleShape);
 */ function $3179757e477018e0$var$Capsule(options) {
    if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        options = {
            length: arguments[0],
            radius: arguments[1]
        };
        console.warn('The Capsule constructor signature has changed. Please use the following format: new Capsule({ radius: 1, length: 1 })');
    }
    options = options || {};
    /**
     * The distance between the end points.
     * @property {Number} length
     */ this.length = options.length || 1;
    /**
     * The radius of the capsule.
     * @property {Number} radius
     */ this.radius = options.radius || 1;
    options.type = $k7z01.CAPSULE;
    $k7z01.call(this, options);
}
$3179757e477018e0$var$Capsule.prototype = new $k7z01();
$3179757e477018e0$var$Capsule.prototype.constructor = $3179757e477018e0$var$Capsule;
/**
 * Compute the mass moment of inertia of the Capsule.
 * @method conputeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 * @todo
 */ $3179757e477018e0$var$Capsule.prototype.computeMomentOfInertia = function(mass) {
    // Approximate with rectangle
    var r = this.radius, w = this.length + r, h = r * 2;
    return mass * (h * h + w * w) / 12;
};
/**
 * @method updateBoundingRadius
 */ $3179757e477018e0$var$Capsule.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.radius + this.length / 2;
};
/**
 * @method updateArea
 */ $3179757e477018e0$var$Capsule.prototype.updateArea = function() {
    this.area = Math.PI * this.radius * this.radius + this.radius * 2 * this.length;
};
var $3179757e477018e0$var$r = $2Ys9z.create();
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $3179757e477018e0$var$Capsule.prototype.computeAABB = function(out, position, angle) {
    var radius = this.radius;
    // Compute center position of one of the the circles, world oriented, but with local offset
    $2Ys9z.set($3179757e477018e0$var$r, this.length / 2, 0);
    if (angle !== 0) $2Ys9z.rotate($3179757e477018e0$var$r, $3179757e477018e0$var$r, angle);
    // Get bounds
    $2Ys9z.set(out.upperBound, Math.max($3179757e477018e0$var$r[0] + radius, -$3179757e477018e0$var$r[0] + radius), Math.max($3179757e477018e0$var$r[1] + radius, -$3179757e477018e0$var$r[1] + radius));
    $2Ys9z.set(out.lowerBound, Math.min($3179757e477018e0$var$r[0] - radius, -$3179757e477018e0$var$r[0] - radius), Math.min($3179757e477018e0$var$r[1] - radius, -$3179757e477018e0$var$r[1] - radius));
    // Add offset
    $2Ys9z.add(out.lowerBound, out.lowerBound, position);
    $2Ys9z.add(out.upperBound, out.upperBound, position);
};
var $3179757e477018e0$var$intersectCapsule_hitPointWorld = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_normal = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_l0 = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_l1 = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_unit_y = $2Ys9z.fromValues(0, 1);
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $3179757e477018e0$var$Capsule.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var hitPointWorld = $3179757e477018e0$var$intersectCapsule_hitPointWorld;
    var normal = $3179757e477018e0$var$intersectCapsule_normal;
    var l0 = $3179757e477018e0$var$intersectCapsule_l0;
    var l1 = $3179757e477018e0$var$intersectCapsule_l1;
    // The sides
    var halfLen = this.length / 2;
    for(var i = 0; i < 2; i++){
        // get start and end of the line
        var y = this.radius * (i * 2 - 1);
        $2Ys9z.set(l0, -halfLen, y);
        $2Ys9z.set(l1, halfLen, y);
        $2Ys9z.toGlobalFrame(l0, l0, position, angle);
        $2Ys9z.toGlobalFrame(l1, l1, position, angle);
        var delta = $2Ys9z.getLineSegmentsIntersectionFraction(from, to, l0, l1);
        if (delta >= 0) {
            $2Ys9z.rotate(normal, $3179757e477018e0$var$intersectCapsule_unit_y, angle);
            $2Ys9z.scale(normal, normal, i * 2 - 1);
            ray.reportIntersection(result, delta, normal, -1);
            if (result.shouldStop(ray)) return;
        }
    }
    // Circles
    var diagonalLengthSquared = Math.pow(this.radius, 2) + Math.pow(halfLen, 2);
    for(var i = 0; i < 2; i++){
        $2Ys9z.set(l0, halfLen * (i * 2 - 1), 0);
        $2Ys9z.toGlobalFrame(l0, l0, position, angle);
        var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
        var b = 2 * ((to[0] - from[0]) * (from[0] - l0[0]) + (to[1] - from[1]) * (from[1] - l0[1]));
        var c = Math.pow(from[0] - l0[0], 2) + Math.pow(from[1] - l0[1], 2) - Math.pow(this.radius, 2);
        var delta = Math.pow(b, 2) - 4 * a * c;
        if (delta < 0) continue;
        else if (delta === 0) {
            // single intersection point
            $2Ys9z.lerp(hitPointWorld, from, to, delta);
            if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                $2Ys9z.sub(normal, hitPointWorld, l0);
                $2Ys9z.normalize(normal, normal);
                ray.reportIntersection(result, delta, normal, -1);
                if (result.shouldStop(ray)) return;
            }
        } else {
            var sqrtDelta = Math.sqrt(delta);
            var inv2a = 1 / (2 * a);
            var d1 = (-b - sqrtDelta) * inv2a;
            var d2 = (-b + sqrtDelta) * inv2a;
            if (d1 >= 0 && d1 <= 1) {
                $2Ys9z.lerp(hitPointWorld, from, to, d1);
                if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                    $2Ys9z.sub(normal, hitPointWorld, l0);
                    $2Ys9z.normalize(normal, normal);
                    ray.reportIntersection(result, d1, normal, -1);
                    if (result.shouldStop(ray)) return;
                }
            }
            if (d2 >= 0 && d2 <= 1) {
                $2Ys9z.lerp(hitPointWorld, from, to, d2);
                if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                    $2Ys9z.sub(normal, hitPointWorld, l0);
                    $2Ys9z.normalize(normal, normal);
                    ray.reportIntersection(result, d2, normal, -1);
                    if (result.shouldStop(ray)) return;
                }
            }
        }
    }
};

});

parcelRegister("OJ0UJ", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $0987966afaa2e433$var$Circle;
/**
 * Circle shape class.
 * @class Circle
 * @extends Shape
 * @constructor
 * @param {options} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {number} [options.radius=1] The radius of this circle
 *
 * @example
 *     var circleShape = new Circle({ radius: 1 });
 *     body.addShape(circleShape);
 */ function $0987966afaa2e433$var$Circle(options) {
    if (typeof arguments[0] === 'number') {
        options = {
            radius: arguments[0]
        };
        console.warn('The Circle constructor signature has changed. Please use the following format: new Circle({ radius: 1 })');
    }
    options = options || {};
    /**
     * The radius of the circle.
     * @property radius
     * @type {number}
     */ this.radius = options.radius || 1;
    options.type = $k7z01.CIRCLE;
    $k7z01.call(this, options);
}
$0987966afaa2e433$var$Circle.prototype = new $k7z01();
$0987966afaa2e433$var$Circle.prototype.constructor = $0987966afaa2e433$var$Circle;
/**
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.computeMomentOfInertia = function(mass) {
    var r = this.radius;
    return mass * r * r / 2;
};
/**
 * @method updateBoundingRadius
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.radius;
};
/**
 * @method updateArea
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.updateArea = function() {
    this.area = Math.PI * this.radius * this.radius;
};
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $0987966afaa2e433$var$Circle.prototype.computeAABB = function(out, position, angle) {
    var r = this.radius;
    $2Ys9z.set(out.upperBound, r, r);
    $2Ys9z.set(out.lowerBound, -r, -r);
    if (position) {
        $2Ys9z.add(out.lowerBound, out.lowerBound, position);
        $2Ys9z.add(out.upperBound, out.upperBound, position);
    }
};
var $0987966afaa2e433$var$Ray_intersectSphere_intersectionPoint = $2Ys9z.create();
var $0987966afaa2e433$var$Ray_intersectSphere_normal = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $0987966afaa2e433$var$Circle.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from, to = ray.to, r = this.radius;
    var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
    var b = 2 * ((to[0] - from[0]) * (from[0] - position[0]) + (to[1] - from[1]) * (from[1] - position[1]));
    var c = Math.pow(from[0] - position[0], 2) + Math.pow(from[1] - position[1], 2) - Math.pow(r, 2);
    var delta = Math.pow(b, 2) - 4 * a * c;
    var intersectionPoint = $0987966afaa2e433$var$Ray_intersectSphere_intersectionPoint;
    var normal = $0987966afaa2e433$var$Ray_intersectSphere_normal;
    if (delta < 0) // No intersection
    return;
    else if (delta === 0) {
        // single intersection point
        $2Ys9z.lerp(intersectionPoint, from, to, delta);
        $2Ys9z.sub(normal, intersectionPoint, position);
        $2Ys9z.normalize(normal, normal);
        ray.reportIntersection(result, delta, normal, -1);
    } else {
        var sqrtDelta = Math.sqrt(delta);
        var inv2a = 1 / (2 * a);
        var d1 = (-b - sqrtDelta) * inv2a;
        var d2 = (-b + sqrtDelta) * inv2a;
        if (d1 >= 0 && d1 <= 1) {
            $2Ys9z.lerp(intersectionPoint, from, to, d1);
            $2Ys9z.sub(normal, intersectionPoint, position);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, d1, normal, -1);
            if (result.shouldStop(ray)) return;
        }
        if (d2 >= 0 && d2 <= 1) {
            $2Ys9z.lerp(intersectionPoint, from, to, d2);
            $2Ys9z.sub(normal, intersectionPoint, position);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, d2, normal, -1);
        }
    }
};

});

parcelRegister("3iby4", function(module, exports) {
module.exports = $265c02d6433a735e$var$Constraint;

var $dMz05 = parcelRequire("dMz05");
/**
 * Base constraint class.
 *
 * @class Constraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} type
 * @param {Object} [options]
 * @param {Object} [options.collideConnected=true]
 */ function $265c02d6433a735e$var$Constraint(bodyA, bodyB, type, options) {
    /**
     * The type of constraint. May be one of Constraint.DISTANCE, Constraint.GEAR, Constraint.LOCK, Constraint.PRISMATIC or Constraint.REVOLUTE.
     * @property {number} type
     */ this.type = type;
    options = $dMz05.defaults(options, {
        collideConnected: true,
        wakeUpBodies: true
    });
    /**
     * Equations to be solved in this constraint
     *
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * First body participating in the constraint.
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second body participating in the constraint.
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
    /**
     * Set to true if you want the connected bodies to collide.
     * @property collideConnected
     * @type {Boolean}
     * @default true
     */ this.collideConnected = options.collideConnected;
    // Wake up bodies when connected
    if (options.wakeUpBodies) {
        if (bodyA) bodyA.wakeUp();
        if (bodyB) bodyB.wakeUp();
    }
}
/**
 * Updates the internal constraint parameters before solve.
 * @method update
 */ $265c02d6433a735e$var$Constraint.prototype.update = function() {
    throw new Error("method update() not implmemented in this Constraint subclass!");
};
/**
 * @static
 * @property {number} DISTANCE
 */ $265c02d6433a735e$var$Constraint.DISTANCE = 1;
/**
 * @static
 * @property {number} GEAR
 */ $265c02d6433a735e$var$Constraint.GEAR = 2;
/**
 * @static
 * @property {number} LOCK
 */ $265c02d6433a735e$var$Constraint.LOCK = 3;
/**
 * @static
 * @property {number} PRISMATIC
 */ $265c02d6433a735e$var$Constraint.PRISMATIC = 4;
/**
 * @static
 * @property {number} REVOLUTE
 */ $265c02d6433a735e$var$Constraint.REVOLUTE = 5;
/**
 * Set stiffness for this constraint.
 * @method setStiffness
 * @param {Number} stiffness
 */ $265c02d6433a735e$var$Constraint.prototype.setStiffness = function(stiffness) {
    var eqs = this.equations;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        eq.stiffness = stiffness;
        eq.needsUpdate = true;
    }
};
/**
 * Set relaxation for this constraint.
 * @method setRelaxation
 * @param {Number} relaxation
 */ $265c02d6433a735e$var$Constraint.prototype.setRelaxation = function(relaxation) {
    var eqs = this.equations;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        eq.relaxation = relaxation;
        eq.needsUpdate = true;
    }
};

});

parcelRegister("cSwh0", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $96038ffecb9a9a01$var$ContactEquation;
/**
 * Non-penetration constraint equation. Tries to make the contactPointA and contactPointB vectors coincide, while keeping the applied force repulsive.
 *
 * @class ContactEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ function $96038ffecb9a9a01$var$ContactEquation(bodyA, bodyB) {
    $f0tQu.call(this, bodyA, bodyB, 0, Number.MAX_VALUE);
    /**
     * Vector from body i center of mass to the contact point.
     * @property contactPointA
     * @type {Array}
     */ this.contactPointA = $2Ys9z.create();
    this.penetrationVec = $2Ys9z.create();
    /**
     * World-oriented vector from body A center of mass to the contact point.
     * @property contactPointB
     * @type {Array}
     */ this.contactPointB = $2Ys9z.create();
    /**
     * The normal vector, pointing out of body i
     * @property normalA
     * @type {Array}
     */ this.normalA = $2Ys9z.create();
    /**
     * The restitution to use (0=no bounciness, 1=max bounciness).
     * @property restitution
     * @type {Number}
     */ this.restitution = 0;
    /**
     * This property is set to true if this is the first impact between the bodies (not persistant contact).
     * @property firstImpact
     * @type {Boolean}
     * @readOnly
     */ this.firstImpact = false;
    /**
     * The shape in body i that triggered this contact.
     * @property shapeA
     * @type {Shape}
     */ this.shapeA = null;
    /**
     * The shape in body j that triggered this contact.
     * @property shapeB
     * @type {Shape}
     */ this.shapeB = null;
}
$96038ffecb9a9a01$var$ContactEquation.prototype = new $f0tQu();
$96038ffecb9a9a01$var$ContactEquation.prototype.constructor = $96038ffecb9a9a01$var$ContactEquation;
$96038ffecb9a9a01$var$ContactEquation.prototype.computeB = function(a, b, h) {
    var bi = this.bodyA, bj = this.bodyB, ri = this.contactPointA, rj = this.contactPointB, xi = bi.position, xj = bj.position;
    var penetrationVec = this.penetrationVec, n = this.normalA, G = this.G;
    // Caluclate cross products
    var rixn = $2Ys9z.crossLength(ri, n), rjxn = $2Ys9z.crossLength(rj, n);
    // G = [-n -rixn n rjxn]
    G[0] = -n[0];
    G[1] = -n[1];
    G[2] = -rixn;
    G[3] = n[0];
    G[4] = n[1];
    G[5] = rjxn;
    // Calculate q = xj+rj -(xi+ri) i.e. the penetration vector
    $2Ys9z.add(penetrationVec, xj, rj);
    $2Ys9z.sub(penetrationVec, penetrationVec, xi);
    $2Ys9z.sub(penetrationVec, penetrationVec, ri);
    // Compute iteration
    var GW, Gq;
    if (this.firstImpact && this.restitution !== 0) {
        Gq = 0;
        GW = 1 / b * (1 + this.restitution) * this.computeGW();
    } else {
        Gq = $2Ys9z.dot(n, penetrationVec) + this.offset;
        GW = this.computeGW();
    }
    var GiMf = this.computeGiMf();
    var B = -Gq * a - GW * b - h * GiMf;
    return B;
};
var $96038ffecb9a9a01$var$vi = $2Ys9z.create();
var $96038ffecb9a9a01$var$vj = $2Ys9z.create();
var $96038ffecb9a9a01$var$relVel = $2Ys9z.create();
/**
 * Get the relative velocity along the normal vector.
 * @return {number}
 */ $96038ffecb9a9a01$var$ContactEquation.prototype.getVelocityAlongNormal = function() {
    this.bodyA.getVelocityAtPoint($96038ffecb9a9a01$var$vi, this.contactPointA);
    this.bodyB.getVelocityAtPoint($96038ffecb9a9a01$var$vj, this.contactPointB);
    $2Ys9z.subtract($96038ffecb9a9a01$var$relVel, $96038ffecb9a9a01$var$vi, $96038ffecb9a9a01$var$vj);
    return $2Ys9z.dot(this.normalA, $96038ffecb9a9a01$var$relVel);
};

});

parcelRegister("8P1Fq", function(module, exports) {

var $cSwh0 = parcelRequire("cSwh0");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $66c4613b00481d00$var$ContactEquationPool;
/**
 * @class
 */ function $66c4613b00481d00$var$ContactEquationPool() {
    $kaNFS.apply(this, arguments);
}
$66c4613b00481d00$var$ContactEquationPool.prototype = new $kaNFS();
$66c4613b00481d00$var$ContactEquationPool.prototype.constructor = $66c4613b00481d00$var$ContactEquationPool;
/**
 * @method create
 * @return {ContactEquation}
 */ $66c4613b00481d00$var$ContactEquationPool.prototype.create = function() {
    return new $cSwh0();
};
/**
 * @method destroy
 * @param {ContactEquation} equation
 * @return {ContactEquationPool}
 */ $66c4613b00481d00$var$ContactEquationPool.prototype.destroy = function(equation) {
    equation.bodyA = equation.bodyB = null;
    return this;
};

});
parcelRegister("kaNFS", function(module, exports) {
module.exports = $eafb461b641e6378$var$Pool;
/**
 * @class Object pooling utility.
 */ function $eafb461b641e6378$var$Pool(options) {
    options = options || {};
    /**
	 * @property {Array} objects
	 * @type {Array}
	 */ this.objects = [];
    if (options.size !== undefined) this.resize(options.size);
}
/**
 * @method resize
 * @param {number} size
 * @return {Pool} Self, for chaining
 */ $eafb461b641e6378$var$Pool.prototype.resize = function(size) {
    var objects = this.objects;
    while(objects.length > size)objects.pop();
    while(objects.length < size)objects.push(this.create());
    return this;
};
/**
 * Get an object from the pool or create a new instance.
 * @method get
 * @return {Object}
 */ $eafb461b641e6378$var$Pool.prototype.get = function() {
    var objects = this.objects;
    return objects.length ? objects.pop() : this.create();
};
/**
 * Clean up and put the object back into the pool for later use.
 * @method release
 * @param {Object} object
 * @return {Pool} Self for chaining
 */ $eafb461b641e6378$var$Pool.prototype.release = function(object) {
    this.destroy(object);
    this.objects.push(object);
    return this;
};

});


parcelRegister("hzM8V", function(module, exports) {

var $kfn8e = parcelRequire("kfn8e");

var $f0tQu = parcelRequire("f0tQu");
module.exports = $ccbb0cb7a4ce210f$var$ContactMaterial;
/**
 * Defines what happens when two materials meet, such as what friction coefficient to use. You can also set other things such as restitution, surface velocity and constraint parameters.
 * @class ContactMaterial
 * @constructor
 * @param {Material} materialA
 * @param {Material} materialB
 * @param {Object}   [options]
 * @param {Number}   [options.friction=0.3]       Friction coefficient.
 * @param {Number}   [options.restitution=0]      Restitution coefficient aka "bounciness".
 * @param {Number}   [options.stiffness]          ContactEquation stiffness.
 * @param {Number}   [options.relaxation]         ContactEquation relaxation.
 * @param {Number}   [options.frictionStiffness]  FrictionEquation stiffness.
 * @param {Number}   [options.frictionRelaxation] FrictionEquation relaxation.
 * @param {Number}   [options.surfaceVelocity=0]  Surface velocity.
 * @author schteppe
 */ function $ccbb0cb7a4ce210f$var$ContactMaterial(materialA, materialB, options) {
    options = options || {};
    if (!(materialA instanceof $kfn8e) || !(materialB instanceof $kfn8e)) throw new Error("First two arguments must be Material instances.");
    /**
     * The contact material identifier
     * @property id
     * @type {Number}
     */ this.id = $ccbb0cb7a4ce210f$var$ContactMaterial.idCounter++;
    /**
     * First material participating in the contact material
     * @property materialA
     * @type {Material}
     */ this.materialA = materialA;
    /**
     * Second material participating in the contact material
     * @property materialB
     * @type {Material}
     */ this.materialB = materialB;
    /**
     * Friction coefficient to use in the contact of these two materials. Friction = 0 will make the involved objects super slippery, and friction = 1 will make it much less slippery. A friction coefficient larger than 1 will allow for very large friction forces, which can be convenient for preventing car tires not slip on the ground.
     * @property friction
     * @type {Number}
     * @default 0.3
     */ this.friction = typeof options.friction !== "undefined" ? Number(options.friction) : 0.3;
    /**
     * Restitution, or "bounciness" to use in the contact of these two materials. A restitution of 0 will make no bounce, while restitution=1 will approximately bounce back with the same velocity the object came with.
     * @property restitution
     * @type {Number}
     * @default 0
     */ this.restitution = typeof options.restitution !== "undefined" ? Number(options.restitution) : 0;
    /**
     * Hardness of the contact. Less stiffness will make the objects penetrate more, and will make the contact act more like a spring than a contact force. Default value is {{#crossLink "Equation/DEFAULT_STIFFNESS:property"}}Equation.DEFAULT_STIFFNESS{{/crossLink}}.
     * @property stiffness
     * @type {Number}
     */ this.stiffness = typeof options.stiffness !== "undefined" ? Number(options.stiffness) : $f0tQu.DEFAULT_STIFFNESS;
    /**
     * Relaxation of the resulting ContactEquation that this ContactMaterial generate. Default value is {{#crossLink "Equation/DEFAULT_RELAXATION:property"}}Equation.DEFAULT_RELAXATION{{/crossLink}}.
     * @property relaxation
     * @type {Number}
     */ this.relaxation = typeof options.relaxation !== "undefined" ? Number(options.relaxation) : $f0tQu.DEFAULT_RELAXATION;
    /**
     * Stiffness of the resulting friction force. For most cases, the value of this property should be a large number. I cannot think of any case where you would want less frictionStiffness. Default value is {{#crossLink "Equation/DEFAULT_STIFFNESS:property"}}Equation.DEFAULT_STIFFNESS{{/crossLink}}.
     * @property frictionStiffness
     * @type {Number}
     */ this.frictionStiffness = typeof options.frictionStiffness !== "undefined" ? Number(options.frictionStiffness) : $f0tQu.DEFAULT_STIFFNESS;
    /**
     * Relaxation of the resulting friction force. The default value should be good for most simulations. Default value is {{#crossLink "Equation/DEFAULT_RELAXATION:property"}}Equation.DEFAULT_RELAXATION{{/crossLink}}.
     * @property frictionRelaxation
     * @type {Number}
     */ this.frictionRelaxation = typeof options.frictionRelaxation !== "undefined" ? Number(options.frictionRelaxation) : $f0tQu.DEFAULT_RELAXATION;
    /**
     * Will add surface velocity to this material. If bodyA rests on top if bodyB, and the surface velocity is positive, bodyA will slide to the right.
     * @property {Number} surfaceVelocity
     * @default 0
     */ this.surfaceVelocity = typeof options.surfaceVelocity !== "undefined" ? Number(options.surfaceVelocity) : 0;
    /**
     * Offset to be set on ContactEquations. A positive value will make the bodies penetrate more into each other. Can be useful in scenes where contacts need to be more persistent, for example when stacking. Aka "cure for nervous contacts".
     * @property contactSkinSize
     * @type {Number}
     */ this.contactSkinSize = 0.005;
}
$ccbb0cb7a4ce210f$var$ContactMaterial.idCounter = 0;

});
parcelRegister("kfn8e", function(module, exports) {
module.exports = $ebd726d555576f25$var$Material;
/**
 * Defines a physics material.
 * @class Material
 * @constructor
 * @param {number} id Material identifier
 * @author schteppe
 */ function $ebd726d555576f25$var$Material(id) {
    /**
     * The material identifier
     * @property id
     * @type {Number}
     */ this.id = id || $ebd726d555576f25$var$Material.idCounter++;
}
$ebd726d555576f25$var$Material.idCounter = 0;

});


parcelRegister("2pi2h", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
module.exports = $1c0be813d760ad79$var$DistanceConstraint;
/**
 * Constraint that tries to keep the distance between two bodies constant.
 *
 * @class DistanceConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {number} [options.distance] The distance to keep between the anchor points. Defaults to the current distance between the bodies.
 * @param {Array} [options.localAnchorA] The anchor point for bodyA, defined locally in bodyA frame. Defaults to [0,0].
 * @param {Array} [options.localAnchorB] The anchor point for bodyB, defined locally in bodyB frame. Defaults to [0,0].
 * @param {object} [options.maxForce=Number.MAX_VALUE] Maximum force to apply.
 * @extends Constraint
 *
 * @example
 *     // If distance is not given as an option, then the current distance between the bodies is used.
 *     // In this example, the bodies will be constrained to have a distance of 2 between their centers.
 *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
 *     var bodyB = new Body({ mass: 1, position: [1, 0] });
 *     var constraint = new DistanceConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 *
 * @example
 *     // Manually set the distance and anchors
 *     var constraint = new DistanceConstraint(bodyA, bodyB, {
 *         distance: 1,          // Distance to keep between the points
 *         localAnchorA: [1, 0], // Point on bodyA
 *         localAnchorB: [-1, 0] // Point on bodyB
 *     });
 *     world.addConstraint(constraint);
 */ function $1c0be813d760ad79$var$DistanceConstraint(bodyA, bodyB, options) {
    options = $dMz05.defaults(options, {
        localAnchorA: [
            0,
            0
        ],
        localAnchorB: [
            0,
            0
        ]
    });
    $3iby4.call(this, bodyA, bodyB, $3iby4.DISTANCE, options);
    /**
     * Local anchor in body A.
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = $2Ys9z.fromValues(options.localAnchorA[0], options.localAnchorA[1]);
    /**
     * Local anchor in body B.
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = $2Ys9z.fromValues(options.localAnchorB[0], options.localAnchorB[1]);
    var localAnchorA = this.localAnchorA;
    var localAnchorB = this.localAnchorB;
    /**
     * The distance to keep.
     * @property distance
     * @type {Number}
     */ this.distance = 0;
    if (typeof options.distance === 'number') this.distance = options.distance;
    else {
        // Use the current world distance between the world anchor points.
        var worldAnchorA = $2Ys9z.create(), worldAnchorB = $2Ys9z.create(), r = $2Ys9z.create();
        // Transform local anchors to world
        $2Ys9z.rotate(worldAnchorA, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(worldAnchorB, localAnchorB, bodyB.angle);
        $2Ys9z.add(r, bodyB.position, worldAnchorB);
        $2Ys9z.sub(r, r, worldAnchorA);
        $2Ys9z.sub(r, r, bodyA.position);
        this.distance = $2Ys9z.length(r);
    }
    var maxForce;
    if (typeof options.maxForce === "undefined") maxForce = Number.MAX_VALUE;
    else maxForce = options.maxForce;
    var normal = new $f0tQu(bodyA, bodyB, -maxForce, maxForce); // Just in the normal direction
    this.equations = [
        normal
    ];
    /**
     * Max force to apply.
     * @property {number} maxForce
     */ this.maxForce = maxForce;
    // g = (xi - xj).dot(n)
    // dg/dt = (vi - vj).dot(n) = G*W = [n 0 -n 0] * [vi wi vj wj]'
    // ...and if we were to include offset points:
    // g =
    //      (xj + rj - xi - ri).dot(n) - distance
    //
    // dg/dt =
    //      (vj + wj x rj - vi - wi x ri).dot(n) =
    //      { term 2 is near zero } =
    //      [-n   -ri x n   n   rj x n] * [vi wi vj wj]' =
    //      G * W
    //
    // => G = [-n -rixn n rjxn]
    var r = $2Ys9z.create();
    var ri = $2Ys9z.create(); // worldAnchorA
    var rj = $2Ys9z.create(); // worldAnchorB
    var that = this;
    normal.computeGq = function() {
        var bodyA = this.bodyA, bodyB = this.bodyB, xi = bodyA.position, xj = bodyB.position;
        // Transform local anchors to world
        $2Ys9z.rotate(ri, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(rj, localAnchorB, bodyB.angle);
        $2Ys9z.add(r, xj, rj);
        $2Ys9z.sub(r, r, ri);
        $2Ys9z.sub(r, r, xi);
        //vec2.sub(r, bodyB.position, bodyA.position);
        return $2Ys9z.length(r) - that.distance;
    };
    // Make the contact constraint bilateral
    this.setMaxForce(maxForce);
    /**
     * If the upper limit is enabled or not.
     * @property {Boolean} upperLimitEnabled
     */ this.upperLimitEnabled = false;
    /**
     * The upper constraint limit.
     * @property {number} upperLimit
     */ this.upperLimit = 1;
    /**
     * If the lower limit is enabled or not.
     * @property {Boolean} lowerLimitEnabled
     */ this.lowerLimitEnabled = false;
    /**
     * The lower constraint limit.
     * @property {number} lowerLimit
     */ this.lowerLimit = 0;
    /**
     * Current constraint position. This is equal to the current distance between the world anchor points.
     * @property {number} position
     */ this.position = 0;
}
$1c0be813d760ad79$var$DistanceConstraint.prototype = new $3iby4();
$1c0be813d760ad79$var$DistanceConstraint.prototype.constructor = $1c0be813d760ad79$var$DistanceConstraint;
/**
 * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
 * @method update
 */ var $1c0be813d760ad79$var$n = $2Ys9z.create();
var $1c0be813d760ad79$var$ri = $2Ys9z.create(); // worldAnchorA
var $1c0be813d760ad79$var$rj = $2Ys9z.create(); // worldAnchorB
$1c0be813d760ad79$var$DistanceConstraint.prototype.update = function() {
    var normal = this.equations[0], bodyA = this.bodyA, bodyB = this.bodyB, distance = this.distance, xi = bodyA.position, xj = bodyB.position, normalEquation = this.equations[0], G = normal.G;
    // Transform local anchors to world
    $2Ys9z.rotate($1c0be813d760ad79$var$ri, this.localAnchorA, bodyA.angle);
    $2Ys9z.rotate($1c0be813d760ad79$var$rj, this.localAnchorB, bodyB.angle);
    // Get world anchor points and normal
    $2Ys9z.add($1c0be813d760ad79$var$n, xj, $1c0be813d760ad79$var$rj);
    $2Ys9z.sub($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n, $1c0be813d760ad79$var$ri);
    $2Ys9z.sub($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n, xi);
    this.position = $2Ys9z.length($1c0be813d760ad79$var$n);
    var violating = false;
    if (this.upperLimitEnabled) {
        if (this.position > this.upperLimit) {
            normalEquation.maxForce = 0;
            normalEquation.minForce = -this.maxForce;
            this.distance = this.upperLimit;
            violating = true;
        }
    }
    if (this.lowerLimitEnabled) {
        if (this.position < this.lowerLimit) {
            normalEquation.maxForce = this.maxForce;
            normalEquation.minForce = 0;
            this.distance = this.lowerLimit;
            violating = true;
        }
    }
    if ((this.lowerLimitEnabled || this.upperLimitEnabled) && !violating) {
        // No constraint needed.
        normalEquation.enabled = false;
        return;
    }
    normalEquation.enabled = true;
    $2Ys9z.normalize($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n);
    // Caluclate cross products
    var rixn = $2Ys9z.crossLength($1c0be813d760ad79$var$ri, $1c0be813d760ad79$var$n), rjxn = $2Ys9z.crossLength($1c0be813d760ad79$var$rj, $1c0be813d760ad79$var$n);
    // G = [-n -rixn n rjxn]
    G[0] = -$1c0be813d760ad79$var$n[0];
    G[1] = -$1c0be813d760ad79$var$n[1];
    G[2] = -rixn;
    G[3] = $1c0be813d760ad79$var$n[0];
    G[4] = $1c0be813d760ad79$var$n[1];
    G[5] = rjxn;
};
/**
 * Set the max force to be used
 * @method setMaxForce
 * @param {Number} maxForce
 */ $1c0be813d760ad79$var$DistanceConstraint.prototype.setMaxForce = function(maxForce) {
    var normal = this.equations[0];
    normal.minForce = -maxForce;
    normal.maxForce = maxForce;
};
/**
 * Get the max force
 * @method getMaxForce
 * @return {Number}
 */ $1c0be813d760ad79$var$DistanceConstraint.prototype.getMaxForce = function() {
    var normal = this.equations[0];
    return normal.maxForce;
};

});

parcelRegister("jNxse", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("dMz05");
module.exports = $e69c8b3dfcdeabae$var$FrictionEquation;
/**
 * Constrains the slipping in a contact along a tangent
 *
 * @class FrictionEquation
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} slipForce
 * @extends Equation
 */ function $e69c8b3dfcdeabae$var$FrictionEquation(bodyA, bodyB, slipForce) {
    $f0tQu.call(this, bodyA, bodyB, -slipForce, slipForce);
    /**
     * Relative vector from center of body A to the contact point, world oriented.
     * @property contactPointA
     * @type {Array}
     */ this.contactPointA = $2Ys9z.create();
    /**
     * Relative vector from center of body B to the contact point, world oriented.
     * @property contactPointB
     * @type {Array}
     */ this.contactPointB = $2Ys9z.create();
    /**
     * Tangent vector that the friction force will act along. World oriented.
     * @property t
     * @type {Array}
     */ this.t = $2Ys9z.create();
    /**
     * ContactEquations connected to this friction equation. The contact equations can be used to rescale the max force for the friction. If more than one contact equation is given, then the max force can be set to the average.
     * @property contactEquations
     * @type {ContactEquation}
     */ this.contactEquations = [];
    /**
     * The shape in body i that triggered this friction.
     * @property shapeA
     * @type {Shape}
     * @todo Needed? The shape can be looked up via contactEquation.shapeA...
     */ this.shapeA = null;
    /**
     * The shape in body j that triggered this friction.
     * @property shapeB
     * @type {Shape}
     * @todo Needed? The shape can be looked up via contactEquation.shapeB...
     */ this.shapeB = null;
    /**
     * The friction coefficient to use.
     * @property frictionCoefficient
     * @type {Number}
     */ this.frictionCoefficient = 0.3;
}
$e69c8b3dfcdeabae$var$FrictionEquation.prototype = new $f0tQu();
$e69c8b3dfcdeabae$var$FrictionEquation.prototype.constructor = $e69c8b3dfcdeabae$var$FrictionEquation;
/**
 * Set the slipping condition for the constraint. The friction force cannot be
 * larger than this value.
 * @method setSlipForce
 * @param  {Number} slipForce
 */ $e69c8b3dfcdeabae$var$FrictionEquation.prototype.setSlipForce = function(slipForce) {
    this.maxForce = slipForce;
    this.minForce = -slipForce;
};
/**
 * Get the max force for the constraint.
 * @method getSlipForce
 * @return {Number}
 */ $e69c8b3dfcdeabae$var$FrictionEquation.prototype.getSlipForce = function() {
    return this.maxForce;
};
$e69c8b3dfcdeabae$var$FrictionEquation.prototype.computeB = function(a, b, h) {
    var bi = this.bodyA, bj = this.bodyB, ri = this.contactPointA, rj = this.contactPointB, t = this.t, G = this.G;
    // G = [-t -rixt t rjxt]
    // And remember, this is a pure velocity constraint, g is always zero!
    G[0] = -t[0];
    G[1] = -t[1];
    G[2] = -$2Ys9z.crossLength(ri, t);
    G[3] = t[0];
    G[4] = t[1];
    G[5] = $2Ys9z.crossLength(rj, t);
    var GW = this.computeGW(), GiMf = this.computeGiMf();
    var B = /* - g * a  */ -GW * b - h * GiMf;
    return B;
};

});

parcelRegister("gwWMZ", function(module, exports) {

var $jNxse = parcelRequire("jNxse");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $c08d3cd3ab799811$var$FrictionEquationPool;
/**
 * @class
 */ function $c08d3cd3ab799811$var$FrictionEquationPool() {
    $kaNFS.apply(this, arguments);
}
$c08d3cd3ab799811$var$FrictionEquationPool.prototype = new $kaNFS();
$c08d3cd3ab799811$var$FrictionEquationPool.prototype.constructor = $c08d3cd3ab799811$var$FrictionEquationPool;
/**
 * @method create
 * @return {FrictionEquation}
 */ $c08d3cd3ab799811$var$FrictionEquationPool.prototype.create = function() {
    return new $jNxse();
};
/**
 * @method destroy
 * @param {FrictionEquation} equation
 * @return {FrictionEquationPool}
 */ $c08d3cd3ab799811$var$FrictionEquationPool.prototype.destroy = function(equation) {
    equation.bodyA = equation.bodyB = null;
    return this;
};

});

parcelRegister("bb1X1", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");
parcelRequire("f0tQu");

var $5PEF1 = parcelRequire("5PEF1");
parcelRequire("2Ys9z");
module.exports = $82323c3c86809ad8$var$GearConstraint;
/**
 * Constrains the angle of two bodies to each other to be equal. If a gear ratio is not one, the angle of bodyA must be a multiple of the angle of bodyB.
 * @class GearConstraint
 * @constructor
 * @author schteppe
 * @param {Body}            bodyA
 * @param {Body}            bodyB
 * @param {Object}          [options]
 * @param {Number}          [options.angle=0] Relative angle between the bodies. Will be set to the current angle between the bodies (the gear ratio is accounted for).
 * @param {Number}          [options.ratio=1] Gear ratio.
 * @param {Number}          [options.maxTorque] Maximum torque to apply.
 * @extends Constraint
 *
 * @example
 *     var constraint = new GearConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 *
 * @example
 *     var constraint = new GearConstraint(bodyA, bodyB, {
 *         ratio: 2,
 *         maxTorque: 1000
 *     });
 *     world.addConstraint(constraint);
 */ function $82323c3c86809ad8$var$GearConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.GEAR, options);
    /**
     * The gear ratio.
     * @property ratio
     * @type {Number}
     */ this.ratio = options.ratio !== undefined ? options.ratio : 1;
    /**
     * The relative angle
     * @property angle
     * @type {Number}
     */ this.angle = options.angle !== undefined ? options.angle : bodyB.angle - this.ratio * bodyA.angle;
    // Send same parameters to the equation
    options.angle = this.angle;
    options.ratio = this.ratio;
    this.equations = [
        new $5PEF1(bodyA, bodyB, options)
    ];
    // Set max torque
    if (options.maxTorque !== undefined) this.setMaxTorque(options.maxTorque);
}
$82323c3c86809ad8$var$GearConstraint.prototype = new $3iby4();
$82323c3c86809ad8$var$GearConstraint.prototype.constructor = $82323c3c86809ad8$var$GearConstraint;
$82323c3c86809ad8$var$GearConstraint.prototype.update = function() {
    var eq = this.equations[0];
    if (eq.ratio !== this.ratio) eq.setRatio(this.ratio);
    eq.angle = this.angle;
};
/**
 * Set the max torque for the constraint.
 * @method setMaxTorque
 * @param {Number} torque
 */ $82323c3c86809ad8$var$GearConstraint.prototype.setMaxTorque = function(torque) {
    this.equations[0].setMaxTorque(torque);
};
/**
 * Get the max torque for the constraint.
 * @method getMaxTorque
 * @return {Number}
 */ $82323c3c86809ad8$var$GearConstraint.prototype.getMaxTorque = function(torque) {
    return this.equations[0].maxForce;
};

});

parcelRegister("hejTV", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $aZxNS = parcelRequire("aZxNS");

var $dMz05 = parcelRequire("dMz05");

var $jNxse = parcelRequire("jNxse");
module.exports = $c8b32e6144340a1d$var$GSSolver;
/**
 * Iterative Gauss-Seidel constraint equation solver.
 *
 * @class GSSolver
 * @constructor
 * @extends Solver
 * @param {Object} [options]
 * @param {Number} [options.iterations=10]
 * @param {Number} [options.tolerance=0]
 */ function $c8b32e6144340a1d$var$GSSolver(options) {
    $aZxNS.call(this, options, $aZxNS.GS);
    options = options || {};
    /**
     * The max number of iterations to do when solving. More gives better results, but is more expensive.
     * @property iterations
     * @type {Number}
     */ this.iterations = options.iterations || 10;
    /**
     * The error tolerance, per constraint. If the total error is below this limit, the solver will stop iterating. Set to zero for as good solution as possible, but to something larger than zero to make computations faster.
     * @property tolerance
     * @type {Number}
     * @default 1e-7
     */ this.tolerance = options.tolerance || 1e-7;
    this.arrayStep = 30;
    this.lambda = new $dMz05.ARRAY_TYPE(this.arrayStep);
    this.Bs = new $dMz05.ARRAY_TYPE(this.arrayStep);
    this.invCs = new $dMz05.ARRAY_TYPE(this.arrayStep);
    /**
     * Set to true to set all right hand side terms to zero when solving. Can be handy for a few applications.
     * @property useZeroRHS
     * @type {Boolean}
     * @todo Remove, not used
     */ this.useZeroRHS = false;
    /**
     * Number of solver iterations that are used to approximate normal forces used for friction (F_friction = mu * F_normal). These friction forces will override any other friction forces that are set. If you set frictionIterations = 0, then this feature will be disabled.
     *
     * Use only frictionIterations > 0 if the approximated normal force (F_normal = mass * gravity) is not good enough. Examples of where it can happen is in space games where gravity is zero, or in tall stacks where the normal force is large at bottom but small at top.
     *
     * @property frictionIterations
     * @type {Number}
     * @default 0
     */ this.frictionIterations = options.frictionIterations !== undefined ? 0 : options.frictionIterations;
    /**
     * The number of iterations that were made during the last solve. If .tolerance is zero, this value will always be equal to .iterations, but if .tolerance is larger than zero, and the solver can quit early, then this number will be somewhere between 1 and .iterations.
     * @property {Number} usedIterations
     */ this.usedIterations = 0;
}
$c8b32e6144340a1d$var$GSSolver.prototype = new $aZxNS();
$c8b32e6144340a1d$var$GSSolver.prototype.constructor = $c8b32e6144340a1d$var$GSSolver;
function $c8b32e6144340a1d$var$setArrayZero(array) {
    var l = array.length;
    while(l--)array[l] = 0;
}
/**
 * Solve the system of equations
 * @method solve
 * @param  {Number}  h       Time step
 * @param  {World}   world    World to solve
 */ $c8b32e6144340a1d$var$GSSolver.prototype.solve = function(h, world) {
    this.sortEquations();
    var iter = 0, maxIter = this.iterations, maxFrictionIter = this.frictionIterations, equations = this.equations, Neq = equations.length, tolSquared = Math.pow(this.tolerance * Neq, 2), bodies = world.bodies, Nbodies = world.bodies.length, add = $2Ys9z.add, set = $2Ys9z.set, useZeroRHS = this.useZeroRHS, lambda = this.lambda;
    this.usedIterations = 0;
    if (Neq) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i];
        // Update solve mass
        b.updateSolveMassProperties();
    }
    // Things that does not change during iteration can be computed once
    if (lambda.length < Neq) {
        lambda = this.lambda = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
        this.Bs = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
        this.invCs = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
    }
    $c8b32e6144340a1d$var$setArrayZero(lambda);
    var invCs = this.invCs, Bs = this.Bs, lambda = this.lambda;
    for(var i = 0; i !== equations.length; i++){
        var c = equations[i];
        if (c.timeStep !== h || c.needsUpdate) {
            c.timeStep = h;
            c.update();
        }
        Bs[i] = c.computeB(c.a, c.b, h);
        invCs[i] = c.computeInvC(c.epsilon);
    }
    var q, B, c, deltalambdaTot, i, j;
    if (Neq !== 0) {
        for(i = 0; i !== Nbodies; i++){
            var b = bodies[i];
            // Reset vlambda
            b.resetConstraintVelocity();
        }
        if (maxFrictionIter) {
            // Iterate over contact equations to get normal forces
            for(iter = 0; iter !== maxFrictionIter; iter++){
                // Accumulate the total error for each iteration.
                deltalambdaTot = 0.0;
                for(j = 0; j !== Neq; j++){
                    c = equations[j];
                    var deltalambda = $c8b32e6144340a1d$var$GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
                    deltalambdaTot += Math.abs(deltalambda);
                }
                this.usedIterations++;
                // If the total error is small enough - stop iterate
                if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
            }
            $c8b32e6144340a1d$var$GSSolver.updateMultipliers(equations, lambda, 1 / h);
            // Set computed friction force
            for(j = 0; j !== Neq; j++){
                var eq = equations[j];
                if (eq instanceof $jNxse) {
                    var f = 0.0;
                    for(var k = 0; k !== eq.contactEquations.length; k++)f += eq.contactEquations[k].multiplier;
                    f *= eq.frictionCoefficient / eq.contactEquations.length;
                    eq.maxForce = f;
                    eq.minForce = -f;
                }
            }
        }
        // Iterate over all equations
        for(iter = 0; iter !== maxIter; iter++){
            // Accumulate the total error for each iteration.
            deltalambdaTot = 0.0;
            for(j = 0; j !== Neq; j++){
                c = equations[j];
                var deltalambda = $c8b32e6144340a1d$var$GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
                deltalambdaTot += Math.abs(deltalambda);
            }
            this.usedIterations++;
            // If the total error is small enough - stop iterate
            if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
        }
        // Add result to velocity
        for(i = 0; i !== Nbodies; i++)bodies[i].addConstraintVelocity();
        $c8b32e6144340a1d$var$GSSolver.updateMultipliers(equations, lambda, 1 / h);
    }
};
// Sets the .multiplier property of each equation
$c8b32e6144340a1d$var$GSSolver.updateMultipliers = function(equations, lambda, invDt) {
    // Set the .multiplier property of each equation
    var l = equations.length;
    while(l--)equations[l].multiplier = lambda[l] * invDt;
};
$c8b32e6144340a1d$var$GSSolver.iterateEquation = function(j, eq, eps, Bs, invCs, lambda, useZeroRHS, dt, iter) {
    // Compute iteration
    var B = Bs[j], invC = invCs[j], lambdaj = lambda[j], GWlambda = eq.computeGWlambda();
    var maxForce = eq.maxForce, minForce = eq.minForce;
    if (useZeroRHS) B = 0;
    var deltalambda = invC * (B - GWlambda - eps * lambdaj);
    // Clamp if we are not within the min/max interval
    var lambdaj_plus_deltalambda = lambdaj + deltalambda;
    if (lambdaj_plus_deltalambda < minForce * dt) deltalambda = minForce * dt - lambdaj;
    else if (lambdaj_plus_deltalambda > maxForce * dt) deltalambda = maxForce * dt - lambdaj;
    lambda[j] += deltalambda;
    eq.addToWlambda(deltalambda);
    return deltalambda;
};

});
parcelRegister("aZxNS", function(module, exports) {
parcelRequire("dMz05");

var $5POlg = parcelRequire("5POlg");
module.exports = $8009d28ee8bf1079$var$Solver;
/**
 * Base class for constraint solvers.
 * @class Solver
 * @constructor
 * @extends EventEmitter
 */ function $8009d28ee8bf1079$var$Solver(options, type) {
    options = options || {};
    $5POlg.call(this);
    this.type = type;
    /**
     * Current equations in the solver.
     *
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * Function that is used to sort all equations before each solve.
     * @property equationSortFunction
     * @type {function|boolean}
     */ this.equationSortFunction = options.equationSortFunction || false;
}
$8009d28ee8bf1079$var$Solver.prototype = new $5POlg();
$8009d28ee8bf1079$var$Solver.prototype.constructor = $8009d28ee8bf1079$var$Solver;
/**
 * Method to be implemented in each subclass
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */ $8009d28ee8bf1079$var$Solver.prototype.solve = function(dt, world) {
    throw new Error("Solver.solve should be implemented by subclasses!");
};
var $8009d28ee8bf1079$var$mockWorld = {
    bodies: []
};
/**
 * Solves all constraints in an island.
 * @method solveIsland
 * @param  {Number} dt
 * @param  {Island} island
 */ $8009d28ee8bf1079$var$Solver.prototype.solveIsland = function(dt, island) {
    this.removeAllEquations();
    if (island.equations.length) {
        // Add equations to solver
        this.addEquations(island.equations);
        $8009d28ee8bf1079$var$mockWorld.bodies.length = 0;
        island.getBodies($8009d28ee8bf1079$var$mockWorld.bodies);
        // Solve
        if ($8009d28ee8bf1079$var$mockWorld.bodies.length) this.solve(dt, $8009d28ee8bf1079$var$mockWorld);
    }
};
/**
 * Sort all equations using the .equationSortFunction. Should be called by subclasses before solving.
 * @method sortEquations
 */ $8009d28ee8bf1079$var$Solver.prototype.sortEquations = function() {
    if (this.equationSortFunction) this.equations.sort(this.equationSortFunction);
};
/**
 * Add an equation to be solved.
 *
 * @method addEquation
 * @param {Equation} eq
 */ $8009d28ee8bf1079$var$Solver.prototype.addEquation = function(eq) {
    if (eq.enabled) this.equations.push(eq);
};
/**
 * Add equations. Same as .addEquation, but this time the argument is an array of Equations
 *
 * @method addEquations
 * @param {Array} eqs
 */ $8009d28ee8bf1079$var$Solver.prototype.addEquations = function(eqs) {
    //Utils.appendArray(this.equations,eqs);
    for(var i = 0, N = eqs.length; i !== N; i++){
        var eq = eqs[i];
        if (eq.enabled) this.equations.push(eq);
    }
};
/**
 * Remove an equation.
 *
 * @method removeEquation
 * @param {Equation} eq
 */ $8009d28ee8bf1079$var$Solver.prototype.removeEquation = function(eq) {
    var i = this.equations.indexOf(eq);
    if (i !== -1) this.equations.splice(i, 1);
};
/**
 * Remove all currently added equations.
 *
 * @method removeAllEquations
 */ $8009d28ee8bf1079$var$Solver.prototype.removeAllEquations = function() {
    this.equations.length = 0;
};
$8009d28ee8bf1079$var$Solver.GS = 1;
$8009d28ee8bf1079$var$Solver.ISLAND = 2;

});


parcelRegister("6Xtot", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $510f0dbbb907ec6c$var$Heightfield;
/**
 * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a distance "elementWidth".
 * @class Heightfield
 * @extends Shape
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {array} [options.heights] An array of Y values that will be used to construct the terrain.
 * @param {Number} [options.minValue] Minimum value of the data points in the data array. Will be computed automatically if not given.
 * @param {Number} [options.maxValue] Maximum value.
 * @param {Number} [options.elementWidth=0.1] World spacing between the data points in X direction.
 *
 * @example
 *     // Generate some height data (y-values).
 *     var heights = [];
 *     for(var i = 0; i < 1000; i++){
 *         var y = 0.5 * Math.cos(0.2 * i);
 *         heights.push(y);
 *     }
 *
 *     // Create the heightfield shape
 *     var heightfieldShape = new Heightfield({
 *         heights: heights,
 *         elementWidth: 1 // Distance between the data points in X direction
 *     });
 *     var heightfieldBody = new Body();
 *     heightfieldBody.addShape(heightfieldShape);
 *     world.addBody(heightfieldBody);
 *
 * @todo Should use a scale property with X and Y direction instead of just elementWidth
 */ function $510f0dbbb907ec6c$var$Heightfield(options) {
    if (Array.isArray(arguments[0])) {
        options = {
            heights: arguments[0]
        };
        if (typeof arguments[1] === 'object') for(var key in arguments[1])options[key] = arguments[1][key];
        console.warn('The Heightfield constructor signature has changed. Please use the following format: new Heightfield({ heights: [...], ... })');
    }
    options = options || {};
    /**
     * An array of numbers, or height values, that are spread out along the x axis.
     * @property {array} heights
     */ this.heights = options.heights ? options.heights.slice(0) : [];
    /**
     * Max value of the heights
     * @property {number} maxValue
     */ this.maxValue = options.maxValue || null;
    /**
     * Max value of the heights
     * @property {number} minValue
     */ this.minValue = options.minValue || null;
    /**
     * The width of each element
     * @property {number} elementWidth
     */ this.elementWidth = options.elementWidth || 0.1;
    if (options.maxValue === undefined || options.minValue === undefined) this.updateMaxMinValues();
    options.type = $k7z01.HEIGHTFIELD;
    $k7z01.call(this, options);
}
$510f0dbbb907ec6c$var$Heightfield.prototype = new $k7z01();
$510f0dbbb907ec6c$var$Heightfield.prototype.constructor = $510f0dbbb907ec6c$var$Heightfield;
/**
 * Update the .minValue and the .maxValue
 * @method updateMaxMinValues
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.updateMaxMinValues = function() {
    var data = this.heights;
    var maxValue = data[0];
    var minValue = data[0];
    for(var i = 0; i !== data.length; i++){
        var v = data[i];
        if (v > maxValue) maxValue = v;
        if (v < minValue) minValue = v;
    }
    this.maxValue = maxValue;
    this.minValue = minValue;
};
/**
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.computeMomentOfInertia = function(mass) {
    return Number.MAX_VALUE;
};
$510f0dbbb907ec6c$var$Heightfield.prototype.updateBoundingRadius = function() {
    this.boundingRadius = Number.MAX_VALUE;
};
$510f0dbbb907ec6c$var$Heightfield.prototype.updateArea = function() {
    var data = this.heights, area = 0;
    for(var i = 0; i < data.length - 1; i++)area += (data[i] + data[i + 1]) / 2 * this.elementWidth;
    this.area = area;
};
var $510f0dbbb907ec6c$var$points = [
    $2Ys9z.create(),
    $2Ys9z.create(),
    $2Ys9z.create(),
    $2Ys9z.create()
];
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.computeAABB = function(out, position, angle) {
    $2Ys9z.set($510f0dbbb907ec6c$var$points[0], 0, this.maxValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[1], this.elementWidth * this.heights.length, this.maxValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[2], this.elementWidth * this.heights.length, this.minValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[3], 0, this.minValue);
    out.setFromPoints($510f0dbbb907ec6c$var$points, position, angle);
};
/**
 * Get a line segment in the heightfield
 * @method getLineSegment
 * @param  {array} start Where to store the resulting start point
 * @param  {array} end Where to store the resulting end point
 * @param  {number} i
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.getLineSegment = function(start, end, i) {
    var data = this.heights;
    var width = this.elementWidth;
    $2Ys9z.set(start, i * width, data[i]);
    $2Ys9z.set(end, (i + 1) * width, data[i + 1]);
};
$510f0dbbb907ec6c$var$Heightfield.prototype.getSegmentIndex = function(position) {
    return Math.floor(position[0] / this.elementWidth);
};
$510f0dbbb907ec6c$var$Heightfield.prototype.getClampedSegmentIndex = function(position) {
    var i = this.getSegmentIndex(position);
    i = Math.min(this.heights.length, Math.max(i, 0)); // clamp
    return i;
};
var $510f0dbbb907ec6c$var$intersectHeightfield_hitPointWorld = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_worldNormal = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_l0 = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_l1 = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_localFrom = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_localTo = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_unit_y = $2Ys9z.fromValues(0, 1);
// Returns 1 if the lines intersect, otherwise 0.
function $510f0dbbb907ec6c$var$getLineSegmentsIntersection(out, p0, p1, p2, p3) {
    var s1_x, s1_y, s2_x, s2_y;
    s1_x = p1[0] - p0[0];
    s1_y = p1[1] - p0[1];
    s2_x = p3[0] - p2[0];
    s2_y = p3[1] - p2[1];
    var s, t;
    s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
    t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
        var intX = p0[0] + t * s1_x;
        var intY = p0[1] + t * s1_y;
        out[0] = intX;
        out[1] = intY;
        return t;
    }
    return -1; // No collision
}
/**
 * @method raycast
 * @param  {RayResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var hitPointWorld = $510f0dbbb907ec6c$var$intersectHeightfield_hitPointWorld;
    var worldNormal = $510f0dbbb907ec6c$var$intersectHeightfield_worldNormal;
    var l0 = $510f0dbbb907ec6c$var$intersectHeightfield_l0;
    var l1 = $510f0dbbb907ec6c$var$intersectHeightfield_l1;
    var localFrom = $510f0dbbb907ec6c$var$intersectHeightfield_localFrom;
    var localTo = $510f0dbbb907ec6c$var$intersectHeightfield_localTo;
    // get local ray start and end
    $2Ys9z.toLocalFrame(localFrom, from, position, angle);
    $2Ys9z.toLocalFrame(localTo, to, position, angle);
    // Get the segment range
    var i0 = this.getClampedSegmentIndex(localFrom);
    var i1 = this.getClampedSegmentIndex(localTo);
    if (i0 > i1) {
        var tmp = i0;
        i0 = i1;
        i1 = tmp;
    }
    // The segments
    for(var i = 0; i < this.heights.length - 1; i++){
        this.getLineSegment(l0, l1, i);
        var t = $2Ys9z.getLineSegmentsIntersectionFraction(localFrom, localTo, l0, l1);
        if (t >= 0) {
            $2Ys9z.sub(worldNormal, l1, l0);
            $2Ys9z.rotate(worldNormal, worldNormal, angle + Math.PI / 2);
            $2Ys9z.normalize(worldNormal, worldNormal);
            ray.reportIntersection(result, t, worldNormal, -1);
            if (result.shouldStop(ray)) return;
        }
    }
};

});

parcelRegister("d7wN7", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $98d55d71a3dcbc9d$var$Line;
/**
 * Line shape class. The line shape is along the x direction, and stretches from [-length/2, 0] to [length/2,0].
 * @class Line
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.length=1] The total length of the line
 * @extends Shape
 * @constructor
 */ function $98d55d71a3dcbc9d$var$Line(options) {
    if (typeof arguments[0] === 'number') {
        options = {
            length: arguments[0]
        };
        console.warn('The Line constructor signature has changed. Please use the following format: new Line({ length: 1, ... })');
    }
    options = options || {};
    /**
     * Length of this line
     * @property {Number} length
     * @default 1
     */ this.length = options.length || 1;
    options.type = $k7z01.LINE;
    $k7z01.call(this, options);
}
$98d55d71a3dcbc9d$var$Line.prototype = new $k7z01();
$98d55d71a3dcbc9d$var$Line.prototype.constructor = $98d55d71a3dcbc9d$var$Line;
$98d55d71a3dcbc9d$var$Line.prototype.computeMomentOfInertia = function(mass) {
    return mass * Math.pow(this.length, 2) / 12;
};
$98d55d71a3dcbc9d$var$Line.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.length / 2;
};
var $98d55d71a3dcbc9d$var$points = [
    $2Ys9z.create(),
    $2Ys9z.create()
];
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $98d55d71a3dcbc9d$var$Line.prototype.computeAABB = function(out, position, angle) {
    var l2 = this.length / 2;
    $2Ys9z.set($98d55d71a3dcbc9d$var$points[0], -l2, 0);
    $2Ys9z.set($98d55d71a3dcbc9d$var$points[1], l2, 0);
    out.setFromPoints($98d55d71a3dcbc9d$var$points, position, angle, 0);
};
var $98d55d71a3dcbc9d$var$raycast_hitPoint = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_normal = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_l0 = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_l1 = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_unit_y = $2Ys9z.fromValues(0, 1);
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {number} angle
 * @param  {array} position
 */ $98d55d71a3dcbc9d$var$Line.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var l0 = $98d55d71a3dcbc9d$var$raycast_l0;
    var l1 = $98d55d71a3dcbc9d$var$raycast_l1;
    // get start and end of the line
    var halfLen = this.length / 2;
    $2Ys9z.set(l0, -halfLen, 0);
    $2Ys9z.set(l1, halfLen, 0);
    $2Ys9z.toGlobalFrame(l0, l0, position, angle);
    $2Ys9z.toGlobalFrame(l1, l1, position, angle);
    var fraction = $2Ys9z.getLineSegmentsIntersectionFraction(l0, l1, from, to);
    if (fraction >= 0) {
        var normal = $98d55d71a3dcbc9d$var$raycast_normal;
        $2Ys9z.rotate(normal, $98d55d71a3dcbc9d$var$raycast_unit_y, angle); // todo: this should depend on which side the ray comes from
        ray.reportIntersection(result, fraction, normal, -1);
    }
};

});

parcelRegister("48dNO", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $2Ys9z = parcelRequire("2Ys9z");

var $f0tQu = parcelRequire("f0tQu");
module.exports = $30229da6f24f1f47$var$LockConstraint;
/**
 * Locks the relative position and rotation between two bodies.
 *
 * @class LockConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Array}  [options.localOffsetB] The offset of bodyB in bodyA's frame. If not given the offset is computed from current positions.
 * @param {number} [options.localAngleB] The angle of bodyB in bodyA's frame. If not given, the angle is computed from current angles.
 * @param {number} [options.maxForce]
 * @extends Constraint
 *
 * @example
 *     // Locks the relative position and rotation between bodyA and bodyB
 *     var constraint = new LockConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 */ function $30229da6f24f1f47$var$LockConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.LOCK, options);
    var maxForce = typeof options.maxForce === "undefined" ? Number.MAX_VALUE : options.maxForce;
    var localAngleB = options.localAngleB || 0;
    // Use 3 equations:
    // gx =   (xj - xi - l) * xhat = 0
    // gy =   (xj - xi - l) * yhat = 0
    // gr =   (xi - xj + r) * that = 0
    //
    // ...where:
    //   l is the localOffsetB vector rotated to world in bodyA frame
    //   r is the same vector but reversed and rotated from bodyB frame
    //   xhat, yhat are world axis vectors
    //   that is the tangent of r
    //
    // For the first two constraints, we get
    // G*W = (vj - vi - ldot  ) * xhat
    //     = (vj - vi - wi x l) * xhat
    //
    // Since (wi x l) * xhat = (l x xhat) * wi, we get
    // G*W = [ -1   0   (-l x xhat)  1   0   0] * [vi wi vj wj]
    //
    // The last constraint gives
    // GW = (vi - vj + wj x r) * that
    //    = [  that   0  -that  (r x t) ]
    var x = new $f0tQu(bodyA, bodyB, -maxForce, maxForce), y = new $f0tQu(bodyA, bodyB, -maxForce, maxForce), rot = new $f0tQu(bodyA, bodyB, -maxForce, maxForce);
    var l = $2Ys9z.create(), g = $2Ys9z.create(), that = this;
    x.computeGq = function() {
        $2Ys9z.rotate(l, that.localOffsetB, bodyA.angle);
        $2Ys9z.sub(g, bodyB.position, bodyA.position);
        $2Ys9z.sub(g, g, l);
        return g[0];
    };
    y.computeGq = function() {
        $2Ys9z.rotate(l, that.localOffsetB, bodyA.angle);
        $2Ys9z.sub(g, bodyB.position, bodyA.position);
        $2Ys9z.sub(g, g, l);
        return g[1];
    };
    var r = $2Ys9z.create(), t = $2Ys9z.create();
    rot.computeGq = function() {
        $2Ys9z.rotate(r, that.localOffsetB, bodyB.angle - that.localAngleB);
        $2Ys9z.scale(r, r, -1);
        $2Ys9z.sub(g, bodyA.position, bodyB.position);
        $2Ys9z.add(g, g, r);
        $2Ys9z.rotate(t, r, -Math.PI / 2);
        $2Ys9z.normalize(t, t);
        return $2Ys9z.dot(g, t);
    };
    /**
     * The offset of bodyB in bodyA's frame.
     * @property {Array} localOffsetB
     */ this.localOffsetB = $2Ys9z.create();
    if (options.localOffsetB) $2Ys9z.copy(this.localOffsetB, options.localOffsetB);
    else {
        // Construct from current positions
        $2Ys9z.sub(this.localOffsetB, bodyB.position, bodyA.position);
        $2Ys9z.rotate(this.localOffsetB, this.localOffsetB, -bodyA.angle);
    }
    /**
     * The offset angle of bodyB in bodyA's frame.
     * @property {Number} localAngleB
     */ this.localAngleB = 0;
    if (typeof options.localAngleB === 'number') this.localAngleB = options.localAngleB;
    else // Construct
    this.localAngleB = bodyB.angle - bodyA.angle;
    this.equations.push(x, y, rot);
    this.setMaxForce(maxForce);
}
$30229da6f24f1f47$var$LockConstraint.prototype = new $3iby4();
$30229da6f24f1f47$var$LockConstraint.prototype.constructor = $30229da6f24f1f47$var$LockConstraint;
/**
 * Set the maximum force to be applied.
 * @method setMaxForce
 * @param {Number} force
 */ $30229da6f24f1f47$var$LockConstraint.prototype.setMaxForce = function(force) {
    var eqs = this.equations;
    for(var i = 0; i < this.equations.length; i++){
        eqs[i].maxForce = force;
        eqs[i].minForce = -force;
    }
};
/**
 * Get the max force.
 * @method getMaxForce
 * @return {Number}
 */ $30229da6f24f1f47$var$LockConstraint.prototype.getMaxForce = function() {
    return this.equations[0].maxForce;
};
var $30229da6f24f1f47$var$l = $2Ys9z.create();
var $30229da6f24f1f47$var$r = $2Ys9z.create();
var $30229da6f24f1f47$var$t = $2Ys9z.create();
var $30229da6f24f1f47$var$xAxis = $2Ys9z.fromValues(1, 0);
var $30229da6f24f1f47$var$yAxis = $2Ys9z.fromValues(0, 1);
$30229da6f24f1f47$var$LockConstraint.prototype.update = function() {
    var x = this.equations[0], y = this.equations[1], rot = this.equations[2], bodyA = this.bodyA, bodyB = this.bodyB;
    $2Ys9z.rotate($30229da6f24f1f47$var$l, this.localOffsetB, bodyA.angle);
    $2Ys9z.rotate($30229da6f24f1f47$var$r, this.localOffsetB, bodyB.angle - this.localAngleB);
    $2Ys9z.scale($30229da6f24f1f47$var$r, $30229da6f24f1f47$var$r, -1);
    $2Ys9z.rotate($30229da6f24f1f47$var$t, $30229da6f24f1f47$var$r, Math.PI / 2);
    $2Ys9z.normalize($30229da6f24f1f47$var$t, $30229da6f24f1f47$var$t);
    x.G[0] = -1;
    x.G[1] = 0;
    x.G[2] = -$2Ys9z.crossLength($30229da6f24f1f47$var$l, $30229da6f24f1f47$var$xAxis);
    x.G[3] = 1;
    y.G[0] = 0;
    y.G[1] = -1;
    y.G[2] = -$2Ys9z.crossLength($30229da6f24f1f47$var$l, $30229da6f24f1f47$var$yAxis);
    y.G[4] = 1;
    rot.G[0] = -$30229da6f24f1f47$var$t[0];
    rot.G[1] = -$30229da6f24f1f47$var$t[1];
    rot.G[3] = $30229da6f24f1f47$var$t[0];
    rot.G[4] = $30229da6f24f1f47$var$t[1];
    rot.G[5] = $2Ys9z.crossLength($30229da6f24f1f47$var$r, $30229da6f24f1f47$var$t);
};

});

parcelRegister("3QUo8", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
var $2ce1f7f3add6a2a7$var$sub = $2Ys9z.sub, $2ce1f7f3add6a2a7$var$add = $2Ys9z.add, $2ce1f7f3add6a2a7$var$dot = $2Ys9z.dot;
parcelRequire("dMz05");

var $8P1Fq = parcelRequire("8P1Fq");

var $gwWMZ = parcelRequire("gwWMZ");

var $jFBgF = parcelRequire("jFBgF");

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("cSwh0");
parcelRequire("jNxse");

var $OJ0UJ = parcelRequire("OJ0UJ");

var $clDtn = parcelRequire("clDtn");

var $k7z01 = parcelRequire("k7z01");
parcelRequire("e7hLo");

var $62ywx = parcelRequire("62ywx");
module.exports = $2ce1f7f3add6a2a7$var$Narrowphase;
// Temp things
var $2ce1f7f3add6a2a7$var$yAxis = $2Ys9z.fromValues(0, 1);
var $2ce1f7f3add6a2a7$var$tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp3 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp4 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp5 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp6 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp7 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp8 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp9 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp10 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp11 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp12 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp13 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp14 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp15 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp16 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp17 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp18 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmpArray = [];
/**
 * Narrowphase. Creates contacts and friction given shapes and transforms.
 * @class Narrowphase
 * @constructor
 */ function $2ce1f7f3add6a2a7$var$Narrowphase() {
    /**
     * @property contactEquations
     * @type {Array}
     */ this.contactEquations = [];
    /**
     * @property frictionEquations
     * @type {Array}
     */ this.frictionEquations = [];
    /**
     * Whether to make friction equations in the upcoming contacts.
     * @property enableFriction
     * @type {Boolean}
     */ this.enableFriction = true;
    /**
     * Whether to make equations enabled in upcoming contacts.
     * @property enabledEquations
     * @type {Boolean}
     */ this.enabledEquations = true;
    /**
     * The friction slip force to use when creating friction equations.
     * @property slipForce
     * @type {Number}
     */ this.slipForce = 10.0;
    /**
     * The friction value to use in the upcoming friction equations.
     * @property frictionCoefficient
     * @type {Number}
     */ this.frictionCoefficient = 0.3;
    /**
     * Will be the .relativeVelocity in each produced FrictionEquation.
     * @property {Number} surfaceVelocity
     */ this.surfaceVelocity = 0;
    /**
     * Keeps track of the allocated ContactEquations.
     * @property {ContactEquationPool} contactEquationPool
     *
     * @example
     *
     *     // Allocate a few equations before starting the simulation.
     *     // This way, no contact objects need to be created on the fly in the game loop.
     *     world.narrowphase.contactEquationPool.resize(1024);
     *     world.narrowphase.frictionEquationPool.resize(1024);
     */ this.contactEquationPool = new $8P1Fq({
        size: 32
    });
    /**
     * Keeps track of the allocated ContactEquations.
     * @property {FrictionEquationPool} frictionEquationPool
     */ this.frictionEquationPool = new $gwWMZ({
        size: 64
    });
    /**
     * The restitution value to use in the next contact equations.
     * @property restitution
     * @type {Number}
     */ this.restitution = 0;
    /**
     * The stiffness value to use in the next contact equations.
     * @property {Number} stiffness
     */ this.stiffness = $f0tQu.DEFAULT_STIFFNESS;
    /**
     * The stiffness value to use in the next contact equations.
     * @property {Number} stiffness
     */ this.relaxation = $f0tQu.DEFAULT_RELAXATION;
    /**
     * The stiffness value to use in the next friction equations.
     * @property frictionStiffness
     * @type {Number}
     */ this.frictionStiffness = $f0tQu.DEFAULT_STIFFNESS;
    /**
     * The relaxation value to use in the next friction equations.
     * @property frictionRelaxation
     * @type {Number}
     */ this.frictionRelaxation = $f0tQu.DEFAULT_RELAXATION;
    /**
     * Enable reduction of friction equations. If disabled, a box on a plane will generate 2 contact equations and 2 friction equations. If enabled, there will be only one friction equation. Same kind of simplifications are made  for all collision types.
     * @property enableFrictionReduction
     * @type {Boolean}
     * @deprecated This flag will be removed when the feature is stable enough.
     * @default true
     */ this.enableFrictionReduction = true;
    /**
     * Keeps track of the colliding bodies last step.
     * @private
     * @property collidingBodiesLastStep
     * @type {TupleDictionary}
     */ this.collidingBodiesLastStep = new $jFBgF();
    /**
     * Contact skin size value to use in the next contact equations.
     * @property {Number} contactSkinSize
     * @default 0.01
     */ this.contactSkinSize = 0.01;
}
var $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionA = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionB = $2Ys9z.create();
/**
 * @method bodiesOverlap
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 * @todo shape world transforms are wrong
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.bodiesOverlap = function(bodyA, bodyB) {
    var shapePositionA = $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionA;
    var shapePositionB = $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionB;
    // Loop over all shapes of bodyA
    for(var k = 0, Nshapesi = bodyA.shapes.length; k !== Nshapesi; k++){
        var shapeA = bodyA.shapes[k];
        bodyA.toWorldFrame(shapePositionA, shapeA.position);
        // All shapes of body j
        for(var l = 0, Nshapesj = bodyB.shapes.length; l !== Nshapesj; l++){
            var shapeB = bodyB.shapes[l];
            bodyB.toWorldFrame(shapePositionB, shapeB.position);
            if (this[shapeA.type | shapeB.type](bodyA, shapeA, shapePositionA, shapeA.angle + bodyA.angle, bodyB, shapeB, shapePositionB, shapeB.angle + bodyB.angle, true)) return true;
        }
    }
    return false;
};
/**
 * Check if the bodies were in contact since the last reset().
 * @method collidedLastStep
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.collidedLastStep = function(bodyA, bodyB) {
    var id1 = bodyA.id | 0, id2 = bodyB.id | 0;
    return !!this.collidingBodiesLastStep.get(id1, id2);
};
/**
 * Throws away the old equations and gets ready to create new
 * @method reset
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.reset = function() {
    this.collidingBodiesLastStep.reset();
    var eqs = this.contactEquations;
    var l = eqs.length;
    while(l--){
        var eq = eqs[l], id1 = eq.bodyA.id, id2 = eq.bodyB.id;
        this.collidingBodiesLastStep.set(id1, id2, true);
    }
    var ce = this.contactEquations, fe = this.frictionEquations;
    for(var i = 0; i < ce.length; i++)this.contactEquationPool.release(ce[i]);
    for(var i = 0; i < fe.length; i++)this.frictionEquationPool.release(fe[i]);
    // Reset
    this.contactEquations.length = this.frictionEquations.length = 0;
};
/**
 * Creates a ContactEquation, either by reusing an existing object or creating a new one.
 * @method createContactEquation
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {ContactEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createContactEquation = function(bodyA, bodyB, shapeA, shapeB) {
    var c = this.contactEquationPool.get();
    c.bodyA = bodyA;
    c.bodyB = bodyB;
    c.shapeA = shapeA;
    c.shapeB = shapeB;
    c.restitution = this.restitution;
    c.firstImpact = !this.collidedLastStep(bodyA, bodyB);
    c.stiffness = this.stiffness;
    c.relaxation = this.relaxation;
    c.needsUpdate = true;
    c.enabled = this.enabledEquations;
    c.offset = this.contactSkinSize;
    return c;
};
/**
 * Creates a FrictionEquation, either by reusing an existing object or creating a new one.
 * @method createFrictionEquation
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {FrictionEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionEquation = function(bodyA, bodyB, shapeA, shapeB) {
    var c = this.frictionEquationPool.get();
    c.bodyA = bodyA;
    c.bodyB = bodyB;
    c.shapeA = shapeA;
    c.shapeB = shapeB;
    c.setSlipForce(this.slipForce);
    c.frictionCoefficient = this.frictionCoefficient;
    c.relativeVelocity = this.surfaceVelocity;
    c.enabled = this.enabledEquations;
    c.needsUpdate = true;
    c.stiffness = this.frictionStiffness;
    c.relaxation = this.frictionRelaxation;
    c.contactEquations.length = 0;
    return c;
};
/**
 * Creates a FrictionEquation given the data in the ContactEquation. Uses same offset vectors ri and rj, but the tangent vector will be constructed from the collision normal.
 * @method createFrictionFromContact
 * @param  {ContactEquation} contactEquation
 * @return {FrictionEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionFromContact = function(c) {
    var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
    $2Ys9z.copy(eq.contactPointA, c.contactPointA);
    $2Ys9z.copy(eq.contactPointB, c.contactPointB);
    $2Ys9z.rotate90cw(eq.t, c.normalA);
    eq.contactEquations.push(c);
    return eq;
};
// Take the average N latest contact point on the plane.
$2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionFromAverage = function(numContacts) {
    var c = this.contactEquations[this.contactEquations.length - 1];
    var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
    var bodyA = c.bodyA;
    var bodyB = c.bodyB;
    $2Ys9z.set(eq.contactPointA, 0, 0);
    $2Ys9z.set(eq.contactPointB, 0, 0);
    $2Ys9z.set(eq.t, 0, 0);
    for(var i = 0; i !== numContacts; i++){
        c = this.contactEquations[this.contactEquations.length - 1 - i];
        if (c.bodyA === bodyA) {
            $2Ys9z.add(eq.t, eq.t, c.normalA);
            $2Ys9z.add(eq.contactPointA, eq.contactPointA, c.contactPointA);
            $2Ys9z.add(eq.contactPointB, eq.contactPointB, c.contactPointB);
        } else {
            $2Ys9z.sub(eq.t, eq.t, c.normalA);
            $2Ys9z.add(eq.contactPointA, eq.contactPointA, c.contactPointB);
            $2Ys9z.add(eq.contactPointB, eq.contactPointB, c.contactPointA);
        }
        eq.contactEquations.push(c);
    }
    var invNumContacts = 1 / numContacts;
    $2Ys9z.scale(eq.contactPointA, eq.contactPointA, invNumContacts);
    $2Ys9z.scale(eq.contactPointB, eq.contactPointB, invNumContacts);
    $2Ys9z.normalize(eq.t, eq.t);
    $2Ys9z.rotate90cw(eq.t, eq.t);
    return eq;
};
/**
 * Convex/line narrowphase
 * @method convexLine
 * @param  {Body}       convexBody
 * @param  {Convex}     convexShape
 * @param  {Array}      convexOffset
 * @param  {Number}     convexAngle
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      lineOffset
 * @param  {Number}     lineAngle
 * @param {boolean}     justTest
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexLine = function(convexBody, convexShape, convexOffset, convexAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
/**
 * Line/box narrowphase
 * @method lineBox
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      lineOffset
 * @param  {Number}     lineAngle
 * @param  {Body}       boxBody
 * @param  {Box}  boxShape
 * @param  {Array}      boxOffset
 * @param  {Number}     boxAngle
 * @param  {Boolean}    justTest
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineBox = function(lineBody, lineShape, lineOffset, lineAngle, boxBody, boxShape, boxOffset, boxAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
function $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(convexShape, capsuleShape) {
    $2Ys9z.set(convexShape.vertices[0], -capsuleShape.length * 0.5, -capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[1], capsuleShape.length * 0.5, -capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[2], capsuleShape.length * 0.5, capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[3], -capsuleShape.length * 0.5, capsuleShape.radius);
}
var $2ce1f7f3add6a2a7$var$convexCapsule_tempRect = new $62ywx({
    width: 1,
    height: 1
}), $2ce1f7f3add6a2a7$var$convexCapsule_tempVec = $2Ys9z.create();
/**
 * Convex/capsule narrowphase
 * @method convexCapsule
 * @param  {Body}       convexBody
 * @param  {Convex}     convexShape
 * @param  {Array}      convexPosition
 * @param  {Number}     convexAngle
 * @param  {Body}       capsuleBody
 * @param  {Capsule}    capsuleShape
 * @param  {Array}      capsulePosition
 * @param  {Number}     capsuleAngle
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexCapsule = function(convexBody, convexShape, convexPosition, convexAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    // Check the circles
    // Add offsets!
    var circlePos = $2ce1f7f3add6a2a7$var$convexCapsule_tempVec;
    $2Ys9z.set(circlePos, capsuleShape.length / 2, 0);
    $2Ys9z.rotate(circlePos, circlePos, capsuleAngle);
    $2Ys9z.add(circlePos, circlePos, capsulePosition);
    var result1 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
    $2Ys9z.set(circlePos, -capsuleShape.length / 2, 0);
    $2Ys9z.rotate(circlePos, circlePos, capsuleAngle);
    $2Ys9z.add(circlePos, circlePos, capsulePosition);
    var result2 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
    if (justTest && (result1 || result2)) return true;
    // Check center rect
    var r = $2ce1f7f3add6a2a7$var$convexCapsule_tempRect;
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(r, capsuleShape);
    var result = this.convexConvex(convexBody, convexShape, convexPosition, convexAngle, capsuleBody, r, capsulePosition, capsuleAngle, justTest);
    return result + result1 + result2;
};
/**
 * Capsule/line narrowphase
 * @method lineCapsule
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      linePosition
 * @param  {Number}     lineAngle
 * @param  {Body}       capsuleBody
 * @param  {Capsule}    capsuleShape
 * @param  {Array}      capsulePosition
 * @param  {Number}     capsuleAngle
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineCapsule = function(lineBody, lineShape, linePosition, lineAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec1 = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec2 = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempRect1 = new $62ywx({
    width: 1,
    height: 1
});
/**
 * Capsule/capsule narrowphase
 * @method capsuleCapsule
 * @param  {Body}       bi
 * @param  {Capsule}    si
 * @param  {Array}      xi
 * @param  {Number}     ai
 * @param  {Body}       bj
 * @param  {Capsule}    sj
 * @param  {Array}      xj
 * @param  {Number}     aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.capsuleCapsule = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    var enableFrictionBefore;
    // Check the circles
    // Add offsets!
    var circlePosi = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec1, circlePosj = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec2;
    var numContacts = 0;
    // Need 4 circle checks, between all
    for(var i = 0; i < 2; i++){
        $2Ys9z.set(circlePosi, (i === 0 ? -1 : 1) * si.length / 2, 0);
        $2Ys9z.rotate(circlePosi, circlePosi, ai);
        $2Ys9z.add(circlePosi, circlePosi, xi);
        for(var j = 0; j < 2; j++){
            $2Ys9z.set(circlePosj, (j === 0 ? -1 : 1) * sj.length / 2, 0);
            $2Ys9z.rotate(circlePosj, circlePosj, aj);
            $2Ys9z.add(circlePosj, circlePosj, xj);
            // Temporarily turn off friction
            if (this.enableFrictionReduction) {
                enableFrictionBefore = this.enableFriction;
                this.enableFriction = false;
            }
            var result = this.circleCircle(bi, si, circlePosi, ai, bj, sj, circlePosj, aj, justTest, si.radius, sj.radius);
            if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
            if (justTest && result) return true;
            numContacts += result;
        }
    }
    if (this.enableFrictionReduction) {
        // Temporarily turn off friction
        enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    // Check circles against the center boxs
    var rect = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempRect1;
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(rect, si);
    var result1 = this.convexCapsule(bi, rect, xi, ai, bj, sj, xj, aj, justTest);
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest && result1) return true;
    numContacts += result1;
    if (this.enableFrictionReduction) {
        // Temporarily turn off friction
        var enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(rect, sj);
    var result2 = this.convexCapsule(bj, rect, xj, aj, bi, si, xi, ai, justTest);
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest && result2) return true;
    numContacts += result2;
    if (this.enableFrictionReduction) {
        if (numContacts && this.enableFriction) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
/**
 * Line/line narrowphase
 * @method lineLine
 * @param  {Body}       bodyA
 * @param  {Line}       shapeA
 * @param  {Array}      positionA
 * @param  {Number}     angleA
 * @param  {Body}       bodyB
 * @param  {Line}       shapeB
 * @param  {Array}      positionB
 * @param  {Number}     angleB
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineLine = function(bodyA, shapeA, positionA, angleA, bodyB, shapeB, positionB, angleB, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
/**
 * Plane/line Narrowphase
 * @method planeLine
 * @param  {Body}   planeBody
 * @param  {Plane}  planeShape
 * @param  {Array}  planeOffset
 * @param  {Number} planeAngle
 * @param  {Body}   lineBody
 * @param  {Line}   lineShape
 * @param  {Array}  lineOffset
 * @param  {Number} lineAngle
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeLine = function(planeBody, planeShape, planeOffset, planeAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldVertex01 = $2ce1f7f3add6a2a7$var$tmp3, worldVertex11 = $2ce1f7f3add6a2a7$var$tmp4, worldEdge = $2ce1f7f3add6a2a7$var$tmp5, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp6, dist = $2ce1f7f3add6a2a7$var$tmp7, worldNormal = $2ce1f7f3add6a2a7$var$tmp8, worldTangent = $2ce1f7f3add6a2a7$var$tmp9, verts = $2ce1f7f3add6a2a7$var$tmpArray, numContacts = 0;
    // Get start and end points
    $2Ys9z.set(worldVertex0, -lineShape.length / 2, 0);
    $2Ys9z.set(worldVertex1, lineShape.length / 2, 0);
    // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
    $2Ys9z.rotate(worldVertex01, worldVertex0, lineAngle);
    $2Ys9z.rotate(worldVertex11, worldVertex1, lineAngle);
    $2ce1f7f3add6a2a7$var$add(worldVertex01, worldVertex01, lineOffset);
    $2ce1f7f3add6a2a7$var$add(worldVertex11, worldVertex11, lineOffset);
    $2Ys9z.copy(worldVertex0, worldVertex01);
    $2Ys9z.copy(worldVertex1, worldVertex11);
    // Get vector along the line
    $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
    $2Ys9z.normalize(worldEdgeUnit, worldEdge);
    // Get tangent to the edge.
    $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    // Check line ends
    verts[0] = worldVertex0;
    verts[1] = worldVertex1;
    for(var i = 0; i < verts.length; i++){
        var v = verts[i];
        $2ce1f7f3add6a2a7$var$sub(dist, v, planeOffset);
        var d = $2ce1f7f3add6a2a7$var$dot(dist, worldNormal);
        if (d < 0) {
            if (justTest) return true;
            var c = this.createContactEquation(planeBody, lineBody, planeShape, lineShape);
            numContacts++;
            $2Ys9z.copy(c.normalA, worldNormal);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // distance vector along plane normal
            $2Ys9z.scale(dist, worldNormal, d);
            // Vector from plane center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, v, dist);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
            // From line center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, v, lineOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (!this.enableFrictionReduction) {
                if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            }
        }
    }
    if (justTest) return false;
    if (!this.enableFrictionReduction) {
        if (numContacts && this.enableFriction) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
$2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particleCapsule = function(particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    return this.circleLine(particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest, capsuleShape.radius, 0);
};
/**
 * Circle/line Narrowphase
 * @method circleLine
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} lineBody
 * @param  {Line} lineShape
 * @param  {Array} lineOffset
 * @param  {Number} lineAngle
 * @param {Boolean} justTest If set to true, this function will return the result (intersection or not) without adding equations.
 * @param {Number} lineRadius Radius to add to the line. Can be used to test Capsules.
 * @param {Number} circleRadius If set, this value overrides the circle shape radius.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleLine = function(circleBody, circleShape, circleOffset, circleAngle, lineBody, lineShape, lineOffset, lineAngle, justTest, lineRadius, circleRadius) {
    var lineRadius = lineRadius || 0, circleRadius = typeof circleRadius !== "undefined" ? circleRadius : circleShape.radius, orthoDist = $2ce1f7f3add6a2a7$var$tmp1, lineToCircleOrthoUnit = $2ce1f7f3add6a2a7$var$tmp2, projectedPoint = $2ce1f7f3add6a2a7$var$tmp3, centerDist = $2ce1f7f3add6a2a7$var$tmp4, worldTangent = $2ce1f7f3add6a2a7$var$tmp5, worldEdge = $2ce1f7f3add6a2a7$var$tmp6, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp7, worldVertex0 = $2ce1f7f3add6a2a7$var$tmp8, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp9, worldVertex01 = $2ce1f7f3add6a2a7$var$tmp10, worldVertex11 = $2ce1f7f3add6a2a7$var$tmp11, dist = $2ce1f7f3add6a2a7$var$tmp12, lineToCircle = $2ce1f7f3add6a2a7$var$tmp13, lineEndToLineRadius = $2ce1f7f3add6a2a7$var$tmp14, verts = $2ce1f7f3add6a2a7$var$tmpArray;
    // Get start and end points
    $2Ys9z.set(worldVertex0, -lineShape.length / 2, 0);
    $2Ys9z.set(worldVertex1, lineShape.length / 2, 0);
    // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
    $2Ys9z.rotate(worldVertex01, worldVertex0, lineAngle);
    $2Ys9z.rotate(worldVertex11, worldVertex1, lineAngle);
    $2ce1f7f3add6a2a7$var$add(worldVertex01, worldVertex01, lineOffset);
    $2ce1f7f3add6a2a7$var$add(worldVertex11, worldVertex11, lineOffset);
    $2Ys9z.copy(worldVertex0, worldVertex01);
    $2Ys9z.copy(worldVertex1, worldVertex11);
    // Get vector along the line
    $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
    $2Ys9z.normalize(worldEdgeUnit, worldEdge);
    // Get tangent to the edge.
    $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
    // Check distance from the plane spanned by the edge vs the circle
    $2ce1f7f3add6a2a7$var$sub(dist, circleOffset, worldVertex0);
    var d = $2ce1f7f3add6a2a7$var$dot(dist, worldTangent); // Distance from center of line to circle center
    $2ce1f7f3add6a2a7$var$sub(centerDist, worldVertex0, lineOffset);
    $2ce1f7f3add6a2a7$var$sub(lineToCircle, circleOffset, lineOffset);
    var radiusSum = circleRadius + lineRadius;
    if (Math.abs(d) < radiusSum) {
        // Now project the circle onto the edge
        $2Ys9z.scale(orthoDist, worldTangent, d);
        $2ce1f7f3add6a2a7$var$sub(projectedPoint, circleOffset, orthoDist);
        // Add the missing line radius
        $2Ys9z.scale(lineToCircleOrthoUnit, worldTangent, $2ce1f7f3add6a2a7$var$dot(worldTangent, lineToCircle));
        $2Ys9z.normalize(lineToCircleOrthoUnit, lineToCircleOrthoUnit);
        $2Ys9z.scale(lineToCircleOrthoUnit, lineToCircleOrthoUnit, lineRadius);
        $2ce1f7f3add6a2a7$var$add(projectedPoint, projectedPoint, lineToCircleOrthoUnit);
        // Check if the point is within the edge span
        var pos = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, projectedPoint);
        var pos0 = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, worldVertex0);
        var pos1 = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, worldVertex1);
        if (pos > pos0 && pos < pos1) {
            // We got contact!
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
            $2Ys9z.scale(c.normalA, orthoDist, -1);
            $2Ys9z.normalize(c.normalA, c.normalA);
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, projectedPoint, lineOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    // Add corner
    verts[0] = worldVertex0;
    verts[1] = worldVertex1;
    for(var i = 0; i < verts.length; i++){
        var v = verts[i];
        $2ce1f7f3add6a2a7$var$sub(dist, v, circleOffset);
        if ($2Ys9z.squaredLength(dist) < Math.pow(radiusSum, 2)) {
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // Vector from circle to contact point is the normal times the circle radius
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, v, lineOffset);
            $2Ys9z.scale(lineEndToLineRadius, c.normalA, -lineRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineEndToLineRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    return 0;
};
/**
 * Circle/capsule Narrowphase
 * @method circleCapsule
 * @param  {Body}   bi
 * @param  {Circle} si
 * @param  {Array}  xi
 * @param  {Number} ai
 * @param  {Body}   bj
 * @param  {Line}   sj
 * @param  {Array}  xj
 * @param  {Number} aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleCapsule = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    return this.circleLine(bi, si, xi, ai, bj, sj, xj, aj, justTest, sj.radius);
};
/**
 * Circle/convex Narrowphase.
 * @method circleConvex
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param  {Boolean} justTest
 * @param  {Number} circleRadius
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleConvex = function(circleBody, circleShape, circleOffset, circleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest, circleRadius) {
    var circleRadius = typeof circleRadius === "number" ? circleRadius : circleShape.radius;
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldEdge = $2ce1f7f3add6a2a7$var$tmp3, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp4, worldNormal = $2ce1f7f3add6a2a7$var$tmp5, centerDist = $2ce1f7f3add6a2a7$var$tmp6, convexToCircle = $2ce1f7f3add6a2a7$var$tmp7, orthoDist = $2ce1f7f3add6a2a7$var$tmp8, projectedPoint = $2ce1f7f3add6a2a7$var$tmp9, dist = $2ce1f7f3add6a2a7$var$tmp10, worldVertex = $2ce1f7f3add6a2a7$var$tmp11, closestEdge = -1, closestEdgeDistance = null, closestEdgeOrthoDist = $2ce1f7f3add6a2a7$var$tmp12, closestEdgeProjectedPoint = $2ce1f7f3add6a2a7$var$tmp13, candidate = $2ce1f7f3add6a2a7$var$tmp14, candidateDist = $2ce1f7f3add6a2a7$var$tmp15, minCandidate = $2ce1f7f3add6a2a7$var$tmp16, found = false, minCandidateDistance = Number.MAX_VALUE;
    var numReported = 0;
    // New algorithm:
    // 1. Check so center of circle is not inside the polygon. If it is, this wont work...
    // 2. For each edge
    // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
    // 2. 2. Check if point is inside.
    var verts = convexShape.vertices;
    // Check all edges first
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
        $2Ys9z.normalize(worldEdgeUnit, worldEdge);
        // Get tangent to the edge. Points out of the Convex
        $2Ys9z.rotate90cw(worldNormal, worldEdgeUnit);
        // Get point on circle, closest to the polygon
        $2Ys9z.scale(candidate, worldNormal, -circleShape.radius);
        $2ce1f7f3add6a2a7$var$add(candidate, candidate, circleOffset);
        if ($2ce1f7f3add6a2a7$var$pointInConvex(candidate, convexShape, convexOffset, convexAngle)) {
            $2Ys9z.sub(candidateDist, worldVertex0, candidate);
            var candidateDistance = Math.abs($2Ys9z.dot(candidateDist, worldNormal));
            if (candidateDistance < minCandidateDistance) {
                $2Ys9z.copy(minCandidate, candidate);
                minCandidateDistance = candidateDistance;
                $2Ys9z.scale(closestEdgeProjectedPoint, worldNormal, candidateDistance);
                $2Ys9z.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, candidate);
                found = true;
            }
        }
    }
    if (found) {
        if (justTest) return true;
        var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
        $2Ys9z.sub(c.normalA, minCandidate, circleOffset);
        $2Ys9z.normalize(c.normalA, c.normalA);
        $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
        $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
        $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
        this.contactEquations.push(c);
        if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        return 1;
    }
    // Check all vertices
    if (circleRadius > 0) for(var i = 0; i < verts.length; i++){
        var localVertex = verts[i];
        $2Ys9z.rotate(worldVertex, localVertex, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex, worldVertex, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, circleOffset);
        if ($2Ys9z.squaredLength(dist) < Math.pow(circleRadius, 2)) {
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // Vector from circle to contact point is the normal times the circle radius
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldVertex, convexOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    return 0;
};
var $2ce1f7f3add6a2a7$var$pic_worldVertex0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_worldVertex1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_r0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_r1 = $2Ys9z.create();
/*
 * Check if a point is in a polygon
 */ function $2ce1f7f3add6a2a7$var$pointInConvex(worldPoint, convexShape, convexOffset, convexAngle) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$pic_worldVertex0, worldVertex1 = $2ce1f7f3add6a2a7$var$pic_worldVertex1, r0 = $2ce1f7f3add6a2a7$var$pic_r0, r1 = $2ce1f7f3add6a2a7$var$pic_r1, point = worldPoint, verts = convexShape.vertices, lastCross = null;
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        // Transform vertices to world
        // @todo The point should be transformed to local coordinates in the convex, no need to transform each vertex
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(r0, worldVertex0, point);
        $2ce1f7f3add6a2a7$var$sub(r1, worldVertex1, point);
        var cross = $2Ys9z.crossLength(r0, r1);
        if (lastCross === null) lastCross = cross;
        // If we got a different sign of the distance vector, the point is out of the polygon
        if (cross * lastCross <= 0) return false;
        lastCross = cross;
    }
    return true;
}
/**
 * Particle/convex Narrowphase
 * @method particleConvex
 * @param  {Body} particleBody
 * @param  {Particle} particleShape
 * @param  {Array} particleOffset
 * @param  {Number} particleAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param {Boolean} justTest
 * @todo use pointInConvex and code more similar to circleConvex
 * @todo don't transform each vertex, but transform the particle position to convex-local instead
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particleConvex = function(particleBody, particleShape, particleOffset, particleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldEdge = $2ce1f7f3add6a2a7$var$tmp3, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp4, worldTangent = $2ce1f7f3add6a2a7$var$tmp5, centerDist = $2ce1f7f3add6a2a7$var$tmp6, convexToparticle = $2ce1f7f3add6a2a7$var$tmp7, orthoDist = $2ce1f7f3add6a2a7$var$tmp8, projectedPoint = $2ce1f7f3add6a2a7$var$tmp9, dist = $2ce1f7f3add6a2a7$var$tmp10, worldVertex = $2ce1f7f3add6a2a7$var$tmp11, closestEdge = -1, closestEdgeDistance = null, closestEdgeOrthoDist = $2ce1f7f3add6a2a7$var$tmp12, closestEdgeProjectedPoint = $2ce1f7f3add6a2a7$var$tmp13, r0 = $2ce1f7f3add6a2a7$var$tmp14, r1 = $2ce1f7f3add6a2a7$var$tmp15, localPoint = $2ce1f7f3add6a2a7$var$tmp16, candidateDist = $2ce1f7f3add6a2a7$var$tmp17, minEdgeNormal = $2ce1f7f3add6a2a7$var$tmp18, minCandidateDistance = Number.MAX_VALUE;
    var numReported = 0, found = false, verts = convexShape.vertices;
    // Check if the particle is in the polygon at all
    if (!$2ce1f7f3add6a2a7$var$pointInConvex(particleOffset, convexShape, convexOffset, convexAngle)) return 0;
    if (justTest) return true;
    // Check edges first
    var lastCross = null;
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        // Transform vertices to world
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        // Get world edge
        $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
        $2Ys9z.normalize(worldEdgeUnit, worldEdge);
        // Get tangent to the edge. Points out of the Convex
        $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
        // Check distance from the infinite line (spanned by the edge) to the particle
        $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, worldVertex0);
        var d = $2ce1f7f3add6a2a7$var$dot(dist, worldTangent);
        $2ce1f7f3add6a2a7$var$sub(centerDist, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(convexToparticle, particleOffset, convexOffset);
        $2Ys9z.sub(candidateDist, worldVertex0, particleOffset);
        var candidateDistance = Math.abs($2Ys9z.dot(candidateDist, worldTangent));
        if (candidateDistance < minCandidateDistance) {
            minCandidateDistance = candidateDistance;
            $2Ys9z.scale(closestEdgeProjectedPoint, worldTangent, candidateDistance);
            $2Ys9z.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, particleOffset);
            $2Ys9z.copy(minEdgeNormal, worldTangent);
            found = true;
        }
    }
    if (found) {
        var c = this.createContactEquation(particleBody, convexBody, particleShape, convexShape);
        $2Ys9z.scale(c.normalA, minEdgeNormal, -1);
        $2Ys9z.normalize(c.normalA, c.normalA);
        // Particle has no extent to the contact point
        $2Ys9z.set(c.contactPointA, 0, 0);
        $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, particleOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, particleBody.position);
        // From convex center to point
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
        $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
        this.contactEquations.push(c);
        if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        return 1;
    }
    return 0;
};
/**
 * Circle/circle Narrowphase
 * @method circleCircle
 * @param  {Body} bodyA
 * @param  {Circle} shapeA
 * @param  {Array} offsetA
 * @param  {Number} angleA
 * @param  {Body} bodyB
 * @param  {Circle} shapeB
 * @param  {Array} offsetB
 * @param  {Number} angleB
 * @param {Boolean} justTest
 * @param {Number} [radiusA] Optional radius to use for shapeA
 * @param {Number} [radiusB] Optional radius to use for shapeB
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleCircle = function(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest, radiusA, radiusB) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1, radiusA = radiusA || shapeA.radius, radiusB = radiusB || shapeB.radius;
    $2ce1f7f3add6a2a7$var$sub(dist, offsetA, offsetB);
    var r = radiusA + radiusB;
    if ($2Ys9z.squaredLength(dist) > Math.pow(r, 2)) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
    $2ce1f7f3add6a2a7$var$sub(c.normalA, offsetB, offsetA);
    $2Ys9z.normalize(c.normalA, c.normalA);
    $2Ys9z.scale(c.contactPointA, c.normalA, radiusA);
    $2Ys9z.scale(c.contactPointB, c.normalA, -radiusB);
    $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, offsetA);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, bodyA.position);
    $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, offsetB);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, bodyB.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
/**
 * Plane/Convex Narrowphase
 * @method planeConvex
 * @param  {Body} planeBody
 * @param  {Plane} planeShape
 * @param  {Array} planeOffset
 * @param  {Number} planeAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeConvex = function(planeBody, planeShape, planeOffset, planeAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
    var worldVertex = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2, dist = $2ce1f7f3add6a2a7$var$tmp3;
    var numReported = 0;
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    for(var i = 0; i !== convexShape.vertices.length; i++){
        var v = convexShape.vertices[i];
        $2Ys9z.rotate(worldVertex, v, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex, worldVertex, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, planeOffset);
        if ($2ce1f7f3add6a2a7$var$dot(dist, worldNormal) <= 0) {
            if (justTest) return true;
            // Found vertex
            numReported++;
            var c = this.createContactEquation(planeBody, convexBody, planeShape, convexShape);
            $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, planeOffset);
            $2Ys9z.copy(c.normalA, worldNormal);
            var d = $2ce1f7f3add6a2a7$var$dot(dist, c.normalA);
            $2Ys9z.scale(dist, c.normalA, d);
            // rj is from convex center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldVertex, convexBody.position);
            // ri is from plane center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, worldVertex, dist);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
            this.contactEquations.push(c);
            if (!this.enableFrictionReduction) {
                if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            }
        }
    }
    if (this.enableFrictionReduction) {
        if (this.enableFriction && numReported) this.frictionEquations.push(this.createFrictionFromAverage(numReported));
    }
    return numReported;
};
/**
 * Narrowphase for particle vs plane
 * @method particlePlane
 * @param  {Body}       particleBody
 * @param  {Particle}   particleShape
 * @param  {Array}      particleOffset
 * @param  {Number}     particleAngle
 * @param  {Body}       planeBody
 * @param  {Plane}      planeShape
 * @param  {Array}      planeOffset
 * @param  {Number}     planeAngle
 * @param {Boolean}     justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.PLANE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particlePlane = function(particleBody, particleShape, particleOffset, particleAngle, planeBody, planeShape, planeOffset, planeAngle, justTest) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2;
    planeAngle = planeAngle || 0;
    $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, planeOffset);
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    var d = $2ce1f7f3add6a2a7$var$dot(dist, worldNormal);
    if (d > 0) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(planeBody, particleBody, planeShape, particleShape);
    $2Ys9z.copy(c.normalA, worldNormal);
    $2Ys9z.scale(dist, c.normalA, d);
    // dist is now the distance vector in the normal direction
    // ri is the particle position projected down onto the plane, from the plane center
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, particleOffset, dist);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
    // rj is from the body center to the particle center
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, particleOffset, particleBody.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
/**
 * Circle/Particle Narrowphase
 * @method circleParticle
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} particleBody
 * @param  {Particle} particleShape
 * @param  {Array} particleOffset
 * @param  {Number} particleAngle
 * @param  {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.PARTICLE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleParticle = function(circleBody, circleShape, circleOffset, circleAngle, particleBody, particleShape, particleOffset, particleAngle, justTest) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1;
    $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, circleOffset);
    if ($2Ys9z.squaredLength(dist) > Math.pow(circleShape.radius, 2)) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(circleBody, particleBody, circleShape, particleShape);
    $2Ys9z.copy(c.normalA, dist);
    $2Ys9z.normalize(c.normalA, c.normalA);
    // Vector from circle to contact point is the normal times the circle radius
    $2Ys9z.scale(c.contactPointA, c.normalA, circleShape.radius);
    $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
    // Vector from particle center to contact point is zero
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, particleOffset, particleBody.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
var $2ce1f7f3add6a2a7$var$planeCapsule_tmpCircle = new $OJ0UJ({
    radius: 1
}), $2ce1f7f3add6a2a7$var$planeCapsule_tmp1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$planeCapsule_tmp2 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$planeCapsule_tmp3 = $2Ys9z.create();
/**
 * @method planeCapsule
 * @param  {Body} planeBody
 * @param  {Circle} planeShape
 * @param  {Array} planeOffset
 * @param  {Number} planeAngle
 * @param  {Body} capsuleBody
 * @param  {Particle} capsuleShape
 * @param  {Array} capsuleOffset
 * @param  {Number} capsuleAngle
 * @param {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeCapsule = function(planeBody, planeShape, planeOffset, planeAngle, capsuleBody, capsuleShape, capsuleOffset, capsuleAngle, justTest) {
    var end1 = $2ce1f7f3add6a2a7$var$planeCapsule_tmp1, end2 = $2ce1f7f3add6a2a7$var$planeCapsule_tmp2, circle = $2ce1f7f3add6a2a7$var$planeCapsule_tmpCircle, dst = $2ce1f7f3add6a2a7$var$planeCapsule_tmp3;
    // Compute world end positions
    $2Ys9z.set(end1, -capsuleShape.length / 2, 0);
    $2Ys9z.rotate(end1, end1, capsuleAngle);
    $2ce1f7f3add6a2a7$var$add(end1, end1, capsuleOffset);
    $2Ys9z.set(end2, capsuleShape.length / 2, 0);
    $2Ys9z.rotate(end2, end2, capsuleAngle);
    $2ce1f7f3add6a2a7$var$add(end2, end2, capsuleOffset);
    circle.radius = capsuleShape.radius;
    var enableFrictionBefore;
    // Temporarily turn off friction
    if (this.enableFrictionReduction) {
        enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    // Do Narrowphase as two circles
    var numContacts1 = this.circlePlane(capsuleBody, circle, end1, 0, planeBody, planeShape, planeOffset, planeAngle, justTest), numContacts2 = this.circlePlane(capsuleBody, circle, end2, 0, planeBody, planeShape, planeOffset, planeAngle, justTest);
    // Restore friction
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest) return numContacts1 || numContacts2;
    else {
        var numTotal = numContacts1 + numContacts2;
        if (this.enableFrictionReduction) {
            if (numTotal) this.frictionEquations.push(this.createFrictionFromAverage(numTotal));
        }
        return numTotal;
    }
};
/**
 * Creates ContactEquations and FrictionEquations for a collision.
 * @method circlePlane
 * @param  {Body}    bi     The first body that should be connected to the equations.
 * @param  {Circle}  si     The circle shape participating in the collision.
 * @param  {Array}   xi     Extra offset to take into account for the Shape, in addition to the one in circleBody.position. Will *not* be rotated by circleBody.angle (maybe it should, for sake of homogenity?). Set to null if none.
 * @param  {Body}    bj     The second body that should be connected to the equations.
 * @param  {Plane}   sj     The Plane shape that is participating
 * @param  {Array}   xj     Extra offset for the plane shape.
 * @param  {Number}  aj     Extra angle to apply to the plane
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.PLANE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circlePlane = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    var circleBody = bi, circleShape = si, circleOffset = xi, planeBody = bj, shapeB = sj, planeOffset = xj, planeAngle = aj;
    planeAngle = planeAngle || 0;
    // Vector from plane to circle
    var planeToCircle = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2, temp = $2ce1f7f3add6a2a7$var$tmp3;
    $2ce1f7f3add6a2a7$var$sub(planeToCircle, circleOffset, planeOffset);
    // World plane normal
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    // Normal direction distance
    var d = $2ce1f7f3add6a2a7$var$dot(worldNormal, planeToCircle);
    if (d > circleShape.radius) return 0; // No overlap. Abort.
    if (justTest) return true;
    // Create contact
    var contact = this.createContactEquation(planeBody, circleBody, sj, si);
    // ni is the plane world normal
    $2Ys9z.copy(contact.normalA, worldNormal);
    // rj is the vector from circle center to the contact point
    $2Ys9z.scale(contact.contactPointB, contact.normalA, -circleShape.radius);
    $2ce1f7f3add6a2a7$var$add(contact.contactPointB, contact.contactPointB, circleOffset);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointB, contact.contactPointB, circleBody.position);
    // ri is the distance from plane center to contact.
    $2Ys9z.scale(temp, contact.normalA, d);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointA, planeToCircle, temp); // Subtract normal distance vector from the distance vector
    $2ce1f7f3add6a2a7$var$add(contact.contactPointA, contact.contactPointA, planeOffset);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointA, contact.contactPointA, planeBody.position);
    this.contactEquations.push(contact);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(contact));
    return 1;
};
/**
 * Convex/convex Narrowphase.See <a href="http://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/">this article</a> for more info.
 * @method convexConvex
 * @param  {Body} bi
 * @param  {Convex} si
 * @param  {Array} xi
 * @param  {Number} ai
 * @param  {Body} bj
 * @param  {Convex} sj
 * @param  {Array} xj
 * @param  {Number} aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexConvex = function(bi, si, xi, ai, bj, sj, xj, aj, justTest, precision) {
    var sepAxis = $2ce1f7f3add6a2a7$var$tmp1, worldPoint = $2ce1f7f3add6a2a7$var$tmp2, worldPoint0 = $2ce1f7f3add6a2a7$var$tmp3, worldPoint1 = $2ce1f7f3add6a2a7$var$tmp4, worldEdge = $2ce1f7f3add6a2a7$var$tmp5, projected = $2ce1f7f3add6a2a7$var$tmp6, penetrationVec = $2ce1f7f3add6a2a7$var$tmp7, dist = $2ce1f7f3add6a2a7$var$tmp8, worldNormal = $2ce1f7f3add6a2a7$var$tmp9, numContacts = 0, precision = typeof precision === 'number' ? precision : 0;
    var found = $2ce1f7f3add6a2a7$var$Narrowphase.findSeparatingAxis(si, xi, ai, sj, xj, aj, sepAxis);
    if (!found) return 0;
    // Make sure the separating axis is directed from shape i to shape j
    $2ce1f7f3add6a2a7$var$sub(dist, xj, xi);
    if ($2ce1f7f3add6a2a7$var$dot(sepAxis, dist) > 0) $2Ys9z.scale(sepAxis, sepAxis, -1);
    // Find edges with normals closest to the separating axis
    var closestEdge1 = $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge(si, ai, sepAxis, true), closestEdge2 = $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge(sj, aj, sepAxis);
    if (closestEdge1 === -1 || closestEdge2 === -1) return 0;
    // Loop over the shapes
    for(var k = 0; k < 2; k++){
        var closestEdgeA = closestEdge1, closestEdgeB = closestEdge2, shapeA = si, shapeB = sj, offsetA = xi, offsetB = xj, angleA = ai, angleB = aj, bodyA = bi, bodyB = bj;
        if (k === 0) {
            // Swap!
            var tmp;
            tmp = closestEdgeA;
            closestEdgeA = closestEdgeB;
            closestEdgeB = tmp;
            tmp = shapeA;
            shapeA = shapeB;
            shapeB = tmp;
            tmp = offsetA;
            offsetA = offsetB;
            offsetB = tmp;
            tmp = angleA;
            angleA = angleB;
            angleB = tmp;
            tmp = bodyA;
            bodyA = bodyB;
            bodyB = tmp;
        }
        // Loop over 2 points in convex B
        for(var j = closestEdgeB; j < closestEdgeB + 2; j++){
            // Get world point
            var v = shapeB.vertices[(j + shapeB.vertices.length) % shapeB.vertices.length];
            $2Ys9z.rotate(worldPoint, v, angleB);
            $2ce1f7f3add6a2a7$var$add(worldPoint, worldPoint, offsetB);
            var insideNumEdges = 0;
            // Loop over the 3 closest edges in convex A
            for(var i = closestEdgeA - 1; i < closestEdgeA + 2; i++){
                var v0 = shapeA.vertices[(i + shapeA.vertices.length) % shapeA.vertices.length], v1 = shapeA.vertices[(i + 1 + shapeA.vertices.length) % shapeA.vertices.length];
                // Construct the edge
                $2Ys9z.rotate(worldPoint0, v0, angleA);
                $2Ys9z.rotate(worldPoint1, v1, angleA);
                $2ce1f7f3add6a2a7$var$add(worldPoint0, worldPoint0, offsetA);
                $2ce1f7f3add6a2a7$var$add(worldPoint1, worldPoint1, offsetA);
                $2ce1f7f3add6a2a7$var$sub(worldEdge, worldPoint1, worldPoint0);
                $2Ys9z.rotate90cw(worldNormal, worldEdge); // Normal points out of convex 1
                $2Ys9z.normalize(worldNormal, worldNormal);
                $2ce1f7f3add6a2a7$var$sub(dist, worldPoint, worldPoint0);
                var d = $2ce1f7f3add6a2a7$var$dot(worldNormal, dist);
                if (i === closestEdgeA && d <= precision || i !== closestEdgeA && d <= 0) insideNumEdges++;
            }
            if (insideNumEdges >= 3) {
                if (justTest) return true;
                // worldPoint was on the "inside" side of each of the 3 checked edges.
                // Project it to the center edge and use the projection direction as normal
                // Create contact
                var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
                numContacts++;
                // Get center edge from body A
                var v0 = shapeA.vertices[closestEdgeA % shapeA.vertices.length], v1 = shapeA.vertices[(closestEdgeA + 1) % shapeA.vertices.length];
                // Construct the edge
                $2Ys9z.rotate(worldPoint0, v0, angleA);
                $2Ys9z.rotate(worldPoint1, v1, angleA);
                $2ce1f7f3add6a2a7$var$add(worldPoint0, worldPoint0, offsetA);
                $2ce1f7f3add6a2a7$var$add(worldPoint1, worldPoint1, offsetA);
                $2ce1f7f3add6a2a7$var$sub(worldEdge, worldPoint1, worldPoint0);
                $2Ys9z.rotate90cw(c.normalA, worldEdge); // Normal points out of convex A
                $2Ys9z.normalize(c.normalA, c.normalA);
                $2ce1f7f3add6a2a7$var$sub(dist, worldPoint, worldPoint0); // From edge point to the penetrating point
                var d = $2ce1f7f3add6a2a7$var$dot(c.normalA, dist); // Penetration
                $2Ys9z.scale(penetrationVec, c.normalA, d); // Vector penetration
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, worldPoint, offsetA);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, penetrationVec);
                $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, offsetA);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, bodyA.position);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldPoint, offsetB);
                $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, offsetB);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, bodyB.position);
                this.contactEquations.push(c);
                // Todo reduce to 1 friction equation if we have 2 contact points
                if (!this.enableFrictionReduction) {
                    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
                }
            }
        }
    }
    if (this.enableFrictionReduction) {
        if (this.enableFriction && numContacts) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
// .projectConvex is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$pcoa_tmp1 = $2Ys9z.fromValues(0, 0);
/**
 * Project a Convex onto a world-oriented axis
 * @method projectConvexOntoAxis
 * @static
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param  {Array} worldAxis
 * @param  {Array} result
 */ $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis = function(convexShape, convexOffset, convexAngle, worldAxis, result) {
    var max = null, min = null, v, value, localAxis = $2ce1f7f3add6a2a7$var$pcoa_tmp1;
    // Convert the axis to local coords of the body
    $2Ys9z.rotate(localAxis, worldAxis, -convexAngle);
    // Get projected position of all vertices
    for(var i = 0; i < convexShape.vertices.length; i++){
        v = convexShape.vertices[i];
        value = $2ce1f7f3add6a2a7$var$dot(v, localAxis);
        if (max === null || value > max) max = value;
        if (min === null || value < min) min = value;
    }
    if (min > max) {
        var t = min;
        min = max;
        max = t;
    }
    // Project the position of the body onto the axis - need to add this to the result
    var offset = $2ce1f7f3add6a2a7$var$dot(convexOffset, worldAxis);
    $2Ys9z.set(result, min + offset, max + offset);
};
// .findSeparatingAxis is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$fsa_tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp3 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp4 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp5 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp6 = $2Ys9z.fromValues(0, 0);
/**
 * Find a separating axis between the shapes, that maximizes the separating distance between them.
 * @method findSeparatingAxis
 * @static
 * @param  {Convex}     c1
 * @param  {Array}      offset1
 * @param  {Number}     angle1
 * @param  {Convex}     c2
 * @param  {Array}      offset2
 * @param  {Number}     angle2
 * @param  {Array}      sepAxis     The resulting axis
 * @return {Boolean}                Whether the axis could be found.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.findSeparatingAxis = function(c1, offset1, angle1, c2, offset2, angle2, sepAxis) {
    var maxDist = null, overlap = false, found = false, edge = $2ce1f7f3add6a2a7$var$fsa_tmp1, worldPoint0 = $2ce1f7f3add6a2a7$var$fsa_tmp2, worldPoint1 = $2ce1f7f3add6a2a7$var$fsa_tmp3, normal = $2ce1f7f3add6a2a7$var$fsa_tmp4, span1 = $2ce1f7f3add6a2a7$var$fsa_tmp5, span2 = $2ce1f7f3add6a2a7$var$fsa_tmp6;
    if (c1 instanceof $62ywx && c2 instanceof $62ywx) for(var j = 0; j !== 2; j++){
        var c = c1, angle = angle1;
        if (j === 1) {
            c = c2;
            angle = angle2;
        }
        for(var i = 0; i !== 2; i++){
            // Get the world edge
            if (i === 0) $2Ys9z.set(normal, 0, 1);
            else if (i === 1) $2Ys9z.set(normal, 1, 0);
            if (angle !== 0) $2Ys9z.rotate(normal, normal, angle);
            // Project hulls onto that normal
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
            // Order by span position
            var a = span1, b = span2, swapped = false;
            if (span1[0] > span2[0]) {
                b = span1;
                a = span2;
                swapped = true;
            }
            // Get separating distance
            var dist = b[0] - a[1];
            overlap = dist <= 0;
            if (maxDist === null || dist > maxDist) {
                $2Ys9z.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    else for(var j = 0; j !== 2; j++){
        var c = c1, angle = angle1;
        if (j === 1) {
            c = c2;
            angle = angle2;
        }
        for(var i = 0; i !== c.vertices.length; i++){
            // Get the world edge
            $2Ys9z.rotate(worldPoint0, c.vertices[i], angle);
            $2Ys9z.rotate(worldPoint1, c.vertices[(i + 1) % c.vertices.length], angle);
            $2ce1f7f3add6a2a7$var$sub(edge, worldPoint1, worldPoint0);
            // Get normal - just rotate 90 degrees since vertices are given in CCW
            $2Ys9z.rotate90cw(normal, edge);
            $2Ys9z.normalize(normal, normal);
            // Project hulls onto that normal
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
            // Order by span position
            var a = span1, b = span2, swapped = false;
            if (span1[0] > span2[0]) {
                b = span1;
                a = span2;
                swapped = true;
            }
            // Get separating distance
            var dist = b[0] - a[1];
            overlap = dist <= 0;
            if (maxDist === null || dist > maxDist) {
                $2Ys9z.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    /*
    // Needs to be tested some more
    for(var j=0; j!==2; j++){
        var c = c1,
            angle = angle1;
        if(j===1){
            c = c2;
            angle = angle2;
        }

        for(var i=0; i!==c.axes.length; i++){

            var normal = c.axes[i];

            // Project hulls onto that normal
            Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);

            // Order by span position
            var a=span1,
                b=span2,
                swapped = false;
            if(span1[0] > span2[0]){
                b=span1;
                a=span2;
                swapped = true;
            }

            // Get separating distance
            var dist = b[0] - a[1];
            overlap = (dist <= Narrowphase.convexPrecision);

            if(maxDist===null || dist > maxDist){
                vec2.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    */ return found;
};
// .getClosestEdge is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$gce_tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$gce_tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$gce_tmp3 = $2Ys9z.fromValues(0, 0);
/**
 * Get the edge that has a normal closest to an axis.
 * @method getClosestEdge
 * @static
 * @param  {Convex}     c
 * @param  {Number}     angle
 * @param  {Array}      axis
 * @param  {Boolean}    flip
 * @return {Number}             Index of the edge that is closest. This index and the next spans the resulting edge. Returns -1 if failed.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge = function(c, angle, axis, flip) {
    var localAxis = $2ce1f7f3add6a2a7$var$gce_tmp1, edge = $2ce1f7f3add6a2a7$var$gce_tmp2, normal = $2ce1f7f3add6a2a7$var$gce_tmp3;
    // Convert the axis to local coords of the body
    $2Ys9z.rotate(localAxis, axis, -angle);
    if (flip) $2Ys9z.scale(localAxis, localAxis, -1);
    var closestEdge = -1, N = c.vertices.length, maxDot = -1;
    for(var i = 0; i !== N; i++){
        // Get the edge
        $2ce1f7f3add6a2a7$var$sub(edge, c.vertices[(i + 1) % N], c.vertices[i % N]);
        // Get normal - just rotate 90 degrees since vertices are given in CCW
        $2Ys9z.rotate90cw(normal, edge);
        $2Ys9z.normalize(normal, normal);
        var d = $2ce1f7f3add6a2a7$var$dot(normal, localAxis);
        if (closestEdge === -1 || d > maxDot) {
            closestEdge = i % N;
            maxDot = d;
        }
    }
    return closestEdge;
};
var $2ce1f7f3add6a2a7$var$circleHeightfield_candidate = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_dist = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_v0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_v1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidate = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_worldNormal = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidateNormal = $2Ys9z.create();
/**
 * @method circleHeightfield
 * @param  {Body}           bi
 * @param  {Circle}         si
 * @param  {Array}          xi
 * @param  {Body}           bj
 * @param  {Heightfield}    sj
 * @param  {Array}          xj
 * @param  {Number}         aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleHeightfield = function(circleBody, circleShape, circlePos, circleAngle, hfBody, hfShape, hfPos, hfAngle, justTest, radius) {
    var data = hfShape.heights, radius = radius || circleShape.radius, w = hfShape.elementWidth, dist = $2ce1f7f3add6a2a7$var$circleHeightfield_dist, candidate = $2ce1f7f3add6a2a7$var$circleHeightfield_candidate, minCandidate = $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidate, minCandidateNormal = $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidateNormal, worldNormal = $2ce1f7f3add6a2a7$var$circleHeightfield_worldNormal, v0 = $2ce1f7f3add6a2a7$var$circleHeightfield_v0, v1 = $2ce1f7f3add6a2a7$var$circleHeightfield_v1;
    // Get the index of the points to test against
    var idxA = Math.floor((circlePos[0] - radius - hfPos[0]) / w), idxB = Math.ceil((circlePos[0] + radius - hfPos[0]) / w);
    /*if(idxB < 0 || idxA >= data.length)
        return justTest ? false : 0;*/ if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max and min
    var max = data[idxA], min = data[idxB];
    for(var i = idxA; i < idxB; i++){
        if (data[i] < min) min = data[i];
        if (data[i] > max) max = data[i];
    }
    if (circlePos[1] - radius > max) return justTest ? false : 0;
    /*
    if(circlePos[1]+radius < min){
        // Below the minimum point... We can just guess.
        // TODO
    }
    */ // 1. Check so center of circle is not inside the field. If it is, this wont work...
    // 2. For each edge
    // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
    // 2. 2. Check if point is inside.
    var found = false;
    // Check all edges first
    for(var i = idxA; i < idxB; i++){
        // Get points
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.set(v1, (i + 1) * w, data[i + 1]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.add(v1, v1, hfPos);
        // Get normal
        $2Ys9z.sub(worldNormal, v1, v0);
        $2Ys9z.rotate(worldNormal, worldNormal, Math.PI / 2);
        $2Ys9z.normalize(worldNormal, worldNormal);
        // Get point on circle, closest to the edge
        $2Ys9z.scale(candidate, worldNormal, -radius);
        $2Ys9z.add(candidate, candidate, circlePos);
        // Distance from v0 to the candidate point
        $2Ys9z.sub(dist, candidate, v0);
        // Check if it is in the element "stick"
        var d = $2Ys9z.dot(dist, worldNormal);
        if (candidate[0] >= v0[0] && candidate[0] < v1[0] && d <= 0) {
            if (justTest) return true;
            found = true;
            // Store the candidate point, projected to the edge
            $2Ys9z.scale(dist, worldNormal, -d);
            $2Ys9z.add(minCandidate, candidate, dist);
            $2Ys9z.copy(minCandidateNormal, worldNormal);
            var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
            // Normal is out of the heightfield
            $2Ys9z.copy(c.normalA, minCandidateNormal);
            // Vector from circle to heightfield
            $2Ys9z.scale(c.contactPointB, c.normalA, -radius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, circlePos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, circleBody.position);
            $2Ys9z.copy(c.contactPointA, minCandidate);
            $2Ys9z.sub(c.contactPointA, c.contactPointA, hfBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        }
    }
    // Check all vertices
    found = false;
    if (radius > 0) for(var i = idxA; i <= idxB; i++){
        // Get point
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.sub(dist, circlePos, v0);
        if ($2Ys9z.squaredLength(dist) < Math.pow(radius, 2)) {
            if (justTest) return true;
            found = true;
            var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
            // Construct normal - out of heightfield
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            $2Ys9z.scale(c.contactPointB, c.normalA, -radius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, circlePos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, v0, hfPos);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, hfPos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, hfBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        }
    }
    if (found) return 1;
    return 0;
};
var $2ce1f7f3add6a2a7$var$convexHeightfield_v0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_v1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_tilePos = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_tempConvexShape = new $clDtn({
    vertices: [
        $2Ys9z.create(),
        $2Ys9z.create(),
        $2Ys9z.create(),
        $2Ys9z.create()
    ]
});
/**
 * @method circleHeightfield
 * @param  {Body}           bi
 * @param  {Circle}         si
 * @param  {Array}          xi
 * @param  {Body}           bj
 * @param  {Heightfield}    sj
 * @param  {Array}          xj
 * @param  {Number}         aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.BOX | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexHeightfield = function(convexBody, convexShape, convexPos, convexAngle, hfBody, hfShape, hfPos, hfAngle, justTest) {
    var data = hfShape.heights, w = hfShape.elementWidth, v0 = $2ce1f7f3add6a2a7$var$convexHeightfield_v0, v1 = $2ce1f7f3add6a2a7$var$convexHeightfield_v1, tilePos = $2ce1f7f3add6a2a7$var$convexHeightfield_tilePos, tileConvex = $2ce1f7f3add6a2a7$var$convexHeightfield_tempConvexShape;
    // Get the index of the points to test against
    var idxA = Math.floor((convexBody.aabb.lowerBound[0] - hfPos[0]) / w), idxB = Math.ceil((convexBody.aabb.upperBound[0] - hfPos[0]) / w);
    if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max and min
    var max = data[idxA], min = data[idxB];
    for(var i = idxA; i < idxB; i++){
        if (data[i] < min) min = data[i];
        if (data[i] > max) max = data[i];
    }
    if (convexBody.aabb.lowerBound[1] > max) return justTest ? false : 0;
    var found = false;
    var numContacts = 0;
    // Loop over all edges
    // TODO: If possible, construct a convex from several data points (need o check if the points make a convex shape)
    for(var i = idxA; i < idxB; i++){
        // Get points
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.set(v1, (i + 1) * w, data[i + 1]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.add(v1, v1, hfPos);
        // Construct a convex
        var tileHeight = 100; // todo
        $2Ys9z.set(tilePos, (v1[0] + v0[0]) * 0.5, (v1[1] + v0[1] - tileHeight) * 0.5);
        $2Ys9z.sub(tileConvex.vertices[0], v1, tilePos);
        $2Ys9z.sub(tileConvex.vertices[1], v0, tilePos);
        $2Ys9z.copy(tileConvex.vertices[2], tileConvex.vertices[1]);
        $2Ys9z.copy(tileConvex.vertices[3], tileConvex.vertices[0]);
        tileConvex.vertices[2][1] -= tileHeight;
        tileConvex.vertices[3][1] -= tileHeight;
        // Do convex collision
        numContacts += this.convexConvex(convexBody, convexShape, convexPos, convexAngle, hfBody, tileConvex, tilePos, 0, justTest);
    }
    return numContacts;
};

});
parcelRegister("jFBgF", function(module, exports) {

var $dMz05 = parcelRequire("dMz05");
module.exports = $e51ec140a1f3ad06$var$TupleDictionary;
/**
 * @class TupleDictionary
 * @constructor
 */ function $e51ec140a1f3ad06$var$TupleDictionary() {
    /**
     * The data storage
     * @property data
     * @type {Object}
     */ this.data = {};
    /**
     * Keys that are currently used.
     * @property {Array} keys
     */ this.keys = [];
}
/**
 * Generate a key given two integers
 * @method getKey
 * @param  {number} i
 * @param  {number} j
 * @return {string}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.getKey = function(id1, id2) {
    id1 = id1 | 0;
    id2 = id2 | 0;
    if ((id1 | 0) === (id2 | 0)) return -1;
    // valid for values < 2^16
    return ((id1 | 0) > (id2 | 0) ? id1 << 16 | id2 & 0xFFFF : id2 << 16 | id1 & 0xFFFF) | 0;
};
/**
 * @method getByKey
 * @param  {Number} key
 * @return {Object}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.getByKey = function(key) {
    key = key | 0;
    return this.data[key];
};
/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.get = function(i, j) {
    return this.data[this.getKey(i, j)];
};
/**
 * Set a value.
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.set = function(i, j, value) {
    if (!value) throw new Error("No data!");
    var key = this.getKey(i, j);
    // Check if key already exists
    if (!this.data[key]) this.keys.push(key);
    this.data[key] = value;
    return key;
};
/**
 * Remove all data.
 * @method reset
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.reset = function() {
    var data = this.data, keys = this.keys;
    var l = keys.length;
    while(l--)delete data[keys[l]];
    keys.length = 0;
};
/**
 * Copy another TupleDictionary. Note that all data in this dictionary will be removed.
 * @method copy
 * @param {TupleDictionary} dict The TupleDictionary to copy into this one.
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.copy = function(dict) {
    this.reset();
    $dMz05.appendArray(this.keys, dict.keys);
    var l = dict.keys.length;
    while(l--){
        var key = dict.keys[l];
        this.data[key] = dict.data[key];
    }
};

});

parcelRegister("62ywx", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $k7z01 = parcelRequire("k7z01");

var $clDtn = parcelRequire("clDtn");
module.exports = $465db5af288332c5$var$Box;
/**
 * Box shape class.
 * @class Box
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.width=1] Total width of the box
 * @param {Number} [options.height=1] Total height of the box
 * @extends Convex
 */ function $465db5af288332c5$var$Box(options) {
    if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        options = {
            width: arguments[0],
            height: arguments[1]
        };
        console.warn('The Rectangle has been renamed to Box and its constructor signature has changed. Please use the following format: new Box({ width: 1, height: 1, ... })');
    }
    options = options || {};
    /**
     * Total width of the box
     * @property width
     * @type {Number}
     */ var width = this.width = options.width || 1;
    /**
     * Total height of the box
     * @property height
     * @type {Number}
     */ var height = this.height = options.height || 1;
    var verts = [
        $2Ys9z.fromValues(-width / 2, -height / 2),
        $2Ys9z.fromValues(width / 2, -height / 2),
        $2Ys9z.fromValues(width / 2, height / 2),
        $2Ys9z.fromValues(-width / 2, height / 2)
    ];
    var axes = [
        $2Ys9z.fromValues(1, 0),
        $2Ys9z.fromValues(0, 1)
    ];
    options.vertices = verts;
    options.axes = axes;
    options.type = $k7z01.BOX;
    $clDtn.call(this, options);
}
$465db5af288332c5$var$Box.prototype = new $clDtn();
$465db5af288332c5$var$Box.prototype.constructor = $465db5af288332c5$var$Box;
/**
 * Compute moment of inertia
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $465db5af288332c5$var$Box.prototype.computeMomentOfInertia = function(mass) {
    var w = this.width, h = this.height;
    return mass * (h * h + w * w) / 12;
};
/**
 * Update the bounding radius
 * @method updateBoundingRadius
 */ $465db5af288332c5$var$Box.prototype.updateBoundingRadius = function() {
    var w = this.width, h = this.height;
    this.boundingRadius = Math.sqrt(w * w + h * h) / 2;
};
var $465db5af288332c5$var$corner1 = $2Ys9z.create(), $465db5af288332c5$var$corner2 = $2Ys9z.create(), $465db5af288332c5$var$corner3 = $2Ys9z.create(), $465db5af288332c5$var$corner4 = $2Ys9z.create();
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $465db5af288332c5$var$Box.prototype.computeAABB = function(out, position, angle) {
    out.setFromPoints(this.vertices, position, angle, 0);
};
$465db5af288332c5$var$Box.prototype.updateArea = function() {
    this.area = this.width * this.height;
};

});


parcelRegister("8e56j", function(module, exports) {
parcelRequire("OJ0UJ");
parcelRequire("hNAi3");
parcelRequire("k7z01");
parcelRequire("fwNHk");

var $dQgku = parcelRequire("dQgku");
parcelRequire("2Ys9z");
module.exports = $5fd396785f3a7a98$var$NaiveBroadphase;
/**
 * Naive broadphase implementation. Does N^2 tests.
 *
 * @class NaiveBroadphase
 * @constructor
 * @extends Broadphase
 */ function $5fd396785f3a7a98$var$NaiveBroadphase() {
    $dQgku.call(this, $dQgku.NAIVE);
}
$5fd396785f3a7a98$var$NaiveBroadphase.prototype = new $dQgku();
$5fd396785f3a7a98$var$NaiveBroadphase.prototype.constructor = $5fd396785f3a7a98$var$NaiveBroadphase;
/**
 * Get the colliding pairs
 * @method getCollisionPairs
 * @param  {World} world
 * @return {Array}
 */ $5fd396785f3a7a98$var$NaiveBroadphase.prototype.getCollisionPairs = function(world) {
    var bodies = world.bodies, result = this.result;
    result.length = 0;
    for(var i = 0, Ncolliding = bodies.length; i !== Ncolliding; i++){
        var bi = bodies[i];
        for(var j = 0; j < i; j++){
            var bj = bodies[j];
            if ($dQgku.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) result.push(bi, bj);
        }
    }
    return result;
};
/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */ $5fd396785f3a7a98$var$NaiveBroadphase.prototype.aabbQuery = function(world, aabb, result) {
    result = result || [];
    var bodies = world.bodies;
    for(var i = 0; i < bodies.length; i++){
        var b = bodies[i];
        if (b.aabbNeedsUpdate) b.updateAABB();
        if (b.aabb.overlaps(aabb)) result.push(b);
    }
    return result;
};

});
parcelRegister("hNAi3", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $cf5329bd50db2f04$var$Plane;
/**
 * Plane shape class. The plane is facing in the Y direction.
 * @class Plane
 * @extends Shape
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 */ function $cf5329bd50db2f04$var$Plane(options) {
    options = options || {};
    options.type = $k7z01.PLANE;
    $k7z01.call(this, options);
}
$cf5329bd50db2f04$var$Plane.prototype = new $k7z01();
$cf5329bd50db2f04$var$Plane.prototype.constructor = $cf5329bd50db2f04$var$Plane;
/**
 * Compute moment of inertia
 * @method computeMomentOfInertia
 */ $cf5329bd50db2f04$var$Plane.prototype.computeMomentOfInertia = function(mass) {
    return 0; // Plane is infinite. The inertia should therefore be infinty but by convention we set 0 here
};
/**
 * Update the bounding radius
 * @method updateBoundingRadius
 */ $cf5329bd50db2f04$var$Plane.prototype.updateBoundingRadius = function() {
    this.boundingRadius = Number.MAX_VALUE;
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $cf5329bd50db2f04$var$Plane.prototype.computeAABB = function(out, position, angle) {
    var a = angle % (2 * Math.PI);
    var set = $2Ys9z.set;
    var max = 1e7;
    var lowerBound = out.lowerBound;
    var upperBound = out.upperBound;
    // Set max bounds
    set(lowerBound, -max, -max);
    set(upperBound, max, max);
    if (a === 0) // y goes from -inf to 0
    upperBound[1] = 0;
    else if (a === Math.PI / 2) // x goes from 0 to inf
    lowerBound[0] = 0;
    else if (a === Math.PI) // y goes from 0 to inf
    lowerBound[1] = 0;
    else if (a === 3 * Math.PI / 2) // x goes from -inf to 0
    upperBound[0] = 0;
};
$cf5329bd50db2f04$var$Plane.prototype.updateArea = function() {
    this.area = Number.MAX_VALUE;
};
var $cf5329bd50db2f04$var$intersectPlane_planePointToFrom = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_dir_scaled_with_t = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_hitPoint = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_normal = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_len = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RayResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $cf5329bd50db2f04$var$Plane.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var planePointToFrom = $cf5329bd50db2f04$var$intersectPlane_planePointToFrom;
    var dir_scaled_with_t = $cf5329bd50db2f04$var$intersectPlane_dir_scaled_with_t;
    var hitPoint = $cf5329bd50db2f04$var$intersectPlane_hitPoint;
    var normal = $cf5329bd50db2f04$var$intersectPlane_normal;
    var len = $cf5329bd50db2f04$var$intersectPlane_len;
    // Get plane normal
    $2Ys9z.set(normal, 0, 1);
    $2Ys9z.rotate(normal, normal, angle);
    $2Ys9z.sub(len, from, position);
    var planeToFrom = $2Ys9z.dot(len, normal);
    $2Ys9z.sub(len, to, position);
    var planeToTo = $2Ys9z.dot(len, normal);
    if (planeToFrom * planeToTo > 0) // "from" and "to" are on the same side of the plane... bail out
    return;
    if ($2Ys9z.squaredDistance(from, to) < planeToFrom * planeToFrom) return;
    var n_dot_dir = $2Ys9z.dot(normal, direction);
    $2Ys9z.sub(planePointToFrom, from, position);
    var t = -$2Ys9z.dot(normal, planePointToFrom) / n_dot_dir / ray.length;
    ray.reportIntersection(result, t, normal, -1);
};

});

parcelRegister("fwNHk", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $b4e0651ff5e40f92$var$Particle;
/**
 * Particle shape class.
 * @class Particle
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @extends Shape
 */ function $b4e0651ff5e40f92$var$Particle(options) {
    options = options || {};
    options.type = $k7z01.PARTICLE;
    $k7z01.call(this, options);
}
$b4e0651ff5e40f92$var$Particle.prototype = new $k7z01();
$b4e0651ff5e40f92$var$Particle.prototype.constructor = $b4e0651ff5e40f92$var$Particle;
$b4e0651ff5e40f92$var$Particle.prototype.computeMomentOfInertia = function(mass) {
    return 0; // Can't rotate a particle
};
$b4e0651ff5e40f92$var$Particle.prototype.updateBoundingRadius = function() {
    this.boundingRadius = 0;
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $b4e0651ff5e40f92$var$Particle.prototype.computeAABB = function(out, position, angle) {
    $2Ys9z.copy(out.lowerBound, position);
    $2Ys9z.copy(out.upperBound, position);
};

});


parcelRegister("fc4SC", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $f0tQu = parcelRequire("f0tQu");

var $5vxRN = parcelRequire("5vxRN");

var $5UnY9 = parcelRequire("5UnY9");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $b0fbc309f6f5f11f$var$RevoluteConstraint;
var $b0fbc309f6f5f11f$var$worldPivotA = $2Ys9z.create(), $b0fbc309f6f5f11f$var$worldPivotB = $2Ys9z.create(), $b0fbc309f6f5f11f$var$xAxis = $2Ys9z.fromValues(1, 0), $b0fbc309f6f5f11f$var$yAxis = $2Ys9z.fromValues(0, 1), $b0fbc309f6f5f11f$var$g = $2Ys9z.create();
/**
 * Connects two bodies at given offset points, letting them rotate relative to each other around this point.
 * @class RevoluteConstraint
 * @constructor
 * @author schteppe
 * @param {Body}    bodyA
 * @param {Body}    bodyB
 * @param {Object}  [options]
 * @param {Array}   [options.worldPivot] A pivot point given in world coordinates. If specified, localPivotA and localPivotB are automatically computed from this value.
 * @param {Array}   [options.localPivotA] The point relative to the center of mass of bodyA which bodyA is constrained to.
 * @param {Array}   [options.localPivotB] See localPivotA.
 * @param {Number}  [options.maxForce] The maximum force that should be applied to constrain the bodies.
 * @extends Constraint
 *
 * @example
 *     // This will create a revolute constraint between two bodies with pivot point in between them.
 *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
 *     var bodyB = new Body({ mass: 1, position: [1, 0] });
 *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
 *         worldPivot: [0, 0]
 *     });
 *     world.addConstraint(constraint);
 *
 *     // Using body-local pivot points, the constraint could have been constructed like this:
 *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
 *         localPivotA: [1, 0],
 *         localPivotB: [-1, 0]
 *     });
 */ function $b0fbc309f6f5f11f$var$RevoluteConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.REVOLUTE, options);
    var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
    /**
     * @property {Array} pivotA
     */ this.pivotA = $2Ys9z.create();
    /**
     * @property {Array} pivotB
     */ this.pivotB = $2Ys9z.create();
    if (options.worldPivot) {
        // Compute pivotA and pivotB
        $2Ys9z.sub(this.pivotA, options.worldPivot, bodyA.position);
        $2Ys9z.sub(this.pivotB, options.worldPivot, bodyB.position);
        // Rotate to local coordinate system
        $2Ys9z.rotate(this.pivotA, this.pivotA, -bodyA.angle);
        $2Ys9z.rotate(this.pivotB, this.pivotB, -bodyB.angle);
    } else {
        // Get pivotA and pivotB
        $2Ys9z.copy(this.pivotA, options.localPivotA);
        $2Ys9z.copy(this.pivotB, options.localPivotB);
    }
    // Equations to be fed to the solver
    var eqs = this.equations = [
        new $f0tQu(bodyA, bodyB, -maxForce, maxForce),
        new $f0tQu(bodyA, bodyB, -maxForce, maxForce)
    ];
    var x = eqs[0];
    var y = eqs[1];
    var that = this;
    x.computeGq = function() {
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, that.pivotA, bodyA.angle);
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, that.pivotB, bodyB.angle);
        $2Ys9z.add($b0fbc309f6f5f11f$var$g, bodyB.position, $b0fbc309f6f5f11f$var$worldPivotB);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, bodyA.position);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$worldPivotA);
        return $2Ys9z.dot($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$xAxis);
    };
    y.computeGq = function() {
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, that.pivotA, bodyA.angle);
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, that.pivotB, bodyB.angle);
        $2Ys9z.add($b0fbc309f6f5f11f$var$g, bodyB.position, $b0fbc309f6f5f11f$var$worldPivotB);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, bodyA.position);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$worldPivotA);
        return $2Ys9z.dot($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$yAxis);
    };
    y.minForce = x.minForce = -maxForce;
    y.maxForce = x.maxForce = maxForce;
    this.motorEquation = new $5vxRN(bodyA, bodyB);
    /**
     * Indicates whether the motor is enabled. Use .enableMotor() to enable the constraint motor.
     * @property {Boolean} motorEnabled
     * @readOnly
     */ this.motorEnabled = false;
    /**
     * The constraint position.
     * @property angle
     * @type {Number}
     * @readOnly
     */ this.angle = 0;
    /**
     * Set to true to enable lower limit
     * @property lowerLimitEnabled
     * @type {Boolean}
     */ this.lowerLimitEnabled = false;
    /**
     * Set to true to enable upper limit
     * @property upperLimitEnabled
     * @type {Boolean}
     */ this.upperLimitEnabled = false;
    /**
     * The lower limit on the constraint angle.
     * @property lowerLimit
     * @type {Boolean}
     */ this.lowerLimit = 0;
    /**
     * The upper limit on the constraint angle.
     * @property upperLimit
     * @type {Boolean}
     */ this.upperLimit = 0;
    this.upperLimitEquation = new $5UnY9(bodyA, bodyB);
    this.lowerLimitEquation = new $5UnY9(bodyA, bodyB);
    this.upperLimitEquation.minForce = 0;
    this.lowerLimitEquation.maxForce = 0;
}
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype = new $3iby4();
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.constructor = $b0fbc309f6f5f11f$var$RevoluteConstraint;
/**
 * Set the constraint angle limits.
 * @method setLimits
 * @param {number} lower Lower angle limit.
 * @param {number} upper Upper angle limit.
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.setLimits = function(lower, upper) {
    if (typeof lower === 'number') {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = true;
    } else {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = false;
    }
    if (typeof upper === 'number') {
        this.upperLimit = upper;
        this.upperLimitEnabled = true;
    } else {
        this.upperLimit = upper;
        this.upperLimitEnabled = false;
    }
};
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.update = function() {
    var bodyA = this.bodyA, bodyB = this.bodyB, pivotA = this.pivotA, pivotB = this.pivotB, eqs = this.equations, normal = eqs[0], tangent = eqs[1], x = eqs[0], y = eqs[1], upperLimit = this.upperLimit, lowerLimit = this.lowerLimit, upperLimitEquation = this.upperLimitEquation, lowerLimitEquation = this.lowerLimitEquation;
    var relAngle = this.angle = bodyB.angle - bodyA.angle;
    if (this.upperLimitEnabled && relAngle > upperLimit) {
        upperLimitEquation.angle = upperLimit;
        if (eqs.indexOf(upperLimitEquation) === -1) eqs.push(upperLimitEquation);
    } else {
        var idx = eqs.indexOf(upperLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    if (this.lowerLimitEnabled && relAngle < lowerLimit) {
        lowerLimitEquation.angle = lowerLimit;
        if (eqs.indexOf(lowerLimitEquation) === -1) eqs.push(lowerLimitEquation);
    } else {
        var idx = eqs.indexOf(lowerLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    /*

    The constraint violation is

        g = xj + rj - xi - ri

    ...where xi and xj are the body positions and ri and rj world-oriented offset vectors. Differentiate:

        gdot = vj + wj x rj - vi - wi x ri

    We split this into x and y directions. (let x and y be unit vectors along the respective axes)

        gdot * x = ( vj + wj x rj - vi - wi x ri ) * x
                 = ( vj*x + (wj x rj)*x -vi*x -(wi x ri)*x
                 = ( vj*x + (rj x x)*wj -vi*x -(ri x x)*wi
                 = [ -x   -(ri x x)   x   (rj x x)] * [vi wi vj wj]
                 = G*W

    ...and similar for y. We have then identified the jacobian entries for x and y directions:

        Gx = [ x   (rj x x)   -x   -(ri x x)]
        Gy = [ y   (rj x y)   -y   -(ri x y)]

     */ $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, pivotA, bodyA.angle);
    $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, pivotB, bodyB.angle);
    // todo: these are a bit sparse. We could save some computations on making custom eq.computeGW functions, etc
    x.G[0] = -1;
    x.G[1] = 0;
    x.G[2] = -$2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotA, $b0fbc309f6f5f11f$var$xAxis);
    x.G[3] = 1;
    x.G[4] = 0;
    x.G[5] = $2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotB, $b0fbc309f6f5f11f$var$xAxis);
    y.G[0] = 0;
    y.G[1] = -1;
    y.G[2] = -$2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotA, $b0fbc309f6f5f11f$var$yAxis);
    y.G[3] = 0;
    y.G[4] = 1;
    y.G[5] = $2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotB, $b0fbc309f6f5f11f$var$yAxis);
};
/**
 * Enable the rotational motor
 * @method enableMotor
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.enableMotor = function() {
    if (this.motorEnabled) return;
    this.equations.push(this.motorEquation);
    this.motorEnabled = true;
};
/**
 * Disable the rotational motor
 * @method disableMotor
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.disableMotor = function() {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations.splice(i, 1);
    this.motorEnabled = false;
};
/**
 * Check if the motor is enabled.
 * @method motorIsEnabled
 * @deprecated use property motorEnabled instead.
 * @return {Boolean}
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.motorIsEnabled = function() {
    return !!this.motorEnabled;
};
/**
 * Set the speed of the rotational constraint motor
 * @method setMotorSpeed
 * @param  {Number} speed
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.setMotorSpeed = function(speed) {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations[i].relativeVelocity = speed;
};
/**
 * Get the speed of the rotational constraint motor
 * @method getMotorSpeed
 * @return {Number} The current speed, or false if the motor is not enabled.
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.getMotorSpeed = function() {
    if (!this.motorEnabled) return false;
    return this.motorEquation.relativeVelocity;
};

});
parcelRegister("5vxRN", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("2Ys9z");
module.exports = $402a1e36da19cf95$var$RotationalVelocityEquation;
/**
 * Syncs rotational velocity of two bodies, or sets a relative velocity (motor).
 *
 * @class RotationalVelocityEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ function $402a1e36da19cf95$var$RotationalVelocityEquation(bodyA, bodyB) {
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    this.relativeVelocity = 1;
    this.ratio = 1;
}
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype = new $f0tQu();
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype.constructor = $402a1e36da19cf95$var$RotationalVelocityEquation;
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype.computeB = function(a, b, h) {
    var G = this.G;
    G[2] = -1;
    G[5] = this.ratio;
    var GiMf = this.computeGiMf();
    var GW = this.computeGW();
    var B = -GW * b - h * GiMf;
    return B;
};

});

parcelRegister("5UnY9", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $44d4c67ddbb0d8a5$var$RotationalLockEquation;
/**
 * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
 *
 * @class RotationalLockEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Number} [options.angle] Angle to add to the local vector in bodyA.
 */ function $44d4c67ddbb0d8a5$var$RotationalLockEquation(bodyA, bodyB, options) {
    options = options || {};
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    /**
     * @property {number} angle
     */ this.angle = options.angle || 0;
    var G = this.G;
    G[2] = 1;
    G[5] = -1;
}
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype = new $f0tQu();
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype.constructor = $44d4c67ddbb0d8a5$var$RotationalLockEquation;
var $44d4c67ddbb0d8a5$var$worldVectorA = $2Ys9z.create(), $44d4c67ddbb0d8a5$var$worldVectorB = $2Ys9z.create(), $44d4c67ddbb0d8a5$var$xAxis = $2Ys9z.fromValues(1, 0), $44d4c67ddbb0d8a5$var$yAxis = $2Ys9z.fromValues(0, 1);
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype.computeGq = function() {
    $2Ys9z.rotate($44d4c67ddbb0d8a5$var$worldVectorA, $44d4c67ddbb0d8a5$var$xAxis, this.bodyA.angle + this.angle);
    $2Ys9z.rotate($44d4c67ddbb0d8a5$var$worldVectorB, $44d4c67ddbb0d8a5$var$yAxis, this.bodyB.angle);
    return $2Ys9z.dot($44d4c67ddbb0d8a5$var$worldVectorA, $44d4c67ddbb0d8a5$var$worldVectorB);
};

});


parcelRegister("1u9oZ", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $cSwh0 = parcelRequire("cSwh0");

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");

var $5UnY9 = parcelRequire("5UnY9");
module.exports = $114fe2d7375fdc4f$var$PrismaticConstraint;
/**
 * Constraint that only allows bodies to move along a line, relative to each other. See <a href="http://www.iforce2d.net/b2dtut/joints-prismatic">this tutorial</a>. Also called "slider constraint".
 *
 * @class PrismaticConstraint
 * @constructor
 * @extends Constraint
 * @author schteppe
 * @param {Body}    bodyA
 * @param {Body}    bodyB
 * @param {Object}  [options]
 * @param {Number}  [options.maxForce]                Max force to be applied by the constraint
 * @param {Array}   [options.localAnchorA]            Body A's anchor point, defined in its own local frame.
 * @param {Array}   [options.localAnchorB]            Body B's anchor point, defined in its own local frame.
 * @param {Array}   [options.localAxisA]              An axis, defined in body A frame, that body B's anchor point may slide along.
 * @param {Boolean} [options.disableRotationalLock]   If set to true, bodyB will be free to rotate around its anchor point.
 * @param {Number}  [options.upperLimit]
 * @param {Number}  [options.lowerLimit]
 * @todo Ability to create using only a point and a worldAxis
 */ function $114fe2d7375fdc4f$var$PrismaticConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.PRISMATIC, options);
    // Get anchors
    var localAnchorA = $2Ys9z.fromValues(0, 0), localAxisA = $2Ys9z.fromValues(1, 0), localAnchorB = $2Ys9z.fromValues(0, 0);
    if (options.localAnchorA) $2Ys9z.copy(localAnchorA, options.localAnchorA);
    if (options.localAxisA) $2Ys9z.copy(localAxisA, options.localAxisA);
    if (options.localAnchorB) $2Ys9z.copy(localAnchorB, options.localAnchorB);
    /**
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = localAnchorA;
    /**
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = localAnchorB;
    /**
     * @property localAxisA
     * @type {Array}
     */ this.localAxisA = localAxisA;
    /*

    The constraint violation for the common axis point is

        g = ( xj + rj - xi - ri ) * t   :=  gg*t

    where r are body-local anchor points, and t is a tangent to the constraint axis defined in body i frame.

        gdot =  ( vj + wj x rj - vi - wi x ri ) * t + ( xj + rj - xi - ri ) * ( wi x t )

    Note the use of the chain rule. Now we identify the jacobian

        G*W = [ -t      -ri x t + t x gg     t    rj x t ] * [vi wi vj wj]

    The rotational part is just a rotation lock.

     */ var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
    // Translational part
    var trans = new $f0tQu(bodyA, bodyB, -maxForce, maxForce);
    var ri = new $2Ys9z.create(), rj = new $2Ys9z.create(), gg = new $2Ys9z.create(), t = new $2Ys9z.create();
    trans.computeGq = function() {
        // g = ( xj + rj - xi - ri ) * t
        return $2Ys9z.dot(gg, t);
    };
    trans.updateJacobian = function() {
        var G = this.G, xi = bodyA.position, xj = bodyB.position;
        $2Ys9z.rotate(ri, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(rj, localAnchorB, bodyB.angle);
        $2Ys9z.add(gg, xj, rj);
        $2Ys9z.sub(gg, gg, xi);
        $2Ys9z.sub(gg, gg, ri);
        $2Ys9z.rotate(t, localAxisA, bodyA.angle + Math.PI / 2);
        G[0] = -t[0];
        G[1] = -t[1];
        G[2] = -$2Ys9z.crossLength(ri, t) + $2Ys9z.crossLength(t, gg);
        G[3] = t[0];
        G[4] = t[1];
        G[5] = $2Ys9z.crossLength(rj, t);
    };
    this.equations.push(trans);
    // Rotational part
    if (!options.disableRotationalLock) {
        var rot = new $5UnY9(bodyA, bodyB, -maxForce, maxForce);
        this.equations.push(rot);
    }
    /**
     * The position of anchor A relative to anchor B, along the constraint axis.
     * @property position
     * @type {Number}
     */ this.position = 0;
    // Is this one used at all?
    this.velocity = 0;
    /**
     * Set to true to enable lower limit.
     * @property lowerLimitEnabled
     * @type {Boolean}
     */ this.lowerLimitEnabled = typeof options.lowerLimit !== "undefined" ? true : false;
    /**
     * Set to true to enable upper limit.
     * @property upperLimitEnabled
     * @type {Boolean}
     */ this.upperLimitEnabled = typeof options.upperLimit !== "undefined" ? true : false;
    /**
     * Lower constraint limit. The constraint position is forced to be larger than this value.
     * @property lowerLimit
     * @type {Number}
     */ this.lowerLimit = typeof options.lowerLimit !== "undefined" ? options.lowerLimit : 0;
    /**
     * Upper constraint limit. The constraint position is forced to be smaller than this value.
     * @property upperLimit
     * @type {Number}
     */ this.upperLimit = typeof options.upperLimit !== "undefined" ? options.upperLimit : 1;
    // Equations used for limits
    this.upperLimitEquation = new $cSwh0(bodyA, bodyB);
    this.lowerLimitEquation = new $cSwh0(bodyA, bodyB);
    // Set max/min forces
    this.upperLimitEquation.minForce = this.lowerLimitEquation.minForce = 0;
    this.upperLimitEquation.maxForce = this.lowerLimitEquation.maxForce = maxForce;
    /**
     * Equation used for the motor.
     * @property motorEquation
     * @type {Equation}
     */ this.motorEquation = new $f0tQu(bodyA, bodyB);
    /**
     * The current motor state. Enable or disable the motor using .enableMotor
     * @property motorEnabled
     * @type {Boolean}
     */ this.motorEnabled = false;
    /**
     * Set the target speed for the motor.
     * @property motorSpeed
     * @type {Number}
     */ this.motorSpeed = 0;
    var that = this;
    var motorEquation = this.motorEquation;
    var old = motorEquation.computeGW;
    motorEquation.computeGq = function() {
        return 0;
    };
    motorEquation.computeGW = function() {
        var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.velocity, vj = bj.velocity, wi = bi.angularVelocity, wj = bj.angularVelocity;
        return this.gmult(G, vi, wi, vj, wj) + that.motorSpeed;
    };
}
$114fe2d7375fdc4f$var$PrismaticConstraint.prototype = new $3iby4();
$114fe2d7375fdc4f$var$PrismaticConstraint.prototype.constructor = $114fe2d7375fdc4f$var$PrismaticConstraint;
var $114fe2d7375fdc4f$var$worldAxisA = $2Ys9z.create(), $114fe2d7375fdc4f$var$worldAnchorA = $2Ys9z.create(), $114fe2d7375fdc4f$var$worldAnchorB = $2Ys9z.create(), $114fe2d7375fdc4f$var$orientedAnchorA = $2Ys9z.create(), $114fe2d7375fdc4f$var$orientedAnchorB = $2Ys9z.create(), $114fe2d7375fdc4f$var$tmp = $2Ys9z.create();
/**
 * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
 * @method update
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.update = function() {
    var eqs = this.equations, trans = eqs[0], upperLimit = this.upperLimit, lowerLimit = this.lowerLimit, upperLimitEquation = this.upperLimitEquation, lowerLimitEquation = this.lowerLimitEquation, bodyA = this.bodyA, bodyB = this.bodyB, localAxisA = this.localAxisA, localAnchorA = this.localAnchorA, localAnchorB = this.localAnchorB;
    trans.updateJacobian();
    // Transform local things to world
    $2Ys9z.rotate($114fe2d7375fdc4f$var$worldAxisA, localAxisA, bodyA.angle);
    $2Ys9z.rotate($114fe2d7375fdc4f$var$orientedAnchorA, localAnchorA, bodyA.angle);
    $2Ys9z.add($114fe2d7375fdc4f$var$worldAnchorA, $114fe2d7375fdc4f$var$orientedAnchorA, bodyA.position);
    $2Ys9z.rotate($114fe2d7375fdc4f$var$orientedAnchorB, localAnchorB, bodyB.angle);
    $2Ys9z.add($114fe2d7375fdc4f$var$worldAnchorB, $114fe2d7375fdc4f$var$orientedAnchorB, bodyB.position);
    var relPosition = this.position = $2Ys9z.dot($114fe2d7375fdc4f$var$worldAnchorB, $114fe2d7375fdc4f$var$worldAxisA) - $2Ys9z.dot($114fe2d7375fdc4f$var$worldAnchorA, $114fe2d7375fdc4f$var$worldAxisA);
    // Motor
    if (this.motorEnabled) {
        // G = [ a     a x ri   -a   -a x rj ]
        var G = this.motorEquation.G;
        G[0] = $114fe2d7375fdc4f$var$worldAxisA[0];
        G[1] = $114fe2d7375fdc4f$var$worldAxisA[1];
        G[2] = $2Ys9z.crossLength($114fe2d7375fdc4f$var$worldAxisA, $114fe2d7375fdc4f$var$orientedAnchorB);
        G[3] = -$114fe2d7375fdc4f$var$worldAxisA[0];
        G[4] = -$114fe2d7375fdc4f$var$worldAxisA[1];
        G[5] = -$2Ys9z.crossLength($114fe2d7375fdc4f$var$worldAxisA, $114fe2d7375fdc4f$var$orientedAnchorA);
    }
    /*
        Limits strategy:
        Add contact equation, with normal along the constraint axis.
        min/maxForce is set so the constraint is repulsive in the correct direction.
        Some offset is added to either equation.contactPointA or .contactPointB to get the correct upper/lower limit.

                 ^
                 |
      upperLimit x
                 |    ------
         anchorB x<---|  B |
                 |    |    |
        ------   |    ------
        |    |   |
        |  A |-->x anchorA
        ------   |
                 x lowerLimit
                 |
                axis
     */ if (this.upperLimitEnabled && relPosition > upperLimit) {
        // Update contact constraint normal, etc
        $2Ys9z.scale(upperLimitEquation.normalA, $114fe2d7375fdc4f$var$worldAxisA, -1);
        $2Ys9z.sub(upperLimitEquation.contactPointA, $114fe2d7375fdc4f$var$worldAnchorA, bodyA.position);
        $2Ys9z.sub(upperLimitEquation.contactPointB, $114fe2d7375fdc4f$var$worldAnchorB, bodyB.position);
        $2Ys9z.scale($114fe2d7375fdc4f$var$tmp, $114fe2d7375fdc4f$var$worldAxisA, upperLimit);
        $2Ys9z.add(upperLimitEquation.contactPointA, upperLimitEquation.contactPointA, $114fe2d7375fdc4f$var$tmp);
        if (eqs.indexOf(upperLimitEquation) === -1) eqs.push(upperLimitEquation);
    } else {
        var idx = eqs.indexOf(upperLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    if (this.lowerLimitEnabled && relPosition < lowerLimit) {
        // Update contact constraint normal, etc
        $2Ys9z.scale(lowerLimitEquation.normalA, $114fe2d7375fdc4f$var$worldAxisA, 1);
        $2Ys9z.sub(lowerLimitEquation.contactPointA, $114fe2d7375fdc4f$var$worldAnchorA, bodyA.position);
        $2Ys9z.sub(lowerLimitEquation.contactPointB, $114fe2d7375fdc4f$var$worldAnchorB, bodyB.position);
        $2Ys9z.scale($114fe2d7375fdc4f$var$tmp, $114fe2d7375fdc4f$var$worldAxisA, lowerLimit);
        $2Ys9z.sub(lowerLimitEquation.contactPointB, lowerLimitEquation.contactPointB, $114fe2d7375fdc4f$var$tmp);
        if (eqs.indexOf(lowerLimitEquation) === -1) eqs.push(lowerLimitEquation);
    } else {
        var idx = eqs.indexOf(lowerLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
};
/**
 * Enable the motor
 * @method enableMotor
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.enableMotor = function() {
    if (this.motorEnabled) return;
    this.equations.push(this.motorEquation);
    this.motorEnabled = true;
};
/**
 * Disable the rotational motor
 * @method disableMotor
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.disableMotor = function() {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations.splice(i, 1);
    this.motorEnabled = false;
};
/**
 * Set the constraint limits.
 * @method setLimits
 * @param {number} lower Lower limit.
 * @param {number} upper Upper limit.
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.setLimits = function(lower, upper) {
    if (typeof lower === 'number') {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = true;
    } else {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = false;
    }
    if (typeof upper === 'number') {
        this.upperLimit = upper;
        this.upperLimitEnabled = true;
    } else {
        this.upperLimit = upper;
        this.upperLimitEnabled = false;
    }
};

});

parcelRegister("konik", function(module, exports) {

var $dMz05 = parcelRequire("dMz05");

var $dQgku = parcelRequire("dQgku");
module.exports = $ed881e60f3706c0e$var$SAPBroadphase;
/**
 * Sweep and prune broadphase along one axis.
 *
 * @class SAPBroadphase
 * @constructor
 * @extends Broadphase
 */ function $ed881e60f3706c0e$var$SAPBroadphase() {
    $dQgku.call(this, $dQgku.SAP);
    /**
     * List of bodies currently in the broadphase.
     * @property axisList
     * @type {Array}
     */ this.axisList = [];
    /**
     * The axis to sort along. 0 means x-axis and 1 y-axis. If your bodies are more spread out over the X axis, set axisIndex to 0, and you will gain some performance.
     * @property axisIndex
     * @type {Number}
     */ this.axisIndex = 0;
    var that = this;
    this._addBodyHandler = function(e) {
        that.axisList.push(e.body);
    };
    this._removeBodyHandler = function(e) {
        // Remove from list
        var idx = that.axisList.indexOf(e.body);
        if (idx !== -1) that.axisList.splice(idx, 1);
    };
}
$ed881e60f3706c0e$var$SAPBroadphase.prototype = new $dQgku();
$ed881e60f3706c0e$var$SAPBroadphase.prototype.constructor = $ed881e60f3706c0e$var$SAPBroadphase;
/**
 * Change the world
 * @method setWorld
 * @param {World} world
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.setWorld = function(world) {
    // Clear the old axis array
    this.axisList.length = 0;
    // Add all bodies from the new world
    $dMz05.appendArray(this.axisList, world.bodies);
    // Remove old handlers, if any
    world.off("addBody", this._addBodyHandler).off("removeBody", this._removeBodyHandler);
    // Add handlers to update the list of bodies.
    world.on("addBody", this._addBodyHandler).on("removeBody", this._removeBodyHandler);
    this.world = world;
};
/**
 * Sorts bodies along an axis.
 * @method sortAxisList
 * @param {Array} a
 * @param {number} axisIndex
 * @return {Array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.sortAxisList = function(a, axisIndex) {
    axisIndex = axisIndex | 0;
    for(var i = 1, l = a.length; i < l; i++){
        var v = a[i];
        for(var j = i - 1; j >= 0; j--){
            if (a[j].aabb.lowerBound[axisIndex] <= v.aabb.lowerBound[axisIndex]) break;
            a[j + 1] = a[j];
        }
        a[j + 1] = v;
    }
    return a;
};
$ed881e60f3706c0e$var$SAPBroadphase.prototype.sortList = function() {
    var bodies = this.axisList, axisIndex = this.axisIndex;
    // Sort the lists
    $ed881e60f3706c0e$var$SAPBroadphase.sortAxisList(bodies, axisIndex);
};
/**
 * Get the colliding pairs
 * @method getCollisionPairs
 * @param  {World} world
 * @return {Array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.getCollisionPairs = function(world) {
    var bodies = this.axisList, result = this.result, axisIndex = this.axisIndex;
    result.length = 0;
    // Update all AABBs if needed
    var l = bodies.length;
    while(l--){
        var b = bodies[l];
        if (b.aabbNeedsUpdate) b.updateAABB();
    }
    // Sort the lists
    this.sortList();
    // Look through the X list
    for(var i = 0, N = bodies.length | 0; i !== N; i++){
        var bi = bodies[i];
        for(var j = i + 1; j < N; j++){
            var bj = bodies[j];
            // Bounds overlap?
            var overlaps = bj.aabb.lowerBound[axisIndex] <= bi.aabb.upperBound[axisIndex];
            if (!overlaps) break;
            if ($dQgku.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) result.push(bi, bj);
        }
    }
    return result;
};
/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.aabbQuery = function(world, aabb, result) {
    result = result || [];
    this.sortList();
    var axisIndex = this.axisIndex;
    var axis = 'x';
    if (axisIndex === 1) axis = 'y';
    if (axisIndex === 2) axis = 'z';
    var axisList = this.axisList;
    var lower = aabb.lowerBound[axis];
    var upper = aabb.upperBound[axis];
    for(var i = 0; i < axisList.length; i++){
        var b = axisList[i];
        if (b.aabbNeedsUpdate) b.updateAABB();
        if (b.aabb.overlaps(aabb)) result.push(b);
    }
    return result;
};

});

parcelRegister("94u9A", function(module, exports) {
parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
module.exports = $69abe0a67fd3e3ca$var$Spring;
/**
 * A spring, connecting two bodies. The Spring explicitly adds force and angularForce to the bodies and does therefore not put load on the constraint solver.
 *
 * @class Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1]      A number >= 0. Default: 1
 * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
 * @param {Array}  [options.localAnchorB]
 * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
 * @param {Array}  [options.worldAnchorB]
 */ function $69abe0a67fd3e3ca$var$Spring(bodyA, bodyB, options) {
    options = $dMz05.defaults(options, {
        stiffness: 100,
        damping: 1
    });
    /**
     * Stiffness of the spring.
     * @property stiffness
     * @type {number}
     */ this.stiffness = options.stiffness;
    /**
     * Damping of the spring.
     * @property damping
     * @type {number}
     */ this.damping = options.damping;
    /**
     * First connected body.
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second connected body.
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
}
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $69abe0a67fd3e3ca$var$Spring.prototype.applyForce = function() {
// To be implemented by subclasses
};

});

parcelRegister("3TW5l", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");

var $3iby4 = parcelRequire("3iby4");

var $jNxse = parcelRequire("jNxse");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $2d7390aa62f5a93b$var$TopDownVehicle;
/**
 * @class TopDownVehicle
 * @constructor
 * @param {Body} chassisBody A dynamic body, already added to the world.
 * @param {Object} [options]
 *
 * @example
 *
 *     // Create a dynamic body for the chassis
 *     var chassisBody = new Body({
 *         mass: 1
 *     });
 *     var boxShape = new Box({ width: 0.5, height: 1 });
 *     chassisBody.addShape(boxShape);
 *     world.addBody(chassisBody);
 *
 *     // Create the vehicle
 *     var vehicle = new TopDownVehicle(chassisBody);
 *
 *     // Add one front wheel and one back wheel - we don't actually need four :)
 *     var frontWheel = vehicle.addWheel({
 *         localPosition: [0, 0.5] // front
 *     });
 *     frontWheel.setSideFriction(4);
 *
 *     // Back wheel
 *     var backWheel = vehicle.addWheel({
 *         localPosition: [0, -0.5] // back
 *     });
 *     backWheel.setSideFriction(3); // Less side friction on back wheel makes it easier to drift
 *     vehicle.addToWorld(world);
 *
 *     // Steer value zero means straight forward. Positive is left and negative right.
 *     frontWheel.steerValue = Math.PI / 16;
 *
 *     // Engine force forward
 *     backWheel.engineForce = 10;
 *     backWheel.setBrakeForce(0);
 */ function $2d7390aa62f5a93b$var$TopDownVehicle(chassisBody, options) {
    options = options || {};
    /**
     * @property {Body} chassisBody
     */ this.chassisBody = chassisBody;
    /**
     * @property {Array} wheels
     */ this.wheels = [];
    // A dummy body to constrain the chassis to
    this.groundBody = new $e7hLo({
        mass: 0
    });
    this.world = null;
    var that = this;
    this.preStepCallback = function() {
        that.update();
    };
}
/**
 * @method addToWorld
 * @param {World} world
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.addToWorld = function(world) {
    this.world = world;
    world.addBody(this.groundBody);
    world.on('preStep', this.preStepCallback);
    for(var i = 0; i < this.wheels.length; i++){
        var wheel = this.wheels[i];
        world.addConstraint(wheel);
    }
};
/**
 * @method removeFromWorld
 * @param {World} world
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.removeFromWorld = function() {
    var world = this.world;
    world.removeBody(this.groundBody);
    world.off('preStep', this.preStepCallback);
    for(var i = 0; i < this.wheels.length; i++){
        var wheel = this.wheels[i];
        world.removeConstraint(wheel);
    }
    this.world = null;
};
/**
 * @method addWheel
 * @param {object} [wheelOptions]
 * @return {WheelConstraint}
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.addWheel = function(wheelOptions) {
    var wheel = new $2d7390aa62f5a93b$var$WheelConstraint(this, wheelOptions);
    this.wheels.push(wheel);
    return wheel;
};
/**
 * @method update
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.update = function() {
    for(var i = 0; i < this.wheels.length; i++)this.wheels[i].update();
};
/**
 * @class WheelConstraint
 * @constructor
 * @extends {Constraint}
 * @param {Vehicle} vehicle
 * @param {object} [options]
 * @param {Array} [options.localForwardVector]The local wheel forward vector in local body space. Default is zero.
 * @param {Array} [options.localPosition] The local position of the wheen in the chassis body. Default is zero - the center of the body.
 * @param {Array} [options.sideFriction=5] The max friction force in the sideways direction.
 */ function $2d7390aa62f5a93b$var$WheelConstraint(vehicle, options) {
    options = options || {};
    this.vehicle = vehicle;
    this.forwardEquation = new $jNxse(vehicle.chassisBody, vehicle.groundBody);
    this.sideEquation = new $jNxse(vehicle.chassisBody, vehicle.groundBody);
    /**
     * @property {number} steerValue
     */ this.steerValue = 0;
    /**
     * @property {number} engineForce
     */ this.engineForce = 0;
    this.setSideFriction(options.sideFriction !== undefined ? options.sideFriction : 5);
    /**
     * @property {Array} localForwardVector
     */ this.localForwardVector = $2Ys9z.fromValues(0, 1);
    if (options.localForwardVector) $2Ys9z.copy(this.localForwardVector, options.localForwardVector);
    /**
     * @property {Array} localPosition
     */ this.localPosition = $2Ys9z.fromValues(0, 0);
    if (options.localPosition) $2Ys9z.copy(this.localPosition, options.localPosition);
    $3iby4.apply(this, vehicle.chassisBody, vehicle.groundBody);
    this.equations.push(this.forwardEquation, this.sideEquation);
    this.setBrakeForce(0);
}
$2d7390aa62f5a93b$var$WheelConstraint.prototype = new $3iby4();
/**
 * @method setForwardFriction
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.setBrakeForce = function(force) {
    this.forwardEquation.setSlipForce(force);
};
/**
 * @method setSideFriction
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.setSideFriction = function(force) {
    this.sideEquation.setSlipForce(force);
};
var $2d7390aa62f5a93b$var$worldVelocity = $2Ys9z.create();
var $2d7390aa62f5a93b$var$relativePoint = $2Ys9z.create();
/**
 * @method getSpeed
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.getSpeed = function() {
    this.vehicle.chassisBody.vectorToWorldFrame($2d7390aa62f5a93b$var$relativePoint, this.localForwardVector);
    this.vehicle.chassisBody.getVelocityAtPoint($2d7390aa62f5a93b$var$worldVelocity, $2d7390aa62f5a93b$var$relativePoint);
    return $2Ys9z.dot($2d7390aa62f5a93b$var$worldVelocity, $2d7390aa62f5a93b$var$relativePoint);
};
var $2d7390aa62f5a93b$var$tmpVec = $2Ys9z.create();
/**
 * @method update
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.update = function() {
    // Directional
    this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.t, this.localForwardVector);
    $2Ys9z.rotate(this.sideEquation.t, this.localForwardVector, Math.PI / 2);
    this.vehicle.chassisBody.vectorToWorldFrame(this.sideEquation.t, this.sideEquation.t);
    $2Ys9z.rotate(this.forwardEquation.t, this.forwardEquation.t, this.steerValue);
    $2Ys9z.rotate(this.sideEquation.t, this.sideEquation.t, this.steerValue);
    // Attachment point
    this.vehicle.chassisBody.toWorldFrame(this.forwardEquation.contactPointB, this.localPosition);
    $2Ys9z.copy(this.sideEquation.contactPointB, this.forwardEquation.contactPointB);
    this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.contactPointA, this.localPosition);
    $2Ys9z.copy(this.sideEquation.contactPointA, this.forwardEquation.contactPointA);
    // Add engine force
    $2Ys9z.normalize($2d7390aa62f5a93b$var$tmpVec, this.forwardEquation.t);
    $2Ys9z.scale($2d7390aa62f5a93b$var$tmpVec, $2d7390aa62f5a93b$var$tmpVec, this.engineForce);
    this.vehicle.chassisBody.applyForce($2d7390aa62f5a93b$var$tmpVec, this.forwardEquation.contactPointA);
};

});

parcelRegister("8ZZ8g", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $94u9A = parcelRequire("94u9A");
parcelRequire("dMz05");
module.exports = $68d370db3526695c$var$LinearSpring;
/**
 * A spring, connecting two bodies.
 *
 * The Spring explicitly adds force and angularForce to the bodies.
 *
 * @class LinearSpring
 * @extends Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restLength]   A number > 0. Default is the current distance between the world anchor points.
 * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1]      A number >= 0. Default: 1
 * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
 * @param {Array}  [options.worldAnchorB]
 * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
 * @param {Array}  [options.localAnchorB]
 */ function $68d370db3526695c$var$LinearSpring(bodyA, bodyB, options) {
    options = options || {};
    $94u9A.call(this, bodyA, bodyB, options);
    /**
     * Anchor for bodyA in local bodyA coordinates.
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = $2Ys9z.fromValues(0, 0);
    /**
     * Anchor for bodyB in local bodyB coordinates.
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = $2Ys9z.fromValues(0, 0);
    if (options.localAnchorA) $2Ys9z.copy(this.localAnchorA, options.localAnchorA);
    if (options.localAnchorB) $2Ys9z.copy(this.localAnchorB, options.localAnchorB);
    if (options.worldAnchorA) this.setWorldAnchorA(options.worldAnchorA);
    if (options.worldAnchorB) this.setWorldAnchorB(options.worldAnchorB);
    var worldAnchorA = $2Ys9z.create();
    var worldAnchorB = $2Ys9z.create();
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);
    var worldDistance = $2Ys9z.distance(worldAnchorA, worldAnchorB);
    /**
     * Rest length of the spring.
     * @property restLength
     * @type {number}
     */ this.restLength = typeof options.restLength === "number" ? options.restLength : worldDistance;
}
$68d370db3526695c$var$LinearSpring.prototype = new $94u9A();
$68d370db3526695c$var$LinearSpring.prototype.constructor = $68d370db3526695c$var$LinearSpring;
/**
 * Set the anchor point on body A, using world coordinates.
 * @method setWorldAnchorA
 * @param {Array} worldAnchorA
 */ $68d370db3526695c$var$LinearSpring.prototype.setWorldAnchorA = function(worldAnchorA) {
    this.bodyA.toLocalFrame(this.localAnchorA, worldAnchorA);
};
/**
 * Set the anchor point on body B, using world coordinates.
 * @method setWorldAnchorB
 * @param {Array} worldAnchorB
 */ $68d370db3526695c$var$LinearSpring.prototype.setWorldAnchorB = function(worldAnchorB) {
    this.bodyB.toLocalFrame(this.localAnchorB, worldAnchorB);
};
/**
 * Get the anchor point on body A, in world coordinates.
 * @method getWorldAnchorA
 * @param {Array} result The vector to store the result in.
 */ $68d370db3526695c$var$LinearSpring.prototype.getWorldAnchorA = function(result) {
    this.bodyA.toWorldFrame(result, this.localAnchorA);
};
/**
 * Get the anchor point on body B, in world coordinates.
 * @method getWorldAnchorB
 * @param {Array} result The vector to store the result in.
 */ $68d370db3526695c$var$LinearSpring.prototype.getWorldAnchorB = function(result) {
    this.bodyB.toWorldFrame(result, this.localAnchorB);
};
var $68d370db3526695c$var$applyForce_r = $2Ys9z.create(), $68d370db3526695c$var$applyForce_r_unit = $2Ys9z.create(), $68d370db3526695c$var$applyForce_u = $2Ys9z.create(), $68d370db3526695c$var$applyForce_f = $2Ys9z.create(), $68d370db3526695c$var$applyForce_worldAnchorA = $2Ys9z.create(), $68d370db3526695c$var$applyForce_worldAnchorB = $2Ys9z.create(), $68d370db3526695c$var$applyForce_ri = $2Ys9z.create(), $68d370db3526695c$var$applyForce_rj = $2Ys9z.create(), $68d370db3526695c$var$applyForce_tmp = $2Ys9z.create();
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $68d370db3526695c$var$LinearSpring.prototype.applyForce = function() {
    var k = this.stiffness, d = this.damping, l = this.restLength, bodyA = this.bodyA, bodyB = this.bodyB, r = $68d370db3526695c$var$applyForce_r, r_unit = $68d370db3526695c$var$applyForce_r_unit, u = $68d370db3526695c$var$applyForce_u, f = $68d370db3526695c$var$applyForce_f, tmp = $68d370db3526695c$var$applyForce_tmp;
    var worldAnchorA = $68d370db3526695c$var$applyForce_worldAnchorA, worldAnchorB = $68d370db3526695c$var$applyForce_worldAnchorB, ri = $68d370db3526695c$var$applyForce_ri, rj = $68d370db3526695c$var$applyForce_rj;
    // Get world anchors
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);
    // Get offset points
    $2Ys9z.sub(ri, worldAnchorA, bodyA.position);
    $2Ys9z.sub(rj, worldAnchorB, bodyB.position);
    // Compute distance vector between world anchor points
    $2Ys9z.sub(r, worldAnchorB, worldAnchorA);
    var rlen = $2Ys9z.len(r);
    $2Ys9z.normalize(r_unit, r);
    //console.log(rlen)
    //console.log("A",vec2.str(worldAnchorA),"B",vec2.str(worldAnchorB))
    // Compute relative velocity of the anchor points, u
    $2Ys9z.sub(u, bodyB.velocity, bodyA.velocity);
    $2Ys9z.crossZV(tmp, bodyB.angularVelocity, rj);
    $2Ys9z.add(u, u, tmp);
    $2Ys9z.crossZV(tmp, bodyA.angularVelocity, ri);
    $2Ys9z.sub(u, u, tmp);
    // F = - k * ( x - L ) - D * ( u )
    $2Ys9z.scale(f, r_unit, -k * (rlen - l) - d * $2Ys9z.dot(u, r_unit));
    // Add forces to bodies
    $2Ys9z.sub(bodyA.force, bodyA.force, f);
    $2Ys9z.add(bodyB.force, bodyB.force, f);
    // Angular force
    var ri_x_f = $2Ys9z.crossLength(ri, f);
    var rj_x_f = $2Ys9z.crossLength(rj, f);
    bodyA.angularForce -= ri_x_f;
    bodyB.angularForce += rj_x_f;
};

});

parcelRegister("B7IZE", function(module, exports) {
parcelRequire("2Ys9z");

var $94u9A = parcelRequire("94u9A");
module.exports = $06f972c7d347034e$var$RotationalSpring;
/**
 * A rotational spring, connecting two bodies rotation. This spring explicitly adds angularForce (torque) to the bodies.
 *
 * The spring can be combined with a {{#crossLink "RevoluteConstraint"}}{{/crossLink}} to make, for example, a mouse trap.
 *
 * @class RotationalSpring
 * @extends Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restAngle] The relative angle of bodies at which the spring is at rest. If not given, it's set to the current relative angle between the bodies.
 * @param {number} [options.stiffness=100] Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1] A number >= 0.
 */ function $06f972c7d347034e$var$RotationalSpring(bodyA, bodyB, options) {
    options = options || {};
    $94u9A.call(this, bodyA, bodyB, options);
    /**
     * Rest angle of the spring.
     * @property restAngle
     * @type {number}
     */ this.restAngle = typeof options.restAngle === "number" ? options.restAngle : bodyB.angle - bodyA.angle;
}
$06f972c7d347034e$var$RotationalSpring.prototype = new $94u9A();
$06f972c7d347034e$var$RotationalSpring.prototype.constructor = $06f972c7d347034e$var$RotationalSpring;
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $06f972c7d347034e$var$RotationalSpring.prototype.applyForce = function() {
    var k = this.stiffness, d = this.damping, l = this.restAngle, bodyA = this.bodyA, bodyB = this.bodyB, x = bodyB.angle - bodyA.angle, u = bodyB.angularVelocity - bodyA.angularVelocity;
    var torque = -k * (x - l) - d * u * 0;
    bodyA.angularForce -= torque;
    bodyB.angularForce += torque;
};

});

parcelRegister("hGmj1", function(module, exports) {

var $hejTV = parcelRequire("hejTV");
parcelRequire("aZxNS");
parcelRequire("l9ZUH");

var $2Ys9z = parcelRequire("2Ys9z");

var $OJ0UJ = parcelRequire("OJ0UJ");

var $clDtn = parcelRequire("clDtn");
parcelRequire("d7wN7");

var $hNAi3 = parcelRequire("hNAi3");

var $4flMw = parcelRequire("4flMw");

var $fwNHk = parcelRequire("fwNHk");

var $5POlg = parcelRequire("5POlg");

var $e7hLo = parcelRequire("e7hLo");
parcelRequire("k7z01");
parcelRequire("8ZZ8g");

var $kfn8e = parcelRequire("kfn8e");

var $hzM8V = parcelRequire("hzM8V");
parcelRequire("2pi2h");
parcelRequire("3iby4");
parcelRequire("48dNO");
parcelRequire("fc4SC");
parcelRequire("1u9oZ");
parcelRequire("bb1X1");
parcelRequire("hIDwd");
parcelRequire("dQgku");

var $hkl1e = parcelRequire("hkl1e");

var $konik = parcelRequire("konik");

var $3QUo8 = parcelRequire("3QUo8");

var $dMz05 = parcelRequire("dMz05");

var $lST4l = parcelRequire("lST4l");

var $9JhUu = parcelRequire("9JhUu");
parcelRequire("B7IZE");
module.exports = $cdf7a95ffc36e12c$var$World;
/**
 * The dynamics world, where all bodies and constraints live.
 *
 * @class World
 * @constructor
 * @param {Object} [options]
 * @param {Solver} [options.solver] Defaults to GSSolver.
 * @param {Array} [options.gravity] Defaults to y=-9.78.
 * @param {Broadphase} [options.broadphase] Defaults to SAPBroadphase
 * @param {Boolean} [options.islandSplit=true]
 * @extends EventEmitter
 *
 * @example
 *     var world = new World({
 *         gravity: [0, -10],
 *         broadphase: new SAPBroadphase()
 *     });
 *     world.addBody(new Body());
 */ function $cdf7a95ffc36e12c$var$World(options) {
    $5POlg.apply(this);
    options = options || {};
    /**
     * All springs in the world. To add a spring to the world, use {{#crossLink "World/addSpring:method"}}{{/crossLink}}.
     *
     * @property springs
     * @type {Array}
     */ this.springs = [];
    /**
     * All bodies in the world. To add a body to the world, use {{#crossLink "World/addBody:method"}}{{/crossLink}}.
     * @property {Array} bodies
     */ this.bodies = [];
    /**
     * Disabled body collision pairs. See {{#crossLink "World/disableBodyCollision:method"}}.
     * @private
     * @property {Array} disabledBodyCollisionPairs
     */ this.disabledBodyCollisionPairs = [];
    /**
     * The solver used to satisfy constraints and contacts. Default is {{#crossLink "GSSolver"}}{{/crossLink}}.
     * @property {Solver} solver
     */ this.solver = options.solver || new $hejTV();
    /**
     * The narrowphase to use to generate contacts.
     *
     * @property narrowphase
     * @type {Narrowphase}
     */ this.narrowphase = new $3QUo8(this);
    /**
     * The island manager of this world.
     * @property {IslandManager} islandManager
     */ this.islandManager = new $9JhUu();
    /**
     * Gravity in the world. This is applied on all bodies in the beginning of each step().
     *
     * @property gravity
     * @type {Array}
     */ this.gravity = $2Ys9z.fromValues(0, -9.78);
    if (options.gravity) $2Ys9z.copy(this.gravity, options.gravity);
    /**
     * Gravity to use when approximating the friction max force (mu*mass*gravity).
     * @property {Number} frictionGravity
     */ this.frictionGravity = $2Ys9z.length(this.gravity) || 10;
    /**
     * Set to true if you want .frictionGravity to be automatically set to the length of .gravity.
     * @property {Boolean} useWorldGravityAsFrictionGravity
     * @default true
     */ this.useWorldGravityAsFrictionGravity = true;
    /**
     * If the length of .gravity is zero, and .useWorldGravityAsFrictionGravity=true, then switch to using .frictionGravity for friction instead. This fallback is useful for gravityless games.
     * @property {Boolean} useFrictionGravityOnZeroGravity
     * @default true
     */ this.useFrictionGravityOnZeroGravity = true;
    /**
     * The broadphase algorithm to use.
     *
     * @property broadphase
     * @type {Broadphase}
     */ this.broadphase = options.broadphase || new $konik();
    this.broadphase.setWorld(this);
    /**
     * User-added constraints.
     *
     * @property constraints
     * @type {Array}
     */ this.constraints = [];
    /**
     * Dummy default material in the world, used in .defaultContactMaterial
     * @property {Material} defaultMaterial
     */ this.defaultMaterial = new $kfn8e();
    /**
     * The default contact material to use, if no contact material was set for the colliding materials.
     * @property {ContactMaterial} defaultContactMaterial
     */ this.defaultContactMaterial = new $hzM8V(this.defaultMaterial, this.defaultMaterial);
    /**
     * For keeping track of what time step size we used last step
     * @property lastTimeStep
     * @type {Number}
     */ this.lastTimeStep = 1 / 60;
    /**
     * Enable to automatically apply spring forces each step.
     * @property applySpringForces
     * @type {Boolean}
     * @default true
     */ this.applySpringForces = true;
    /**
     * Enable to automatically apply body damping each step.
     * @property applyDamping
     * @type {Boolean}
     * @default true
     */ this.applyDamping = true;
    /**
     * Enable to automatically apply gravity each step.
     * @property applyGravity
     * @type {Boolean}
     * @default true
     */ this.applyGravity = true;
    /**
     * Enable/disable constraint solving in each step.
     * @property solveConstraints
     * @type {Boolean}
     * @default true
     */ this.solveConstraints = true;
    /**
     * The ContactMaterials added to the World.
     * @property contactMaterials
     * @type {Array}
     */ this.contactMaterials = [];
    /**
     * World time.
     * @property time
     * @type {Number}
     */ this.time = 0.0;
    this.accumulator = 0;
    /**
     * Is true during step().
     * @property {Boolean} stepping
     */ this.stepping = false;
    /**
     * Bodies that are scheduled to be removed at the end of the step.
     * @property {Array} bodiesToBeRemoved
     * @private
     */ this.bodiesToBeRemoved = [];
    /**
     * Whether to enable island splitting. Island splitting can be an advantage for both precision and performance. See {{#crossLink "IslandManager"}}{{/crossLink}}.
     * @property {Boolean} islandSplit
     * @default true
     */ this.islandSplit = typeof options.islandSplit !== "undefined" ? !!options.islandSplit : true;
    /**
     * Set to true if you want to the world to emit the "impact" event. Turning this off could improve performance.
     * @property emitImpactEvent
     * @type {Boolean}
     * @default true
     */ this.emitImpactEvent = true;
    // Id counters
    this._constraintIdCounter = 0;
    this._bodyIdCounter = 0;
    /**
     * Fired after the step().
     * @event postStep
     */ this.postStepEvent = {
        type: "postStep"
    };
    /**
     * Fired when a body is added to the world.
     * @event addBody
     * @param {Body} body
     */ this.addBodyEvent = {
        type: "addBody",
        body: null
    };
    /**
     * Fired when a body is removed from the world.
     * @event removeBody
     * @param {Body} body
     */ this.removeBodyEvent = {
        type: "removeBody",
        body: null
    };
    /**
     * Fired when a spring is added to the world.
     * @event addSpring
     * @param {Spring} spring
     */ this.addSpringEvent = {
        type: "addSpring",
        spring: null
    };
    /**
     * Fired when a first contact is created between two bodies. This event is fired after the step has been done.
     * @event impact
     * @param {Body} bodyA
     * @param {Body} bodyB
     */ this.impactEvent = {
        type: "impact",
        bodyA: null,
        bodyB: null,
        shapeA: null,
        shapeB: null,
        contactEquation: null
    };
    /**
     * Fired after the Broadphase has collected collision pairs in the world.
     * Inside the event handler, you can modify the pairs array as you like, to
     * prevent collisions between objects that you don't want.
     * @event postBroadphase
     * @param {Array} pairs An array of collision pairs. If this array is [body1,body2,body3,body4], then the body pairs 1,2 and 3,4 would advance to narrowphase.
     */ this.postBroadphaseEvent = {
        type: "postBroadphase",
        pairs: null
    };
    /**
     * How to deactivate bodies during simulation. Possible modes are: {{#crossLink "World/NO_SLEEPING:property"}}World.NO_SLEEPING{{/crossLink}}, {{#crossLink "World/BODY_SLEEPING:property"}}World.BODY_SLEEPING{{/crossLink}} and {{#crossLink "World/ISLAND_SLEEPING:property"}}World.ISLAND_SLEEPING{{/crossLink}}.
     * If sleeping is enabled, you might need to {{#crossLink "Body/wakeUp:method"}}wake up{{/crossLink}} the bodies if they fall asleep when they shouldn't. If you want to enable sleeping in the world, but want to disable it for a particular body, see {{#crossLink "Body/allowSleep:property"}}Body.allowSleep{{/crossLink}}.
     * @property sleepMode
     * @type {number}
     * @default World.NO_SLEEPING
     */ this.sleepMode = $cdf7a95ffc36e12c$var$World.NO_SLEEPING;
    /**
     * Fired when two shapes starts start to overlap. Fired in the narrowphase, during step.
     * @event beginContact
     * @param {Shape} shapeA
     * @param {Shape} shapeB
     * @param {Body}  bodyA
     * @param {Body}  bodyB
     * @param {Array} contactEquations
     */ this.beginContactEvent = {
        type: "beginContact",
        shapeA: null,
        shapeB: null,
        bodyA: null,
        bodyB: null,
        contactEquations: []
    };
    /**
     * Fired when two shapes stop overlapping, after the narrowphase (during step).
     * @event endContact
     * @param {Shape} shapeA
     * @param {Shape} shapeB
     * @param {Body}  bodyA
     * @param {Body}  bodyB
     */ this.endContactEvent = {
        type: "endContact",
        shapeA: null,
        shapeB: null,
        bodyA: null,
        bodyB: null
    };
    /**
     * Fired just before equations are added to the solver to be solved. Can be used to control what equations goes into the solver.
     * @event preSolve
     * @param {Array} contactEquations  An array of contacts to be solved.
     * @param {Array} frictionEquations An array of friction equations to be solved.
     */ this.preSolveEvent = {
        type: "preSolve",
        contactEquations: null,
        frictionEquations: null
    };
    // For keeping track of overlapping shapes
    this.overlappingShapesLastState = {
        keys: []
    };
    this.overlappingShapesCurrentState = {
        keys: []
    };
    /**
     * @property {OverlapKeeper} overlapKeeper
     */ this.overlapKeeper = new $lST4l();
}
$cdf7a95ffc36e12c$var$World.prototype = new Object($5POlg.prototype);
$cdf7a95ffc36e12c$var$World.prototype.constructor = $cdf7a95ffc36e12c$var$World;
/**
 * Never deactivate bodies.
 * @static
 * @property {number} NO_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.NO_SLEEPING = 1;
/**
 * Deactivate individual bodies if they are sleepy.
 * @static
 * @property {number} BODY_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.BODY_SLEEPING = 2;
/**
 * Deactivates bodies that are in contact, if all of them are sleepy. Note that you must enable {{#crossLink "World/islandSplit:property"}}.islandSplit{{/crossLink}} for this to work.
 * @static
 * @property {number} ISLAND_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.ISLAND_SLEEPING = 4;
/**
 * Add a constraint to the simulation.
 *
 * @method addConstraint
 * @param {Constraint} constraint
 * @example
 *     var constraint = new LockConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 */ $cdf7a95ffc36e12c$var$World.prototype.addConstraint = function(constraint) {
    this.constraints.push(constraint);
};
/**
 * Add a ContactMaterial to the simulation.
 * @method addContactMaterial
 * @param {ContactMaterial} contactMaterial
 */ $cdf7a95ffc36e12c$var$World.prototype.addContactMaterial = function(contactMaterial) {
    this.contactMaterials.push(contactMaterial);
};
/**
 * Removes a contact material
 *
 * @method removeContactMaterial
 * @param {ContactMaterial} cm
 */ $cdf7a95ffc36e12c$var$World.prototype.removeContactMaterial = function(cm) {
    var idx = this.contactMaterials.indexOf(cm);
    if (idx !== -1) $dMz05.splice(this.contactMaterials, idx, 1);
};
/**
 * Get a contact material given two materials
 * @method getContactMaterial
 * @param {Material} materialA
 * @param {Material} materialB
 * @return {ContactMaterial} The matching ContactMaterial, or false on fail.
 * @todo Use faster hash map to lookup from material id's
 */ $cdf7a95ffc36e12c$var$World.prototype.getContactMaterial = function(materialA, materialB) {
    var cmats = this.contactMaterials;
    for(var i = 0, N = cmats.length; i !== N; i++){
        var cm = cmats[i];
        if (cm.materialA.id === materialA.id && cm.materialB.id === materialB.id || cm.materialA.id === materialB.id && cm.materialB.id === materialA.id) return cm;
    }
    return false;
};
/**
 * Removes a constraint
 *
 * @method removeConstraint
 * @param {Constraint} constraint
 */ $cdf7a95ffc36e12c$var$World.prototype.removeConstraint = function(constraint) {
    var idx = this.constraints.indexOf(constraint);
    if (idx !== -1) $dMz05.splice(this.constraints, idx, 1);
};
var $cdf7a95ffc36e12c$var$step_r = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_runit = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_u = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_f = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_fhMinv = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_velodt = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_mg = $2Ys9z.create(), $cdf7a95ffc36e12c$var$xiw = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$xjw = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$zero = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$interpvelo = $2Ys9z.fromValues(0, 0);
/**
 * Step the physics world forward in time.
 *
 * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
 *
 * @method step
 * @param {Number} dt                       The fixed time step size to use.
 * @param {Number} [timeSinceLastCalled=0]  The time elapsed since the function was last called.
 * @param {Number} [maxSubSteps=10]         Maximum number of fixed steps to take per function call.
 *
 * @example
 *     // Simple fixed timestepping without interpolation
 *     var fixedTimeStep = 1 / 60;
 *     var world = new World();
 *     var body = new Body({ mass: 1 });
 *     world.addBody(body);
 *
 *     function animate(){
 *         requestAnimationFrame(animate);
 *         world.step(fixedTimeStep);
 *         renderBody(body.position, body.angle);
 *     }
 *
 *     // Start animation loop
 *     requestAnimationFrame(animate);
 *
 * @example
 *     // Fixed timestepping with interpolation
 *     var maxSubSteps = 10;
 *     var lastTimeSeconds;
 *
 *     function animate(t){
 *         requestAnimationFrame(animate);
 *         timeSeconds = t / 1000;
 *         lastTimeSeconds = lastTimeSeconds || timeSeconds;
 *
 *         deltaTime = timeSeconds - lastTimeSeconds;
 *         world.step(fixedTimeStep, deltaTime, maxSubSteps);
 *
 *         renderBody(body.interpolatedPosition, body.interpolatedAngle);
 *     }
 *
 *     // Start animation loop
 *     requestAnimationFrame(animate);
 *
 * @see http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
 */ $cdf7a95ffc36e12c$var$World.prototype.step = function(dt, timeSinceLastCalled, maxSubSteps) {
    maxSubSteps = maxSubSteps || 10;
    timeSinceLastCalled = timeSinceLastCalled || 0;
    if (timeSinceLastCalled === 0) {
        this.internalStep(dt);
        // Increment time
        this.time += dt;
    } else {
        this.accumulator += timeSinceLastCalled;
        var substeps = 0;
        while(this.accumulator >= dt && substeps < maxSubSteps){
            // Do fixed steps to catch up
            this.internalStep(dt);
            this.time += dt;
            this.accumulator -= dt;
            substeps++;
        }
        var t = this.accumulator % dt / dt;
        for(var j = 0; j !== this.bodies.length; j++){
            var b = this.bodies[j];
            $2Ys9z.lerp(b.interpolatedPosition, b.previousPosition, b.position, t);
            b.interpolatedAngle = b.previousAngle + t * (b.angle - b.previousAngle);
        }
    }
};
var $cdf7a95ffc36e12c$var$endOverlaps = [];
/**
 * Make a fixed step.
 * @method internalStep
 * @param  {number} dt
 * @private
 */ $cdf7a95ffc36e12c$var$World.prototype.internalStep = function(dt) {
    this.stepping = true;
    var that = this, Nsprings = this.springs.length, springs = this.springs, bodies = this.bodies, g = this.gravity, solver = this.solver, Nbodies = this.bodies.length, broadphase = this.broadphase, np = this.narrowphase, constraints = this.constraints, t0, t1, fhMinv = $cdf7a95ffc36e12c$var$step_fhMinv, velodt = $cdf7a95ffc36e12c$var$step_velodt, mg = $cdf7a95ffc36e12c$var$step_mg, scale = $2Ys9z.scale, add = $2Ys9z.add, rotate = $2Ys9z.rotate, islandManager = this.islandManager;
    this.overlapKeeper.tick();
    this.lastTimeStep = dt;
    // Update approximate friction gravity.
    if (this.useWorldGravityAsFrictionGravity) {
        var gravityLen = $2Ys9z.length(this.gravity);
        if (!(gravityLen === 0 && this.useFrictionGravityOnZeroGravity)) // Nonzero gravity. Use it.
        this.frictionGravity = gravityLen;
    }
    // Add gravity to bodies
    if (this.applyGravity) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i], fi = b.force;
        if (b.type !== $e7hLo.DYNAMIC || b.sleepState === $e7hLo.SLEEPING) continue;
        $2Ys9z.scale(mg, g, b.mass * b.gravityScale); // F=m*g
        add(fi, fi, mg);
    }
    // Add spring forces
    if (this.applySpringForces) for(var i = 0; i !== Nsprings; i++){
        var s = springs[i];
        s.applyForce();
    }
    if (this.applyDamping) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i];
        if (b.type === $e7hLo.DYNAMIC) b.applyDamping(dt);
    }
    // Broadphase
    var result = broadphase.getCollisionPairs(this);
    // Remove ignored collision pairs
    var ignoredPairs = this.disabledBodyCollisionPairs;
    for(var i = ignoredPairs.length - 2; i >= 0; i -= 2){
        for(var j = result.length - 2; j >= 0; j -= 2)if (ignoredPairs[i] === result[j] && ignoredPairs[i + 1] === result[j + 1] || ignoredPairs[i + 1] === result[j] && ignoredPairs[i] === result[j + 1]) result.splice(j, 2);
    }
    // Remove constrained pairs with collideConnected == false
    var Nconstraints = constraints.length;
    for(i = 0; i !== Nconstraints; i++){
        var c = constraints[i];
        if (!c.collideConnected) {
            for(var j = result.length - 2; j >= 0; j -= 2)if (c.bodyA === result[j] && c.bodyB === result[j + 1] || c.bodyB === result[j] && c.bodyA === result[j + 1]) result.splice(j, 2);
        }
    }
    // postBroadphase event
    this.postBroadphaseEvent.pairs = result;
    this.emit(this.postBroadphaseEvent);
    this.postBroadphaseEvent.pairs = null;
    // Narrowphase
    np.reset(this);
    for(var i = 0, Nresults = result.length; i !== Nresults; i += 2){
        var bi = result[i], bj = result[i + 1];
        // Loop over all shapes of body i
        for(var k = 0, Nshapesi = bi.shapes.length; k !== Nshapesi; k++){
            var si = bi.shapes[k], xi = si.position, ai = si.angle;
            // All shapes of body j
            for(var l = 0, Nshapesj = bj.shapes.length; l !== Nshapesj; l++){
                var sj = bj.shapes[l], xj = sj.position, aj = sj.angle;
                var cm = this.defaultContactMaterial;
                if (si.material && sj.material) {
                    var tmp = this.getContactMaterial(si.material, sj.material);
                    if (tmp) cm = tmp;
                }
                this.runNarrowphase(np, bi, si, xi, ai, bj, sj, xj, aj, cm, this.frictionGravity);
            }
        }
    }
    // Wake up bodies
    for(var i = 0; i !== Nbodies; i++){
        var body = bodies[i];
        if (body._wakeUpAfterNarrowphase) {
            body.wakeUp();
            body._wakeUpAfterNarrowphase = false;
        }
    }
    // Emit end overlap events
    if (this.has('endContact')) {
        this.overlapKeeper.getEndOverlaps($cdf7a95ffc36e12c$var$endOverlaps);
        var e = this.endContactEvent;
        var l = $cdf7a95ffc36e12c$var$endOverlaps.length;
        while(l--){
            var data = $cdf7a95ffc36e12c$var$endOverlaps[l];
            e.shapeA = data.shapeA;
            e.shapeB = data.shapeB;
            e.bodyA = data.bodyA;
            e.bodyB = data.bodyB;
            this.emit(e);
        }
        $cdf7a95ffc36e12c$var$endOverlaps.length = 0;
    }
    var preSolveEvent = this.preSolveEvent;
    preSolveEvent.contactEquations = np.contactEquations;
    preSolveEvent.frictionEquations = np.frictionEquations;
    this.emit(preSolveEvent);
    preSolveEvent.contactEquations = preSolveEvent.frictionEquations = null;
    // update constraint equations
    var Nconstraints = constraints.length;
    for(i = 0; i !== Nconstraints; i++)constraints[i].update();
    if (np.contactEquations.length || np.frictionEquations.length || Nconstraints) {
        if (this.islandSplit) {
            // Split into islands
            islandManager.equations.length = 0;
            $dMz05.appendArray(islandManager.equations, np.contactEquations);
            $dMz05.appendArray(islandManager.equations, np.frictionEquations);
            for(i = 0; i !== Nconstraints; i++)$dMz05.appendArray(islandManager.equations, constraints[i].equations);
            islandManager.split(this);
            for(var i = 0; i !== islandManager.islands.length; i++){
                var island = islandManager.islands[i];
                if (island.equations.length) solver.solveIsland(dt, island);
            }
        } else {
            // Add contact equations to solver
            solver.addEquations(np.contactEquations);
            solver.addEquations(np.frictionEquations);
            // Add user-defined constraint equations
            for(i = 0; i !== Nconstraints; i++)solver.addEquations(constraints[i].equations);
            if (this.solveConstraints) solver.solve(dt, this);
            solver.removeAllEquations();
        }
    }
    // Step forward
    for(var i = 0; i !== Nbodies; i++){
        var body = bodies[i];
        // if(body.sleepState !== Body.SLEEPING && body.type !== Body.STATIC){
        body.integrate(dt);
    // }
    }
    // Reset force
    for(var i = 0; i !== Nbodies; i++)bodies[i].setZeroForce();
    // Emit impact event
    if (this.emitImpactEvent && this.has('impact')) {
        var ev = this.impactEvent;
        for(var i = 0; i !== np.contactEquations.length; i++){
            var eq = np.contactEquations[i];
            if (eq.firstImpact) {
                ev.bodyA = eq.bodyA;
                ev.bodyB = eq.bodyB;
                ev.shapeA = eq.shapeA;
                ev.shapeB = eq.shapeB;
                ev.contactEquation = eq;
                this.emit(ev);
            }
        }
    }
    // Sleeping update
    if (this.sleepMode === $cdf7a95ffc36e12c$var$World.BODY_SLEEPING) for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, false, dt);
    else if (this.sleepMode === $cdf7a95ffc36e12c$var$World.ISLAND_SLEEPING && this.islandSplit) {
        // Tell all bodies to sleep tick but dont sleep yet
        for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, true, dt);
        // Sleep islands
        for(var i = 0; i < this.islandManager.islands.length; i++){
            var island = this.islandManager.islands[i];
            if (island.wantsToSleep()) island.sleep();
        }
    }
    this.stepping = false;
    // Remove bodies that are scheduled for removal
    var bodiesToBeRemoved = this.bodiesToBeRemoved;
    for(var i = 0; i !== bodiesToBeRemoved.length; i++)this.removeBody(bodiesToBeRemoved[i]);
    bodiesToBeRemoved.length = 0;
    this.emit(this.postStepEvent);
};
/**
 * Runs narrowphase for the shape pair i and j.
 * @method runNarrowphase
 * @param  {Narrowphase} np
 * @param  {Body} bi
 * @param  {Shape} si
 * @param  {Array} xi
 * @param  {Number} ai
 * @param  {Body} bj
 * @param  {Shape} sj
 * @param  {Array} xj
 * @param  {Number} aj
 * @param  {Number} mu
 */ $cdf7a95ffc36e12c$var$World.prototype.runNarrowphase = function(np, bi, si, xi, ai, bj, sj, xj, aj, cm, glen) {
    // Check collision groups and masks
    if (!((si.collisionGroup & sj.collisionMask) !== 0 && (sj.collisionGroup & si.collisionMask) !== 0)) return;
    // Get world position and angle of each shape
    $2Ys9z.rotate($cdf7a95ffc36e12c$var$xiw, xi, bi.angle);
    $2Ys9z.rotate($cdf7a95ffc36e12c$var$xjw, xj, bj.angle);
    $2Ys9z.add($cdf7a95ffc36e12c$var$xiw, $cdf7a95ffc36e12c$var$xiw, bi.position);
    $2Ys9z.add($cdf7a95ffc36e12c$var$xjw, $cdf7a95ffc36e12c$var$xjw, bj.position);
    var aiw = ai + bi.angle;
    var ajw = aj + bj.angle;
    np.enableFriction = cm.friction > 0;
    np.frictionCoefficient = cm.friction;
    var reducedMass;
    if (bi.type === $e7hLo.STATIC || bi.type === $e7hLo.KINEMATIC) reducedMass = bj.mass;
    else if (bj.type === $e7hLo.STATIC || bj.type === $e7hLo.KINEMATIC) reducedMass = bi.mass;
    else reducedMass = bi.mass * bj.mass / (bi.mass + bj.mass);
    np.slipForce = cm.friction * glen * reducedMass;
    np.restitution = cm.restitution;
    np.surfaceVelocity = cm.surfaceVelocity;
    np.frictionStiffness = cm.frictionStiffness;
    np.frictionRelaxation = cm.frictionRelaxation;
    np.stiffness = cm.stiffness;
    np.relaxation = cm.relaxation;
    np.contactSkinSize = cm.contactSkinSize;
    np.enabledEquations = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;
    var resolver = np[si.type | sj.type], numContacts = 0;
    if (resolver) {
        var sensor = si.sensor || sj.sensor;
        var numFrictionBefore = np.frictionEquations.length;
        if (si.type < sj.type) numContacts = resolver.call(np, bi, si, $cdf7a95ffc36e12c$var$xiw, aiw, bj, sj, $cdf7a95ffc36e12c$var$xjw, ajw, sensor);
        else numContacts = resolver.call(np, bj, sj, $cdf7a95ffc36e12c$var$xjw, ajw, bi, si, $cdf7a95ffc36e12c$var$xiw, aiw, sensor);
        var numFrictionEquations = np.frictionEquations.length - numFrictionBefore;
        if (numContacts) {
            if (bi.allowSleep && bi.type === $e7hLo.DYNAMIC && bi.sleepState === $e7hLo.SLEEPING && bj.sleepState === $e7hLo.AWAKE && bj.type !== $e7hLo.STATIC) {
                var speedSquaredB = $2Ys9z.squaredLength(bj.velocity) + Math.pow(bj.angularVelocity, 2);
                var speedLimitSquaredB = Math.pow(bj.sleepSpeedLimit, 2);
                if (speedSquaredB >= speedLimitSquaredB * 2) bi._wakeUpAfterNarrowphase = true;
            }
            if (bj.allowSleep && bj.type === $e7hLo.DYNAMIC && bj.sleepState === $e7hLo.SLEEPING && bi.sleepState === $e7hLo.AWAKE && bi.type !== $e7hLo.STATIC) {
                var speedSquaredA = $2Ys9z.squaredLength(bi.velocity) + Math.pow(bi.angularVelocity, 2);
                var speedLimitSquaredA = Math.pow(bi.sleepSpeedLimit, 2);
                if (speedSquaredA >= speedLimitSquaredA * 2) bj._wakeUpAfterNarrowphase = true;
            }
            this.overlapKeeper.setOverlapping(bi, si, bj, sj);
            if (this.has('beginContact') && this.overlapKeeper.isNewOverlap(si, sj)) {
                // Report new shape overlap
                var e = this.beginContactEvent;
                e.shapeA = si;
                e.shapeB = sj;
                e.bodyA = bi;
                e.bodyB = bj;
                // Reset contact equations
                e.contactEquations.length = 0;
                if (typeof numContacts === "number") for(var i = np.contactEquations.length - numContacts; i < np.contactEquations.length; i++)e.contactEquations.push(np.contactEquations[i]);
                this.emit(e);
            }
            // divide the max friction force by the number of contacts
            if (typeof numContacts === "number" && numFrictionEquations > 1) for(var i = np.frictionEquations.length - numFrictionEquations; i < np.frictionEquations.length; i++){
                var f = np.frictionEquations[i];
                f.setSlipForce(f.getSlipForce() / numFrictionEquations);
            }
        }
    }
};
/**
 * Add a spring to the simulation
 *
 * @method addSpring
 * @param {Spring} spring
 */ $cdf7a95ffc36e12c$var$World.prototype.addSpring = function(spring) {
    this.springs.push(spring);
    var evt = this.addSpringEvent;
    evt.spring = spring;
    this.emit(evt);
    evt.spring = null;
};
/**
 * Remove a spring
 *
 * @method removeSpring
 * @param {Spring} spring
 */ $cdf7a95ffc36e12c$var$World.prototype.removeSpring = function(spring) {
    var idx = this.springs.indexOf(spring);
    if (idx !== -1) $dMz05.splice(this.springs, idx, 1);
};
/**
 * Add a body to the simulation
 *
 * @method addBody
 * @param {Body} body
 *
 * @example
 *     var world = new World(),
 *         body = new Body();
 *     world.addBody(body);
 * @todo What if this is done during step?
 */ $cdf7a95ffc36e12c$var$World.prototype.addBody = function(body) {
    if (this.bodies.indexOf(body) === -1) {
        this.bodies.push(body);
        body.world = this;
        var evt = this.addBodyEvent;
        evt.body = body;
        this.emit(evt);
        evt.body = null;
    }
};
/**
 * Remove a body from the simulation. If this method is called during step(), the body removal is scheduled to after the step.
 *
 * @method removeBody
 * @param {Body} body
 */ $cdf7a95ffc36e12c$var$World.prototype.removeBody = function(body) {
    if (this.stepping) this.bodiesToBeRemoved.push(body);
    else {
        body.world = null;
        var idx = this.bodies.indexOf(body);
        if (idx !== -1) {
            $dMz05.splice(this.bodies, idx, 1);
            this.removeBodyEvent.body = body;
            body.resetConstraintVelocity();
            this.emit(this.removeBodyEvent);
            this.removeBodyEvent.body = null;
        }
    }
};
/**
 * Get a body by its id.
 * @method getBodyById
 * @param {number} id
 * @return {Body} The body, or false if it was not found.
 */ $cdf7a95ffc36e12c$var$World.prototype.getBodyById = function(id) {
    var bodies = this.bodies;
    for(var i = 0; i < bodies.length; i++){
        var b = bodies[i];
        if (b.id === id) return b;
    }
    return false;
};
/**
 * Disable collision between two bodies
 * @method disableBodyCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ $cdf7a95ffc36e12c$var$World.prototype.disableBodyCollision = function(bodyA, bodyB) {
    this.disabledBodyCollisionPairs.push(bodyA, bodyB);
};
/**
 * Enable collisions between the given two bodies
 * @method enableBodyCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ $cdf7a95ffc36e12c$var$World.prototype.enableBodyCollision = function(bodyA, bodyB) {
    var pairs = this.disabledBodyCollisionPairs;
    for(var i = 0; i < pairs.length; i += 2)if (pairs[i] === bodyA && pairs[i + 1] === bodyB || pairs[i + 1] === bodyA && pairs[i] === bodyB) {
        pairs.splice(i, 2);
        return;
    }
};
/**
 * Resets the World, removes all bodies, constraints and springs.
 *
 * @method clear
 */ $cdf7a95ffc36e12c$var$World.prototype.clear = function() {
    this.time = 0;
    // Remove all solver equations
    if (this.solver && this.solver.equations.length) this.solver.removeAllEquations();
    // Remove all constraints
    var cs = this.constraints;
    for(var i = cs.length - 1; i >= 0; i--)this.removeConstraint(cs[i]);
    // Remove all bodies
    var bodies = this.bodies;
    for(var i = bodies.length - 1; i >= 0; i--)this.removeBody(bodies[i]);
    // Remove all springs
    var springs = this.springs;
    for(var i = springs.length - 1; i >= 0; i--)this.removeSpring(springs[i]);
    // Remove all contact materials
    var cms = this.contactMaterials;
    for(var i = cms.length - 1; i >= 0; i--)this.removeContactMaterial(cms[i]);
    $cdf7a95ffc36e12c$var$World.apply(this);
};
var $cdf7a95ffc36e12c$var$hitTest_tmp1 = $2Ys9z.create(), $cdf7a95ffc36e12c$var$hitTest_zero = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$hitTest_tmp2 = $2Ys9z.fromValues(0, 0);
/**
 * Test if a world point overlaps bodies
 * @method hitTest
 * @param  {Array}  worldPoint  Point to use for intersection tests
 * @param  {Array}  bodies      A list of objects to check for intersection
 * @param  {Number} precision   Used for matching against particles and lines. Adds some margin to these infinitesimal objects.
 * @return {Array}              Array of bodies that overlap the point
 * @todo Should use an api similar to the raycast function
 * @todo Should probably implement a .containsPoint method for all shapes. Would be more efficient
 * @todo Should use the broadphase
 */ $cdf7a95ffc36e12c$var$World.prototype.hitTest = function(worldPoint, bodies, precision) {
    precision = precision || 0;
    // Create a dummy particle body with a particle shape to test against the bodies
    var pb = new $e7hLo({
        position: worldPoint
    }), ps = new $fwNHk(), px = worldPoint, pa = 0, x = $cdf7a95ffc36e12c$var$hitTest_tmp1, zero = $cdf7a95ffc36e12c$var$hitTest_zero, tmp = $cdf7a95ffc36e12c$var$hitTest_tmp2;
    pb.addShape(ps);
    var n = this.narrowphase, result = [];
    // Check bodies
    for(var i = 0, N = bodies.length; i !== N; i++){
        var b = bodies[i];
        for(var j = 0, NS = b.shapes.length; j !== NS; j++){
            var s = b.shapes[j];
            // Get shape world position + angle
            $2Ys9z.rotate(x, s.position, b.angle);
            $2Ys9z.add(x, x, b.position);
            var a = s.angle + b.angle;
            if (s instanceof $OJ0UJ && n.circleParticle(b, s, x, a, pb, ps, px, pa, true) || s instanceof $clDtn && n.particleConvex(pb, ps, px, pa, b, s, x, a, true) || s instanceof $hNAi3 && n.particlePlane(pb, ps, px, pa, b, s, x, a, true) || s instanceof $4flMw && n.particleCapsule(pb, ps, px, pa, b, s, x, a, true) || s instanceof $fwNHk && $2Ys9z.squaredLength($2Ys9z.sub(tmp, x, worldPoint)) < precision * precision) result.push(b);
        }
    }
    return result;
};
/**
 * Set the stiffness for all equations and contact materials.
 * @method setGlobalStiffness
 * @param {Number} stiffness
 */ $cdf7a95ffc36e12c$var$World.prototype.setGlobalStiffness = function(stiffness) {
    // Set for all constraints
    var constraints = this.constraints;
    for(var i = 0; i !== constraints.length; i++){
        var c = constraints[i];
        for(var j = 0; j !== c.equations.length; j++){
            var eq = c.equations[j];
            eq.stiffness = stiffness;
            eq.needsUpdate = true;
        }
    }
    // Set for all contact materials
    var contactMaterials = this.contactMaterials;
    for(var i = 0; i !== contactMaterials.length; i++){
        var c = contactMaterials[i];
        c.stiffness = c.frictionStiffness = stiffness;
    }
    // Set for default contact material
    var c = this.defaultContactMaterial;
    c.stiffness = c.frictionStiffness = stiffness;
};
/**
 * Set the relaxation for all equations and contact materials.
 * @method setGlobalRelaxation
 * @param {Number} relaxation
 */ $cdf7a95ffc36e12c$var$World.prototype.setGlobalRelaxation = function(relaxation) {
    // Set for all constraints
    for(var i = 0; i !== this.constraints.length; i++){
        var c = this.constraints[i];
        for(var j = 0; j !== c.equations.length; j++){
            var eq = c.equations[j];
            eq.relaxation = relaxation;
            eq.needsUpdate = true;
        }
    }
    // Set for all contact materials
    for(var i = 0; i !== this.contactMaterials.length; i++){
        var c = this.contactMaterials[i];
        c.relaxation = c.frictionRelaxation = relaxation;
    }
    // Set for default contact material
    var c = this.defaultContactMaterial;
    c.relaxation = c.frictionRelaxation = relaxation;
};
var $cdf7a95ffc36e12c$var$tmpAABB = new $hkl1e();
var $cdf7a95ffc36e12c$var$tmpArray = [];
/**
 * Ray cast against all bodies in the world.
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @return {boolean} True if any body was hit.
 *
 * @example
 *     var ray = new Ray({
 *         mode: Ray.CLOSEST, // or ANY
 *         from: [0, 0],
 *         to: [10, 0],
 *     });
 *     var result = new RaycastResult();
 *     world.raycast(result, ray);
 *
 *     // Get the hit point
 *     var hitPoint = vec2.create();
 *     result.getHitPoint(hitPoint, ray);
 *     console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
 *
 * @example
 *     var ray = new Ray({
 *         mode: Ray.ALL,
 *         from: [0, 0],
 *         to: [10, 0],
 *         callback: function(result){
 *
 *             // Print some info about the hit
 *             console.log('Hit body and shape: ', result.body, result.shape);
 *
 *             // Get the hit point
 *             var hitPoint = vec2.create();
 *             result.getHitPoint(hitPoint, ray);
 *             console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
 *
 *             // If you are happy with the hits you got this far, you can stop the traversal here:
 *             result.stop();
 *         }
 *     });
 *     var result = new RaycastResult();
 *     world.raycast(result, ray);
 */ $cdf7a95ffc36e12c$var$World.prototype.raycast = function(result, ray) {
    // Get all bodies within the ray AABB
    ray.getAABB($cdf7a95ffc36e12c$var$tmpAABB);
    this.broadphase.aabbQuery(this, $cdf7a95ffc36e12c$var$tmpAABB, $cdf7a95ffc36e12c$var$tmpArray);
    ray.intersectBodies(result, $cdf7a95ffc36e12c$var$tmpArray);
    $cdf7a95ffc36e12c$var$tmpArray.length = 0;
    return result.hasHit();
};

});
parcelRegister("hIDwd", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"p2\",\"version\":\"0.7.1\",\"description\":\"A JavaScript 2D physics engine.\",\"author\":\"Stefan Hedman <schteppe@gmail.com> (http://steffe.se)\",\"keywords\":[\"p2.js\",\"p2\",\"physics\",\"engine\",\"2d\"],\"main\":\"./src/p2.js\",\"engines\":{\"node\":\"*\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/schteppe/p2.js.git\"},\"bugs\":{\"url\":\"https://github.com/schteppe/p2.js/issues\"},\"licenses\":[{\"type\":\"MIT\"}],\"devDependencies\":{\"grunt\":\"^0.4.5\",\"grunt-contrib-jshint\":\"^0.11.2\",\"grunt-contrib-nodeunit\":\"^0.4.1\",\"grunt-contrib-uglify\":\"~0.4.0\",\"grunt-contrib-watch\":\"~0.5.0\",\"grunt-browserify\":\"~2.0.1\",\"grunt-contrib-concat\":\"^0.4.0\"},\"dependencies\":{\"poly-decomp\":\"0.1.1\"}}");

});

parcelRegister("lST4l", function(module, exports) {

var $jFBgF = parcelRequire("jFBgF");
parcelRequire("5IjXE");

var $8jYw9 = parcelRequire("8jYw9");
parcelRequire("dMz05");
module.exports = $fee95bb0a8dde0c7$var$OverlapKeeper;
/**
 * Keeps track of overlaps in the current state and the last step state.
 * @class OverlapKeeper
 * @constructor
 */ function $fee95bb0a8dde0c7$var$OverlapKeeper() {
    this.overlappingShapesLastState = new $jFBgF();
    this.overlappingShapesCurrentState = new $jFBgF();
    this.recordPool = new $8jYw9({
        size: 16
    });
    this.tmpDict = new $jFBgF();
    this.tmpArray1 = [];
}
/**
 * Ticks one step forward in time. This will move the current overlap state to the "old" overlap state, and create a new one as current.
 * @method tick
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.tick = function() {
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Save old objects into pool
    var l = last.keys.length;
    while(l--){
        var key = last.keys[l];
        var lastObject = last.getByKey(key);
        var currentObject = current.getByKey(key);
        if (lastObject) // The record is only used in the "last" dict, and will be removed. We might as well pool it.
        this.recordPool.release(lastObject);
    }
    // Clear last object
    last.reset();
    // Transfer from new object to old
    last.copy(current);
    // Clear current object
    current.reset();
};
/**
 * @method setOverlapping
 * @param {Body} bodyA
 * @param {Body} shapeA
 * @param {Body} bodyB
 * @param {Body} shapeB
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.setOverlapping = function(bodyA, shapeA, bodyB, shapeB) {
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Store current contact state
    if (!current.get(shapeA.id, shapeB.id)) {
        var data = this.recordPool.get();
        data.set(bodyA, shapeA, bodyB, shapeB);
        current.set(shapeA.id, shapeB.id, data);
    }
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getNewOverlaps = function(result) {
    return this.getDiff(this.overlappingShapesLastState, this.overlappingShapesCurrentState, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getEndOverlaps = function(result) {
    return this.getDiff(this.overlappingShapesCurrentState, this.overlappingShapesLastState, result);
};
/**
 * Checks if two bodies are currently overlapping.
 * @method bodiesAreOverlapping
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {boolean}
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.bodiesAreOverlapping = function(bodyA, bodyB) {
    var current = this.overlappingShapesCurrentState;
    var l = current.keys.length;
    while(l--){
        var key = current.keys[l];
        var data = current.data[key];
        if (data.bodyA === bodyA && data.bodyB === bodyB || data.bodyA === bodyB && data.bodyB === bodyA) return true;
    }
    return false;
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getDiff = function(dictA, dictB, result) {
    var result = result || [];
    var last = dictA;
    var current = dictB;
    result.length = 0;
    var l = current.keys.length;
    while(l--){
        var key = current.keys[l];
        var data = current.data[key];
        if (!data) throw new Error('Key ' + key + ' had no data!');
        var lastData = last.data[key];
        if (!lastData) // Not overlapping in last state, but in current.
        result.push(data);
    }
    return result;
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.isNewOverlap = function(shapeA, shapeB) {
    var idA = shapeA.id | 0, idB = shapeB.id | 0;
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Not in last but in new
    return !!!last.get(idA, idB) && !!current.get(idA, idB);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getNewBodyOverlaps = function(result) {
    this.tmpArray1.length = 0;
    var overlaps = this.getNewOverlaps(this.tmpArray1);
    return this.getBodyDiff(overlaps, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getEndBodyOverlaps = function(result) {
    this.tmpArray1.length = 0;
    var overlaps = this.getEndOverlaps(this.tmpArray1);
    return this.getBodyDiff(overlaps, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getBodyDiff = function(overlaps, result) {
    result = result || [];
    var accumulator = this.tmpDict;
    var l = overlaps.length;
    while(l--){
        var data = overlaps[l];
        // Since we use body id's for the accumulator, these will be a subset of the original one
        accumulator.set(data.bodyA.id | 0, data.bodyB.id | 0, data);
    }
    l = accumulator.keys.length;
    while(l--){
        var data = accumulator.getByKey(accumulator.keys[l]);
        if (data) result.push(data.bodyA, data.bodyB);
    }
    accumulator.reset();
    return result;
};

});
parcelRegister("5IjXE", function(module, exports) {
module.exports = $42908ba6b1df7d06$var$OverlapKeeperRecord;
/**
 * Overlap data container for the OverlapKeeper
 * @class OverlapKeeperRecord
 * @constructor
 * @param {Body} bodyA
 * @param {Shape} shapeA
 * @param {Body} bodyB
 * @param {Shape} shapeB
 */ function $42908ba6b1df7d06$var$OverlapKeeperRecord(bodyA, shapeA, bodyB, shapeB) {
    /**
     * @property {Shape} shapeA
     */ this.shapeA = shapeA;
    /**
     * @property {Shape} shapeB
     */ this.shapeB = shapeB;
    /**
     * @property {Body} bodyA
     */ this.bodyA = bodyA;
    /**
     * @property {Body} bodyB
     */ this.bodyB = bodyB;
}
/**
 * Set the data for the record
 * @method set
 * @param {Body} bodyA
 * @param {Shape} shapeA
 * @param {Body} bodyB
 * @param {Shape} shapeB
 */ $42908ba6b1df7d06$var$OverlapKeeperRecord.prototype.set = function(bodyA, shapeA, bodyB, shapeB) {
    $42908ba6b1df7d06$var$OverlapKeeperRecord.call(this, bodyA, shapeA, bodyB, shapeB);
};

});

parcelRegister("8jYw9", function(module, exports) {

var $5IjXE = parcelRequire("5IjXE");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $60ef0a975cb5d592$var$OverlapKeeperRecordPool;
/**
 * @class
 */ function $60ef0a975cb5d592$var$OverlapKeeperRecordPool() {
    $kaNFS.apply(this, arguments);
}
$60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype = new $kaNFS();
$60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.constructor = $60ef0a975cb5d592$var$OverlapKeeperRecordPool;
/**
 * @method create
 * @return {OverlapKeeperRecord}
 */ $60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.create = function() {
    return new $5IjXE();
};
/**
 * @method destroy
 * @param {OverlapKeeperRecord} record
 * @return {OverlapKeeperRecordPool}
 */ $60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.destroy = function(record) {
    record.bodyA = record.bodyB = record.shapeA = record.shapeB = null;
    return this;
};

});


parcelRegister("9JhUu", function(module, exports) {
parcelRequire("2Ys9z");
parcelRequire("Nc8B5");
parcelRequire("41pPr");

var $kQdy2 = parcelRequire("kQdy2");

var $3HB0m = parcelRequire("3HB0m");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $715635955fbf123c$var$IslandManager;
/**
 * Splits the system of bodies and equations into independent islands
 *
 * @class IslandManager
 * @constructor
 * @param {Object} [options]
 * @extends Solver
 */ function $715635955fbf123c$var$IslandManager(options) {
    /**
     * @property nodePool
     * @type {IslandNodePool}
     */ this.nodePool = new $kQdy2({
        size: 16
    });
    /**
     * @property islandPool
     * @type {IslandPool}
     */ this.islandPool = new $3HB0m({
        size: 8
    });
    /**
     * The equations to split. Manually fill this array before running .split().
     * @property {Array} equations
     */ this.equations = [];
    /**
     * The resulting {{#crossLink "Island"}}{{/crossLink}}s.
     * @property {Array} islands
     */ this.islands = [];
    /**
     * The resulting graph nodes.
     * @property {Array} nodes
     */ this.nodes = [];
    /**
     * The node queue, used when traversing the graph of nodes.
     * @private
     * @property {Array} queue
     */ this.queue = [];
}
/**
 * Get an unvisited node from a list of nodes.
 * @static
 * @method getUnvisitedNode
 * @param  {Array} nodes
 * @return {IslandNode|boolean} The node if found, else false.
 */ $715635955fbf123c$var$IslandManager.getUnvisitedNode = function(nodes) {
    var Nnodes = nodes.length;
    for(var i = 0; i !== Nnodes; i++){
        var node = nodes[i];
        if (!node.visited && node.body.type === $e7hLo.DYNAMIC) return node;
    }
    return false;
};
/**
 * Visit a node.
 * @method visit
 * @param  {IslandNode} node
 * @param  {Array} bds
 * @param  {Array} eqs
 */ $715635955fbf123c$var$IslandManager.prototype.visit = function(node, bds, eqs) {
    bds.push(node.body);
    var Neqs = node.equations.length;
    for(var i = 0; i !== Neqs; i++){
        var eq = node.equations[i];
        if (eqs.indexOf(eq) === -1) eqs.push(eq);
    }
};
/**
 * Runs the search algorithm, starting at a root node. The resulting bodies and equations will be stored in the provided arrays.
 * @method bfs
 * @param  {IslandNode} root The node to start from
 * @param  {Array} bds  An array to append resulting Bodies to.
 * @param  {Array} eqs  An array to append resulting Equations to.
 */ $715635955fbf123c$var$IslandManager.prototype.bfs = function(root, bds, eqs) {
    // Reset the visit queue
    var queue = this.queue;
    queue.length = 0;
    // Add root node to queue
    queue.push(root);
    root.visited = true;
    this.visit(root, bds, eqs);
    // Process all queued nodes
    while(queue.length){
        // Get next node in the queue
        var node = queue.pop();
        // Visit unvisited neighboring nodes
        var child;
        while(child = $715635955fbf123c$var$IslandManager.getUnvisitedNode(node.neighbors)){
            child.visited = true;
            this.visit(child, bds, eqs);
            // Only visit the children of this node if it's dynamic
            if (child.body.type === $e7hLo.DYNAMIC) queue.push(child);
        }
    }
};
/**
 * Split the world into independent islands. The result is stored in .islands.
 * @method split
 * @param  {World} world
 * @return {Array} The generated islands
 */ $715635955fbf123c$var$IslandManager.prototype.split = function(world) {
    var bodies = world.bodies, nodes = this.nodes, equations = this.equations;
    // Move old nodes to the node pool
    while(nodes.length)this.nodePool.release(nodes.pop());
    // Create needed nodes, reuse if possible
    for(var i = 0; i !== bodies.length; i++){
        var node = this.nodePool.get();
        node.body = bodies[i];
        nodes.push(node);
    // if(this.nodePool.length){
    //     var node = this.nodePool.pop();
    //     node.reset();
    //     node.body = bodies[i];
    //     nodes.push(node);
    // } else {
    //     nodes.push(new IslandNode(bodies[i]));
    // }
    }
    // Add connectivity data. Each equation connects 2 bodies.
    for(var k = 0; k !== equations.length; k++){
        var eq = equations[k], i = bodies.indexOf(eq.bodyA), j = bodies.indexOf(eq.bodyB), ni = nodes[i], nj = nodes[j];
        ni.neighbors.push(nj);
        nj.neighbors.push(ni);
        ni.equations.push(eq);
        nj.equations.push(eq);
    }
    // Move old islands to the island pool
    var islands = this.islands;
    for(var i = 0; i < islands.length; i++)this.islandPool.release(islands[i]);
    islands.length = 0;
    // Get islands
    var child;
    while(child = $715635955fbf123c$var$IslandManager.getUnvisitedNode(nodes)){
        // Create new island
        var island = this.islandPool.get();
        // Get all equations and bodies in this island
        this.bfs(child, island.bodies, island.equations);
        islands.push(island);
    }
    return islands;
};

});
parcelRegister("Nc8B5", function(module, exports) {

var $e7hLo = parcelRequire("e7hLo");
module.exports = $093dfe014d5a9292$var$Island;
/**
 * An island of bodies connected with equations.
 * @class Island
 * @constructor
 */ function $093dfe014d5a9292$var$Island() {
    /**
     * Current equations in this island.
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * Current bodies in this island.
     * @property bodies
     * @type {Array}
     */ this.bodies = [];
}
/**
 * Clean this island from bodies and equations.
 * @method reset
 */ $093dfe014d5a9292$var$Island.prototype.reset = function() {
    this.equations.length = this.bodies.length = 0;
};
var $093dfe014d5a9292$var$bodyIds = [];
/**
 * Get all unique bodies in this island.
 * @method getBodies
 * @return {Array} An array of Body
 */ $093dfe014d5a9292$var$Island.prototype.getBodies = function(result) {
    var bodies = result || [], eqs = this.equations;
    $093dfe014d5a9292$var$bodyIds.length = 0;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        if ($093dfe014d5a9292$var$bodyIds.indexOf(eq.bodyA.id) === -1) {
            bodies.push(eq.bodyA);
            $093dfe014d5a9292$var$bodyIds.push(eq.bodyA.id);
        }
        if ($093dfe014d5a9292$var$bodyIds.indexOf(eq.bodyB.id) === -1) {
            bodies.push(eq.bodyB);
            $093dfe014d5a9292$var$bodyIds.push(eq.bodyB.id);
        }
    }
    return bodies;
};
/**
 * Check if the entire island wants to sleep.
 * @method wantsToSleep
 * @return {Boolean}
 */ $093dfe014d5a9292$var$Island.prototype.wantsToSleep = function() {
    for(var i = 0; i < this.bodies.length; i++){
        var b = this.bodies[i];
        if (b.type === $e7hLo.DYNAMIC && !b.wantsToSleep) return false;
    }
    return true;
};
/**
 * Make all bodies in the island sleep.
 * @method sleep
 */ $093dfe014d5a9292$var$Island.prototype.sleep = function() {
    for(var i = 0; i < this.bodies.length; i++){
        var b = this.bodies[i];
        b.sleep();
    }
    return true;
};

});

parcelRegister("41pPr", function(module, exports) {
module.exports = $2edb4a7c51a2c2bf$var$IslandNode;
/**
 * Holds a body and keeps track of some additional properties needed for graph traversal.
 * @class IslandNode
 * @constructor
 * @param {Body} body
 */ function $2edb4a7c51a2c2bf$var$IslandNode(body) {
    /**
	 * The body that is contained in this node.
	 * @property {Body} body
	 */ this.body = body;
    /**
     * Neighboring IslandNodes
     * @property {Array} neighbors
     */ this.neighbors = [];
    /**
     * Equations connected to this node.
     * @property {Array} equations
     */ this.equations = [];
    /**
     * If this node was visiting during the graph traversal.
     * @property visited
     * @type {Boolean}
     */ this.visited = false;
}
/**
 * Clean this node from bodies and equations.
 * @method reset
 */ $2edb4a7c51a2c2bf$var$IslandNode.prototype.reset = function() {
    this.equations.length = 0;
    this.neighbors.length = 0;
    this.visited = false;
    this.body = null;
};

});

parcelRegister("kQdy2", function(module, exports) {

var $41pPr = parcelRequire("41pPr");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $f2c32c4db917f534$var$IslandNodePool;
/**
 * @class
 */ function $f2c32c4db917f534$var$IslandNodePool() {
    $kaNFS.apply(this, arguments);
}
$f2c32c4db917f534$var$IslandNodePool.prototype = new $kaNFS();
$f2c32c4db917f534$var$IslandNodePool.prototype.constructor = $f2c32c4db917f534$var$IslandNodePool;
/**
 * @method create
 * @return {IslandNode}
 */ $f2c32c4db917f534$var$IslandNodePool.prototype.create = function() {
    return new $41pPr();
};
/**
 * @method destroy
 * @param {IslandNode} node
 * @return {IslandNodePool}
 */ $f2c32c4db917f534$var$IslandNodePool.prototype.destroy = function(node) {
    node.reset();
    return this;
};

});

parcelRegister("3HB0m", function(module, exports) {

var $Nc8B5 = parcelRequire("Nc8B5");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $2b22179ccdf77f84$var$IslandPool;
/**
 * @class
 */ function $2b22179ccdf77f84$var$IslandPool() {
    $kaNFS.apply(this, arguments);
}
$2b22179ccdf77f84$var$IslandPool.prototype = new $kaNFS();
$2b22179ccdf77f84$var$IslandPool.prototype.constructor = $2b22179ccdf77f84$var$IslandPool;
/**
 * @method create
 * @return {Island}
 */ $2b22179ccdf77f84$var$IslandPool.prototype.create = function() {
    return new $Nc8B5();
};
/**
 * @method destroy
 * @param {Island} island
 * @return {IslandPool}
 */ $2b22179ccdf77f84$var$IslandPool.prototype.destroy = function(island) {
    island.reset();
    return this;
};

});




parcelRegister("gehDP", function(module, exports) {

$parcel$export(module.exports, "LAYERS", () => $4fdefd1822880974$export$fdca3ba65b5cceec);
$parcel$export(module.exports, "DEFAULT_LAYER", () => $4fdefd1822880974$export$3d0b505b9576cf7e);

var $39Dnl = parcelRequire("39Dnl");

var $cbsax = parcelRequire("cbsax");
const $4fdefd1822880974$export$fdca3ba65b5cceec = {
    // Background effects layer - renders behind main layer
    background: new (0, $39Dnl.LayerInfo)(),
    // Main game world layer - moves with camera
    main: new (0, $39Dnl.LayerInfo)(),
    // User interface layer - stays fixed on screen
    ui: new (0, $39Dnl.LayerInfo)({
        paralax: (0, $cbsax.V)(0, 0)
    }),
    // HUD background layer - stays fixed on screen, renders behind HUD elements
    menuBackground: new (0, $39Dnl.LayerInfo)({
        paralax: (0, $cbsax.V)(0, 0)
    }),
    // Menu layer
    menu: new (0, $39Dnl.LayerInfo)({
        paralax: (0, $cbsax.V)(0, 0)
    }),
    // Debug overlay layer - stays fixed on screen, renders on top
    debugHud: new (0, $39Dnl.LayerInfo)({
        paralax: (0, $cbsax.V)(0, 0)
    }),
    // Mouse cursor. This should always be on top of everything else.
    cursor: new (0, $39Dnl.LayerInfo)({
        paralax: (0, $cbsax.V)(0, 0)
    })
};
const $4fdefd1822880974$export$3d0b505b9576cf7e = "main";

});
parcelRegister("39Dnl", function(module, exports) {

$parcel$export(module.exports, "LayerInfo", () => $348f60db61f8cc25$export$ee4b0c6dc2df0875);
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");

var $cbsax = parcelRequire("cbsax");
class $348f60db61f8cc25$export$ee4b0c6dc2df0875 {
    /**
   * Creates a new LayerInfo with the specified configuration.
   *
   * @param options - Layer configuration options
   * @param options.paralax - Camera movement response [x, y] (default: [1, 1])
   * @param options.anchor - Transformation origin [x, y] (default: [0, 0])
   * @param options.filters - Visual filters to apply (default: [])
   * @param options.alpha - Layer transparency (default: 1.0)
   */ constructor({ paralax: paralax = (0, $cbsax.V)(1.0, 1.0), anchor: anchor = (0, $cbsax.V)(0, 0), filters: filters = [], alpha: alpha = 1.0 } = {}){
        this.container = new $eicwU.Container();
        this.paralax = paralax;
        this.anchor = anchor;
        this.container.filters = filters;
        this.container.alpha = alpha;
    }
}

});
parcelRegister("cbsax", function(module, exports) {

$parcel$export(module.exports, "V", () => $6b6a54a072724620$export$e7c866399fa523f5);
$parcel$export(module.exports, "V2d", () => $6b6a54a072724620$export$19606695c7c6ab3a);

var $jd0t2 = parcelRequire("jd0t2");
function $6b6a54a072724620$export$e7c866399fa523f5(x, y) {
    if (x instanceof $6b6a54a072724620$export$19606695c7c6ab3a) return x.clone();
    else if (x instanceof Array || x instanceof Float32Array) return new $6b6a54a072724620$export$19606695c7c6ab3a(x[0], x[1]);
    return new $6b6a54a072724620$export$19606695c7c6ab3a(x ?? 0, y ?? x ?? 0);
}
class $6b6a54a072724620$export$19606695c7c6ab3a extends Array {
    constructor(x, y){
        super(), this.length = 2;
        if (isNaN(x) || isNaN(y)) throw new Error(`Can't make a V2d with NaN ${x},${y}`);
        this[0] = x;
        this[1] = y;
    }
    get v() {
        return this;
    }
    /** Return the result of adding this vector to another. */ add(other) {
        return this.clone().iadd(other);
    }
    /** (In Place) Return the result of adding this vector to another. */ iadd(other) {
        this[0] += other[0];
        this[1] += other[1];
        return this;
    }
    /** Return the result of multiplying a scalar by another vector and adding it to this. */ addScaled(other, scale) {
        return this.clone().iaddScaled(other, scale);
    }
    /** (In Place) Return the result of multiplying a scalar by another vector and adding it to this. */ iaddScaled(other, scale = 1) {
        this[0] += other[0] * scale;
        this[1] += other[1] * scale;
        return this;
    }
    /** Return the result of subtracting a vector from this one. */ sub(other) {
        return this.clone().isub(other);
    }
    /** (In Place) Return the result of subtracting a vector from this one. */ isub(other) {
        this[0] -= other[0];
        this[1] -= other[1];
        return this;
    }
    /** Return the result of multiplying this vector by a scalar. */ mul(scalar) {
        return this.clone().imul(scalar);
    }
    /** (In Place) Return the result of multiplying this vector by a scalar. */ imul(scalar) {
        this[0] *= scalar;
        this[1] *= scalar;
        return this;
    }
    /** Return the result of multiplying this vector by another vector componentwise. */ mulComponent(other) {
        return this.clone().imulComponent(other);
    }
    /** (In Place) Return the result of multiplying this vector by another vector componentwise. */ imulComponent(other) {
        this[0] *= other[0];
        this[1] *= other[1];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees clockwise */ rotate90cw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[1], -this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees clockwise */ irotate90cw() {
        [this[0], this[1]] = [
            this[1],
            -this[0]
        ];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees counter-clockwise */ rotate90ccw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(-this[1], this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees counter-clockwise */ irotate90ccw() {
        [this[0], this[1]] = [
            -this[1],
            this[0]
        ];
        return this;
    }
    /** Return the result of rotating this angle by `angle` radians ccw. */ rotate(angle) {
        return this.clone().irotate(angle);
    }
    /** (In Place) Return the result of rotating this angle by `angle` radians ccw. */ irotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = this[0];
        const y = this[1];
        this[0] = cos * x - sin * y;
        this[1] = sin * x + cos * y;
        return this;
    }
    /** Return the dot product of this and another vector */ dot(other) {
        return this[0] * other[0] + this[1] * other[1];
    }
    set(x, y) {
        if (typeof x === "number") {
            this[0] = x;
            this[1] = y;
        } else {
            this[0] = x[0];
            this[1] = x[1];
        }
        return this;
    }
    /** Return a normalized version of this vector */ normalize(length = 1) {
        return this.clone().inormalize(length);
    }
    /** (In Place) Return a normalized version of this vector */ inormalize(length = 1) {
        if (!(this[0] === 0 && this[1] === 0)) this.magnitude = length;
        return this;
    }
    /**
   * Returns a new vector with magnitude limited to the specified maximum.
   * If current magnitude is less than max, returns unchanged vector.
   * @param max - Maximum allowed magnitude
   * @returns New vector with limited magnitude
   */ limit(max) {
        return this.clone().ilimit(max);
    }
    /**
   * (In-place) Limits this vector's magnitude to the specified maximum.
   * If current magnitude is less than max, vector remains unchanged.
   * @param max - Maximum allowed magnitude
   * @returns This vector for method chaining
   */ ilimit(max) {
        if (this.magnitude > max) this.magnitude = max;
        return this;
    }
    /** Return a new vector with the same values as this one */ clone() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[0], this[1]);
    }
    /** Return a vector that is between this and other */ lerp(other, t = 0) {
        return this.clone().ilerp(other, t);
    }
    /** (In place) Return a vector that is between this and other */ ilerp(other, t = 0) {
        this[0] = (0, $jd0t2.lerp)(this[0], other[0], t);
        this[1] = (0, $jd0t2.lerp)(this[1], other[1], t);
        return this;
    }
    equals(other) {
        return other != undefined && other[0] == this[0] && other[1] == this[1];
    }
    /**
   * Alias for [0].
   */ get x() {
        return this[0];
    }
    set x(value) {
        this[0] = value;
    }
    /**
   * Alias for [1]
   */ get y() {
        return this[1];
    }
    set y(value) {
        this[1] = value;
    }
    /**
   * The magnitude (length) of this vector.
   * Changing it does not change the angle.
   */ get magnitude() {
        return Math.sqrt(this[0] * this[0] + this[1] * this[1]) || 0;
    }
    set magnitude(value) {
        if (this[0] !== 0 || this[1] !== 0) this.imul(value / this.magnitude);
    }
    /**
   * The angle in radians ccw from east of this vector.
   * Changing it does not change the magnitude.
   */ get angle() {
        return Math.atan2(this[1], this[0]);
    }
    set angle(value) {
        this.irotate(value - this.angle);
    }
}

});
parcelRegister("jd0t2", function(module, exports) {

$parcel$export(module.exports, "GOLDEN_RATIO", () => $2172aedd5a25ff17$export$c6140092ef9278ff);
$parcel$export(module.exports, "mod", () => $2172aedd5a25ff17$export$842a2cf37af977e1);
$parcel$export(module.exports, "clampUp", () => $2172aedd5a25ff17$export$f982906e4d317fcc);
$parcel$export(module.exports, "clamp", () => $2172aedd5a25ff17$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "lerp", () => $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "ilerp", () => $2172aedd5a25ff17$export$7fd48e0d5697c0a3);
$parcel$export(module.exports, "lerpLerp", () => $2172aedd5a25ff17$export$bb8abe96b4978817);
$parcel$export(module.exports, "lerpV2d", () => $2172aedd5a25ff17$export$249619bf5c02b900);
$parcel$export(module.exports, "lerpOrSnap", () => $2172aedd5a25ff17$export$e4d952dcf42a5ff5);
$parcel$export(module.exports, "normalizeAngle", () => $2172aedd5a25ff17$export$e3df76cf4464bc81);
$parcel$export(module.exports, "angleDelta", () => $2172aedd5a25ff17$export$ff5848069bdbaf5a);
$parcel$export(module.exports, "polarToVec", () => $2172aedd5a25ff17$export$240e5320db1c20ee);
$parcel$export(module.exports, "stepToward", () => $2172aedd5a25ff17$export$b26f3c29b28fecef);
$parcel$export(module.exports, "noteToFrequency", () => $2172aedd5a25ff17$export$3e4adc039be3c924);

var $cbsax = parcelRequire("cbsax");
const $2172aedd5a25ff17$export$c6140092ef9278ff = 1.618;
function $2172aedd5a25ff17$export$842a2cf37af977e1(a, b) {
    return (a % b + b) % b;
}
function $2172aedd5a25ff17$export$f982906e4d317fcc(value) {
    return Math.max(value, 0);
}
function $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(max, value));
}
function $2172aedd5a25ff17$export$56196e15071099de(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 3 * t ** 2 - 2 * t ** 3;
}
function $2172aedd5a25ff17$export$92900799e793e1cd(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 6 * t ** 5 - 15 * t ** 4 + 10 * t ** 3;
}
function $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t = 0.5) {
    return (1 - t) * a + t * b;
}
function $2172aedd5a25ff17$export$7fd48e0d5697c0a3(a, b, value) {
    if (a === b) return 0; // Avoid division by zero
    return $2172aedd5a25ff17$export$7d15b64cf5a3a4c4((value - a) / (b - a));
}
function $2172aedd5a25ff17$export$bb8abe96b4978817(inputRange, outputRange, value) {
    const t = $2172aedd5a25ff17$export$7fd48e0d5697c0a3(inputRange[0], inputRange[1], value);
    return $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(outputRange[0], outputRange[1], t);
}
function $2172aedd5a25ff17$export$249619bf5c02b900(a, b, t = 0.5) {
    const x = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[0], b[0], t);
    const y = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[1], b[1], t);
    return (0, $cbsax.V)(x, y);
}
function $2172aedd5a25ff17$export$e4d952dcf42a5ff5(a, b, t = 0.5, threshold = 0.01) {
    if (Math.abs(b - a) < threshold) return b;
    return $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t);
}
function $2172aedd5a25ff17$export$e3df76cf4464bc81(angle) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(angle + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$ff5848069bdbaf5a(a, b) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(b - a + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * Math.PI / 180;
}
function $2172aedd5a25ff17$export$54390e3b44c4a9cb(radians) {
    return radians * 180 / Math.PI;
}
function $2172aedd5a25ff17$export$33ee1f58d7bb6e30(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(Math.PI - theta);
}
function $2172aedd5a25ff17$export$f20e6a45c2713c2c(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(-theta);
}
function $2172aedd5a25ff17$export$d429e27eb9ce77d1(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(theta - Math.PI);
}
function $2172aedd5a25ff17$export$240e5320db1c20ee(theta, r) {
    return (0, $cbsax.V)(r * Math.cos(theta), r * Math.sin(theta));
}
function $2172aedd5a25ff17$export$d9385b944d276332(points) {
    let total = 0;
    for(let i = 1; i < points.length; i++){
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        total += (x2 - x1) * (y2 + y1);
    }
    return total > 0;
}
function $2172aedd5a25ff17$export$b26f3c29b28fecef(from, to, stepSize) {
    if (to > from) return Math.min(from + stepSize, to);
    else return Math.max(from - stepSize, to);
}
function $2172aedd5a25ff17$export$3e4adc039be3c924(noteNumber) {
    return 440 * Math.pow(2, (noteNumber - 69) / 12);
}

});




parcelRegister("e2Ri5", function(module, exports) {

$parcel$export(module.exports, "PersistenceLevel", () => $574f0445b7f3e5b6$export$fd7cad3db969c1e1);
/** Levels of persistence for entities. Determines at what lifecycle stages the entity is cleaned up. */ var $574f0445b7f3e5b6$export$fd7cad3db969c1e1 = /*#__PURE__*/ function(PersistenceLevel) {
    /** DEFAULT, cleared at the end of each level */ PersistenceLevel[PersistenceLevel["Level"] = 0] = "Level";
    /** Cleared at the end of each game */ PersistenceLevel[PersistenceLevel["Game"] = 1] = "Game";
    /** Never cleared */ PersistenceLevel[PersistenceLevel["Permanent"] = 2] = "Permanent";
    return PersistenceLevel;
}({});

});

parcelRegister("9iM1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9da4ea4870251b3$export$2e2bcd8739ae039);

var $2oYNi = parcelRequire("2oYNi");

var $04rLh = parcelRequire("04rLh");

var $adOUJ = parcelRequire("adOUJ");

var $hf1qb = parcelRequire("hf1qb");

var $18ihr = parcelRequire("18ihr");

var $7ZE7Q = parcelRequire("7ZE7Q");

var $gDKQe = parcelRequire("gDKQe");

var $knYRz = parcelRequire("knYRz");

var $fsTIF = parcelRequire("fsTIF");
class $d9da4ea4870251b3$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    /**
   * Get the TempoClock entity for access by other systems like BloomController
   */ get tempoClock() {
        const maybeTempoClock = this.game?.entities.getById("tempoClock");
        if (maybeTempoClock instanceof (0, $fsTIF.TempoClock)) return maybeTempoClock;
        throw new Error("TempoClock entity is not available");
    }
    /**
   * Initialize the structured music system with all required components.
   * Creates timing, control, master composer, and structured instruments.
   */ onAdd() {
        if (!this.game?.audio) throw new Error("No audio context available for music generator");
        if (!this.game?.masterGain) throw new Error("No master gain node available for music generator");
        // Initialize core music timing and control
        this.addChild(new (0, $fsTIF.TempoClock)(this.params.tempo));
        this.addChild(new (0, $knYRz.default)());
        // Initialize master composer for coordinated music generation
        const masterComposer = new (0, $hf1qb.MasterComposer)();
        this.addChild(masterComposer);
        // Add structured instruments with their composers using InstrumentPlayer
        this.addChild(new (0, $18ihr.InstrumentPlayer)(new (0, $04rLh.BassComposer)(), masterComposer, new (0, $7ZE7Q.BassInstrument)(this.game.audio, this.game.masterGain)));
        this.addChild(new (0, $18ihr.InstrumentPlayer)(new (0, $adOUJ.DrumsComposer)(), masterComposer, new (0, $gDKQe.DrumsInstrument)(this.game.audio, this.game.masterGain)));
    // this.addChild(
    //   new InstrumentPlayer(
    //     new StabComposer(masterComposer),
    //     masterComposer,
    //     new StabInstrument(this.game.audio, this.game.masterGain),
    //   ),
    // );
    }
    getInstruments() {
        return this.children.filter((child)=>child instanceof (0, $18ihr.InstrumentPlayer));
    }
    /**
   * Update music parameters that affect all composers.
   * Changes are applied immediately via MasterComposer and composers will use
   * the new values on their next beat generation.
   */ setParams(newParams) {
        this.params = {
            ...this.params,
            ...newParams
        };
        // Apply tempo changes to the timing system
        if (this.tempoClock && newParams.tempo !== undefined) this.tempoClock.setTempo(this.params.tempo);
        // Update master composer with new parameters
        const masterComposer = this.game?.entities.getById("masterComposer");
        if (masterComposer) masterComposer.setParams({
            intensity: this.params.intensity,
            tempo: this.params.tempo
        });
    }
    getParams() {
        return {
            ...this.params
        };
    }
    /**
   * Request a tempo change for dynamic music response.
   * This is the interface that game systems should use to change tempo.
   */ requestTempoChange(newBpm, options) {
        const tempoClock = this.tempoClock;
        if (!tempoClock) return;
        if (options?.immediate) tempoClock.setTempo(newBpm);
        else {
            // Default: apply at the next measure boundary for musical smoothness
            const currentBeat = tempoClock.getCurrentBeatNumber();
            const nextMeasure = Math.ceil(currentBeat / 4) * 4;
            const targetBeat = options?.atBeat ?? nextMeasure;
            tempoClock.scheduleTempo(newBpm, targetBeat);
        }
        // Update internal tempo parameter to match
        this.params.tempo = newBpm;
    }
    /**
   * Gradually change tempo over time (accelerando/ritardando)
   */ requestTempoRamp(fromBpm, toBpm, durationBeats) {
        const tempoClock = this.tempoClock;
        if (!tempoClock) return;
        const currentBeat = tempoClock.getCurrentBeatNumber();
        const steps = Math.max(4, Math.floor(durationBeats / 2)); // At least 4 steps, every 2 beats
        for(let i = 0; i <= steps; i++){
            const progress = i / steps;
            const interpolatedBpm = fromBpm + (toBpm - fromBpm) * progress;
            const targetBeat = currentBeat + durationBeats * progress;
            tempoClock.scheduleTempo(interpolatedBpm, targetBeat);
        }
        // Update internal tempo parameter to final value
        this.params.tempo = toBpm;
    }
    /**
   * Get current tempo in BPM for game systems
   */ getCurrentTempo() {
        return this.tempoClock?.getCurrentTempo() ?? this.params.tempo;
    }
    constructor(...args){
        super(...args), this.tags = [
            "musicGenerator"
        ], this.id = "musicGenerator", this.pausable = false // Keep music playing during game pause
        , /** Current music parameters affecting all composers */ this.params = {
            intensity: 0.3,
            tempo: 130
        };
    }
}

});
parcelRegister("2oYNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59361981bac2575$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");

var $e2Ri5 = parcelRequire("e2Ri5");

var $jd0t2 = parcelRequire("jd0t2");

var $cg2iY = parcelRequire("cg2iY");

var $cbsax = parcelRequire("cbsax");

var $c4Qw3 = parcelRequire("c4Qw3");
class $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(entityDef){
        this.children = [];
        this.game = undefined;
        this.pausable = true;
        this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Level;
        this.tags = [];
        if (entityDef) this.loadFromDef(entityDef);
    }
    loadFromDef(def) {
        if (this.game) throw new Error("Can't load from def after entity has been added to game.");
        if (def.sprites) {
            if (def.sprites.length === 1) this.sprite = (0, $c4Qw3.spriteFromDef)(def.sprites[0]);
            else this.sprites = def.sprites.map((spriteDef)=>(0, $c4Qw3.spriteFromDef)(spriteDef));
        }
        if (def.body) {
            this.body = new (0, $biKyI.Body)({
                mass: def.body.mass
            });
            for (const shapeDef of def.body.shapes){
                const shape = (0, $cg2iY.shapeFromDef)(shapeDef);
                this.body.addShape(shape, shape.position, shape.angle);
            }
        }
    }
    /**
   * Convert local coordinates to world coordinates.
   *
   * Local coordinates are relative to this entity's position and rotation.
   * World coordinates are absolute positions in the physics world.
   *
   * Requires this entity to have a physics body for the transformation.
   *
   * @param localPoint Point in local space relative to entity center
   * @returns Point in world space coordinates
   *
   * @example
   * // Get world position of a point 10 units to the right of entity
   * const rightOfEntity = this.localToWorld([10, 0]);
   *
   * // Get world position of entity's "gun barrel" offset
   * const barrelTip = this.localToWorld([0, -30]); // 30 units up from center
   */ localToWorld(localPoint) {
        if (this.body) {
            const result = (0, $cbsax.V)(0, 0);
            this.body.toWorldFrame(result, localPoint);
            return result;
        }
        return (0, $cbsax.V)(0, 0);
    }
    /**
   * Convert world coordinates to local coordinates.
   *
   * World coordinates are absolute positions in the physics world.
   * Local coordinates are relative to this entity's position and rotation.
   *
   * Requires this entity to have a physics body for the transformation.
   *
   * @param worldPoint Point in world space coordinates
   * @returns Point in local space relative to entity center
   *
   * @example
   * // Convert mouse position to local entity coordinates
   * const mouseWorld = game.camera.screenToWorld(mousePosition);
   * const mouseLocal = this.worldToLocal(mouseWorld);
   *
   * // Check if a world point is "in front" of this entity
   * const targetLocal = this.worldToLocal(target.getPosition());
   * const isInFront = targetLocal.y < 0; // Negative Y is "up" in local space
   */ worldToLocal(worldPoint) {
        if (this.body) {
            const result = (0, $cbsax.V)(0, 0);
            this.body.toLocalFrame(result, worldPoint);
            return result;
        }
        return (0, $cbsax.V)(0, 0);
    }
    /**
   * Get the current world position of this entity.
   *
   * Returns the position from the physics body if available, otherwise
   * falls back to the sprite position. Throws an error if neither exists.
   *
   * @returns Current world position as a Vector
   *
   * @example
   * // Get distance between two entities
   * const distance = this.getPosition().distance(target.getPosition());
   *
   * // Move towards a target
   * const direction = target.getPosition().sub(this.getPosition()).normalize();
   * this.body.velocity = direction.imul(speed);
   */ getPosition() {
        if (this.body) return (0, $cbsax.V)(this.body.position);
        else if (this.sprite) return (0, $cbsax.V)(this.sprite.position.x, this.sprite.position.y);
        throw new Error("Position is not implemented for this entity");
    }
    isDestroyed() {
        return this.game == undefined;
    }
    isAlive() {
        return this.game != undefined;
    }
    // Removes this from the game. You probably shouldn't override this method.
    destroy() {
        if (this.game) {
            this.game.removeEntity(this);
            while(this.children?.length)this.children[this.children.length - 1].destroy();
            if (this.parent) {
                const pChildren = this.parent.children;
                const index = pChildren.lastIndexOf(this);
                if (index < 0) throw new Error(`Parent doesn't have child`);
                pChildren.splice(index, 1);
            }
        }
    }
    /**
   * Add another entity as a child of this entity.
   *
   * Child entities are automatically managed by their parent:
   * - Added to game when parent is added (if parent is already in game)
   * - Destroyed when parent is destroyed
   * - Can access parent via child.parent property
   *
   * This is useful for creating composite entities (turret with base + barrel),
   * temporary effects (explosion with multiple particle systems), or any
   * hierarchical organization.
   *
   * @param child Entity to add as a child
   * @param changeParent If true, moves child from existing parent to this one
   * @returns The child entity for chaining
   *
   * @example
   * class Turret extends BaseEntity {
   *   constructor() {
   *     super();
   *
   *     // Create child components
   *     const base = new TurretBase();
   *     const barrel = new TurretBarrel();
   *
   *     // Add as children - they'll be destroyed with the turret
   *     this.addChild(base);
   *     this.addChild(barrel);
   *   }
   * }
   *
   * // Chaining example
   * this.addChild(new Effect()).addChild(new Sound()).addChild(new Particle());
   */ addChild(child, changeParent = false) {
        if (child.parent) {
            if (changeParent) {
                // This can lead to weird state where a child is added but its parent isn't, dunno if that's bad
                const oldParent = child.parent;
                oldParent.children.splice(oldParent.children.indexOf(child), 1);
            } else throw new Error("Child already has a parent.");
        }
        child.parent = this;
        this.children = this.children ?? [];
        this.children.push(child);
        if (this.game && !child.game) this.game.addEntity(child);
        return child;
    }
    /**
   * Add multiple entities as children of this entity.
   *
   * Convenience method for adding multiple children at once.
   * Each child is added using addChild() with default parameters.
   *
   * @param children Entities to add as children
   *
   * @example
   * // Add multiple child entities at once
   * this.addChildren(
   *   new TurretBase(),
   *   new TurretBarrel(),
   *   new TurretMuzzleFlash()
   * );
   */ addChildren(...children) {
        for (const child of children)this.addChild(child);
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onTick  Do something every tick while waiting
   */ wait(delay = 0, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(delay, ()=>resolve(), onTick, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onRender  Do something every render while waiting
   */ waitRender(delay = 0, onRender, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$RenderTimer(delay, ()=>resolve(), onRender, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Wait until a condition is filled. Probably not great to use, but seems kinda cool too.
   */ waitUntil(predicate, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(Infinity, ()=>resolve(), (dt, t)=>{
                if (onTick) onTick(dt, t);
                if (predicate()) timer.timeRemaining = 0;
            }, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Remove all timers from this instance. i.e. cancel all 'waits'.
   */ clearTimers(timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.destroy();
        }
    }
    /**
   * Update the time remaing on a timer (or all timers).
   */ updateTimers(value = 0, timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.timeRemaining = value;
        }
    }
    /**
   * Dispatch an event to all entities in the game.
   *
   * This is a convenience method that calls game.dispatch(). Events are sent
   * to all entities that have a matching onEventName handler method.
   *
   * @param eventName Name of the event to dispatch
   * @param data Event data to send to handlers
   * @param respectPause If true (default), pausable entities won't receive event when paused
   *
   * @example
   * // Dispatch score event when enemy is killed
   * this.dispatch("scoreAdded", { points: 100, source: this });
   *
   * // Dispatch level complete event
   * this.dispatch("levelComplete", { level: this.currentLevel });
   *
   * // Dispatch event that ignores pause state
   * this.dispatch("gameStateChanged", { state: "paused" }, false);
   */ dispatch(eventName, data, respectPause) {
        this.game?.dispatch(eventName, data, respectPause);
    }
}
class $c59361981bac2575$var$Timer extends $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(delay, endEffect, duringEffect, timerId){
        super(), this.delay = delay, this.timerId = timerId, this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onTick(dt) {
        this.timeRemaining -= dt;
        const t = (0, $jd0t2.clamp)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
class $c59361981bac2575$var$RenderTimer extends $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(delay, endEffect, duringEffect, timerId){
        super(), this.delay = delay, this.timerId = timerId, this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onRender(dt) {
        this.timeRemaining -= dt;
        const t = (0, $jd0t2.clamp)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
function $c59361981bac2575$var$isTimer(e) {
    return e instanceof $c59361981bac2575$var$Timer;
}

});
parcelRegister("cg2iY", function(module, exports) {

$parcel$export(module.exports, "shapeFromDef", () => $ade141b390e8be57$export$5398643d93d9cfa1);

var $biKyI = parcelRequire("biKyI");

var $cbsax = parcelRequire("cbsax");
function $ade141b390e8be57$export$9d43ca2c1f9c9b92(p1, p2) {
    const vector = p2.sub(p1);
    const midpoint = p1.add(p2).imul(0.5);
    return new (0, $biKyI.Line)({
        position: midpoint,
        angle: vector.angle,
        length: vector.magnitude
    });
}
function $ade141b390e8be57$export$5398643d93d9cfa1(shapeDef) {
    const shape = $ade141b390e8be57$var$baseShapeFromDef(shapeDef);
    shape.collisionGroup = shapeDef.collisionGroup;
    shape.collisionMask = shapeDef.collisionMask;
    return shape;
}
/** Creates the base p2.js Shape from ShapeDef without collision settings */ function $ade141b390e8be57$var$baseShapeFromDef(shapeDef) {
    switch(shapeDef.type){
        case "line":
            return $ade141b390e8be57$export$9d43ca2c1f9c9b92((0, $cbsax.V)(shapeDef.start), (0, $cbsax.V)(shapeDef.end));
        case "circle":
            return new (0, $biKyI.Circle)({
                radius: shapeDef.radius,
                position: (0, $cbsax.V)(shapeDef.center),
                angle: 0
            });
        case "box":
            return new (0, $biKyI.Box)({
                width: shapeDef.size[0],
                height: shapeDef.size[1],
                position: (0, $cbsax.V)(shapeDef.center),
                angle: shapeDef.angle
            });
        case "convex":
            return new (0, $biKyI.Convex)({
                vertices: [
                    ...shapeDef.vertices
                ]
            });
    }
}

});

parcelRegister("c4Qw3", function(module, exports) {

$parcel$export(module.exports, "spriteFromDef", () => $3e96093e790a5ff7$export$9a089bbc6e8eca86);
$parcel$export(module.exports, "createGraphics", () => $3e96093e790a5ff7$export$f83f79acb3f2cc85);
parcelRequire("iuB9z");
var $3cebA = parcelRequire("3cebA");
var $4rhnu = parcelRequire("4rhnu");

var $gehDP = parcelRequire("gehDP");
function $3e96093e790a5ff7$export$365048a7a2b11da6(name, layerName, options) {
    const sprite = (0, $4rhnu.Sprite).from(name);
    sprite.layerName = layerName;
    if (options?.anchor) sprite.anchor.set(...options.anchor);
    if (options?.size) sprite.setSize(...options.size);
    return sprite;
}
function $3e96093e790a5ff7$export$9a089bbc6e8eca86(spriteDef) {
    return $3e96093e790a5ff7$export$365048a7a2b11da6(spriteDef.image, spriteDef.layer, {
        anchor: spriteDef.anchor,
        size: spriteDef.size
    });
}
function $3e96093e790a5ff7$export$f83f79acb3f2cc85(layerName = (0, $gehDP.DEFAULT_LAYER)) {
    const graphics = new (0, $3cebA.Graphics)();
    graphics.layerName = layerName;
    return graphics;
}

});


parcelRegister("04rLh", function(module, exports) {

$parcel$export(module.exports, "BassComposer", () => $3f464e7787f38e4c$export$75b9a9febdfc784e);

var $3uik2 = parcelRequire("3uik2");

var $fpXJL = parcelRequire("fpXJL");
class $3f464e7787f38e4c$export$75b9a9febdfc784e {
    /**
   * Generate bass notes for the next beat based on musical context.
   * Stateless - selects and executes patterns based on current context.
   */ generateNotesForBeat(context) {
        const { timingInfo: timingInfo } = context;
        const pattern = this.selectPattern(context);
        // Execute pattern directly - patterns now contain actual MIDI notes
        return pattern.execute(timingInfo, context.intensity);
    }
    selectPattern(context) {
        const { timingInfo: timingInfo } = context;
        if ((0, $fpXJL.PhraseManager).isInFill(timingInfo)) {
            const patternIndex = timingInfo.phraseSeed % this.fillPatterns.length;
            return this.fillPatterns[patternIndex];
        } else {
            const patternIndex = timingInfo.phraseSeed % this.groovePatterns.length;
            return this.groovePatterns[patternIndex];
        }
    }
    constructor(){
        // Pattern libraries (immutable)
        this.groovePatterns = [
            new (0, $3uik2.RootFocusedBassPattern)()
        ];
        this.fillPatterns = [
            new (0, $3uik2.SimpleBassPattern)()
        ];
    }
}

});
parcelRegister("3uik2", function(module, exports) {

$parcel$export(module.exports, "RootFocusedBassPattern", () => $1c23543fb15f4445$export$86494a3cbd1a76df);
$parcel$export(module.exports, "SimpleBassPattern", () => $1c23543fb15f4445$export$bb3290469f53676);
class $1c23543fb15f4445$export$86494a3cbd1a76df {
    execute(timingInfo, intensity) {
        // This pattern operates over a 2-bar (8-beat) cycle
        const beat = timingInfo.beatInPhrase % 8;
        const notes = [];
        // Always hit the root on downbeats (C2)
        notes.push({
            startBeat: 0,
            durationBeats: 0.3,
            noteNumber: 36,
            velocity: 0.8 + intensity * 0.2
        });
        notes.push({
            startBeat: 0.5,
            durationBeats: 0.45,
            noteNumber: 36,
            velocity: 0.4 + intensity * 0.2
        });
        return notes;
    }
}
class $1c23543fb15f4445$export$f5d065505e33751b {
    execute(timingInfo, intensity) {
        const beat = timingInfo.beatInPhrase % 8; // 2-bar pattern
        const notes = [];
        switch(beat){
            case 0:
            case 4:
                // Root on downbeats (C2)
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.6,
                    noteNumber: 36,
                    velocity: 0.8
                });
                break;
            case 1:
            case 5:
                // Scale tones
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.4,
                    noteNumber: 38,
                    velocity: 0.7
                });
                if (intensity > 0.5) notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.3,
                    noteNumber: 40,
                    velocity: 0.6
                });
                break;
            case 2:
            case 6:
                // Chord tones
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.5,
                    noteNumber: 43,
                    velocity: 0.7
                });
                break;
            case 3:
            case 7:
                // Leading back to root
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.3,
                    noteNumber: 35,
                    velocity: 0.6
                });
                if (intensity > 0.7) notes.push({
                    startBeat: 0.75,
                    durationBeats: 0.2,
                    noteNumber: 34,
                    velocity: 0.5
                });
                break;
        }
        return notes;
    }
}
class $1c23543fb15f4445$export$bb3290469f53676 {
    execute(timingInfo, intensity) {
        const notes = [];
        // Simple ascending scale line back to root
        switch(timingInfo.beatInPhrase % 4){
            case 0:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.4,
                    noteNumber: 31,
                    velocity: 0.6
                });
                break;
            case 1:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.4,
                    noteNumber: 33,
                    velocity: 0.7
                });
                break;
            case 2:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.4,
                    noteNumber: 35,
                    velocity: 0.8
                });
                break;
            case 3:
                // Build up to root for next section
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.4,
                    noteNumber: 36,
                    velocity: 0.9
                });
                break;
        }
        return notes;
    }
}

});

parcelRegister("fpXJL", function(module, exports) {

$parcel$export(module.exports, "PhraseManager", () => $11228220ffa0bdd0$export$3764650e84fefd28);
class $11228220ffa0bdd0$export$3764650e84fefd28 {
    constructor(){
        /** Fixed phrase cycle that repeats */ this.phraseStructures = [
            {
                phraseLength: 16,
                fillLength: 2,
                fillType: "small"
            },
            {
                phraseLength: 16,
                fillLength: 4,
                fillType: "medium"
            },
            {
                phraseLength: 16,
                fillLength: 2,
                fillType: "small"
            },
            {
                phraseLength: 32,
                fillLength: 8,
                fillType: "large"
            }
        ];
        // Calculate total cycle length
        this.totalCycleBeats = this.phraseStructures.reduce((sum, phrase)=>sum + phrase.phraseLength, 0);
    }
    /**
   * Get timing information for the given beat.
   * Calculates phrase position and fill status.
   */ getTimingInfo(beatNumber) {
        // Find which phrase we're in
        const beatInCycle = beatNumber % this.totalCycleBeats;
        let cumulativeBeats = 0;
        let phraseIndex = 0;
        for(let i = 0; i < this.phraseStructures.length; i++){
            const phrase = this.phraseStructures[i];
            if (beatInCycle < cumulativeBeats + phrase.phraseLength) {
                phraseIndex = i;
                break;
            }
            cumulativeBeats += phrase.phraseLength;
        }
        const currentPhrase = this.phraseStructures[phraseIndex];
        const beatInPhrase = beatInCycle - cumulativeBeats;
        return {
            beat: beatNumber,
            beatInPhrase: beatInPhrase,
            phraseLength: currentPhrase.phraseLength,
            fillLength: currentPhrase.fillLength,
            fillType: currentPhrase.fillType,
            phraseSeed: this.generatePhraseSeed(beatNumber, phraseIndex)
        };
    }
    /**
   * Get the structure of the next phrase for anticipation.
   * Returns null if we're not near the end of current phrase.
   */ getNextPhraseStructure(beatNumber) {
        const timingInfo = this.getTimingInfo(beatNumber);
        // Only provide next phrase info in the last 4 beats of current phrase
        if (timingInfo.beatInPhrase < timingInfo.phraseLength - 4) return null;
        // Find next phrase index
        const beatInCycle = beatNumber % this.totalCycleBeats;
        let cumulativeBeats = 0;
        let currentPhraseIndex = 0;
        for(let i = 0; i < this.phraseStructures.length; i++){
            const phrase = this.phraseStructures[i];
            if (beatInCycle < cumulativeBeats + phrase.phraseLength) {
                currentPhraseIndex = i;
                break;
            }
            cumulativeBeats += phrase.phraseLength;
        }
        const nextPhraseIndex = (currentPhraseIndex + 1) % this.phraseStructures.length;
        return this.phraseStructures[nextPhraseIndex];
    }
    /**
   * Generate a deterministic seed for the phrase.
   * Ensures same phrase always gets same seed for consistent patterns.
   */ generatePhraseSeed(beatNumber, phraseIndex) {
        // Which complete cycle are we in?
        const cycleNumber = Math.floor(beatNumber / this.totalCycleBeats);
        // Combine cycle and phrase index for unique seed
        return cycleNumber * 1000 + phraseIndex;
    }
    /**
   * Helper to check if we're currently in a fill section.
   */ static isInFill(timingInfo) {
        return timingInfo.beatInPhrase >= timingInfo.phraseLength - timingInfo.fillLength;
    }
    /**
   * Helper to get beat position within the fill (0-based).
   * Returns -1 if not in a fill.
   */ static getBeatInFill(timingInfo) {
        if (!this.isInFill(timingInfo)) return -1;
        return timingInfo.beatInPhrase - (timingInfo.phraseLength - timingInfo.fillLength);
    }
}

});


parcelRegister("adOUJ", function(module, exports) {

$parcel$export(module.exports, "DrumsComposer", () => $95b379a2dbd0bb5e$export$d10eb728756fae1a);

var $bv7Ho = parcelRequire("bv7Ho");

var $fpXJL = parcelRequire("fpXJL");
class $95b379a2dbd0bb5e$export$d10eb728756fae1a {
    /**
   * Generate drum notes for the next beat based on musical context.
   * Stateless - selects and executes patterns based on current context.
   */ generateNotesForBeat(context) {
        if ((0, $fpXJL.PhraseManager).isInFill(context.timingInfo)) return this.executeFillPattern(context);
        else return this.executeGroovePatterns(context);
    }
    /**
   * Execute groove patterns (hi-hat + kick/snare) based on phrase seed.
   */ executeGroovePatterns(context) {
        const notes = [];
        const { timingInfo: timingInfo } = context;
        // Select hi-hat pattern based on phrase seed
        const hiHatIndex = timingInfo.phraseSeed % this.hiHatPatterns.length;
        const hiHatPattern = this.hiHatPatterns[hiHatIndex];
        const hiHatNotes = hiHatPattern.execute(timingInfo, context.intensity);
        notes.push(...hiHatNotes);
        // Select kick/snare pattern (use different calculation for variety)
        const kickSnareIndex = Math.floor(timingInfo.phraseSeed / 2) % this.kickSnarePatterns.length;
        const kickSnarePattern = this.kickSnarePatterns[kickSnareIndex];
        const kickSnareNotes = kickSnarePattern.execute(timingInfo, context.intensity);
        notes.push(...kickSnareNotes);
        return notes;
    }
    /**
   * Execute fill pattern based on fill type and phrase seed.
   */ executeFillPattern(context) {
        const { timingInfo: timingInfo } = context;
        // Select fill pattern based on fill type and phrase seed
        const fillOptions = this.fillPatterns[timingInfo.fillType];
        const fillIndex = timingInfo.phraseSeed % fillOptions.length;
        const fillPattern = fillOptions[fillIndex];
        return fillPattern.execute(timingInfo, context.intensity);
    }
    constructor(){
        // Pattern libraries for each drum element (immutable)
        this.hiHatPatterns = [
            new (0, $bv7Ho.HiHatQuartersPattern)(),
            new (0, $bv7Ho.HiHatEighthsPattern)()
        ];
        this.kickSnarePatterns = [
            new (0, $bv7Ho.KickSnareRockPattern)(),
            new (0, $bv7Ho.KickSnareFunkPattern)()
        ];
        this.fillPatterns = {
            small: [
                new (0, $bv7Ho.SmallSnareFillPattern)()
            ],
            medium: [
                new (0, $bv7Ho.MediumTomFillPattern)()
            ],
            large: [
                new (0, $bv7Ho.LargeCrashFillPattern)()
            ]
        };
    }
}

});
parcelRegister("bv7Ho", function(module, exports) {

$parcel$export(module.exports, "HiHatQuartersPattern", () => $fce7bc3ff8327b0a$export$b46ff90d903c55e7);
$parcel$export(module.exports, "HiHatEighthsPattern", () => $fce7bc3ff8327b0a$export$3486cc39f84efdaa);
$parcel$export(module.exports, "KickSnareRockPattern", () => $fce7bc3ff8327b0a$export$e6d5b60656c154a0);
$parcel$export(module.exports, "KickSnareFunkPattern", () => $fce7bc3ff8327b0a$export$19ed0558f4370bc7);
$parcel$export(module.exports, "SmallSnareFillPattern", () => $fce7bc3ff8327b0a$export$c216555e6c66d315);
$parcel$export(module.exports, "MediumTomFillPattern", () => $fce7bc3ff8327b0a$export$c201c753fc80eb4);
$parcel$export(module.exports, "LargeCrashFillPattern", () => $fce7bc3ff8327b0a$export$521228ccbcfcdb7);

var $fpXJL = parcelRequire("fpXJL");
function $fce7bc3ff8327b0a$export$c3ec62534b994f98(drumType) {
    const drumMap = {
        kick: 36,
        snare: 38,
        hihat_closed: 42,
        hihat_open: 46,
        crash: 49,
        tom_low: 41,
        tom_mid: 43,
        tom_high: 45
    };
    return drumMap[drumType];
}
class $fce7bc3ff8327b0a$export$b46ff90d903c55e7 {
    execute(timingInfo, intensity) {
        const beat = timingInfo.beatInPhrase % 4;
        const notes = [];
        switch(beat){
            case 0:
            case 1:
            case 2:
            case 3:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("hihat_closed"),
                    velocity: 0.7 + intensity * 0.2
                });
                break;
        }
        return notes;
    }
}
class $fce7bc3ff8327b0a$export$3486cc39f84efdaa {
    execute(timingInfo, intensity) {
        const beat = timingInfo.beatInPhrase % 4;
        const notes = [];
        switch(beat){
            case 0:
            case 1:
            case 2:
            case 3:
                // On-beat (stronger)
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("hihat_closed"),
                    velocity: 0.8 + intensity * 0.2
                });
                // Off-beat (weaker)
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("hihat_closed"),
                    velocity: 0.5 + intensity * 0.2
                });
                break;
        }
        return notes;
    }
}
class $fce7bc3ff8327b0a$export$e6d5b60656c154a0 {
    execute(timingInfo, intensity) {
        const beat = timingInfo.beatInPhrase % 4;
        const notes = [];
        switch(beat){
            case 0:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.9
                });
                break;
            case 1:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                // Add ghost snare at higher intensity
                if (intensity > 0.7) notes.push({
                    startBeat: 0.75,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.3
                });
                break;
            case 2:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.9
                });
                // Add extra kick at higher intensity
                if (intensity > 0.5) notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.7
                });
                break;
            case 3:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                break;
        }
        // Apply intensity-based velocity scaling
        return notes.map((note)=>({
                ...note,
                velocity: (note.velocity || 0.7) * (0.7 + intensity * 0.3)
            }));
    }
}
class $fce7bc3ff8327b0a$export$19ed0558f4370bc7 {
    execute(timingInfo, intensity) {
        const beat = timingInfo.beatInPhrase % 4;
        const notes = [];
        switch(beat){
            case 0:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.9
                });
                if (intensity > 0.6) notes.push({
                    startBeat: 0.25,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.6
                });
                break;
            case 1:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                break;
            case 2:
                if (intensity > 0.4) notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.7
                });
                break;
            case 3:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                if (intensity > 0.7) notes.push({
                    startBeat: 0.75,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 0.6
                });
                break;
        }
        return notes.map((note)=>({
                ...note,
                velocity: (note.velocity || 0.7) * (0.7 + intensity * 0.3)
            }));
    }
}
class $fce7bc3ff8327b0a$export$c216555e6c66d315 {
    getFillType() {
        return "small";
    }
    execute(timingInfo, intensity) {
        const beatInFill = (0, $fpXJL.PhraseManager).getBeatInFill(timingInfo);
        const beat = beatInFill % 2; // 2-beat pattern
        const notes = [];
        switch(beat){
            case 0:
                // Snare on beat
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.7
                });
                // Add sixteenth notes at higher intensity
                if (intensity > 0.5) {
                    notes.push({
                        startBeat: 0.25,
                        durationBeats: 0.1,
                        noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                        velocity: 0.5
                    });
                    notes.push({
                        startBeat: 0.5,
                        durationBeats: 0.1,
                        noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                        velocity: 0.6
                    });
                    notes.push({
                        startBeat: 0.75,
                        durationBeats: 0.1,
                        noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                        velocity: 0.5
                    });
                }
                break;
            case 1:
                // Build up to next section
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.9
                });
                break;
        }
        return notes;
    }
}
class $fce7bc3ff8327b0a$export$c201c753fc80eb4 {
    getFillType() {
        return "medium";
    }
    execute(timingInfo, intensity) {
        const beatInFill = (0, $fpXJL.PhraseManager).getBeatInFill(timingInfo);
        const beat = beatInFill % 4; // 4-beat pattern
        const notes = [];
        switch(beat){
            case 0:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_high"),
                    velocity: 0.7
                });
                break;
            case 1:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_mid"),
                    velocity: 0.7
                });
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_mid"),
                    velocity: 0.6
                });
                break;
            case 2:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_low"),
                    velocity: 0.8
                });
                break;
            case 3:
                // Build up with snare
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.7
                });
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.8
                });
                // Crash on last beat to transition
                notes.push({
                    startBeat: 0.75,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("crash"),
                    velocity: 0.9
                });
                break;
        }
        return notes;
    }
}
class $fce7bc3ff8327b0a$export$521228ccbcfcdb7 {
    getFillType() {
        return "large";
    }
    execute(timingInfo, intensity) {
        const beatInFill = (0, $fpXJL.PhraseManager).getBeatInFill(timingInfo);
        const beat = beatInFill % 8; // 8-beat pattern
        const notes = [];
        switch(beat){
            case 0:
            case 2:
            case 4:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_high"),
                    velocity: 0.6
                });
                break;
            case 1:
            case 3:
            case 5:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_mid"),
                    velocity: 0.7
                });
                break;
            case 6:
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("tom_low"),
                    velocity: 0.8
                });
                notes.push({
                    startBeat: 0.5,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("snare"),
                    velocity: 0.9
                });
                break;
            case 7:
                // Big finish
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("crash"),
                    velocity: 1.0
                });
                notes.push({
                    startBeat: 0,
                    durationBeats: 0.1,
                    noteNumber: $fce7bc3ff8327b0a$export$c3ec62534b994f98("kick"),
                    velocity: 1.0
                });
                break;
        }
        return notes;
    }
}

});


parcelRegister("hf1qb", function(module, exports) {

$parcel$export(module.exports, "MasterComposer", () => $7bcadbf06d39860d$export$d2505c369e5515ea);

var $2oYNi = parcelRequire("2oYNi");

var $6U2Lg = parcelRequire("6U2Lg");

var $fpXJL = parcelRequire("fpXJL");
class $7bcadbf06d39860d$export$d2505c369e5515ea extends (0, $2oYNi.default) {
    onAdd() {
        // Initialize core musical management components
        this.phraseManager = new (0, $fpXJL.PhraseManager)();
        this.keyManager = new (0, $6U2Lg.KeyManager)();
    }
    /**
   * Get complete musical context for the specified beat.
   * This is the main interface used by instrument composers.
   */ getMusicalContext(beatNumber) {
        const timingInfo = this.phraseManager.getTimingInfo(beatNumber);
        const nextPhraseStructure = this.phraseManager.getNextPhraseStructure(beatNumber);
        const keyInfo = this.keyManager.getKeyInfo(timingInfo);
        return {
            beatNumber: beatNumber,
            timingInfo: timingInfo,
            nextPhraseStructure: nextPhraseStructure,
            keyInfo: keyInfo,
            intensity: this.intensity,
            tempo: this.tempo,
            getRandom: this.createDeterministicRandom(timingInfo.phraseSeed)
        };
    }
    /**
   * Update musical parameters from game state.
   * Changes are applied immediately for responsive generation.
   */ setParams(params) {
        if (params.intensity !== undefined) this.intensity = params.intensity;
        if (params.tempo !== undefined) this.tempo = params.tempo;
    }
    getParams() {
        return {
            intensity: this.intensity,
            tempo: this.tempo
        };
    }
    /**
   * Create deterministic pseudo-random function based on phrase seed.
   * Ensures same phrase always generates same variations.
   */ createDeterministicRandom(phraseSeed) {
        return (seed)=>{
            // Simple hash function for deterministic randomness
            let hash = phraseSeed;
            for(let i = 0; i < seed.length; i++)hash = (hash << 5) - hash + seed.charCodeAt(i) & 0xffffffff;
            // Normalize to 0-1 range
            return Math.abs(hash) / 0xffffffff;
        };
    }
    constructor(...args){
        super(...args), this.tags = [
            "masterComposer"
        ], this.id = "masterComposer", this.pausable = false, /** Current music parameters */ this.intensity = 0.3, this.tempo = 130;
    }
}

});
parcelRegister("6U2Lg", function(module, exports) {

$parcel$export(module.exports, "KeyManager", () => $e3d405298b7c5d21$export$cc2cdd5bf44ddf2);

var $fpXJL = parcelRequire("fpXJL");
class $e3d405298b7c5d21$export$cc2cdd5bf44ddf2 {
    /**
   * Get key and harmonic information for current timing position.
   * Determines chord based on whether we're in fill portion of phrase.
   */ getKeyInfo(timingInfo) {
        const currentChord = this.determineCurrentChord(timingInfo);
        const scale = this.getScaleForChord(currentChord);
        return {
            rootNote: this.getCurrentRoot(currentChord),
            scale: scale,
            currentChord: currentChord
        };
    }
    /**
   * Set the root note for the key center.
   * All harmony will be relative to this note.
   */ setRootNote(noteNumber) {
        this.rootNote = noteNumber;
    }
    /**
   * Get the current root note.
   */ getRootNote() {
        return this.rootNote;
    }
    /**
   * Determine current chord based on phrase position.
   *
   * Rule: Use V chord during fill portion of phrase for harmonic excitement.
   * This creates tension that resolves when next phrase begins.
   *
   * Examples:
   * - Groove portion: I chord (stable foundation)
   * - Fill portion: V chord (adds tension and excitement)
   */ determineCurrentChord(timingInfo) {
        // V chord during fills for harmonic movement and excitement
        return (0, $fpXJL.PhraseManager).isInFill(timingInfo) ? "V" : "I";
    }
    /**
   * Get the appropriate scale for the current chord.
   *
   * - I chord: Major scale (bright, stable)
   * - V chord: Mixolydian scale (has b7 for dominant flavor)
   */ getScaleForChord(chord) {
        return chord === "I" ? this.majorScale : this.mixolydianScale;
    }
    /**
   * Get the root note for the current chord.
   *
   * - I chord: Use the key's root note
   * - V chord: Use the fifth degree (7 semitones up)
   */ getCurrentRoot(chord) {
        return chord === "I" ? this.rootNote : this.rootNote + 7;
    }
    /**
   * Get chord tones for the current harmony.
   * Useful for composers that want to emphasize harmonic notes.
   */ getChordTones(keyInfo) {
        const root = keyInfo.rootNote;
        if (keyInfo.currentChord === "I") // I chord: 1-3-5 of major scale
        return [
            root,
            root + 4,
            root + 7
        ];
        else // V chord: 1-3-5-b7 of mixolydian (dominant 7th)
        return [
            root,
            root + 4,
            root + 7,
            root + 10
        ];
    }
    /**
   * Check if a note is a chord tone in the current harmony.
   * Useful for composers to emphasize consonant notes.
   */ isChordTone(noteNumber, keyInfo) {
        const chordTones = this.getChordTones(keyInfo);
        const noteInOctave = noteNumber % 12;
        return chordTones.some((chordTone)=>chordTone % 12 === noteInOctave);
    }
    /**
   * Get the scale degree (1-7) of a note in the current key.
   * Returns 0 if the note is not in the scale.
   */ getScaleDegree(noteNumber, keyInfo) {
        const noteInOctave = noteNumber % 12;
        const rootInOctave = keyInfo.rootNote % 12;
        const intervalFromRoot = (noteInOctave - rootInOctave + 12) % 12;
        const scaleIndex = keyInfo.scale.indexOf(intervalFromRoot);
        return scaleIndex >= 0 ? scaleIndex + 1 : 0;
    }
    /**
   * Get a note at a specific scale degree in the current key.
   * Useful for composers to build melodies within the key.
   */ getNoteAtScaleDegree(degree, octave, keyInfo) {
        if (degree < 1 || degree > keyInfo.scale.length) throw new Error(`Scale degree ${degree} out of range for current scale`);
        const scaleInterval = keyInfo.scale[degree - 1];
        return keyInfo.rootNote + (octave - 4) * 12 + scaleInterval;
    }
    constructor(){
        /** Current root note as MIDI number (default: C4) */ this.rootNote = 60;
        /** Major scale intervals from root */ this.majorScale = [
            0,
            2,
            4,
            5,
            7,
            9,
            11
        ];
        /** Mixolydian scale intervals (for V chord) */ this.mixolydianScale = [
            0,
            2,
            4,
            5,
            7,
            9,
            10
        ];
    }
}

});


parcelRegister("18ihr", function(module, exports) {

$parcel$export(module.exports, "InstrumentPlayer", () => $2f3f8a9de86601f0$export$1208302f2f73b75a);

var $2oYNi = parcelRequire("2oYNi");
class $2f3f8a9de86601f0$export$1208302f2f73b75a extends (0, $2oYNi.default) {
    constructor(composer, masterComposer, instrument){
        super(), this.pausable = false // Keep music playing during pause
        ;
        this.composer = composer;
        this.masterComposer = masterComposer;
        this.instrument = instrument;
    }
    /**
   * Get the underlying instrument for direct access.
   */ getInstrument() {
        return this.instrument;
    }
    /**
   * Get the composer for visualization purposes.
   */ getComposer() {
        return this.composer;
    }
    /**
   * Handle beat scheduling event - generate and schedule notes for the upcoming beat.
   * Called automatically by the game's event system when TempoClock dispatches scheduleBeat.
   * Uses lookahead timing to ensure audio events are scheduled before they need to play.
   */ onScheduleBeat(eventData) {
        const { beatNumber: beatNumber, beatStartTime: beatStartTime } = eventData;
        // Get complete musical context from master composer
        const context = this.masterComposer.getMusicalContext(beatNumber);
        // Generate notes using structured composer
        const notes = this.composer.generateNotesForBeat(context);
        // Schedule all generated notes with precise timing
        for (const note of notes)this.scheduleNoteWithTime(note, beatStartTime);
    }
    /**
   * Schedule a musical note for playback using precise beat start time.
   */ scheduleNoteWithTime(note, beatStartTime) {
        if (!this.game?.audio) return;
        const tempoClock = this.game.entities.getById("tempoClock");
        if (!tempoClock?.beatsToSeconds) return;
        // Calculate precise start time relative to beat start
        const beatOffset = note.startBeat - Math.floor(note.startBeat);
        const offsetTime = tempoClock.beatsToSeconds(beatOffset);
        const startTime = beatStartTime + offsetTime;
        const duration = tempoClock.beatsToSeconds(note.durationBeats);
        // Delegate synthesis to the instrument
        this.instrument.playNote(note, startTime, duration);
    }
    /**
   * Schedule a musical note for playback on the instrument (legacy method).
   */ scheduleNote(note) {
        if (!this.game?.audio) return;
        // Convert beat time to absolute audio context time
        const tempoClock = this.game.entities.getById("tempoClock");
        if (!tempoClock?.beatToTime) return;
        const startTime = tempoClock.beatToTime(note.startBeat);
        const duration = tempoClock.beatsToSeconds(note.durationBeats);
        // Delegate synthesis to the instrument
        this.instrument.playNote(note, startTime, duration);
    }
    /**
   * Get all valid MIDI notes that this instrument can play.
   */ getValidNotes() {
        return this.instrument.getValidNotes();
    }
    /**
   * Get a display name for this instrument.
   */ getDisplayName() {
        return this.instrument.getDisplayName();
    }
    /**
   * Set instrument volume (0-1).
   */ setVolume(volume) {
        this.instrument.setVolume(volume);
    }
    getVolume() {
        return this.instrument.getVolume();
    }
    /**
   * Mute or unmute the instrument.
   */ setMuted(muted) {
        this.instrument.setMuted(muted);
    }
    /**
   * Check if the instrument is muted.
   */ isMuted() {
        return this.instrument.isMuted();
    }
    /**
   * Toggle mute state.
   */ toggleMute() {
        this.instrument.toggleMute();
    }
    /**
   * Get the monitor output for this instrument.
   */ get monitor() {
        return this.instrument.monitor;
    }
    /**
   * Get all parameters for this instrument.
   */ getParameters() {
        return this.instrument.getParameters();
    }
    /**
   * Find a parameter by key.
   */ getParameter(key) {
        return this.instrument.getParameter(key);
    }
    /**
   * Set a parameter value by key.
   */ setParameter(key, value) {
        this.instrument.setParameter(key, value);
    }
    /**
   * Reset all parameters to their default values.
   */ resetParametersToDefaults() {
        this.instrument.resetParametersToDefaults();
    }
    /**
   * Compatibility methods for TrackList component.
   */ playNextBeat() {
    // Not needed in structured system - handled by event system
    }
    /**
   * Cleanup when entity is destroyed.
   */ onDestroy() {
        this.instrument.onDestroy();
    }
}

});

parcelRegister("7ZE7Q", function(module, exports) {

$parcel$export(module.exports, "BassInstrument", () => $bca0664497c46c49$export$bb4f20433af10866);

var $9IfhJ = parcelRequire("9IfhJ");

var $jd0t2 = parcelRequire("jd0t2");

var $8x7Ib = parcelRequire("8x7Ib");
class $bca0664497c46c49$export$bb4f20433af10866 extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output), this.tags = [
            "bassInstrument"
        ], // Type-safe parameter fields
        this.attackTime = 0.01, this.decayTime = 0.1, this.sustainLevel = 0.7, this.releaseTime = 0.05;
        this.initializeParameters();
    }
    /**
   * Initialize bass-specific parameters.
   */ initializeParameters() {
        this.addParameter(()=>this.attackTime, (value)=>{
            this.attackTime = value;
        }, {
            key: "attackTime",
            label: "Attack Time",
            min: 0.001,
            max: 0.1,
            defaultValue: 0.01,
            step: 0.001,
            unit: "s",
            category: "Envelope"
        });
        this.addParameter(()=>this.decayTime, (value)=>{
            this.decayTime = value;
        }, {
            key: "decayTime",
            label: "Decay Time",
            min: 0.01,
            max: 0.5,
            defaultValue: 0.1,
            step: 0.01,
            unit: "s",
            category: "Envelope"
        });
        this.addParameter(()=>this.sustainLevel, (value)=>{
            this.sustainLevel = value;
        }, {
            key: "sustainLevel",
            label: "Sustain Level",
            min: 0.1,
            max: 1.0,
            defaultValue: 0.7,
            step: 0.01,
            category: "Envelope"
        });
        this.addParameter(()=>this.releaseTime, (value)=>{
            this.releaseTime = value;
        }, {
            key: "releaseTime",
            label: "Release Time",
            min: 0.01,
            max: 0.2,
            defaultValue: 0.05,
            step: 0.01,
            unit: "s",
            category: "Envelope"
        });
    }
    /**
   * Get valid MIDI notes for bass instrument.
   */ getValidNotes() {
        return (0, $9IfhJ.range)(28, 52); // E1 to E3 for deep bass foundation
    }
    /**
   * Play a single bass note using triangle wave synthesis with ADSR envelope.
   */ playNote(note, startTime, duration) {
        // Create oscillator and gain node for this note
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();
        // Configure triangle wave oscillator
        oscillator.type = "triangle";
        oscillator.frequency.value = (0, $jd0t2.noteToFrequency)(note.noteNumber);
        // ADSR envelope configuration
        const attackTime = 0.01; // 10ms attack - quick but not instant
        const decayTime = 0.1; // 100ms decay
        const sustainLevel = 0.7; // 70% sustain level
        const releaseTime = 0.05; // 50ms release
        // Calculate volume from velocity and ensure good bass presence
        const baseVolume = 0.8; // Strong bass presence
        const volume = baseVolume * (note.velocity ?? 1.0);
        // Set up ADSR envelope
        gainNode.gain.setValueAtTime(0, startTime);
        // Attack
        gainNode.gain.linearRampToValueAtTime(volume, startTime + attackTime);
        // Decay to sustain level
        gainNode.gain.exponentialRampToValueAtTime(volume * sustainLevel, startTime + attackTime + decayTime);
        // Sustain (hold current level during note duration)
        const sustainEndTime = startTime + duration - releaseTime;
        gainNode.gain.setValueAtTime(volume * sustainLevel, Math.max(sustainEndTime, startTime + attackTime + decayTime));
        // Release
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
        // Connect audio graph: oscillator -> gain -> instrument gain chain
        oscillator.connect(gainNode);
        gainNode.connect(this.gain);
        // Clean up nodes after playback to prevent memory leaks
        oscillator.onended = ()=>{
            oscillator.disconnect();
            gainNode.disconnect();
        };
        // Schedule playback
        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
    }
}

});
parcelRegister("9IfhJ", function(module, exports) {

$parcel$export(module.exports, "range", () => $9015b6c2ef849b52$export$d02631cccf789723);
/**
 * Returns the input value unchanged. Useful as a default function or for functional programming patterns.
 */ function $9015b6c2ef849b52$export$f0954fd7d5368655(a) {
    return a;
}
function $9015b6c2ef849b52$export$4c7897fafd92b108(a) {
    return a[a.length - 1];
}
function $9015b6c2ef849b52$export$f672e0b6f7222cd7(...fns) {
    return (arg)=>fns.reduceRight((acc, fn)=>fn(acc), arg);
}
function $9015b6c2ef849b52$export$d02631cccf789723(start, end) {
    if (start > end) throw new Error("Start must be less than or equal to end");
    return Array.from({
        length: end - start + 1
    }, (_, i)=>start + i);
}

});

parcelRegister("8x7Ib", function(module, exports) {

$parcel$export(module.exports, "Instrument", () => $7ccf5348a63ce277$export$25ef33f358b07cf4);

var $9IfhJ = parcelRequire("9IfhJ");

var $eS4rJ = parcelRequire("eS4rJ");
class $7ccf5348a63ce277$export$25ef33f358b07cf4 {
    constructor(audioContext, output){
        // Parameter management
        this.parameters = [];
        this.audioContext = audioContext;
        this.output = output;
        // Create audio chain: gain -> instrument gain -> pan -> mute gain -> output
        this.gain = audioContext.createGain();
        this.pan = audioContext.createStereoPanner();
        this.mute = audioContext.createGain();
        this.gain.connect(this.pan);
        this.pan.connect(this.mute);
        this.mute.connect(output);
        // Initialize common parameters
        // Instrument gain parameter - controls audio node directly
        this.addParameter(()=>this.gain.gain.value, (value)=>{
            this.gain.gain.value = value;
        }, {
            key: "gain",
            label: "Gain",
            min: 0.0,
            max: 2.0,
            defaultValue: 1.0,
            step: 0.01,
            category: "Base"
        });
        // Pan parameter - controls audio node directly
        this.addParameter(()=>this.pan.pan.value, (value)=>{
            this.pan.pan.value = value;
        }, {
            key: "pan",
            label: "Pan",
            min: -1,
            max: 1.0,
            defaultValue: 0.0,
            step: 0.01,
            category: "Base"
        });
    }
    get monitor() {
        return this.mute; // Return the final output node for monitoring
    }
    /**
   * Set instrument volume (0-1).
   */ setVolume(volume) {
        this.gain.gain.value = volume;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    /**
   * Mute or unmute the instrument.
   */ setMuted(muted) {
        this.mute.gain.value = muted ? 0 : 1;
    }
    /**
   * Check if the instrument is muted.
   */ isMuted() {
        return this.mute.gain.value === 0;
    }
    /**
   * Toggle mute state.
   */ toggleMute() {
        this.setMuted(!this.isMuted());
    }
    /**
   * Get all valid MIDI note numbers that this instrument can play.
   * This is used for visualization to efficiently allocate space only for playable notes.
   *
   * For discrete instruments (like drums), return specific note numbers.
   * For continuous instruments (like synths), return a range of notes.
   */ getValidNotes() {
        // Default implementation: generate continuous range for tonal instruments
        return (0, $9IfhJ.range)(20, 108); // Default MIDI range
    }
    /**
   * Get a display name for this instrument.
   * Used in the music test page for labeling tracks.
   */ getDisplayName() {
        // Use constructor name and remove "Instrument" suffix
        return this.constructor.name.replace("Instrument", "");
    }
    /**
   * Add a parameter to this instrument with getter/setter functions.
   */ addParameter(getter, setter, metadata) {
        // Reject duplicate parameter keys
        if (this.getParameter(metadata.key)) throw new Error(`Parameter with key "${metadata.key}" already exists`);
        const parameter = new (0, $eS4rJ.InstrumentParameter)(getter, setter, metadata);
        this.parameters.push(parameter);
        parameter.setValue(parameter.defaultValue);
    }
    /**
   * Get all parameters for this instrument.
   */ getParameters() {
        return [
            ...this.parameters
        ];
    }
    /**
   * Find a parameter by key.
   */ getParameter(key) {
        return this.parameters.find((p)=>p.key === key);
    }
    /**
   * Set a parameter value by key.
   */ setParameter(key, value) {
        const param = this.getParameter(key);
        if (param) param.setValue(value);
        else console.warn(`Unknown parameter: ${key}`);
    }
    /**
   * Reset all parameters to their default values.
   */ resetParametersToDefaults() {
        for (const param of this.parameters)param.setValue(param.defaultValue);
    }
    /**
   * Cleanup audio nodes when instrument is no longer needed.
   */ onDestroy() {
        // Disconnect audio nodes to prevent memory leaks
        this.gain.disconnect();
        this.pan.disconnect();
        this.mute.disconnect();
    }
}

});
parcelRegister("eS4rJ", function(module, exports) {

$parcel$export(module.exports, "InstrumentParameter", () => $ef1036314a1bd1bd$export$b3962dade5610f4b);
/**
 * Metadata for instrument parameters.
 */ class $ef1036314a1bd1bd$export$b3962dade5610f4b {
    constructor(getter, setter, metadata){
        this.getter = getter;
        this.setter = setter;
        this.key = metadata.key;
        this.label = metadata.label;
        this.min = metadata.min ?? 0;
        this.max = metadata.max ?? 1;
        this.defaultValue = metadata.defaultValue ?? 0.5;
        this.step = metadata.step ?? 0.01;
        this.unit = metadata.unit;
        this.category = metadata.category;
    }
    /**
   * Get the current value of the parameter.
   */ getValue() {
        return this.getter();
    }
    /**
   * Set the value of the parameter, clamped to min/max range.
   */ setValue(value) {
        const clamped = Math.max(this.min, Math.min(this.max, value));
        this.setter(clamped);
    }
}

});



parcelRegister("gDKQe", function(module, exports) {

$parcel$export(module.exports, "DrumsInstrument", () => $7f23b139db4be272$export$fb59029e5eb3a982);

var $bkFbu = parcelRequire("bkFbu");

var $dv4sm = parcelRequire("dv4sm");

var $bpFDo = parcelRequire("bpFDo");

var $8x7Ib = parcelRequire("8x7Ib");

var $eS4rJ = parcelRequire("eS4rJ");

var $ivFOt = parcelRequire("ivFOt");

var $k8FXX = parcelRequire("k8FXX");
class $7f23b139db4be272$export$fb59029e5eb3a982 extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output);
        // Create child instruments
        this.kickDrum = new (0, $ivFOt.KickDrum)(audioContext, this.gain);
        this.snareDrum = new (0, $k8FXX.SnareDrum)(audioContext, this.gain);
        this.hiHat = new (0, $bpFDo.HiHat)(audioContext, this.gain);
        this.crashCymbal = new (0, $bkFbu.CrashCymbal)(audioContext, this.gain);
        // Create three tom instances with different pitches
        this.lowTom = new (0, $dv4sm.ElectroTom)(audioContext, this.gain, 41); // F2
        this.midTom = new (0, $dv4sm.ElectroTom)(audioContext, this.gain, 43); // G2
        this.highTom = new (0, $dv4sm.ElectroTom)(audioContext, this.gain, 45); // A2
        // Set default volumes for child instruments
        this.kickDrum.setVolume(1.5);
        this.snareDrum.setVolume(0.8);
        this.hiHat.setVolume(0.4);
        this.crashCymbal.setVolume(0.6);
        this.lowTom.setVolume(0.7);
        this.midTom.setVolume(0.7);
        this.highTom.setVolume(0.7);
    }
    /**
   * Play a drum sound by routing to appropriate child instrument.
   */ playNote(note, startTime, duration) {
        const drumType = this.getDrumTypeFromNote(note.noteNumber);
        // Route to appropriate child instrument
        switch(drumType){
            case "kick":
                this.kickDrum.playNote(note, startTime, duration);
                break;
            case "snare":
                this.snareDrum.playNote(note, startTime, duration);
                break;
            case "hihat_closed":
            case "hihat_open":
                // Both open and closed hi-hats use the same HiHat instrument
                // The instrument determines open/closed based on note number
                this.hiHat.playNote(note, startTime, duration);
                break;
            case "crash":
                this.crashCymbal.playNote(note, startTime, duration);
                break;
            case "tom_low":
                this.lowTom.playNote(note, startTime, duration);
                break;
            case "tom_mid":
                this.midTom.playNote(note, startTime, duration);
                break;
            case "tom_high":
                this.highTom.playNote(note, startTime, duration);
                break;
            default:
                console.warn(`Unknown drum type for note ${note.noteNumber}`);
        }
    }
    /**
   * Map MIDI note numbers to drum types.
   */ getDrumTypeFromNote(noteNumber) {
        switch(noteNumber){
            case 36:
                return "kick";
            case 38:
                return "snare";
            case 42:
                return "hihat_closed";
            case 46:
                return "hihat_open";
            case 49:
                return "crash";
            case 41:
                return "tom_low";
            case 43:
                return "tom_mid";
            case 45:
                return "tom_high";
            default:
                // Default to kick for unknown notes
                return "kick";
        }
    }
    /**
   * Override getParameters to aggregate parameters from all child instruments.
   * This allows the UI to control all drum parameters from a single interface.
   */ getParameters() {
        const baseParameters = super.getParameters();
        const kickParameters = this.kickDrum.getParameters();
        const snareParameters = this.snareDrum.getParameters();
        const hihatParameters = this.hiHat.getParameters();
        const crashParameters = this.crashCymbal.getParameters();
        const lowTomParameters = this.lowTom.getParameters();
        const midTomParameters = this.midTom.getParameters();
        const highTomParameters = this.highTom.getParameters();
        // Prefix child parameters to avoid key conflicts
        const prefixedKickParams = kickParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `kick_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Kick"
            });
        });
        const prefixedSnareParams = snareParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `snare_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Snare"
            });
        });
        const prefixedHihatParams = hihatParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `hihat_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Hi-Hat"
            });
        });
        const prefixedCrashParams = crashParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `crash_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Crash"
            });
        });
        const prefixedLowTomParams = lowTomParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `lowTom_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Low Tom"
            });
        });
        const prefixedMidTomParams = midTomParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `midTom_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "Mid Tom"
            });
        });
        const prefixedHighTomParams = highTomParameters.map((param)=>{
            return new (0, $eS4rJ.InstrumentParameter)(()=>param.getValue(), (value)=>param.setValue(value), {
                key: `highTom_${param.key}`,
                label: param.label,
                min: param.min,
                max: param.max,
                defaultValue: param.defaultValue,
                step: param.step,
                unit: param.unit,
                category: "High Tom"
            });
        });
        return [
            ...baseParameters,
            ...prefixedKickParams,
            ...prefixedSnareParams,
            ...prefixedHihatParams,
            ...prefixedCrashParams,
            ...prefixedLowTomParams,
            ...prefixedMidTomParams,
            ...prefixedHighTomParams
        ];
    }
    /**
   * Get all valid MIDI notes for the drum kit.
   */ getValidNotes() {
        // Combine valid notes from all child instruments
        const kickNotes = this.kickDrum.getValidNotes();
        const snareNotes = this.snareDrum.getValidNotes();
        const hihatNotes = this.hiHat.getValidNotes();
        const crashNotes = this.crashCymbal.getValidNotes();
        const lowTomNotes = this.lowTom.getValidNotes();
        const midTomNotes = this.midTom.getValidNotes();
        const highTomNotes = this.highTom.getValidNotes();
        // Merge and sort all valid notes
        const allNotes = [
            ...kickNotes,
            ...snareNotes,
            ...hihatNotes,
            ...crashNotes,
            ...lowTomNotes,
            ...midTomNotes,
            ...highTomNotes
        ];
        return [
            ...new Set(allNotes)
        ].sort((a, b)=>a - b);
    }
    /**
   * Clean up resources including child instruments.
   */ onDestroy() {
        super.onDestroy();
        this.kickDrum.onDestroy();
        this.snareDrum.onDestroy();
        this.hiHat.onDestroy();
        this.crashCymbal.onDestroy();
        this.lowTom.onDestroy();
        this.midTom.onDestroy();
        this.highTom.onDestroy();
    }
}

});
parcelRegister("bkFbu", function(module, exports) {

$parcel$export(module.exports, "CrashCymbal", () => $77cbc2ad3f388a65$export$ec84ba6324ac143b);

var $8x7Ib = parcelRequire("8x7Ib");

var $lMoWJ = parcelRequire("lMoWJ");
const $77cbc2ad3f388a65$var$crashModes = [
    {
        frequency: 3000,
        Q: 10,
        decay: 2.5
    },
    {
        frequency: 3400,
        Q: 11,
        decay: 2.2
    },
    {
        frequency: 3900,
        Q: 12,
        decay: 2.0
    },
    {
        frequency: 4400,
        Q: 13,
        decay: 1.8
    },
    {
        frequency: 5000,
        Q: 14,
        decay: 1.6
    },
    {
        frequency: 5700,
        Q: 15,
        decay: 1.4
    },
    {
        frequency: 6400,
        Q: 16,
        decay: 1.2
    },
    {
        frequency: 7300,
        Q: 17,
        decay: 1.0
    },
    {
        frequency: 8300,
        Q: 18,
        decay: 0.8
    },
    {
        frequency: 9400,
        Q: 19,
        decay: 0.6
    },
    {
        frequency: 10600,
        Q: 20,
        decay: 0.5
    },
    {
        frequency: 12100,
        Q: 22,
        decay: 0.4
    },
    // Sizzle
    {
        frequency: 8000,
        Q: 3,
        decay: 0.1,
        gain: 2.0,
        type: "highpass"
    }
];
class $77cbc2ad3f388a65$export$ec84ba6324ac143b extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output);
        // Create persistent audio chain
        this.setupPersistentNodes();
        this.initializeParameters();
    }
    /**
   * Set up persistent audio nodes that stay alive for the instrument's lifetime.
   */ setupPersistentNodes() {}
    /**
   * Play a crash cymbal note using persistent oscillators with click-free voice stealing.
   */ playNote(note, startTime, _duration) {
        const crashBus = this.audioContext.createGain();
        // and modulate the filter frequency
        const fmOsc = this.audioContext.createOscillator();
        fmOsc.start(startTime);
        fmOsc.type = "sine";
        fmOsc.frequency.value = 80; // carrier at 80 Hz for a metallic shimmer
        const fmGain = this.audioContext.createGain();
        fmGain.gain.value = 300;
        const resonators = $77cbc2ad3f388a65$var$crashModes.map((mode)=>{
            // White noise
            const noiseSource = (0, $lMoWJ.createNoiseSource)(this.audioContext, {
                length: 1
            });
            noiseSource.start(startTime);
            // But filter it
            const filter = this.audioContext.createBiquadFilter();
            filter.type = mode.type ?? "bandpass";
            filter.frequency.value = mode.frequency;
            filter.Q.value = mode.Q;
            fmOsc.connect(fmGain);
            fmGain.connect(filter.frequency);
            // Envelope
            const gain = this.audioContext.createGain();
            gain.gain.setValueAtTime(mode.gain ?? 1.0, startTime);
            gain.gain.setTargetAtTime(0, startTime, mode.decay * 0.1);
            // Connect nodes
            noiseSource.connect(filter);
            filter.connect(gain);
            return gain;
        });
        const distortion = (0, $lMoWJ.createDistortionNode)(this.audioContext, (x)=>Math.sign(x) * Math.sqrt(Math.abs(x)));
        const comb = this.audioContext.createDelay();
        const fb = this.audioContext.createGain();
        comb.delayTime.value = 0.03; // 30 ms
        fb.gain.value = 0.4;
        for (const resonator of resonators)resonator.connect(crashBus);
        crashBus.connect(comb);
        comb.connect(fb);
        fb.connect(comb);
        comb.connect(distortion);
        distortion.connect(this.gain);
    }
    /**
   * Get valid MIDI notes for crash cymbal.
   */ getValidNotes() {
        return [
            49
        ]; // C#3 crash cymbal note
    }
    /**
   * Initialize crash cymbal parameters.
   */ initializeParameters() {}
}

});
parcelRegister("lMoWJ", function(module, exports) {

$parcel$export(module.exports, "createNoiseSource", () => $75855f99c2aee3a3$export$773c2a3cccb996fb);
$parcel$export(module.exports, "createDistortionNode", () => $75855f99c2aee3a3$export$56042e9ef31e6735);

var $jd0t2 = parcelRequire("jd0t2");

var $azFtk = parcelRequire("azFtk");
function $75855f99c2aee3a3$export$773c2a3cccb996fb(audioContext, { length: length = 1 }) {
    const buffer = audioContext.createBuffer(1, audioContext.sampleRate * length, audioContext.sampleRate);
    const data = buffer.getChannelData(0);
    for(let i = 0; i < data.length; i++)data[i] = (0, $azFtk.rUniform)(-1, 1);
    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    source.loop = true;
    return source;
}
function $75855f99c2aee3a3$export$56042e9ef31e6735(audioContext, f) {
    const distortion = audioContext.createWaveShaper();
    const curve = new Float32Array(256);
    for(let i = 0; i < curve.length; i++){
        const x = (0, $jd0t2.lerpLerp)([
            0,
            curve.length - 1
        ], [
            -1,
            1
        ], i);
        curve[i] = f(x);
    }
    distortion.curve = curve;
    return distortion;
}

});
parcelRegister("azFtk", function(module, exports) {

$parcel$export(module.exports, "rUniform", () => $f1ed8354ebe33615$export$1ab1062261c98efe);
$parcel$export(module.exports, "rDirection", () => $f1ed8354ebe33615$export$6c5277ffd5bb6b0b);
$parcel$export(module.exports, "choose", () => $f1ed8354ebe33615$export$7877a478dd30fd3d);
$parcel$export(module.exports, "rNormal", () => $f1ed8354ebe33615$export$4dc4a801a9bb2c7e);
$parcel$export(module.exports, "rBool", () => $f1ed8354ebe33615$export$e0c4b1630ec012c1);
$parcel$export(module.exports, "rInteger", () => $f1ed8354ebe33615$export$4b740f64b13739ef);
$parcel$export(module.exports, "chooseN", () => $f1ed8354ebe33615$export$ed5876990578d29a);
$parcel$export(module.exports, "shuffle", () => $f1ed8354ebe33615$export$448332262467e042);
$parcel$export(module.exports, "chooseWeighted", () => $f1ed8354ebe33615$export$8a254833e92ed41);

var $jd0t2 = parcelRequire("jd0t2");
/**
 * Utility functions for doing things based on random numbers.
 */ /** Shorthand for Math.random */ const $f1ed8354ebe33615$var$r = Math.random;
function $f1ed8354ebe33615$export$1ab1062261c98efe(min, max) {
    if (min == null) return $f1ed8354ebe33615$var$r();
    if (max == null) {
        max = min;
        min = 0;
    }
    return (max - min) * $f1ed8354ebe33615$var$r() + min;
}
function $f1ed8354ebe33615$export$6c5277ffd5bb6b0b() {
    return $f1ed8354ebe33615$export$1ab1062261c98efe(0, Math.PI * 2);
}
function $f1ed8354ebe33615$export$d2675ab7bc8f0cd4() {
    return $f1ed8354ebe33615$export$7877a478dd30fd3d(0, Math.PI / 2, Math.PI, 3 * Math.PI / 2);
}
function $f1ed8354ebe33615$export$4dc4a801a9bb2c7e(mean = 0.0, deviation = 1.0) {
    return deviation * ($f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() - 3) / 3 + mean;
}
function $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfTrue = 0.5) {
    return $f1ed8354ebe33615$var$r() < chanceOfTrue;
}
function $f1ed8354ebe33615$export$e8015c10d27df017(chanceOfPositive = 0.5) {
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfPositive) ? 1 : -1;
}
function $f1ed8354ebe33615$export$4b740f64b13739ef(min, max) {
    return Math.floor($f1ed8354ebe33615$export$1ab1062261c98efe(min, max));
}
function $f1ed8354ebe33615$export$73b235628570e6fd() {
    return $f1ed8354ebe33615$export$4b740f64b13739ef(0, 256);
}
function $f1ed8354ebe33615$export$9f5ea5e22d955aad(x) {
    const low = Math.floor(x);
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(x - low) ? low + 1 : low;
}
function $f1ed8354ebe33615$export$7877a478dd30fd3d(...options) {
    return options[$f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length)];
}
function $f1ed8354ebe33615$export$ed5876990578d29a(n, options) {
    if (n < 0) throw new Error("Cannot choose negative number of elements");
    if (options.length === 0) throw new Error("Cannot choose from empty array");
    if (n > options.length) throw new Error(`Cannot choose ${n} unique elements from array of length ${options.length}`);
    // For small n relative to array size, use selection algorithm
    if (n <= options.length / 3) {
        const selected = new Set();
        const result = [];
        while(selected.size < n){
            const idx = $f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length);
            if (!selected.has(idx)) {
                selected.add(idx);
                result.push(options[idx]);
            }
        }
        return result;
    }
    // For larger n, shuffle and take first n elements
    const indices = Array.from({
        length: options.length
    }, (_, i)=>i);
    $f1ed8354ebe33615$export$448332262467e042(indices);
    return indices.slice(0, n).map((i)=>options[i]);
}
function $f1ed8354ebe33615$export$8a254833e92ed41(options) {
    if (options.length === 0) throw new Error("Cannot choose from empty array");
    let totalWeight = 0;
    for (const [_, weight] of options){
        if (weight < 0) throw new Error("Weights must be non-negative");
        totalWeight += weight;
    }
    if (totalWeight === 0) throw new Error("Total weight must be greater than 0");
    let random = $f1ed8354ebe33615$export$1ab1062261c98efe(0, totalWeight);
    for (const [item, weight] of options){
        random -= weight;
        if (random <= 0) return item;
    }
    // Fallback (should never happen)
    return options[options.length - 1][0];
}
function $f1ed8354ebe33615$export$b7df5d561049483a(options) {
    if (options.length === 0) throw new Error("Cannot take from empty array");
    return options.splice($f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length), 1)[0];
}
function $f1ed8354ebe33615$export$448332262467e042(a) {
    let i, j;
    i = a.length;
    while(--i > 0){
        j = $f1ed8354ebe33615$export$4b740f64b13739ef(0, i + 1);
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
function $f1ed8354ebe33615$export$9292fb87b153dc08(a, seed) {
    let i, j, temp;
    i = a.length;
    while(--i > 0){
        seed = seed * 1103515245 + 12345 | 0;
        j = (0, $jd0t2.mod)(seed, i + 1);
        temp = a[j];
        a[j] = a[i];
        a[i] = temp;
    }
    return a;
}

});



parcelRegister("dv4sm", function(module, exports) {

$parcel$export(module.exports, "ElectroTom", () => $966aea56bb3da77a$export$ceaf24c31871e3b3);

var $8x7Ib = parcelRequire("8x7Ib");
class $966aea56bb3da77a$export$ceaf24c31871e3b3 extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output, basePitch){
        super(audioContext, output), this.pitchDecayTime = 0.15, this.pitchEnvelopeAmount = 12 // Semitones to sweep down
        , // Tone layer parameters
        this.toneAttack = 0.002, this.toneDecay = 0.3, this.toneMix = 0.7, // Noise layer parameters
        this.noiseAttack = 0.001, this.noiseDecay = 0.02, this.noiseMix = 0.3, this.noiseFilterFreq = 4000;
        this.basePitch = basePitch;
        this.initializeParameters();
    }
    /**
   * Play an electronic tom hit with pitch sweep and noise transient.
   */ playNote(note, startTime, duration) {
        const velocity = note.velocity ?? 1.0;
        // Create tone layer with dual oscillators
        const osc1 = this.audioContext.createOscillator();
        const osc2 = this.audioContext.createOscillator();
        const toneGain = this.audioContext.createGain();
        // Configure oscillators
        osc1.type = "sine";
        osc2.type = "triangle";
        // Set base frequencies (osc2 slightly detuned for richness)
        const baseFreq = this.midiToFrequency(this.basePitch);
        const startFreq = baseFreq * Math.pow(2, this.pitchEnvelopeAmount / 12);
        osc1.frequency.setValueAtTime(startFreq, startTime);
        osc1.frequency.exponentialRampToValueAtTime(baseFreq, startTime + this.pitchDecayTime);
        osc2.frequency.setValueAtTime(startFreq * 1.01, startTime);
        osc2.frequency.exponentialRampToValueAtTime(baseFreq * 1.01, startTime + this.pitchDecayTime);
        // Tone envelope
        toneGain.gain.setValueAtTime(0, startTime);
        toneGain.gain.linearRampToValueAtTime(this.toneMix * velocity, startTime + this.toneAttack);
        toneGain.gain.exponentialRampToValueAtTime(0.001, startTime + this.toneAttack + this.toneDecay);
        // Create noise layer for attack transient
        const noiseBuffer = this.createNoiseBuffer(0.1);
        const noiseSource = this.audioContext.createBufferSource();
        const noiseFilter = this.audioContext.createBiquadFilter();
        const noiseGain = this.audioContext.createGain();
        noiseSource.buffer = noiseBuffer;
        noiseFilter.type = "bandpass";
        noiseFilter.frequency.value = this.noiseFilterFreq;
        noiseFilter.Q.value = 2;
        // Noise envelope (very short)
        noiseGain.gain.setValueAtTime(0, startTime);
        noiseGain.gain.linearRampToValueAtTime(this.noiseMix * velocity, startTime + this.noiseAttack);
        noiseGain.gain.exponentialRampToValueAtTime(0.001, startTime + this.noiseAttack + this.noiseDecay);
        // Connect audio graph
        osc1.connect(toneGain);
        osc2.connect(toneGain);
        toneGain.connect(this.gain);
        noiseSource.connect(noiseFilter);
        noiseFilter.connect(noiseGain);
        noiseGain.connect(this.gain);
        // Schedule playback
        osc1.start(startTime);
        osc2.start(startTime);
        noiseSource.start(startTime);
        const stopTime = startTime + Math.max(this.toneAttack + this.toneDecay, this.noiseAttack + this.noiseDecay) + 0.1;
        osc1.stop(stopTime);
        osc2.stop(stopTime);
        noiseSource.stop(stopTime);
        // Clean up
        osc1.onended = ()=>{
            osc1.disconnect();
            osc2.disconnect();
            toneGain.disconnect();
            noiseSource.disconnect();
            noiseFilter.disconnect();
            noiseGain.disconnect();
        };
    }
    /**
   * Create a white noise buffer for transient layer.
   */ createNoiseBuffer(duration) {
        const sampleRate = this.audioContext.sampleRate;
        const length = sampleRate * duration;
        const buffer = this.audioContext.createBuffer(1, length, sampleRate);
        const channel = buffer.getChannelData(0);
        for(let i = 0; i < length; i++)channel[i] = Math.random() * 2 - 1;
        return buffer;
    }
    /**
   * Convert MIDI note number to frequency.
   */ midiToFrequency(midiNote) {
        return 440 * Math.pow(2, (midiNote - 69) / 12);
    }
    /**
   * Get valid MIDI notes for this tom.
   */ getValidNotes() {
        // Return the MIDI note number based on base pitch
        // This maps to standard tom assignments:
        // 41 = Low Floor Tom (F2)
        // 43 = High Floor Tom (G2)
        // 45 = Low Tom (A2)
        return [
            this.basePitch
        ];
    }
    /**
   * Get display name including tom type.
   */ getDisplayName() {
        switch(this.basePitch){
            case 41:
                return "Low Tom";
            case 43:
                return "Mid Tom";
            case 45:
                return "High Tom";
            default:
                return `Tom (${this.basePitch})`;
        }
    }
    /**
   * Initialize tom-specific parameters.
   */ initializeParameters() {
        // Pitch parameters
        this.addParameter(()=>this.pitchEnvelopeAmount, (value)=>{
            this.pitchEnvelopeAmount = value;
        }, {
            key: "pitchEnvAmount",
            label: "Pitch Sweep",
            min: 0,
            max: 24,
            defaultValue: 12,
            step: 1,
            unit: "semitones",
            category: "Pitch"
        });
        this.addParameter(()=>this.pitchDecayTime, (value)=>{
            this.pitchDecayTime = value;
        }, {
            key: "pitchDecay",
            label: "Pitch Decay",
            min: 0.05,
            max: 0.5,
            defaultValue: 0.15,
            step: 0.01,
            unit: "s",
            category: "Pitch"
        });
        // Tone layer parameters
        this.addParameter(()=>this.toneMix, (value)=>{
            this.toneMix = value;
        }, {
            key: "toneMix",
            label: "Tone Mix",
            min: 0,
            max: 1,
            defaultValue: 0.7,
            step: 0.05,
            category: "Tone"
        });
        this.addParameter(()=>this.toneDecay, (value)=>{
            this.toneDecay = value;
        }, {
            key: "toneDecay",
            label: "Tone Decay",
            min: 0.1,
            max: 1.0,
            defaultValue: 0.3,
            step: 0.05,
            unit: "s",
            category: "Tone"
        });
        // Noise layer parameters
        this.addParameter(()=>this.noiseMix, (value)=>{
            this.noiseMix = value;
        }, {
            key: "noiseMix",
            label: "Noise Mix",
            min: 0,
            max: 1,
            defaultValue: 0.3,
            step: 0.05,
            category: "Noise"
        });
        this.addParameter(()=>this.noiseFilterFreq, (value)=>{
            this.noiseFilterFreq = value;
        }, {
            key: "noiseFilter",
            label: "Noise Filter",
            min: 1000,
            max: 8000,
            defaultValue: 4000,
            step: 100,
            unit: "Hz",
            category: "Noise"
        });
    }
}

});

parcelRegister("bpFDo", function(module, exports) {

$parcel$export(module.exports, "HiHat", () => $4915a2fd05ae9c89$export$8b4e9e9dda1f4a93);

var $8x7Ib = parcelRequire("8x7Ib");
class $4915a2fd05ae9c89$export$8b4e9e9dda1f4a93 extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output), // Synthesis parameters
        this.closedFilterFreq = 8000, this.openFilterFreq = 6000, this.closedDuration = 0.15 // Increased default closed duration
        , this.openDuration = 0.2, this.minVelocityDuration = 0.05 // Duration at velocity 0
        , this.maxVelocityDuration = 0.25 // Duration at velocity 1
        , this.attackTime = 0.001, this.openNoteThreshold = 46 // MIDI notes >= this are open hi-hat (46 = A#2)
        , // Persistent audio nodes
        this.noiseSource = null, this.currentStopId = 0 // Used to cancel previous stop scheduling
        ;
        // Create persistent filter and envelope nodes
        this.filter = this.audioContext.createBiquadFilter();
        this.filter.type = "highpass";
        this.filter.frequency.value = this.closedFilterFreq;
        this.filter.Q.value = 2.0; // Fixed resonance for consistent sound
        this.envelope = this.audioContext.createGain();
        this.envelope.gain.value = 0;
        // Connect the persistent chain
        this.filter.connect(this.envelope);
        this.envelope.connect(this.gain);
        this.initializeParameters();
        this.createNoiseSource();
    }
    /**
   * Create a new noise source and connect it to the filter chain.
   */ createNoiseSource() {
        // Clean up existing source if any
        if (this.noiseSource) this.noiseSource.disconnect();
        // Create noise buffer - longer buffer for better quality
        const bufferSize = this.audioContext.sampleRate * 0.5; // 500ms of noise
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate shaped noise for more metallic character
        for(let i = 0; i < bufferSize; i++){
            // Mix white noise with some higher frequency emphasis
            const whiteNoise = Math.random() * 2 - 1;
            const emphasis = Math.sin(i * 0.001) * 0.7; // Fixed brightness for consistent metallic character
            data[i] = whiteNoise * (1 + emphasis * 0.3);
        }
        // Create and configure new source
        this.noiseSource = this.audioContext.createBufferSource();
        this.noiseSource.buffer = buffer;
        this.noiseSource.loop = true;
        // Connect to persistent filter chain
        this.noiseSource.connect(this.filter);
        // Start the noise source immediately - it will be silent until envelope opens
        this.noiseSource.start();
        // Handle source ending (shouldn't happen due to looping, but just in case)
        this.noiseSource.onended = ()=>{
            console.warn("HiHat noise source ended unexpectedly");
        };
    }
    /**
   * Play a hi-hat note using persistent oscillators.
   */ playNote(note, startTime, _) {
        const velocity = note.velocity ?? 1.0;
        // Determine if this should be an open or closed hi-hat based on note number
        const isOpen = note.noteNumber >= this.openNoteThreshold;
        const filterFreq = isOpen ? this.openFilterFreq : this.closedFilterFreq;
        // Calculate velocity-scaled duration
        const baseDuration = isOpen ? this.openDuration : this.closedDuration;
        const velocityScaledDuration = this.minVelocityDuration + (this.maxVelocityDuration - this.minVelocityDuration) * velocity;
        const hatDuration = Math.max(baseDuration, velocityScaledDuration);
        // Smoothly transition filter frequency to avoid clicks
        this.filter.frequency.setTargetAtTime(filterFreq, startTime, 0.002);
        // Cancel any previous envelope scheduling and hold current value
        this.currentStopId++;
        const thisStopId = this.currentStopId;
        this.envelope.gain.cancelAndHoldAtTime(startTime);
        // Ramp smoothly from current held value to new attack peak
        // No need for setValueAtTime(0) - we ramp from whatever the current value is
        this.envelope.gain.linearRampToValueAtTime(velocity, startTime + this.attackTime);
        this.envelope.gain.exponentialRampToValueAtTime(0.00001, startTime + hatDuration);
        // Use setTargetAtTime for smooth final silence instead of hard cutoff
        this.envelope.gain.setTargetAtTime(0, startTime + hatDuration, 0.001);
    }
    /**
   * Get valid MIDI notes for hi-hat.
   */ getValidNotes() {
        return [
            42,
            46
        ]; // F#2 (closed) and A#2 (open) hi-hat notes
    }
    /**
   * Clean up persistent nodes when instrument is destroyed.
   */ onDestroy() {
        if (this.noiseSource) {
            this.noiseSource.stop();
            this.noiseSource.disconnect();
        }
        this.filter.disconnect();
        this.envelope.disconnect();
        super.onDestroy();
    }
    /**
   * Initialize hi-hat parameters.
   */ initializeParameters() {
        this.addParameter(()=>this.closedFilterFreq, (value)=>{
            this.closedFilterFreq = value;
        }, {
            key: "closedFilterFreq",
            label: "Closed Filter Freq",
            min: 4000,
            max: 12000,
            defaultValue: 8000,
            step: 200,
            unit: "Hz",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.openFilterFreq, (value)=>{
            this.openFilterFreq = value;
        }, {
            key: "openFilterFreq",
            label: "Open Filter Freq",
            min: 3000,
            max: 10000,
            defaultValue: 6000,
            step: 200,
            unit: "Hz",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.minVelocityDuration, (value)=>{
            this.minVelocityDuration = value;
        }, {
            key: "minVelocityDuration",
            label: "Min Velocity Duration",
            min: 0.01,
            max: 0.15,
            defaultValue: 0.05,
            step: 0.005,
            unit: "s",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.maxVelocityDuration, (value)=>{
            this.maxVelocityDuration = value;
        }, {
            key: "maxVelocityDuration",
            label: "Max Velocity Duration",
            min: 0.1,
            max: 0.5,
            defaultValue: 0.25,
            step: 0.005,
            unit: "s",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.closedDuration, (value)=>{
            this.closedDuration = value;
        }, {
            key: "closedDuration",
            label: "Closed Duration",
            min: 0.05,
            max: 0.4,
            defaultValue: 0.15,
            step: 0.01,
            unit: "s",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.openDuration, (value)=>{
            this.openDuration = value;
        }, {
            key: "openDuration",
            label: "Open Duration",
            min: 0.1,
            max: 1.0,
            defaultValue: 0.8,
            step: 0.01,
            unit: "s",
            category: "Hi-Hat"
        });
        this.addParameter(()=>this.attackTime, (value)=>{
            this.attackTime = value;
        }, {
            key: "attackTime",
            label: "Attack Time",
            min: 0.0001,
            max: 0.01,
            defaultValue: 0.001,
            step: 0.0001,
            unit: "s",
            category: "Hi-Hat"
        });
    }
}

});

parcelRegister("ivFOt", function(module, exports) {

$parcel$export(module.exports, "KickDrum", () => $138e0122aeb96628$export$f80df8538ac57b1b);

var $8x7Ib = parcelRequire("8x7Ib");
class $138e0122aeb96628$export$f80df8538ac57b1b extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output), // Sub-bass layer parameters
        this.subBassMix = 0.4, this.subBassDecay = 0.2, // Punch layer parameters
        this.punchStartFreq = 150, this.punchEndFreq = 80, this.punchMix = 0.5, this.punchDecay = 0.15, this.punchSweepTime = 0.05, // Global parameters
        this.attackTime = 0.001;
        // Set up persistent audio nodes that stay alive for the instrument's lifetime.
        // Master envelope controls overall kick output
        this.masterEnvelope = this.audioContext.createGain();
        this.masterEnvelope.gain.value = 0;
        this.masterEnvelope.connect(this.gain);
        // Layer 1: Sub-bass oscillator (40-60Hz)
        this.subBassOsc = this.audioContext.createOscillator();
        this.subBassOsc.type = "sine";
        this.subBassGain = this.audioContext.createGain();
        this.subBassGain.gain.value = this.subBassMix;
        this.subBassOsc.connect(this.subBassGain);
        this.subBassGain.connect(this.masterEnvelope);
        this.subBassOsc.start();
        // Layer 2: Punch oscillator with frequency sweep (100-200Hz dropping)
        this.punchOsc = this.audioContext.createOscillator();
        this.punchOsc.type = "sine";
        this.punchOsc.frequency.value = this.punchStartFreq;
        this.punchGain = this.audioContext.createGain();
        this.punchGain.gain.value = this.punchMix;
        this.punchOsc.connect(this.punchGain);
        this.punchGain.connect(this.masterEnvelope);
        this.punchOsc.start();
        this.initializeParameters();
    }
    /**
   * Play a kick drum note using persistent oscillators with click-free voice stealing.
   */ playNote(note, preStartTime, _duration) {
        const velocity = note.velocity ?? 1.0;
        // Cancel previous envelope and hold current value to avoid clicks
        this.masterEnvelope.gain.cancelAndHoldAtTime(preStartTime);
        this.punchGain.gain.cancelAndHoldAtTime(preStartTime);
        this.punchOsc.frequency.cancelAndHoldAtTime(preStartTime);
        this.subBassGain.gain.cancelAndHoldAtTime(preStartTime);
        // Use a small offset to avoid clicks
        const startTime = preStartTime + 0.02;
        const attackEnd = startTime + this.attackTime;
        // Sub Bass Envelope
        this.subBassGain.gain.linearRampToValueAtTime(this.subBassMix, startTime);
        this.subBassGain.gain.setTargetAtTime(0, startTime, this.subBassDecay);
        // Punch envelope
        this.punchGain.gain.linearRampToValueAtTime(this.punchMix, startTime);
        this.punchGain.gain.setTargetAtTime(0, startTime, this.punchDecay);
        // Punch frequency sweep
        this.punchOsc.frequency.linearRampToValueAtTime(this.punchStartFreq, startTime);
        this.punchOsc.frequency.exponentialRampToValueAtTime(this.punchEndFreq, startTime + this.punchSweepTime);
        // Master envelop
        this.masterEnvelope.gain.setTargetAtTime(velocity, preStartTime, this.attackTime);
    // Ramp down for whatever reason
    // const longestDecay = Math.max(this.subBassDecay, this.punchDecay);
    // this.masterEnvelope.gain.setTargetAtTime(0, startTime + longestDecay, 0.1);
    }
    /**
   * Get valid MIDI notes for kick drum.
   */ getValidNotes() {
        return [
            36
        ]; // Only C2 kick drum note
    }
    /**
   * Clean up persistent nodes when instrument is destroyed.
   */ onDestroy() {
        // Stop and disconnect persistent oscillators
        this.subBassOsc.stop();
        this.subBassOsc.disconnect();
        this.subBassGain.disconnect();
        this.punchOsc.stop();
        this.punchOsc.disconnect();
        this.punchGain.disconnect();
        this.masterEnvelope.disconnect();
        super.onDestroy();
    }
    /**
   * Initialize kick drum parameters for all three layers.
   */ initializeParameters() {
        // Sub-bass layer parameters
        this.addParameter(()=>this.subBassOsc.frequency.value, (value)=>{
            this.subBassOsc.frequency.value = value;
        }, {
            key: "subBassFreq",
            label: "Sub-Bass Freq",
            min: 30,
            max: 300,
            defaultValue: 50,
            step: 1,
            unit: "Hz",
            category: "Kick"
        });
        this.addParameter(()=>this.subBassMix, (value)=>{
            this.subBassMix = value;
        }, {
            key: "subBassGain",
            label: "Sub-Bass Gain",
            min: 0,
            max: 1.0,
            defaultValue: 0.4,
            step: 0.05,
            category: "Kick"
        });
        this.addParameter(()=>this.subBassDecay, (value)=>{
            this.subBassDecay = value;
        }, {
            key: "subBassDecay",
            label: "Sub-Bass Decay",
            min: 0.0,
            max: 0.5,
            defaultValue: 0.1,
            step: 0.01,
            unit: "s",
            category: "Kick"
        });
        // Punch layer parameters
        this.addParameter(()=>this.punchStartFreq, (value)=>{
            this.punchStartFreq = value;
        }, {
            key: "punchStartFreq",
            label: "Punch Start Freq",
            min: 50,
            max: 300,
            defaultValue: 160,
            step: 5,
            unit: "Hz",
            category: "Kick"
        });
        this.addParameter(()=>this.punchEndFreq, (value)=>{
            this.punchEndFreq = value;
        }, {
            key: "punchEndFreq",
            label: "Punch End Freq",
            min: 30,
            max: 200,
            defaultValue: 60,
            step: 5,
            unit: "Hz",
            category: "Kick"
        });
        this.addParameter(()=>this.punchMix, (value)=>{
            this.punchMix = value;
        }, {
            key: "punchMix",
            label: "Punch Mix",
            min: 0,
            max: 1.0,
            defaultValue: 0.5,
            step: 0.05,
            category: "Kick"
        });
        this.addParameter(()=>this.punchDecay, (value)=>{
            this.punchDecay = value;
        }, {
            key: "punchDecay",
            label: "Punch Decay",
            min: 0.0,
            max: 0.5,
            defaultValue: 0.05,
            step: 0.002,
            unit: "s",
            category: "Kick"
        });
        this.addParameter(()=>this.punchSweepTime, (value)=>{
            this.punchSweepTime = value;
        }, {
            key: "punchSweepTime",
            label: "Punch Sweep Time",
            min: 0.01,
            max: 0.2,
            defaultValue: 0.05,
            step: 0.01,
            unit: "s",
            category: "Kick"
        });
        // Global parameters
        this.addParameter(()=>this.attackTime, (value)=>{
            this.attackTime = value;
        }, {
            key: "attackTime",
            label: "Attack Time",
            min: 0.0001,
            max: 0.01,
            defaultValue: 0.001,
            step: 0.0001,
            unit: "s",
            category: "Kick"
        });
    }
}

});

parcelRegister("k8FXX", function(module, exports) {

$parcel$export(module.exports, "SnareDrum", () => $a3161733e9bd84fa$export$74b4a1beb4117103);

var $azFtk = parcelRequire("azFtk");

var $8x7Ib = parcelRequire("8x7Ib");
class $a3161733e9bd84fa$export$74b4a1beb4117103 extends (0, $8x7Ib.Instrument) {
    constructor(audioContext, output){
        super(audioContext, output), // Synthesis parameters
        this.bodyFreq = 200, this.bodyDecay = 0.08, this.bodyMix = 0.3, this.snareFilterFreq = 2000, this.snareFilterQ = 1.5, this.metalFreq1 = 3500, this.metalFreq2 = 5000, this.metalQ = 10, this.metalMix = 0.2, this.attackTime = 0.001, this.defaultDuration = 0.15, this.metalSource = null, this.snareSource = null, this.currentStopId = 0;
        // Create persistent audio chain
        this.setupPersistentNodes();
        this.initializeParameters();
    }
    /**
   * Set up persistent audio nodes that stay alive for the instrument's lifetime.
   */ setupPersistentNodes() {
        // Master envelope controls overall snare output
        this.masterEnvelope = this.audioContext.createGain();
        this.masterEnvelope.gain.value = 0;
        this.masterEnvelope.connect(this.gain);
        // Layer 1: Tonal body oscillator
        this.bodyOsc = this.audioContext.createOscillator();
        this.bodyOsc.type = "triangle";
        this.bodyOsc.frequency.value = this.bodyFreq;
        this.bodyGain = this.audioContext.createGain();
        this.bodyGain.gain.value = this.bodyMix;
        this.bodyOsc.connect(this.bodyGain);
        this.bodyGain.connect(this.masterEnvelope);
        this.bodyOsc.start();
        // Layer 2: Metallic ring filters
        this.metalFilter1 = this.audioContext.createBiquadFilter();
        this.metalFilter1.type = "bandpass";
        this.metalFilter1.frequency.value = this.metalFreq1;
        this.metalFilter1.Q.value = this.metalQ;
        this.metalFilter2 = this.audioContext.createBiquadFilter();
        this.metalFilter2.type = "bandpass";
        this.metalFilter2.frequency.value = this.metalFreq2;
        this.metalFilter2.Q.value = this.metalQ;
        this.metalGain = this.audioContext.createGain();
        this.metalGain.gain.value = this.metalMix;
        this.metalFilter1.connect(this.metalFilter2);
        this.metalFilter2.connect(this.metalGain);
        this.metalGain.connect(this.masterEnvelope);
        // Layer 3: Snare wire filter
        this.snareFilter = this.audioContext.createBiquadFilter();
        this.snareFilter.type = "highpass";
        this.snareFilter.frequency.value = this.snareFilterFreq;
        this.snareFilter.Q.value = this.snareFilterQ;
        this.snareGain = this.audioContext.createGain();
        const snareMix = 1.0 - this.bodyMix - this.metalMix; // Remaining mix
        this.snareGain.gain.value = snareMix;
        this.snareFilter.connect(this.snareGain);
        this.snareGain.connect(this.masterEnvelope);
        // Create initial noise sources
        this.createMetalNoiseSource();
        this.createSnareNoiseSource();
    }
    /**
   * Create metallic noise source for layer 2.
   */ createMetalNoiseSource() {
        if (this.metalSource) this.metalSource.disconnect();
        const bufferSize = this.audioContext.sampleRate * 0.5;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate shaped noise for metallic character
        for(let i = 0; i < bufferSize; i++)data[i] = Math.random() * 2 - 1;
        this.metalSource = this.audioContext.createBufferSource();
        this.metalSource.buffer = buffer;
        this.metalSource.loop = true;
        this.metalSource.connect(this.metalFilter1);
        this.metalSource.start();
        this.metalSource.onended = ()=>{
            setTimeout(()=>this.createMetalNoiseSource(), 10);
        };
    }
    /**
   * Create snare wire noise source for layer 3.
   */ createSnareNoiseSource() {
        if (this.snareSource) this.snareSource.disconnect();
        const bufferSize = this.audioContext.sampleRate * 0.5;
        const buffer = this.audioContext.createBuffer(1, bufferSize, this.audioContext.sampleRate);
        const data = buffer.getChannelData(0);
        // Generate white noise for snare wires
        for(let i = 0; i < bufferSize; i++)data[i] = (0, $azFtk.rUniform)(-1, 1);
        this.snareSource = this.audioContext.createBufferSource();
        this.snareSource.buffer = buffer;
        this.snareSource.loop = true;
        this.snareSource.connect(this.snareFilter);
        this.snareSource.start();
        this.snareSource.onended = ()=>{
            console.warn("Snare source ended unexpectedly");
        };
    }
    /**
   * Play a snare drum note using persistent oscillators with click-free voice stealing.
   */ playNote(note, startTime, _duration) {
        const velocity = note.velocity ?? 1.0;
        // Cancel previous envelope and hold current value to avoid clicks
        this.currentStopId++;
        const thisStopId = this.currentStopId;
        this.masterEnvelope.gain.cancelAndHoldAtTime(startTime);
        // Update persistent oscillator and filter parameters smoothly
        this.bodyOsc.frequency.setTargetAtTime(this.bodyFreq, startTime, 0.001);
        this.metalFilter1.frequency.setTargetAtTime(this.metalFreq1, startTime, 0.002);
        this.metalFilter2.frequency.setTargetAtTime(this.metalFreq2, startTime, 0.002);
        this.snareFilter.frequency.setTargetAtTime(this.snareFilterFreq, startTime, 0.002);
        // Update layer mix levels
        this.bodyGain.gain.setTargetAtTime(this.bodyMix, startTime, 0.001);
        this.metalGain.gain.setTargetAtTime(this.metalMix, startTime, 0.001);
        const snareMix = 1.0 - this.bodyMix - this.metalMix;
        this.snareGain.gain.setTargetAtTime(snareMix, startTime, 0.001);
        // Ramp to new attack peak from whatever the current envelope value is
        this.masterEnvelope.gain.linearRampToValueAtTime(velocity, startTime + this.attackTime);
        // Exponential decay
        this.masterEnvelope.gain.exponentialRampToValueAtTime(0.00001, startTime + this.defaultDuration);
        // Smooth final silence
        this.masterEnvelope.gain.setTargetAtTime(0, startTime + this.defaultDuration, 0.001);
        // Body oscillator frequency sweep (like membrane pitch drop)
        this.bodyOsc.frequency.exponentialRampToValueAtTime(this.bodyFreq * 0.5, startTime + this.bodyDecay);
        // Recreate noise sources periodically to avoid staleness
        const shouldRecreateNoise = Math.random() < 0.03; // 3% chance
        if (shouldRecreateNoise) setTimeout(()=>{
            if (thisStopId === this.currentStopId) {
                this.createMetalNoiseSource();
                this.createSnareNoiseSource();
            }
        }, (startTime - this.audioContext.currentTime) * 1000);
    }
    /**
   * Get valid MIDI notes for snare drum.
   */ getValidNotes() {
        return [
            38
        ]; // Only D2 snare drum note
    }
    /**
   * Clean up persistent nodes when instrument is destroyed.
   */ onDestroy() {
        // Stop and disconnect persistent oscillators
        this.bodyOsc.stop();
        this.bodyOsc.disconnect();
        this.bodyGain.disconnect();
        if (this.metalSource) {
            this.metalSource.stop();
            this.metalSource.disconnect();
        }
        this.metalFilter1.disconnect();
        this.metalFilter2.disconnect();
        this.metalGain.disconnect();
        if (this.snareSource) {
            this.snareSource.stop();
            this.snareSource.disconnect();
        }
        this.snareFilter.disconnect();
        this.snareGain.disconnect();
        this.masterEnvelope.disconnect();
        super.onDestroy();
    }
    /**
   * Initialize snare drum parameters.
   */ initializeParameters() {
        this.addParameter(()=>this.bodyFreq, (value)=>{
            this.bodyFreq = value;
        }, {
            key: "bodyFreq",
            label: "Body Frequency",
            min: 100,
            max: 400,
            defaultValue: 200,
            step: 10,
            unit: "Hz",
            category: "Snare"
        });
        this.addParameter(()=>this.bodyDecay, (value)=>{
            this.bodyDecay = value;
        }, {
            key: "bodyDecay",
            label: "Body Decay",
            min: 0.001,
            max: 0.2,
            defaultValue: 0.02,
            step: 0.005,
            unit: "s",
            category: "Snare"
        });
        this.addParameter(()=>this.bodyMix, (value)=>{
            this.bodyMix = value;
        }, {
            key: "bodyMix",
            label: "Body Mix",
            min: 0,
            max: 1.0,
            defaultValue: 0.3,
            step: 0.05,
            category: "Snare"
        });
        this.addParameter(()=>this.snareFilterFreq, (value)=>{
            this.snareFilterFreq = value;
        }, {
            key: "snareFilterFreq",
            label: "Wire Frequency",
            min: 1000,
            max: 5000,
            defaultValue: 2000,
            step: 100,
            unit: "Hz",
            category: "Snare"
        });
        this.addParameter(()=>this.snareFilterQ, (value)=>{
            this.snareFilterQ = value;
        }, {
            key: "snareFilterQ",
            label: "Wire Resonance",
            min: 0.5,
            max: 5,
            defaultValue: 1.5,
            step: 0.1,
            category: "Snare"
        });
        this.addParameter(()=>this.metalFreq1, (value)=>{
            this.metalFreq1 = value;
        }, {
            key: "metalFreq1",
            label: "Metal Freq 1",
            min: 2000,
            max: 6000,
            defaultValue: 3500,
            step: 100,
            unit: "Hz",
            category: "Snare"
        });
        this.addParameter(()=>this.metalFreq2, (value)=>{
            this.metalFreq2 = value;
        }, {
            key: "metalFreq2",
            label: "Metal Freq 2",
            min: 3000,
            max: 8000,
            defaultValue: 5000,
            step: 100,
            unit: "Hz",
            category: "Snare"
        });
        this.addParameter(()=>this.metalQ, (value)=>{
            this.metalQ = value;
        }, {
            key: "metalQ",
            label: "Metal Resonance",
            min: 5,
            max: 30,
            defaultValue: 10,
            step: 1,
            category: "Snare"
        });
        this.addParameter(()=>this.metalMix, (value)=>{
            this.metalMix = value;
        }, {
            key: "metalMix",
            label: "Metal Mix",
            min: 0,
            max: 1.0,
            defaultValue: 0.2,
            step: 0.05,
            category: "Snare"
        });
        this.addParameter(()=>this.attackTime, (value)=>{
            this.attackTime = value;
        }, {
            key: "attackTime",
            label: "Attack Time",
            min: 0.0001,
            max: 0.01,
            defaultValue: 0.001,
            step: 0.0001,
            unit: "s",
            category: "Snare"
        });
        this.addParameter(()=>this.defaultDuration, (value)=>{
            this.defaultDuration = value;
        }, {
            key: "duration",
            label: "Duration",
            min: 0.05,
            max: 0.8,
            defaultValue: 0.3,
            step: 0.01,
            unit: "s",
            category: "Snare"
        });
    }
}

});


parcelRegister("knYRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a05fa34df60c9d$export$2e2bcd8739ae039);

var $e2Ri5 = parcelRequire("e2Ri5");

var $2oYNi = parcelRequire("2oYNi");

var $9iM1N = parcelRequire("9iM1N");
class $07a05fa34df60c9d$export$2e2bcd8739ae039 extends (0, $2oYNi.default) {
    static{
        /** Music parameters for main menu state */ this.MENU_PARAMS = {
            tempo: 120,
            intensity: 0.5
        };
    }
    static{
        /** Music parameters for active gameplay */ this.PLAYING_PARAMS = {
            tempo: 150,
            intensity: 0.8
        };
    }
    static{
        /** Music parameters for upgrade/victory state */ this.UPGRADE_PARAMS = {
            tempo: 135,
            intensity: 0.3
        };
    }
    static{
        /** Music parameters for game over state */ this.GAME_OVER_PARAMS = {
            tempo: 90,
            intensity: 0.5
        };
    }
    /**
   * Get the MusicGenerator entity
   */ get musicGenerator() {
        const maybeMusicGenerator = this.game?.entities.getById("musicGenerator");
        if (maybeMusicGenerator instanceof (0, $9iM1N.default)) return maybeMusicGenerator;
        return undefined;
    }
    onAdd() {
        // Initialize with menu tempo
        this.setMusicParams($07a05fa34df60c9d$export$2e2bcd8739ae039.MENU_PARAMS);
    }
    /**
   * When a level starts, switch to playing mode
   */ onLevelStart({ level: level }) {
        this.setMusicParams($07a05fa34df60c9d$export$2e2bcd8739ae039.PLAYING_PARAMS);
    }
    /**
   * When a level completes, switch to upgrade mode
   */ onLevelComplete({ level: level, enemiesKilled: enemiesKilled }) {
        this.setMusicParams($07a05fa34df60c9d$export$2e2bcd8739ae039.UPGRADE_PARAMS);
    }
    /**
   * Game over - switch to game over mode
   */ onGameOver({}) {
        this.setMusicParams($07a05fa34df60c9d$export$2e2bcd8739ae039.GAME_OVER_PARAMS);
    }
    /**
   * When an upgrade is chosen, return to playing mode
   */ onUpgradeChosen({ upgrade: upgrade }) {
    // Note: This will trigger when the next level starts via onLevelStart
    // For now, we could stay in upgrade mode until the next level
    }
    /**
   * When returning to main menu, switch to menu mode
   */ onMenuStart({}) {
        this.setMusicParams($07a05fa34df60c9d$export$2e2bcd8739ae039.MENU_PARAMS);
    }
    /**
   * Apply new music parameters with smooth tempo transitions.
   * Non-tempo parameters are applied immediately while tempo
   * is ramped over 2 beats to avoid jarring changes.
   */ setMusicParams(targetParams) {
        const musicGen = this.musicGenerator;
        if (!musicGen) return;
        // Apply smooth tempo transition (2 beats duration)
        musicGen.requestTempoRamp(musicGen.getCurrentTempo(), targetParams.tempo, 2);
        // Update music intensity parameter
        musicGen.setParams({
            intensity: targetParams.intensity
        });
    }
    constructor(...args){
        super(...args), this.tags = [
            "musicController"
        ], this.id = "musicController", this.pausable = false // Keep music control active during pause
        , this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Permanent;
    }
}

});

parcelRegister("fsTIF", function(module, exports) {

$parcel$export(module.exports, "TempoClock", () => $8334eae98b350d4c$export$33a07adf80ac7ccb);

var $2oYNi = parcelRequire("2oYNi");
class $8334eae98b350d4c$export$33a07adf80ac7ccb extends (0, $2oYNi.default) {
    static{
        this.SCHEDULER_LOOKAHEAD = 0.1 // 100ms lookahead for scheduling
        ;
    }
    constructor(initialBpm = 80){
        super(), this.tags = [
            "tempoClock"
        ], this.id = "tempoClock", this.pausable = false // Keep music timing during pause
        , this.beatsPerMeasure = 4, this.tempoSegments = [], this.lastScheduledBeat = -1, this.lastProcessedBeat = -1;
        // Initialize with first tempo segment - will be set to proper audio time in onAdd
        this.tempoSegments.push({
            startBeat: 0,
            bpm: initialBpm,
            startAudioTime: 0
        });
    }
    /**
   * Initialize timing when added to game (when audio context is available).
   */ onAdd() {
        // Update the initial tempo segment with the current audio context time
        if (this.tempoSegments.length > 0) this.tempoSegments[0].startAudioTime = this.audioContext.currentTime;
    }
    get audioContext() {
        const audio = this.game?.audio;
        if (!audio) throw new Error("Audio context not yet available in game");
        return audio;
    }
    /**
   * Get the current beat number with fractional precision.
   * Compensates for audio latency to keep visuals synchronized.
   *
   * @returns Current beat (e.g., 1.25 = quarter way through beat 2)
   */ getCurrentBeatNumber() {
        const visualLatencyCompensation = this.audioContext.baseLatency;
        const currentTime = this.audioContext.currentTime - visualLatencyCompensation;
        return this.getBeatNumberAtTime(currentTime);
    }
    /**
   * Get the current measure number (0-based)
   */ getMeasureNumber() {
        return Math.floor(this.getCurrentBeatNumber() / this.beatsPerMeasure);
    }
    /**
   * Get the current beat within the measure (0-3 for 4/4 time)
   */ getBeatInMeasure() {
        return this.getCurrentBeatNumber() % this.beatsPerMeasure;
    }
    /**
   * Get the current tempo in BPM
   */ getCurrentTempo() {
        const currentBeat = this.getCurrentBeatNumber();
        const segment = this.getSegmentForBeat(currentBeat);
        if (!segment) {
            console.warn("TempoClock: No segment found for current tempo, returning default 120 BPM");
            return 120; // Default fallback tempo
        }
        return segment.bpm;
    }
    /**
   * Convert a beat number to audio context time.
   * Handles tempo changes by finding the appropriate segment
   * and calculating within that segment's timing.
   */ getAudioTimeForBeat(beatNumber) {
        const segment = this.getSegmentForBeat(beatNumber);
        if (!segment) {
            console.warn("TempoClock: No segment found for beat, returning current audio time");
            return this.audioContext.currentTime;
        }
        const beatsFromSegmentStart = beatNumber - segment.startBeat;
        const secondsFromSegmentStart = beatsFromSegmentStart * 60 / segment.bpm;
        const audioTime = segment.startAudioTime + secondsFromSegmentStart;
        return audioTime;
    }
    /**
   * Get the audio context time for a subdivision of a beat
   */ getAudioTimeForSubdivision(beatNumber, subdivision, totalSubdivisions) {
        const beatStartTime = this.getAudioTimeForBeat(beatNumber);
        const beatDuration = 60 / this.getCurrentTempo();
        const subdivisionDuration = beatDuration / totalSubdivisions;
        return beatStartTime + subdivision * subdivisionDuration;
    }
    /**
   * Convert beats to duration in seconds at current tempo.
   * Alias method for compatibility with old instrument system.
   */ beatsToSeconds(beats) {
        const currentTempo = this.getCurrentTempo();
        return beats * 60 / currentTempo;
    }
    /**
   * Convert beat number to audio context time.
   * Alias method for compatibility with old instrument system.
   */ beatToTime(beatNumber) {
        return this.getAudioTimeForBeat(beatNumber);
    }
    /**
   * Change tempo immediately at the next beat boundary.
   * Creates a new tempo segment starting at the next whole beat.
   */ setTempo(bpm) {
        const currentBeat = Math.ceil(this.getCurrentBeatNumber());
        this.scheduleTempo(bpm, currentBeat);
    }
    /**
   * Schedule a tempo change to occur at a specific beat.
   * Removes any conflicting future tempo changes and adds
   * a new segment at the specified beat.
   */ scheduleTempo(bpm, atBeat) {
        const oldBpm = this.getCurrentTempo();
        // Remove any existing segments that start at or after this beat
        this.tempoSegments = this.tempoSegments.filter((seg)=>seg.startBeat < atBeat);
        // Add new tempo segment
        this.tempoSegments.push({
            startBeat: atBeat,
            bpm: bpm,
            startAudioTime: this.getAudioTimeForBeat(atBeat)
        });
        // Sort segments by start beat to maintain order
        this.tempoSegments.sort((a, b)=>a.startBeat - b.startBeat);
        // Emit tempo change event
        this.dispatch("tempoChange", {
            oldBpm: oldBpm,
            newBpm: bpm,
            changeBeat: atBeat
        });
    }
    /**
   * Get beat number at a specific audio time
   */ getBeatNumberAtTime(audioTime) {
        // Safety check - ensure we have at least one tempo segment
        if (this.tempoSegments.length === 0) {
            console.warn("TempoClock: No tempo segments found, returning beat 0");
            return 0;
        }
        // Find the appropriate tempo segment
        let currentSegment = this.tempoSegments[0];
        for (const segment of this.tempoSegments){
            if (segment.startAudioTime <= audioTime) currentSegment = segment;
            else break;
        }
        // Additional safety check
        if (!currentSegment) {
            console.warn("TempoClock: No valid tempo segment found, returning beat 0");
            return 0;
        }
        // Calculate beat number within this segment
        const timeFromSegmentStart = audioTime - currentSegment.startAudioTime;
        const beatsFromSegmentStart = timeFromSegmentStart * currentSegment.bpm / 60;
        return currentSegment.startBeat + beatsFromSegmentStart;
    }
    /**
   * Get the tempo segment that contains a specific beat
   */ getSegmentForBeat(beatNumber) {
        // Safety check for empty segments
        if (this.tempoSegments.length === 0) {
            console.warn("TempoClock: No tempo segments available");
            return undefined;
        }
        let currentSegment = this.tempoSegments[0];
        for (const segment of this.tempoSegments){
            if (segment.startBeat <= beatNumber) currentSegment = segment;
            else break;
        }
        return currentSegment;
    }
    /**
   * Called every frame to emit scheduling and synchronization events.
   * Uses lookahead scheduling to give composers time to prepare audio events.
   */ onTick() {
        // Check for beats that need to be scheduled with lookahead
        const lookaheadTime = this.audioContext.currentTime + $8334eae98b350d4c$export$33a07adf80ac7ccb.SCHEDULER_LOOKAHEAD;
        const lookaheadBeat = Math.floor(this.getBeatNumberAtTime(lookaheadTime));
        if (lookaheadBeat > this.lastScheduledBeat) {
            // We need to schedule this upcoming beat
            const measureNumber = Math.floor(lookaheadBeat / this.beatsPerMeasure);
            const beatInMeasure = lookaheadBeat % this.beatsPerMeasure;
            const beatStartTime = this.getAudioTimeForBeat(lookaheadBeat);
            // Emit scheduling event for composers to prepare audio
            this.dispatch("scheduleBeat", {
                beatNumber: lookaheadBeat,
                measureNumber: measureNumber,
                beatInMeasure: beatInMeasure,
                beatStartTime: beatStartTime
            });
            // Emit measure scheduling event on downbeats
            if (beatInMeasure === 0) this.dispatch("scheduleMeasure", {
                measureNumber: measureNumber,
                beatNumber: lookaheadBeat,
                measureStartTime: beatStartTime
            });
            this.lastScheduledBeat = lookaheadBeat;
        }
        // Also emit synchronization events for visual elements (no lookahead)
        const currentBeat = Math.floor(this.getCurrentBeatNumber());
        if (currentBeat > (this.lastProcessedBeat ?? -1)) {
            const measureNumber = Math.floor(currentBeat / this.beatsPerMeasure);
            const beatInMeasure = currentBeat % this.beatsPerMeasure;
            // Emit beat event for visual synchronization
            this.dispatch("beatStart", {
                beatNumber: currentBeat,
                measureNumber: measureNumber,
                beatInMeasure: beatInMeasure
            });
            // Emit measure event on downbeats
            if (beatInMeasure === 0) this.dispatch("measureStart", {
                measureNumber: measureNumber,
                beatNumber: currentBeat
            });
            this.lastProcessedBeat = currentBeat;
        }
    }
    /**
   * Get how close we are to a beat (0 = exactly on beat, 1 = just before next beat)
   */ getBeatPhase(time) {
        const currentTime = time ?? this.audioContext.currentTime;
        const beatNumber = this.getBeatNumberAtTime(currentTime);
        return beatNumber % 1.0;
    }
    /**
   * Check if we're currently on a downbeat (first beat of measure)
   */ isDownbeat(time) {
        const currentTime = time ?? this.audioContext.currentTime;
        const beatNumber = this.getBeatNumberAtTime(currentTime);
        const nearestBeat = Math.round(beatNumber);
        return nearestBeat % this.beatsPerMeasure === 0;
    }
}

});


parcelRegister("hiAPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d29da6ad0b954b4$export$2e2bcd8739ae039);
class $1d29da6ad0b954b4$export$2e2bcd8739ae039 {
    beginContact(contactInfo) {
        if ($1d29da6ad0b954b4$var$shouldTrack(contactInfo)) this.contacts.push(contactInfo);
    }
    endContact(contactInfo) {
        if ($1d29da6ad0b954b4$var$shouldTrack(contactInfo)) {
            const index = this.contacts.findIndex((info)=>$1d29da6ad0b954b4$var$contactsAreEqual(info, contactInfo));
            if (index >= 0) this.contacts.splice(index, 1);
        }
    }
    getContacts() {
        return this.contacts;
    }
    constructor(){
        this.contacts = [];
    }
}
/** Whether or not this is a collision we need to keep track of */ function $1d29da6ad0b954b4$var$shouldTrack({ shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB }) {
    return true;
}
/** Whether or not two ContactInfos represent the same contact */ function $1d29da6ad0b954b4$var$contactsAreEqual(a, b) {
    return a.bodyA === b.bodyA && a.bodyB === b.bodyB && a.shapeA === b.shapeA && a.shapeB === b.shapeB || a.bodyA === b.bodyB && a.bodyB === b.bodyA && a.shapeA === b.shapeB && a.shapeB === b.shapeA;
}

});

parcelRegister("kD5ZK", function(module, exports) {

$parcel$export(module.exports, "eventHandlerName", () => $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7);
$parcel$export(module.exports, "isEventHandlerName", () => $c0f9b00b45d3abcb$export$cc8b0ace4ebf35fa);
$parcel$export(module.exports, "handlerNameToEventName", () => $c0f9b00b45d3abcb$export$7f9b4f9156103c75);
function $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7(eventName) {
    return `on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`;
}
function $c0f9b00b45d3abcb$export$cc8b0ace4ebf35fa(name) {
    return name.startsWith("on") && name.length > 2;
}
function $c0f9b00b45d3abcb$export$7f9b4f9156103c75(handlerName) {
    const firstLetter = handlerName[2];
    const rest = handlerName.slice(3);
    return firstLetter.toLowerCase() + rest;
}

});

parcelRegister("fknLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $913c3d10ae4e12ec$export$2e2bcd8739ae039);

var $kD5ZK = parcelRequire("kD5ZK");

var $6LGUq = parcelRequire("6LGUq");

var $ljQ02 = parcelRequire("ljQ02");

var $2JTRA = parcelRequire("2JTRA");
const $913c3d10ae4e12ec$export$57d24cb2f04f6e96 = (e)=>Boolean(e.body);
class $913c3d10ae4e12ec$export$2e2bcd8739ae039 {
    constructor(){
        /** Maps entity ids to entities */ this.idToEntity = new Map();
        /** Maps tags to entities */ this.tagged = new (0, $ljQ02.default)();
        /** Maps event types to entities that handle them */ this.handlers = new (0, $ljQ02.default)();
        /** Maps filters to entities that pass them */ this.filters = new (0, $6LGUq.FilterMultiMap)();
        /** All entities */ this.all = new Set();
        this.addFilter($913c3d10ae4e12ec$export$57d24cb2f04f6e96);
    }
    get withBody() {
        return this.getByFilter($913c3d10ae4e12ec$export$57d24cb2f04f6e96);
    }
    /** Adds an entity to this list and all sublists and does all the bookkeeping */ add(entity) {
        this.all.add(entity);
        this.filters.addItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.add(tag, entity);
        for (const methodName of (0, $2JTRA.getAllMethods)(entity))if (methodName.startsWith("on")) this.handlers.add((0, $kD5ZK.handlerNameToEventName)(methodName), entity);
        if (entity.id) {
            if (this.idToEntity.has(entity.id)) throw new Error(`entities with duplicate ids: ${entity.id}`);
            this.idToEntity.set(entity.id, entity);
        }
    }
    /** Removes an entity from this list and all the sublists and does some bookkeeping */ remove(entity) {
        this.all.delete(entity);
        this.filters.removeItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.remove(tag, entity);
        for (const methodName of (0, $2JTRA.getAllMethods)(entity))if ((0, $kD5ZK.isEventHandlerName)(methodName)) this.handlers.remove((0, $kD5ZK.handlerNameToEventName)(methodName), entity);
        if (entity.id) this.idToEntity.delete(entity.id);
    }
    /** Get the entity with the given id. */ getById(id) {
        return this.idToEntity.get(id);
    }
    /** Returns all entities with the given tag. */ getTagged(tag) {
        return this.tagged.get(tag);
    }
    /** Returns all entities that have all the given tags */ getTaggedAll(...tags) {
        if (tags.length === 0) return [];
        return this.getTagged(tags[0]).filter((e)=>tags.every((t)=>e.tags.includes(t)));
    }
    /** Returns all entities that have at least one of the given tags */ getTaggedAny(...tags) {
        const result = new Set();
        for (const tag of tags)for (const e of this.getTagged(tag))result.add(e);
        return [
            ...result
        ];
    }
    /**
   * Adds a filter for fast lookup with getByFilter() in the future.
   */ addFilter(filter) {
        this.filters.addFilter(filter, this.all);
    }
    /**
   * Removes a filter that was added with addFilter().
   */ removeFilter(filter) {
        this.filters.removeFilter(filter);
    }
    /**
   * Return all the entities that pass a type guard.
   * Pair with addFilter() to make this fast.
   */ getByFilter(filter) {
        const result = this.filters.getItems(filter);
        return result ?? [
            ...this.all
        ].filter(filter);
    }
    /**
   * Get all entities that handle a specific event type.
   */ getHandlers(eventType) {
        return this.handlers.get(eventType);
    }
    /**
   * Iterate through all the entities.
   */ [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
}

});
parcelRegister("6LGUq", function(module, exports) {

$parcel$export(module.exports, "FilterMultiMap", () => $2bdf816bbe356527$export$eadac383198be9f3);

var $gs6ty = parcelRequire("gs6ty");
class $2bdf816bbe356527$export$eadac383198be9f3 {
    /** Adds a new filter and optionally populates it with items from the given collection */ addFilter(filter, all = []) {
        if (!this.sets.has(filter)) {
            const set = new (0, $gs6ty.default)(filter);
            for (const item of all)set.addIfValid(item);
            this.sets.set(filter, set);
        }
    }
    /** Removes a filter and its associated filtered set */ removeFilter(filter) {
        this.sets.delete(filter);
    }
    /** Adds an item to all filtered sets where it passes the filter */ addItem(item) {
        for (const list of this.sets.values())list.addIfValid(item);
    }
    /** Removes an item from all filtered sets */ removeItem(item) {
        for (const list of this.sets.values())list.remove(item);
    }
    /** Gets the filtered set for a specific filter */ getItems(filter) {
        return this.sets.get(filter);
    }
    constructor(){
        this.sets = new Map();
    }
}

});
parcelRegister("gs6ty", function(module, exports) {

$parcel$export(module.exports, "default", () => $04179bd0fe63c1d8$export$2e2bcd8739ae039);
/** A type guard function that determines if an item matches a specific type criteria */ class $04179bd0fe63c1d8$export$2e2bcd8739ae039 {
    constructor(predicate){
        this.predicate = predicate;
        this.items = new Set();
    }
    /** Adds an item to the set only if it passes the filter predicate */ addIfValid(item) {
        if (this.predicate(item)) this.items.add(item);
    }
    /** Removes an item from the set if it passes the filter predicate */ remove(item) {
        if (this.predicate(item)) this.items.delete(item);
    }
    /** Gets the number of items in the filtered set */ get size() {
        return this.items.size;
    }
    /** Gets the number of items in the filtered set (alias for size) */ get length() {
        return this.items.size;
    }
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
}

});


parcelRegister("ljQ02", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afe5ecb614970f3$export$2e2bcd8739ae039);
/**
 * A map of lists. Automatically creates and removes lists as needed.
 * TODO: Consider using a Set instead of an Array for the values.
 */ class $3afe5ecb614970f3$export$2e2bcd8739ae039 {
    constructor(){
        this.map = new Map();
    }
    /** Adds a value to the list associated with the given key */ add(key, value) {
        if (!this.map.has(key)) this.map.set(key, [
            value
        ]);
        else this.map.get(key).push(value);
    }
    /** Gets the list of values for the given key, returns empty array if key doesn't exist */ get(key) {
        return this.map.get(key) ?? [];
    }
    /** Checks if a specific key-value pair exists in the map */ has(key, value) {
        return this.map.has(key) && this.map.get(key).includes(value);
    }
    /** Removes a specific value from the list associated with the given key */ remove(key, value) {
        if (this.map.has(key)) {
            const array = this.map.get(key);
            const index = array.indexOf(value);
            if (index >= 0) {
                array.splice(index, 1);
                if (array.length === 0) this.map.delete(key);
                return;
            }
        }
        throw new Error(`<${key}:${value}> not found`);
    }
}

});

parcelRegister("2JTRA", function(module, exports) {

$parcel$export(module.exports, "objectKeys", () => $25c6ed34d0d559af$export$259b4dd69e654a7a);
$parcel$export(module.exports, "objectEntries", () => $25c6ed34d0d559af$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "grouped", () => $25c6ed34d0d559af$export$a188e271553f9211);
$parcel$export(module.exports, "getAllMethods", () => $25c6ed34d0d559af$export$9859237ef1323ecc);
/**
 * Type-safe version of Object.keys() that preserves the object's key types.
 */ function $25c6ed34d0d559af$export$259b4dd69e654a7a(obj) {
    return Object.keys(obj);
}
function $25c6ed34d0d559af$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $25c6ed34d0d559af$export$58aefef1ff9edd34(obj, fn) {
    return $25c6ed34d0d559af$export$259b4dd69e654a7a(obj).reduce((acc, key)=>{
        acc[key] = fn(obj[key], key);
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((acc, key)=>{
        acc[key] = obj[key];
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$a188e271553f9211(arr, getKey) {
    return $25c6ed34d0d559af$export$6a29ade99f81ec8a(arr.reduce((acc, item)=>{
        const key = getKey(item);
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}));
}
function $25c6ed34d0d559af$export$9859237ef1323ecc(entity) {
    const methods = [];
    let current = entity;
    // Traverse up the prototype chain
    while(current !== null && current !== undefined && current !== Object.prototype){
        // Get own property names of the current object
        const propertyNames = Object.getOwnPropertyNames(current);
        // Filter out non-function properties and already added methods
        for (const name of propertyNames)// Access on entity and not currentObject because we're looking at prototypes
        if (typeof entity[name] === "function" && !methods.includes(name)) methods.push(name);
        // Move up the prototype chain
        current = Object.getPrototypeOf(current);
    }
    return methods;
}

});


parcelRegister("lKWt6", function(module, exports) {

$parcel$export(module.exports, "GameRenderer2d", () => $b63a73ca255be033$export$4474c89b2a999acc);
parcelRequire("iuB9z");
var $bja9j = parcelRequire("bja9j");

var $gehDP = parcelRequire("gehDP");

var $cbsax = parcelRequire("cbsax");

var $5v1Ar = parcelRequire("5v1Ar");
class $b63a73ca255be033$export$4474c89b2a999acc {
    /** The number of sprites currently managed by this renderer. Mostly useful for debugging. */ get spriteCount() {
        return this._spriteCount;
    }
    set spriteCount(value) {
        this._spriteCount = value;
    }
    /**
   * The root Pixi container that holds all rendering layers.
   * Each layer in LAYERS is added as a child of this stage container.
   */ get stage() {
        return this.app.stage;
    }
    /**
   * The HTML5 Canvas element where all rendering output is displayed.
   * Managed by Pixi.js with automatic resizing and density scaling.
   */ get canvas() {
        return this.app.renderer.canvas;
    }
    /**
   * Creates a new GameRenderer2d instance.
   *
   * @param layerInfos - Configuration for all rendering layers (from LAYERS config)
   * @param defaultLayerName - Layer to use for sprites that don't specify a layer
   * @param onResize - Optional callback fired when the renderer viewport changes size
   */ constructor(layerInfos, defaultLayerName, onResize){
        this.layerInfos = layerInfos;
        this.defaultLayerName = defaultLayerName;
        this.onResize = onResize;
        this.cursor = "none";
        this._spriteCount = 0;
        this.resizeHandler = ()=>this.handleResize();
        this.app = new $bja9j.Application();
        this.showCursor();
        this.camera = new (0, $5v1Ar.Camera2d)(this, (0, $cbsax.V)(0, 0));
        for (const layerInfo of Object.values((0, $gehDP.LAYERS)))this.app.stage.addChild(layerInfo.container);
        window.addEventListener("resize", this.resizeHandler);
    }
    async init(pixiOptions = {}) {
        await this.app.init({
            resizeTo: window,
            autoDensity: true,
            antialias: true,
            ...pixiOptions
        }).then(()=>{
            document.body.appendChild(this.canvas);
        });
    }
    /**
   * Requests fullscreen mode for the game canvas.
   * Waits for user interaction (click) to comply with browser security requirements.
   */ requestFullscreen() {
        const makeFullScreen = ()=>{
            this.canvas.requestFullscreen();
            this.canvas.removeEventListener("click", makeFullScreen);
        };
        this.canvas.addEventListener("click", makeFullScreen);
    }
    /**
   * Gets the effective height of the renderer viewport in logical pixels.
   */ getHeight() {
        return this.app.renderer.height / this.app.renderer.resolution;
    }
    /**
   * Gets the effective width of the renderer viewport in logical pixels.
   */ getWidth() {
        return this.app.renderer.width / this.app.renderer.resolution;
    }
    getSize() {
        return (0, $cbsax.V)(this.getWidth(), this.getHeight());
    }
    handleResize() {
        this.app.resizeTo = window;
        this.app.resize();
        this.onResize?.(this.getSize());
    }
    hideCursor() {
        this.cursor = "none";
    }
    showCursor() {
        this.cursor = "auto";
    }
    setCursor(value) {
        this.cursor = value;
    }
    /**
   * Renders the current frame to the canvas.
   *
   * This is the core of the rendering pipeline:
   * 1. Updates all layer transformations via camera.updateLayer()
   * 2. Calls Pixi's render() to draw everything to the canvas
   * 3. Updates the cursor style if needed
   *
   * Called once per frame by the main game loop.
   */ render() {
        for (const layerInfo of Object.values(this.layerInfos))this.camera.updateLayer(layerInfo);
        this.app.render();
        if (this.app.renderer.view.canvas.style) this.app.renderer.view.canvas.style.cursor = this.cursor;
    }
    addSprite(sprite) {
        const layerName = sprite.layerName ?? this.defaultLayerName;
        this.layerInfos[layerName].container.addChild(sprite);
        this.spriteCount += 1;
        return sprite;
    }
    /**
   * Removes a sprite from its designated layer.
   *
   * @param sprite - The GameSprite to remove from rendering
   */ removeSprite(sprite) {
        const layerName = sprite.layerName ?? this.defaultLayerName;
        this.layerInfos[layerName].container.removeChild(sprite);
        this.spriteCount -= 1;
    }
    /**
   * Adds a visual filter effect to a specific rendering layer.
   * @param filter - Pixi filter to apply to the layer
   * @param layerName - Name of the layer to apply the filter to
   */ addLayerFilter(filter, layerName) {
        const container = this.layerInfos[layerName].container;
        if (!(container.filters instanceof Array)) throw new Error("layer.filters is not an array");
        container.filters;
        container.filters = [
            ...container.filters,
            filter
        ];
    }
    addStageFilter(filter) {
        if (!this.stage.filters) this.stage.filters = [];
        this.stage.filters = [
            ...this.stage.filters,
            filter
        ];
    }
    removeStageFilter(filterToRemove) {
        if (!this.stage.filters) return;
        this.stage.filters = this.stage.filters.filter((filter)=>filter !== filterToRemove);
    }
    /**
   * Cleans up resources when the renderer is no longer needed.
   * Should be called when destroying the game instance.
   */ destroy() {
        window.removeEventListener("resize", this.resizeHandler);
        this.app.destroy();
    }
}

});
parcelRegister("5v1Ar", function(module, exports) {

$parcel$export(module.exports, "Camera2d", () => $5fd8a8f6f7c6b09a$export$d10b745905c2533b);
parcelRequire("iuB9z");
var $eY4rt = parcelRequire("eY4rt");
var $1HooC = parcelRequire("1HooC");

var $2oYNi = parcelRequire("2oYNi");

var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");
class $5fd8a8f6f7c6b09a$export$d10b745905c2533b extends (0, $2oYNi.default) {
    constructor(renderer, position = (0, $cbsax.V)([
        0,
        0
    ]), z = 25.0, angle = 0){
        super(), this.tags = [
            "camera"
        ], this.persistenceLevel = 100, this.paralaxScale = 0.1;
        this.renderer = renderer;
        this.position = position;
        this.z = z;
        this.angle = angle;
        this.velocity = (0, $cbsax.V)([
            0,
            0
        ]);
    }
    get x() {
        return this.position[0];
    }
    set x(value) {
        this.position[0] = value;
    }
    get y() {
        return this.position[1];
    }
    set y(value) {
        this.position[1] = value;
    }
    get vx() {
        return this.velocity[0];
    }
    set vx(value) {
        this.velocity[0] = value;
    }
    get vy() {
        return this.velocity[1];
    }
    set vy(value) {
        this.velocity[1] = value;
    }
    getPosition() {
        return this.position;
    }
    onTick(dt) {
        this.x += this.vx * dt;
        this.y += this.vy * dt;
    }
    /**
   * Instantly centers the camera on a world position.
   *
   * @param position - World coordinates [x, y] to center the camera on
   * @example
   * ```typescript
   * // Center on player immediately
   * camera.center(player.getPosition());
   *
   * // Center on specific world location
   * camera.center([0, 0]); // World origin
   * ```
   */ center([x, y]) {
        this.x = x;
        this.y = y;
    }
    /**
   * Smoothly moves the camera toward a target position using spring dynamics.
   *
   * This creates natural camera following behavior with configurable responsiveness.
   * The camera will accelerate toward the target and can optionally match target velocity.
   *
   * @param position - Target world coordinates [x, y] to move toward
   * @param velocity - Target velocity [vx, vy] to match (default: [0, 0])
   * @param stiffness - How quickly to accelerate toward target (default: 1.0)
   * @param damping - How much to resist motion, controls overshoot (default: 1.0)
   *
   * @example
   * ```typescript
   * // Basic smooth following
   * camera.smoothCenter(player.getPosition());
   *
   * // Advanced following with velocity matching
   * camera.smoothCenter(
   *   player.getPosition(),
   *   player.velocity,
   *   3.0,  // High stiffness = responsive
   *   0.7   // Lower damping = slight overshoot
   * );
   *
   * // Cinematic slow follow
   * camera.smoothCenter(target, [0, 0], 0.5, 2.0);
   * ```
   */ smoothCenter([x, y], [vx, vy] = (0, $cbsax.V)([
        0,
        0
    ]), stiffness = 1.0, damping = 1.0) {
        const dx = x - this.x;
        const dy = y - this.y;
        const dt = this.game.averageDt;
        this.vx += (stiffness * dx - damping * (this.vx - vx)) * dt;
        this.vy += (stiffness * dy - damping * (this.vy - vy)) * dt;
    }
    smoothSetVelocity([vx, vy], stiffness = 0.9) {
        this.vx = (0, $jd0t2.lerpOrSnap)(this.vx, vx, stiffness, 0.001);
        this.vy = (0, $jd0t2.lerpOrSnap)(this.vy, vy, stiffness, 0.001);
    }
    /**
   * Smoothly interpolates the camera zoom toward a target level.
   *
   * @param z - Target zoom level (higher values = more zoomed in)
   * @param smooth - Interpolation factor (0.0 = instant, 1.0 = no change)
   *
   * @example
   * ```typescript
   * // Smooth zoom in for close-up
   * camera.smoothZoom(50, 0.95);
   *
   * // Quick zoom out for overview
   * camera.smoothZoom(10, 0.7);
   *
   * // Instant zoom (no smoothing)
   * camera.z = 25;
   * ```
   */ smoothZoom(z, smooth = 0.9) {
        this.z = smooth * this.z + (1 - smooth) * z;
    }
    /**
   * Gets the current viewport size in logical pixels.
   *
   * Accounts for device pixel ratio to return the actual drawable area size.
   *
   * @returns [width, height] in logical pixels
   */ getViewportSize() {
        return (0, $cbsax.V)(this.renderer.canvas.width / this.renderer.app.renderer.resolution, this.renderer.canvas.height / this.renderer.app.renderer.resolution);
    }
    /**
   * Calculates the world coordinate bounds of the current camera viewport.
   * Useful for culling, bounds checking, and viewport-relative positioning.
   */ getWorldViewport() {
        const [left, top] = this.toWorld((0, $cbsax.V)(0, 0));
        const [width, height] = this.getViewportSize();
        const [right, bottom] = this.toWorld((0, $cbsax.V)(width, height));
        const worldWidth = right - left;
        const worldHeight = bottom - top;
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: worldWidth,
            height: worldHeight
        };
    }
    /**
   * Checks if a world point is visible within the current camera viewport.
   */ worldPointIsVisible(point) {
        return $5fd8a8f6f7c6b09a$export$a70d1f012eb9e682(point, this.getWorldViewport());
    }
    /**
   * Transforms screen pixel coordinates to world space coordinates.
   *
   * Essential for converting UI interactions (mouse clicks, touch) into game world positions.
   * Accounts for camera position, zoom, rotation, and optional parallax.
   *
   * @param screenPos - Screen coordinates [x, y] in pixels from top-left
   * @param parallax - Parallax multiplier [x, y] (default: [1, 1] = no parallax)
   * @returns World coordinates [x, y] in meters
   *
   * @example
   * ```typescript
   * // Convert mouse click to world position
   * const worldPos = camera.toWorld([event.clientX, event.clientY]);
   *
   * // Spawn entity at click location
   * const entity = new Enemy();
   * entity.setPosition(worldPos);
   *
   * // Convert with parallax for background layer
   * const bgWorldPos = camera.toWorld([mouseX, mouseY], [0.5, 0.5]);
   * ```
   */ toWorld([x, y], parallax = (0, $cbsax.V)(1.0, 1.0)) {
        let p = new (0, $1HooC.Point)(x, y);
        p = this.getMatrix(parallax).applyInverse(p, p);
        return (0, $cbsax.V)(p.x, p.y);
    }
    /**
   * Transforms world space coordinates to screen pixel coordinates.
   *
   * Useful for positioning UI elements relative to world objects or for culling.
   * Accounts for camera position, zoom, rotation, and optional parallax.
   *
   * @param worldPos - World coordinates [x, y] in meters
   * @param parallax - Parallax multiplier [x, y] (default: [1, 1] = no parallax)
   * @returns Screen coordinates [x, y] in pixels from top-left
   *
   * @example
   * ```typescript
   * // Position UI element above player
   * const screenPos = camera.toScreen(player.getPosition());
   * healthBar.style.left = screenPos[0] + 'px';
   * healthBar.style.top = (screenPos[1] - 50) + 'px';
   *
   * // Check if entity is on screen
   * const screenPos = camera.toScreen(entity.getPosition());
   * const [viewWidth, viewHeight] = camera.getViewportSize();
   * const isVisible = screenPos[0] >= 0 && screenPos[0] <= viewWidth &&
   *                   screenPos[1] >= 0 && screenPos[1] <= viewHeight;
   * ```
   */ toScreen([x, y], parallax = (0, $cbsax.V)(1.0, 1.0)) {
        let p = new (0, $1HooC.Point)(x, y);
        p = this.getMatrix(parallax).apply(p, p);
        return (0, $cbsax.V)(p.x, p.y);
    }
    /**
   * Creates a transformation matrix for converting world coordinates to screen coordinates.
   *
   * This is the core of the camera's coordinate transformation system. The matrix combines:
   * 1. Translation by camera position
   * 2. Scaling by zoom level and parallax
   * 3. Rotation by camera angle
   * 4. Final translation to center on screen
   *
   * @param parallax - Parallax multiplier [px, py] for this transformation
   * @param anchor - Anchor point [ax, ay] for rotation/scaling origin
   * @returns Pixi transformation matrix
   *
   * @internal This method is primarily used internally by the rendering system.
   */ getMatrix([px, py] = [
        1,
        1
    ], [ax, ay] = (0, $cbsax.V)(0, 0)) {
        const [w, h] = this.getViewportSize();
        const { x: cx, y: cy, z: z, angle: angle } = this;
        return new (0, $eY4rt.Matrix)()// align the anchor with the camera
        .translate(ax * px, ay * py).translate(-cx * px, -cy * py)// do all the scaling and rotating
        .scale(z * px, z * py).rotate(angle)// put it back
        .translate(-ax * z, -ay * z).scale(1 / px, 1 / py)// Put it on the center of the screen
        .translate(w / 2.0, h / 2.0);
    }
    /**
   * Applies camera transformations to a rendering layer.
   *
   * Called automatically during the render cycle for each layer. Updates the layer's
   * Pixi container with the appropriate transformation matrix based on the layer's
   * parallax and anchor settings.
   *
   * @param layer - LayerInfo containing the container and transformation properties
   *
   * @internal This method is called automatically by the rendering system.
   */ updateLayer(layer) {
        const container = layer.container;
        if (!layer.paralax.equals([
            0,
            0
        ])) {
            const matrix = this.getMatrix(layer.paralax, layer.anchor);
            container.updateTransform({
                x: matrix.tx,
                y: matrix.ty,
                scaleX: matrix.a,
                scaleY: matrix.d,
                skewX: matrix.b,
                skewY: matrix.c
            });
        }
    }
}
function $5fd8a8f6f7c6b09a$export$a70d1f012eb9e682(point, viewport) {
    return point.x >= viewport.left && point.x <= viewport.right && point.y >= viewport.top && point.y <= viewport.bottom;
}

});


parcelRegister("8HrgI", function(module, exports) {

$parcel$export(module.exports, "IOManager", () => $1150a8e0cd0aefe2$export$ac2778e3d733463d);

var $jd0t2 = parcelRequire("jd0t2");

var $cbsax = parcelRequire("cbsax");

var $ITB5d = parcelRequire("ITB5d");

var $5Aynx = parcelRequire("5Aynx");

var $hXYCJ = parcelRequire("hXYCJ");
const $1150a8e0cd0aefe2$var$GAMEPAD_POLLING_FREQUENCY = 250; // Hz
const $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM = 0.2;
const $1150a8e0cd0aefe2$var$GAMEPAD_MAXIMUM = 0.95;
class $1150a8e0cd0aefe2$export$ac2778e3d733463d {
    constructor(view){
        this.handlers = new (0, $5Aynx.default)();
        this.keys = new Map();
        // buttons pressed last frame. Used for checking differences in state.
        this.lastButtons = [];
        this.mouseButtons = [
            false,
            false,
            false,
            false,
            false,
            false
        ];
        this.mousePosition = (0, $cbsax.V)(0, 0);
        this.usingGamepad = false // True if the gamepad is the main input device
        ;
        this.view = view;
        this.view.onclick = (e)=>this.onClick(e);
        this.view.onmousedown = (e)=>this.onMouseDown(e);
        this.view.onmouseup = (e)=>this.onMouseUp(e);
        this.view.onmousemove = (e)=>this.onMouseMove(e);
        this.view.oncontextmenu = (e)=>{
            e.preventDefault();
            this.onClick(e);
            return false;
        };
        document.onkeydown = (e)=>{
            this.onKeyDown(e);
        };
        document.onkeyup = (e)=>this.onKeyUp(e);
        document.onvisibilitychange = (event)=>{
            for (const keyCode of this.keys.keys()){
                this.keys.set(keyCode, false);
                for (const handler of this.handlers.onKeyUp)handler.onKeyUp({
                    key: keyCode
                });
            }
        };
        // Because this is a polling not pushing interface
        this.gamepadIntervalId = window.setInterval(()=>this.handleGamepads(), 1000 / $1150a8e0cd0aefe2$var$GAMEPAD_POLLING_FREQUENCY);
    }
    // True if the left mouse button is down.
    get lmb() {
        return this.mouseButtons[(0, $hXYCJ.MouseButtons).LEFT];
    }
    // True if the middle mouse button is down.
    get mmb() {
        return this.mouseButtons[(0, $hXYCJ.MouseButtons).MIDDLE];
    }
    // True if the right mouse button is down.
    get rmb() {
        return this.mouseButtons[(0, $hXYCJ.MouseButtons).RIGHT];
    }
    // True if the given key is currently pressed down
    isKeyDown(key) {
        return Boolean(this.keys.get(key));
    }
    // Fire events for gamepad button presses.
    handleGamepads() {
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            const buttons = gamepad.buttons.map((button)=>button.pressed);
            for (const [button, isDown] of buttons.entries()){
                if (isDown && !this.lastButtons[button]) {
                    this.setUsingGamepad(true);
                    for (const handler of this.handlers.onButtonDown)handler.onButtonDown({
                        button: button
                    });
                } else if (!isDown && this.lastButtons[button]) for (const handler of this.handlers.onButtonUp)handler.onButtonUp({
                    button: button
                });
            }
            this.lastButtons = buttons;
        } else this.lastButtons = [];
    }
    setUsingGamepad(value) {
        if (this.usingGamepad != value) {
            this.usingGamepad = value;
            for (const handler of this.handlers.onInputDeviceChange)handler.onInputDeviceChange({
                usingGamepad: this.usingGamepad
            });
        }
    }
    addHandler(handler) {
        this.handlers.add(handler);
        if (handler.onInputDeviceChange) handler.onInputDeviceChange({
            usingGamepad: this.usingGamepad
        });
    }
    removeHandler(handler) {
        this.handlers.remove(handler);
    }
    // Update the position of the mouse.
    onMouseMove(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $cbsax.V)(event.clientX, event.clientY);
    }
    // Fire all click handlers.
    onClick(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $cbsax.V)(event.clientX, event.clientY);
        switch(event.button){
            case (0, $hXYCJ.MouseButtons).LEFT:
                for (const handler of this.handlers.onClick)handler.onClick();
                break;
            case (0, $hXYCJ.MouseButtons).RIGHT:
                for (const handler of this.handlers.onRightClick)handler.onRightClick();
                break;
        }
    }
    // Fire all mouse down handlers.
    onMouseDown(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $cbsax.V)(event.clientX, event.clientY);
        this.mouseButtons[event.button] = true;
        switch(event.button){
            case (0, $hXYCJ.MouseButtons).LEFT:
                for (const handler of this.handlers.onMouseDown)handler.onMouseDown();
                break;
            case (0, $hXYCJ.MouseButtons).RIGHT:
                for (const handler of this.handlers.onRightDown)handler.onRightDown();
                break;
        }
    }
    // Fire all mouse up handlers
    onMouseUp(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $cbsax.V)(event.clientX, event.clientY);
        this.mouseButtons[event.button] = false;
        switch(event.button){
            case (0, $hXYCJ.MouseButtons).LEFT:
                for (const handler of this.handlers.onMouseUp)handler.onMouseUp();
                break;
            case (0, $hXYCJ.MouseButtons).RIGHT:
                for (const handler of this.handlers.onRightUp)handler.onRightUp();
                break;
        }
    }
    // Determine whether or not to prevent the default action of a key press.
    shouldPreventDefault(event) {
        if (event.key === "Tab") return true;
        if (event.key.toLowerCase() === "s") // s for save
        return true;
        return false;
    }
    // Fire all key down handlers.
    onKeyDown(event) {
        const code = event.code;
        const wasPressed = this.keys.get(code); // for filtering out auto-repeat stuff
        this.keys.set(code, true);
        if (!wasPressed) for (const handler of this.handlers.onKeyDown)handler.onKeyDown({
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) {
            event.preventDefault();
            return false;
        }
    }
    // Fire all key up handlers.
    onKeyUp(event) {
        const code = event.code;
        this.keys.set(code, false);
        for (const handler of this.handlers.onKeyUp)handler.onKeyUp({
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) {
            event.preventDefault();
            return false;
        }
    }
    /**
   * Gets the current value of a gamepad axis (stick position).
   * @returns Axis value normalized to range [-1, 1], or 0 if no gamepad connected
   */ getAxis(axis) {
        switch(axis){
            case (0, $ITB5d.ControllerAxis).LEFT_X:
                return this.getStick("left").x;
            case (0, $ITB5d.ControllerAxis).LEFT_Y:
                return this.getStick("left").y;
            case (0, $ITB5d.ControllerAxis).RIGHT_X:
                return this.getStick("right").x;
            case (0, $ITB5d.ControllerAxis).RIGHT_Y:
                return this.getStick("right").y;
            default:
                throw new Error("unknown axis");
        }
    }
    getStick(stick) {
        const axes = (0, $cbsax.V)(0, 0);
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            if (stick === "left") {
                axes.x = gamepad.axes[(0, $ITB5d.ControllerAxis).LEFT_X];
                axes.y = gamepad.axes[(0, $ITB5d.ControllerAxis).LEFT_Y];
            } else {
                axes.x = gamepad.axes[(0, $ITB5d.ControllerAxis).RIGHT_X];
                axes.y = gamepad.axes[(0, $ITB5d.ControllerAxis).RIGHT_Y];
            }
            const gamepadRange = $1150a8e0cd0aefe2$var$GAMEPAD_MAXIMUM - $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM;
            axes.magnitude = (0, $jd0t2.clampUp)((axes.magnitude - $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM) / gamepadRange);
            axes.x = (0, $jd0t2.clamp)(axes.x, -1, 1);
            axes.y = (0, $jd0t2.clamp)(axes.y, -1, 1);
        }
        return axes;
    }
    //  Return the value of a button.
    getButton(button) {
        const gamepad = navigator.getGamepads()[0];
        return gamepad?.buttons[button]?.value ?? 0;
    }
    /**
   * Gets standardized movement input from WASD keys, arrow keys, or gamepad left stick.
   * Combines keyboard and gamepad input with proper priority handling.
   * @returns Movement vector with components clamped to [-1, 1] range
   */ getMovementVector() {
        const result = (0, $cbsax.V)(0, 0);
        if (this.usingGamepad) result.iadd(this.getStick("left"));
        if (this.isKeyDown("KeyW") || this.isKeyDown("ArrowUp")) result[1] -= 1;
        if (this.isKeyDown("KeyD") || this.isKeyDown("ArrowRight")) result[0] += 1;
        if (this.isKeyDown("KeyS") || this.isKeyDown("ArrowDown")) result[1] += 1;
        if (this.isKeyDown("KeyA") || this.isKeyDown("ArrowLeft")) result[0] -= 1;
        result[0] = (0, $jd0t2.clamp)(result[0], -1, 1);
        result[1] = (0, $jd0t2.clamp)(result[1], -1, 1);
        return result;
    }
    /**
   * Cleans up IO resources when the IOManager is no longer needed.
   * This prevents memory leaks when closing/refreshing the browser tab.
   */ destroy() {
        // Clear the gamepad polling interval
        if (this.gamepadIntervalId) window.clearInterval(this.gamepadIntervalId);
    }
}

});
parcelRegister("ITB5d", function(module, exports) {

$parcel$export(module.exports, "ControllerAxis", () => $d52f33955bf62086$export$72d962784102bc5);
var $d52f33955bf62086$export$72d962784102bc5 = /*#__PURE__*/ function(ControllerAxis) {
    ControllerAxis[ControllerAxis["LEFT_X"] = 0] = "LEFT_X";
    ControllerAxis[ControllerAxis["LEFT_Y"] = 1] = "LEFT_Y";
    ControllerAxis[ControllerAxis["RIGHT_X"] = 2] = "RIGHT_X";
    ControllerAxis[ControllerAxis["RIGHT_Y"] = 3] = "RIGHT_Y";
    return ControllerAxis;
}({});
var $d52f33955bf62086$export$a72c135d79aea91b = /*#__PURE__*/ function(ControllerButton) {
    ControllerButton[ControllerButton["A"] = 0] = "A";
    ControllerButton[ControllerButton["B"] = 1] = "B";
    ControllerButton[ControllerButton["X"] = 2] = "X";
    ControllerButton[ControllerButton["Y"] = 3] = "Y";
    ControllerButton[ControllerButton["LB"] = 4] = "LB";
    ControllerButton[ControllerButton["RB"] = 5] = "RB";
    ControllerButton[ControllerButton["LT"] = 6] = "LT";
    ControllerButton[ControllerButton["RT"] = 7] = "RT";
    ControllerButton[ControllerButton["BACK"] = 8] = "BACK";
    ControllerButton[ControllerButton["START"] = 9] = "START";
    ControllerButton[ControllerButton["L3"] = 10] = "L3";
    ControllerButton[ControllerButton["R3"] = 11] = "R3";
    ControllerButton[ControllerButton["D_UP"] = 12] = "D_UP";
    ControllerButton[ControllerButton["D_DOWN"] = 13] = "D_DOWN";
    ControllerButton[ControllerButton["D_LEFT"] = 14] = "D_LEFT";
    ControllerButton[ControllerButton["D_RIGHT"] = 15] = "D_RIGHT";
    ControllerButton[ControllerButton["SPECIAL"] = 16] = "SPECIAL";
    return ControllerButton;
}({});

});

parcelRegister("5Aynx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc42310c64ff8212$export$2e2bcd8739ae039);

var $5dcC6 = parcelRequire("5dcC6");

var $gs6ty = parcelRequire("gs6ty");
class $dc42310c64ff8212$export$2e2bcd8739ae039 {
    get onButtonDown() {
        return this.filtered.onButtonDown;
    }
    get onButtonUp() {
        return this.filtered.onButtonUp;
    }
    get onClick() {
        return this.filtered.onClick;
    }
    get onKeyDown() {
        return this.filtered.onKeyDown;
    }
    get onKeyUp() {
        return this.filtered.onKeyUp;
    }
    get onMouseDown() {
        return this.filtered.onMouseDown;
    }
    get onMouseUp() {
        return this.filtered.onMouseUp;
    }
    get onRightClick() {
        return this.filtered.onRightClick;
    }
    get onRightDown() {
        return this.filtered.onRightDown;
    }
    get onRightUp() {
        return this.filtered.onRightUp;
    }
    get onInputDeviceChange() {
        return this.filtered.onInputDeviceChange;
    }
    add(handler) {
        this.all.add(handler);
        for (const list of Object.values(this.filtered))list.addIfValid(handler);
    }
    remove(handler) {
        this.all.delete(handler);
        for (const list of Object.values(this.filtered))list.remove(handler);
    }
    [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
    constructor(){
        this.all = new Set();
        this.filtered = {
            onButtonDown: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("buttonDown")),
            onButtonUp: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("buttonUp")),
            onClick: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("click")),
            onKeyDown: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("keyDown")),
            onKeyUp: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("keyUp")),
            onMouseDown: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("mouseDown")),
            onMouseUp: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("mouseUp")),
            onRightClick: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("rightClick")),
            onRightDown: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("rightDown")),
            onRightUp: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("rightUp")),
            onInputDeviceChange: new (0, $gs6ty.default)((0, $5dcC6.isGameEventHandler)("inputDeviceChange"))
        };
    }
}

});
parcelRegister("5dcC6", function(module, exports) {

$parcel$export(module.exports, "isGameEventHandler", () => $27ab90d841f9c4fb$export$a8c6e42240baf24c);

var $kD5ZK = parcelRequire("kD5ZK");
function $27ab90d841f9c4fb$export$a8c6e42240baf24c(eventName) {
    return (e)=>{
        const handlerName = (0, $kD5ZK.eventHandlerName)(eventName);
        if (!(typeof e === "object" && e !== null)) return false;
        if (!(handlerName in e)) return false;
        if (typeof e[handlerName] !== "function") return false;
        return true;
    };
}

});


parcelRegister("hXYCJ", function(module, exports) {

$parcel$export(module.exports, "MouseButtons", () => $f19c05c4f687fa4a$export$183b5ff8ae4c0231);
const $f19c05c4f687fa4a$export$183b5ff8ae4c0231 = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2
};

});


parcelRegister("jOKqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6dcfd78737b253$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");

var $kKUxA = parcelRequire("kKUxA");

var $cHMhI = parcelRequire("cHMhI");

var $332t4 = parcelRequire("332t4");
// Reduce allocations
const $4e6dcfd78737b253$var$step_mg = (0, $biKyI.vec2).create();
const $4e6dcfd78737b253$var$endOverlaps = [];
class $4e6dcfd78737b253$export$2e2bcd8739ae039 extends (0, $biKyI.World) {
    constructor(options = {}){
        super({
            broadphase: new (0, $332t4.default)(),
            islandSplit: false,
            solver: new (0, $cHMhI.default)(),
            ...options
        }), // Actual stuff that we're keeping track of now
        this.dynamicBodies = new Set(), this.kinematicBodies = new Set();
        this.solver.setWorld(this);
        this.applyGravity = false;
        this.applyDamping = false;
        this.narrowphase = new (0, $kKUxA.default)();
    }
    /**
   * Adds a body to the world and automatically categorizes it by type
   * for optimized processing during physics steps.
   */ addBody(body) {
        super.addBody.call(this, body);
        if (body.type === (0, $biKyI.Body).DYNAMIC) this.dynamicBodies.add(body);
        else if (body.type === (0, $biKyI.Body).KINEMATIC) this.kinematicBodies.add(body);
    }
    /**
   * Removes a body from the world and cleans up type-specific tracking.
   */ removeBody(body) {
        super.removeBody.call(this, body);
        this.dynamicBodies.delete(body);
        this.kinematicBodies.delete(body);
    }
    raycast(result, ray, shouldAddBodies = true) {
        // Get all bodies within the ray AABB
        const bodies = [];
        const aabb = ray.getAABB();
        // TODO: Use a ray-specific query instead of AABB query
        this.broadphase.aabbQuery(this, aabb, bodies, shouldAddBodies);
        ray.intersectBodies(result, bodies);
        return result.hasHit();
    }
    /**
   * Performs a complete physics simulation step with custom optimizations.
   * This is the main entry point called by the game engine each physics tick.
   *
   * The step process is broken down into discrete phases for better control
   * and performance profiling. Each phase operates on the categorized body sets
   * rather than iterating through all bodies.
   */ internalStep(dt) {
        this.stepping = true;
        this.overlapKeeper.tick();
        this.lastTimeStep = dt;
        this.stepPreCollision(dt);
        const broadphaseResult = this.stepBroadphase();
        this.stepNarrowphase(broadphaseResult);
        this.stepWakeup();
        this.stepContactEvents();
        this.stepConstraints(dt);
        this.stepIntegrate(dt);
        this.stepImpactEvents();
        this.stepSleep(dt);
        this.stepping = false;
        this.stepCleanup();
        this.emit(this.postStepEvent);
    }
    //#region internalStep
    stepPreCollision(dt) {
        const g = this.gravity;
        const mg = $4e6dcfd78737b253$var$step_mg;
        // Update approximate friction gravity.
        if (this.useWorldGravityAsFrictionGravity) {
            const gravityLen = (0, $biKyI.vec2).length(this.gravity);
            if (!(gravityLen === 0 && this.useFrictionGravityOnZeroGravity)) // Nonzero gravity. Use it.
            this.frictionGravity = gravityLen;
        }
        // Add gravity to bodies
        if (this.applyGravity) {
            for (const body of this.dynamicBodies)if (body.sleepState !== (0, $biKyI.Body).SLEEPING) {
                (0, $biKyI.vec2).scale(mg, g, body.mass * body.gravityScale);
                (0, $biKyI.vec2).add(body.force, body.force, mg);
            }
        }
        // Add spring forces
        if (this.applySpringForces) for (const s of this.springs)s.applyForce();
        // Add damping
        if (this.applyDamping) for (const body of this.dynamicBodies)body.applyDamping(dt);
    }
    stepBroadphase() {
        // Broadphase
        var result = this.broadphase.getCollisionPairs(this);
        // Remove ignored collision pairs
        var ignoredPairs = this.disabledBodyCollisionPairs;
        for(var i = ignoredPairs.length - 2; i >= 0; i -= 2){
            for(var j = result.length - 2; j >= 0; j -= 2)if (ignoredPairs[i] === result[j] && ignoredPairs[i + 1] === result[j + 1] || ignoredPairs[i + 1] === result[j] && ignoredPairs[i] === result[j + 1]) result.splice(j, 2);
        }
        // Remove constrained pairs with collideConnected == false
        var Nconstraints = this.constraints.length;
        for(i = 0; i !== Nconstraints; i++){
            var c = this.constraints[i];
            if (!c.collideConnected) {
                for(var j = result.length - 2; j >= 0; j -= 2)if (c.bodyA === result[j] && c.bodyB === result[j + 1] || c.bodyB === result[j] && c.bodyA === result[j + 1]) result.splice(j, 2);
            }
        }
        // postBroadphase event
        this.postBroadphaseEvent.pairs = result;
        this.emit(this.postBroadphaseEvent);
        this.postBroadphaseEvent.pairs = [];
        return result;
    }
    stepNarrowphase(broadphaseResult) {
        const np = this.narrowphase;
        // Narrowphase
        np.reset();
        for(var i = 0, Nresults = broadphaseResult.length; i !== Nresults; i += 2){
            var bi = broadphaseResult[i], bj = broadphaseResult[i + 1];
            // Loop over all shapes of body i
            for(var k = 0, Nshapesi = bi.shapes.length; k !== Nshapesi; k++){
                var si = bi.shapes[k], xi = si.position, ai = si.angle;
                // All shapes of body j
                for(var l = 0, Nshapesj = bj.shapes.length; l !== Nshapesj; l++){
                    var sj = bj.shapes[l], xj = sj.position, aj = sj.angle;
                    var cm = this.defaultContactMaterial;
                    if (si.material && sj.material) {
                        var tmp = this.getContactMaterial(si.material, sj.material);
                        if (tmp) cm = tmp;
                    }
                    this.runNarrowphase(np, bi, si, xi, ai, bj, sj, xj, aj, cm, this.frictionGravity);
                }
            }
        }
    }
    stepWakeup() {
        // Wake up bodies
        for (const body of this.dynamicBodies)if (body._wakeUpAfterNarrowphase) {
            body.wakeUp();
            body._wakeUpAfterNarrowphase = false;
        }
    }
    stepContactEvents() {
        const np = this.narrowphase;
        // Emit end overlap events
        if (this.has("endContact", undefined)) {
            this.overlapKeeper.getEndOverlaps($4e6dcfd78737b253$var$endOverlaps);
            const e = this.endContactEvent;
            let i = $4e6dcfd78737b253$var$endOverlaps.length;
            while(i--){
                var data = $4e6dcfd78737b253$var$endOverlaps[i];
                e.shapeA = data.shapeA;
                e.shapeB = data.shapeB;
                e.bodyA = data.bodyA;
                e.bodyB = data.bodyB;
                this.emit(e);
            }
            $4e6dcfd78737b253$var$endOverlaps.length = 0;
        }
        var preSolveEvent = this.preSolveEvent;
        preSolveEvent.contactEquations = np.contactEquations;
        preSolveEvent.frictionEquations = np.frictionEquations;
        this.emit(preSolveEvent);
        preSolveEvent.contactEquations = preSolveEvent.frictionEquations = [];
    }
    stepConstraints(dt) {
        const solver = this.solver;
        const np = this.narrowphase;
        const islandManager = this.islandManager;
        // update constraint equations
        for (const constraint of this.constraints)constraint.update();
        if (np.contactEquations.length || np.frictionEquations.length || this.constraints.length) {
            if (this.islandSplit) {
                // Split into islands
                islandManager.equations.length = 0;
                (0, $biKyI.Utils).appendArray(islandManager.equations, np.contactEquations);
                (0, $biKyI.Utils).appendArray(islandManager.equations, np.frictionEquations);
                for (const constraint of this.constraints)(0, $biKyI.Utils).appendArray(islandManager.equations, constraint.equations);
                for(let i = 0; i < this.constraints.length; i++);
                islandManager.split(this);
                for (const island of islandManager.islands)if (island.equations.length) solver.solveIsland(dt, island);
            } else {
                // Add contact equations to solver
                solver.addEquations(np.contactEquations);
                solver.addEquations(np.frictionEquations);
                // Add user-defined constraint equations
                for (const constraint of this.constraints)solver.addEquations(constraint.equations);
                if (this.solveConstraints) solver.solve(dt, this);
                solver.removeAllEquations();
            }
        }
    }
    stepIntegrate(dt) {
        // Step forward
        for (const body of this.kinematicBodies){
            body.integrate(dt);
            body.setZeroForce();
        }
        for (const body of this.dynamicBodies){
            body.integrate(dt);
            body.setZeroForce();
        }
    }
    stepImpactEvents() {
        const np = this.narrowphase;
        // Emit impact event
        if (this.emitImpactEvent && this.has("impact")) {
            var ev = this.impactEvent;
            for(var i = 0; i !== np.contactEquations.length; i++){
                var eq = np.contactEquations[i];
                if (eq.firstImpact) {
                    ev.bodyA = eq.bodyA;
                    ev.bodyB = eq.bodyB;
                    ev.shapeA = eq.shapeA;
                    ev.shapeB = eq.shapeB;
                    ev.contactEquation = eq;
                    this.emit(ev);
                }
            }
        }
    }
    stepSleep(dt) {
        const bodies = this.bodies;
        const Nbodies = bodies.length;
        // Sleeping update
        if (this.sleepMode === (0, $biKyI.World).BODY_SLEEPING) for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, false, dt);
        else if (this.sleepMode === (0, $biKyI.World).ISLAND_SLEEPING && this.islandSplit) {
            // Tell all bodies to sleep tick but dont sleep yet
            for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, true, dt);
            // Sleep islands
            for(var i = 0; i < this.islandManager.islands.length; i++){
                var island = this.islandManager.islands[i];
                if (island.wantsToSleep()) island.sleep();
            }
        }
    }
    stepCleanup() {
        // Remove bodies that are scheduled for removal
        var bodiesToBeRemoved = this.bodiesToBeRemoved;
        for(var i = 0; i !== bodiesToBeRemoved.length; i++)this.removeBody(bodiesToBeRemoved[i]);
        bodiesToBeRemoved.length = 0;
    }
}

});
parcelRegister("kKUxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719b6279ccaa645$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");
class $9719b6279ccaa645$export$2e2bcd8739ae039 extends (0, $biKyI.Narrowphase) {
}

});

parcelRegister("cHMhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ecbc16ec51b8e17$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");
class $2ecbc16ec51b8e17$export$2e2bcd8739ae039 extends (0, $biKyI.GSSolver) {
    constructor(){
        super({
            iterations: 1,
            tolerance: 0
        });
    }
    setWorld(world) {
        this.world = world;
    }
    /**
   * Prepares dynamic bodies for constraint solving by updating their mass properties.
   * Static and kinematic bodies are skipped since they don't respond to constraints.
   */ prepareBodies() {
        for (const body of this.world.dynamicBodies)body.updateSolveMassProperties();
    }
    /**
   * Computes constraint equation parameters for the current timestep.
   * Calculates force limits and constraint compliance for each equation.
   */ computeEquations(dt) {
        for (const eq of this.equations){
            eq.lambda = 0;
            if (eq.timeStep !== dt || eq.needsUpdate) {
                eq.timeStep = dt;
                eq.update();
            }
            eq.B = eq.computeB(eq.a, eq.b, dt);
            eq.invC = eq.computeInvC(eq.epsilon);
            eq.maxForceDt = eq.maxForce * dt;
            eq.minForceDt = eq.minForce * dt;
        }
    }
    prepareBodies2() {
        for (const body of this.world.dynamicBodies)body.resetConstraintVelocity();
    }
    // Add result to velocity
    postBodies() {
        for (const body of this.world.dynamicBodies)body.addConstraintVelocity();
    }
    doFriction(dt) {
        const maxFrictionIter = this.frictionIterations;
        const equations = this.equations;
        const tolSquared = Math.pow(this.tolerance * this.equations.length, 2);
        if (maxFrictionIter) {
            // Iterate over contact equations to get normal forces
            for(let iter = 0; iter !== maxFrictionIter; iter++){
                // Accumulate the total error for each iteration.
                let deltalambdaTot = 0.0;
                for (const c of equations){
                    var deltalambda = $2ecbc16ec51b8e17$var$iterateEquation(c);
                    deltalambdaTot += Math.abs(deltalambda);
                }
                this.usedIterations++;
                // If the total error is small enough - stop iterate
                if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
            }
            this.postBodies();
            $2ecbc16ec51b8e17$var$updateMultipliers(equations, 1 / dt);
            // Set computed friction force
            for (const eq of equations)if (eq instanceof (0, $biKyI.FrictionEquation)) {
                var f = 0.0;
                for(var k = 0; k !== eq.contactEquations.length; k++)f += eq.contactEquations[k].multiplier;
                f *= eq.frictionCoefficient / eq.contactEquations.length;
                eq.maxForce = f;
                eq.minForce = -f;
                eq.maxForceDt = f * dt;
                eq.minForceDt = -f * dt;
            }
        }
    }
    doIterations(dt) {
        const maxIter = this.iterations;
        const tolSquared = Math.pow(this.tolerance * this.equations.length, 2);
        for(let iter = 0; iter !== maxIter; iter++){
            // Accumulate the total error for each iteration.
            let deltalambdaTot = 0.0;
            for (const c of this.equations){
                var deltalambda = $2ecbc16ec51b8e17$var$iterateEquation(c);
                deltalambdaTot += Math.abs(deltalambda);
            }
            this.usedIterations++;
            // If the total error is small enough - stop iterate
            if (deltalambdaTot * deltalambdaTot < tolSquared) break;
        }
    }
    solve(dt, world) {
        this.sortEquations();
        const equations = this.equations;
        const Neq = equations.length;
        this.usedIterations = 0;
        if (Neq !== 0) {
            this.prepareBodies();
            this.computeEquations(dt);
            this.prepareBodies2();
            this.doFriction(dt);
            this.doIterations(dt);
            this.postBodies();
            $2ecbc16ec51b8e17$var$updateMultipliers(equations, 1 / dt);
        }
    }
}
// Sets the .multiplier property of each equation
function $2ecbc16ec51b8e17$var$updateMultipliers(equations, invDt) {
    var l = equations.length;
    while(l--){
        var eq = equations[l];
        eq.multiplier = eq.lambda * invDt;
    }
}
function $2ecbc16ec51b8e17$var$iterateEquation(eq) {
    // Compute iteration
    var B = eq.B, eps = eq.epsilon, invC = eq.invC, lambdaj = eq.lambda, GWlambda = eq.computeGWlambda(), maxForce_dt = eq.maxForceDt, minForce_dt = eq.minForceDt;
    var deltalambda = invC * (B - GWlambda - eps * lambdaj);
    // Clamp if we are not within the min/max interval
    var lambdaj_plus_deltalambda = lambdaj + deltalambda;
    if (lambdaj_plus_deltalambda < minForce_dt) deltalambda = minForce_dt - lambdaj;
    else if (lambdaj_plus_deltalambda > maxForce_dt) deltalambda = maxForce_dt - lambdaj;
    eq.lambda += deltalambda;
    eq.addToWlambda(deltalambda);
    return deltalambda;
}

});

parcelRegister("332t4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc14462fca3f439$export$2e2bcd8739ae039);

var $biKyI = parcelRequire("biKyI");

var $jd0t2 = parcelRequire("jd0t2");
const $1dc14462fca3f439$var$CUSTOM_BROADPHASE_TYPE = 3;
const $1dc14462fca3f439$var$HUGE_LIMIT = 200;
const $1dc14462fca3f439$var$DEFAULT_CELL_SIZE = 6;
const $1dc14462fca3f439$var$HUGE = [];
class $1dc14462fca3f439$export$2e2bcd8739ae039 extends (0, $biKyI.SAPBroadphase) {
    constructor(// width/height of cell in meters
    cellSize = $1dc14462fca3f439$var$DEFAULT_CELL_SIZE, // number of cells wide
    width = 24, // number of cells tall
    height = 24){
        super($1dc14462fca3f439$var$CUSTOM_BROADPHASE_TYPE), this.cellSize = cellSize, this.width = width, this.height = height, this.particleBodies = new Set(), this.dynamicBodies = new Set(), this.kinematicBodies = new Set(), this.hugeBodies = new Set(), this.partitions = [], this.bodiesAdded = false, this.debugData = {
            numCollisions: 0
        };
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
    }
    setWorld(world) {
        super.setWorld.call(this, world);
        world.on("addBody", ({ body: body })=>this.onAddBody(body));
        world.on("removeBody", ({ body: body })=>this.onRemoveBody(body));
    }
    resize(cellSize, width, height) {
        this.cellSize = cellSize;
        const oldBodies = new Set();
        for (const partition of this.partitions)for (const body of partition)oldBodies.add(body);
        this.partitions = [];
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
        for (const body of oldBodies)this.addBodyToHash(body);
    }
    onAddBody(body) {
        if (body.type === (0, $biKyI.Body).DYNAMIC) {
            if ($1dc14462fca3f439$var$isParticleBody(body)) this.particleBodies.add(body);
            else this.dynamicBodies.add(body);
        } else if (body.type === (0, $biKyI.Body).KINEMATIC) this.kinematicBodies.add(body);
        else this.addBodyToHash(body);
    }
    onRemoveBody(body) {
        if (body.type === (0, $biKyI.Body).DYNAMIC) {
            this.dynamicBodies.delete(body);
            this.particleBodies.delete(body);
        } else if (body.type === (0, $biKyI.Body).KINEMATIC) this.kinematicBodies.delete(body);
        else this.removeBodyFromHash(body);
    }
    addBodyToHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $1dc14462fca3f439$var$HUGE) this.hugeBodies.add(body);
        else for (const cell of cells)this.partitions[cell].add(body);
    }
    removeBodyFromHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $1dc14462fca3f439$var$HUGE) this.hugeBodies.delete(body);
        else for (const cell of cells)this.partitions[cell].delete(body);
    }
    addExtraBodies() {
        for (const kBody of this.kinematicBodies)this.addBodyToHash(kBody);
        for (const dBody of this.dynamicBodies)this.addBodyToHash(dBody);
        for (const pBody of this.particleBodies)this.addBodyToHash(pBody);
    }
    removeExtraBodies() {
        for (const kBody of this.kinematicBodies)this.removeBodyFromHash(kBody);
        for (const dBody of this.dynamicBodies)this.removeBodyFromHash(dBody);
        for (const pBody of this.particleBodies)this.removeBodyFromHash(pBody);
    }
    /**
   * Returns potential collision pairs for this frame.
   *
   * This is the main entry point called by CustomWorld during each physics step.
   * The algorithm temporarily adds dynamic bodies to the hash, finds collision pairs,
   * then removes them to prevent double-counting in subsequent frames.
   *
   * @returns Array where every 2 entries represents a collision pair [bodyA, bodyB, bodyC, bodyD...]
   */ getCollisionPairs(world) {
        const result = [];
        for (const kBody of this.kinematicBodies)this.addBodyToHash(kBody);
        for (const dBody of this.dynamicBodies)this.addBodyToHash(dBody);
        //
        for (const pBody of this.particleBodies){
            for (const other of this.aabbQuery(world, pBody.getAABB(), undefined, false))if ((0, $biKyI.Broadphase).canCollide(pBody, other)) result.push(pBody, other);
        }
        for (const dBody of this.dynamicBodies){
            this.removeBodyFromHash(dBody); // This will make sure we don't overlap ourselves, and that we don't double count anything
            for (const other of this.aabbQuery(world, dBody.getAABB(), undefined, false))if ((0, $biKyI.Broadphase).canCollide(dBody, other)) result.push(dBody, other);
        }
        for (const kBody of this.kinematicBodies)this.removeBodyFromHash(kBody);
        this.debugData.numCollisions = result.length;
        return result;
    }
    xyToCell(x, y) {
        return (0, $jd0t2.mod)(x, this.width) + (0, $jd0t2.mod)(y, this.height) * this.width;
    }
    /**
   * Converts an AABB to the grid cells it overlaps.
   *
   * @param aabb The bounding box to convert
   * @param checkHuge Whether to check if the AABB is too large for efficient hashing
   * @returns Array of cell indices, or HUGE constant if the AABB is too large
   */ aabbToCells(aabb, checkHuge = true) {
        const result = [];
        const lowX = Math.floor(aabb.lowerBound[0] / this.cellSize);
        const lowY = Math.floor(aabb.lowerBound[1] / this.cellSize);
        const highX = Math.floor(aabb.upperBound[0] / this.cellSize);
        const highY = Math.floor(aabb.upperBound[1] / this.cellSize);
        // Check for huge
        if (checkHuge && (!isFinite(lowX) || !isFinite(lowY) || !isFinite(highX) || !isFinite(highY) || Math.abs(highX - lowX) * Math.abs(highY - lowY) > $1dc14462fca3f439$var$HUGE_LIMIT)) return $1dc14462fca3f439$var$HUGE;
        for(let x = lowX; x <= highX; x++)for(let y = lowY; y <= highY; y++)result.push(this.xyToCell(x, y));
        return result;
    }
    aabbQuery(_, aabb, result, shouldAddBodies = true) {
        result = result ?? [];
        if (shouldAddBodies) this.addExtraBodies();
        for (const cell of this.aabbToCells(aabb, false)){
            for (const body of this.partitions[cell])if (body.getAABB().overlaps(aabb) && result.indexOf(body) < 0) result.push(body);
        }
        for (const hugeBody of this.hugeBodies)if (aabb.overlaps(hugeBody.getAABB())) result.push(hugeBody);
        if (shouldAddBodies) this.removeExtraBodies();
        return result;
    }
    // TODO: This is broken for some reason
    rayQuery(ray, shouldAddBodies = true) {
        if (shouldAddBodies) this.addExtraBodies();
        const result = [];
        // See https://www.redblobgames.com/grids/line-drawing.html
        const x1 = ray.from[0] / this.cellSize;
        const y1 = ray.from[1] / this.cellSize;
        const x2 = ray.to[0] / this.cellSize;
        const y2 = ray.to[1] / this.cellSize;
        const dx = x2 - x1;
        const dy = y2 - y1;
        const xSteps = Math.ceil(Math.abs(dx));
        const ySteps = Math.ceil(Math.abs(dy));
        const signX = dx > 0 ? 1 : -1;
        const signY = dy > 0 ? 1 : -1;
        let cellX = Math.floor(x1);
        let cellY = Math.floor(y1);
        for(let ix = 0, iy = 0; ix < xSteps || iy < ySteps;){
            if ((0.5 + ix) / xSteps < (0.5 + iy) / ySteps) {
                // next step is horizontal
                cellX += signX;
                ix++;
            } else {
                // next step is vertical
                cellY += signY;
                iy++;
            }
            const cell = this.xyToCell(cellX, cellY);
            for (const body of this.partitions[cell])if (result.indexOf(body) < 0) result.push(body);
        }
        if (shouldAddBodies) this.removeExtraBodies();
        return result;
    }
}
// Returns true if this is a dynamic body with no non-particle shapes
function $1dc14462fca3f439$var$isParticleBody(body) {
    if (body.type !== (0, $biKyI.Body).DYNAMIC) return false;
    for (const shape of body.shapes){
        if (shape.type !== (0, $biKyI.Shape).PARTICLE) return false;
    }
    return true;
}

});


parcelRegister("ggGVw", function(module, exports) {

$parcel$export(module.exports, "SlowMoManager", () => $964122359910763c$export$386169c468787a);

var $e2Ri5 = parcelRequire("e2Ri5");

var $2oYNi = parcelRequire("2oYNi");

var $jd0t2 = parcelRequire("jd0t2");
class $964122359910763c$export$386169c468787a extends (0, $2oYNi.default) {
    /**
   * Creates a new SlowMoManager.
   * @param rampSpeed - How quickly to ramp between slow-mo values (units per second)
   */ constructor(rampSpeed = 8.0){
        super(), this.id = "slowMoManager", this.persistenceLevel = (0, $e2Ri5.PersistenceLevel).Permanent, this.targetValue = 1.0, this.currentValue = 1.0, this._rampSpeed = 8.0;
        this._rampSpeed = rampSpeed;
    }
    /**
   * Called each tick to update the slow-mo value based on active effects.
   * Finds all SlowMoEffect entities and smoothly ramps to the minimum value.
   */ onTick(dt) {
        if (!this.game) return;
        const effectEntities = this.game.entities.getTagged("slowMoEffect");
        this.targetValue = this.calculateMinimumValue(effectEntities);
        if (this.currentValue !== this.targetValue) {
            this.currentValue = (0, $jd0t2.stepToward)(this.currentValue, this.targetValue, this._rampSpeed * dt);
            this.game.slowMo = this.currentValue;
        }
    }
    /**
   * Calculates the minimum slow-mo value from all active effects.
   * Always includes 1.0 (normal speed) in the calculation.
   */ calculateMinimumValue(effectEntities) {
        return Math.min(1.0, ...effectEntities.map((effect)=>effect.getDesiredSlowMo()));
    }
}

});


parcelRegister("3AV5l", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9Nvxz = parcelRequire("9Nvxz");
const $7a5c18024ebdae3e$var$SMOOTHING = 0.95;
class $7a5c18024ebdae3e$export$2e2bcd8739ae039 extends (0, $9Nvxz.ReactEntity) {
    constructor(){
        super(()=>{
            const { fps: fps, fps2: fps2, bodyCount: bodyCount, hugeBodyCount: hugeBodyCount, kinematicBodyCount: kinematicBodyCount, particleBodyCount: particleBodyCount, dynamicBodyCount: dynamicBodyCount, collisions: collisions, entityCount: entityCount, spriteCount: spriteCount, contacts: contacts, memoryUsed: memoryUsed, memoryTotal: memoryTotal, gpuMemory: gpuMemory, webglInfo: webglInfo, audioInfo: audioInfo } = this.getStats();
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 1000,
                    opacity: this.visible ? 1 : 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    style: {
                        color: "white",
                        fontSize: "12px",
                        fontFamily: "monospace",
                        display: "flex",
                        gap: "16px",
                        margin: 0,
                        padding: 0,
                        listStyle: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "fps: ",
                                fps,
                                " (",
                                fps2,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "bodies: ",
                                bodyCount,
                                " (",
                                kinematicBodyCount,
                                ", ",
                                particleBodyCount,
                                ",",
                                " ",
                                dynamicBodyCount,
                                ", ",
                                hugeBodyCount,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "collisions: ",
                                collisions
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "entities: ",
                                entityCount
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "sprites: ",
                                spriteCount
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "contacts: ",
                                contacts
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "js heap: ",
                                memoryUsed,
                                "MB / ",
                                memoryTotal,
                                "MB"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "gpu memory: ",
                                gpuMemory
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "webgl: ",
                                webglInfo
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                "audio: ",
                                audioInfo
                            ]
                        })
                    ]
                })
            });
        }), this.persistenceLevel = 100, this.averageDuration = 0, this.slowFrameCount = 0, this.lastUpdate = performance.now(), this.visible = false;
    }
    onAdd() {
        super.onAdd();
        this.averageDuration = 1 / 60;
    }
    onRender() {
        const now = performance.now();
        const duration = now - this.lastUpdate;
        this.averageDuration = $7a5c18024ebdae3e$var$SMOOTHING * this.averageDuration + (1.0 - $7a5c18024ebdae3e$var$SMOOTHING) * duration;
        this.lastUpdate = now;
        super.onRender();
    }
    getStats() {
        const world = this.game?.world;
        const broadphase = this.game?.world.broadphase;
        // JS Memory stats (available in Chromium-based browsers)
        let memoryUsed = 0;
        let memoryTotal = 0;
        if ("memory" in performance) {
            const memory = performance.memory;
            memoryUsed = Math.round(memory.usedJSHeapSize / 1024 / 1024);
            memoryTotal = Math.round(memory.totalJSHeapSize / 1024 / 1024);
        }
        // GPU Memory stats (WebGL context info)
        let gpuMemory = "N/A";
        let webglInfo = "N/A";
        try {
            const renderer = this.game?.renderer?.app?.renderer;
            if (renderer && "gl" in renderer) {
                const gl = renderer.gl;
                if (gl) {
                    // Get texture count as a proxy for GPU memory usage
                    const textures = renderer.texture?.managedTextures?.length ?? 0;
                    const geometries = renderer.geometry?.managedGeometries?.length ?? 0;
                    gpuMemory = `${textures} textures, ${geometries} geometries`;
                    // Get WebGL resource usage
                    const numPrograms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
                    const numTextureUnits = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                    const maxRenderBufferSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);
                    // Check WebGL memory extension (if available)
                    const memInfo = gl.getExtension("WEBGL_memory_info");
                    if (memInfo) {
                        const totalMemory = (gl.getParameter(memInfo.MEMORY_INFO_TOTAL_AVAILABLE_MEMORY_WEBGL) / 1024 / 1024).toFixed(0);
                        const currentMemory = (gl.getParameter(memInfo.MEMORY_INFO_CURRENT_AVAILABLE_MEMORY_WEBGL) / 1024 / 1024).toFixed(0);
                        webglInfo = `${currentMemory}/${totalMemory}MB`;
                    } else {
                        // Estimate based on texture dimensions
                        const pixiTextures = renderer.texture?.managedTextures || [];
                        let estimatedBytes = 0;
                        for (const tex of pixiTextures)if (tex?.baseTexture) {
                            const width = tex.baseTexture.width || 0;
                            const height = tex.baseTexture.height || 0;
                            // Assume 4 bytes per pixel (RGBA)
                            estimatedBytes += width * height * 4;
                        }
                        const estimatedMB = (estimatedBytes / 1024 / 1024).toFixed(1);
                        webglInfo = `~${estimatedMB}MB (est)`;
                    }
                }
            }
        } catch (e) {
            gpuMemory = "Error reading GPU info";
            webglInfo = "Error";
        }
        // Audio context stats
        let audioInfo = "N/A";
        try {
            const audioContext = this.game?.audio;
            if (audioContext) {
                const state = audioContext.state;
                const sampleRate = audioContext.sampleRate;
                const currentTime = audioContext.currentTime.toFixed(1);
                // Count active audio nodes
                const audioNodes = this.game?.getAudioNodeCount() || 0;
                audioInfo = `${audioNodes} nodes, ${currentTime}s`;
                // Try to estimate audio buffer memory (very rough)
                // Audio nodes can consume ~1-10KB each depending on type
                const estimatedNodeMB = (audioNodes * 0.005).toFixed(1); // Assume 5KB average
                audioInfo += ` ~${estimatedNodeMB}MB`;
            }
        } catch (e) {
            audioInfo = "Error";
        }
        return {
            fps: Math.ceil(1000 / this.averageDuration),
            fps2: this.game.getScreenFps(),
            bodyCount: world?.bodies.length ?? 0,
            hugeBodyCount: broadphase.hugeBodies?.size ?? 0,
            dynamicBodyCount: broadphase.dynamicBodies.size,
            kinematicBodyCount: broadphase.kinematicBodies.size,
            particleBodyCount: broadphase.particleBodies.size,
            entityCount: this.game?.entities.all.size ?? 0,
            spriteCount: $7a5c18024ebdae3e$var$getSpriteCount(this.game.renderer.stage),
            collisions: (this.game?.world.broadphase).debugData.numCollisions,
            contacts: this.game?.contactList.getContacts().length ?? 0,
            memoryUsed: memoryUsed,
            memoryTotal: memoryTotal,
            gpuMemory: gpuMemory,
            webglInfo: webglInfo,
            audioInfo: audioInfo
        };
    }
    onKeyDown({ key: key }) {
        if (key === "Backquote") this.visible = !this.visible;
    }
}
/** Counts the number of children of a display object. */ function $7a5c18024ebdae3e$var$getSpriteCount(root) {
    let total = 1;
    for (const child of root.children ?? [])total += $7a5c18024ebdae3e$var$getSpriteCount(child);
    return total;
}

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("9Nvxz", function(module, exports) {

$parcel$export(module.exports, "ReactEntity", () => $4201c3499561b952$export$690dd8da38397efd);
$parcel$export(module.exports, "useGame", () => $4201c3499561b952$export$b33a393274d59d25);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $2oYNi = parcelRequire("2oYNi");
class $4201c3499561b952$export$690dd8da38397efd extends (0, $2oYNi.default) {
    constructor(getReactContent, autoRender = true){
        super(), this.getReactContent = getReactContent, this.autoRender = autoRender;
    }
    reactRender() {
        this.reactRoot?.render(/*#__PURE__*/ (0, $ayMG0.jsx)($4201c3499561b952$var$GameContext.Provider, {
            value: this.game,
            children: this.getReactContent()
        }));
    }
    onRender() {
        if (this.autoRender) this.reactRender();
    }
    onAdd() {
        this.el = document.createElement("div");
        document.body.append(this.el);
        this.reactRoot = (0, $aRPiL.createRoot)(this.el);
    }
    onDestroy() {
        if (this.el) this.el.remove();
        if (this.reactRoot) this.reactRoot.unmount();
    }
}
const $4201c3499561b952$var$GameContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $4201c3499561b952$export$b33a393274d59d25() {
    const maybeGame = (0, $acw62.useContext)($4201c3499561b952$var$GameContext);
    if (maybeGame === null) throw new Error("useGame must be used within a GameProvider");
    if (maybeGame === undefined) throw new Error("ReactEntity has no game");
    return maybeGame;
}

});
parcelRegister("aRPiL", function(module, exports) {
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

module.exports = (parcelRequire("iWoMt"));

});
parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.0";

});






parcelRegister("3of0i", function(module, exports) {

$parcel$export(module.exports, "rgbToHex", () => $913afda613ebf2cb$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $913afda613ebf2cb$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "colorLerp", () => $913afda613ebf2cb$export$d150b9d32f0aee0c);
$parcel$export(module.exports, "lighten", () => $913afda613ebf2cb$export$c0816ed86df316af);
$parcel$export(module.exports, "darken", () => $913afda613ebf2cb$export$4b073707ff63303);
$parcel$export(module.exports, "colorToCSS", () => $913afda613ebf2cb$export$f9f18663ca0a4ef4);

var $hA6FJ = parcelRequire("hA6FJ");

var $jd0t2 = parcelRequire("jd0t2");
function $913afda613ebf2cb$export$34d09c4a771c46ef({ r: r, g: g, b: b }) {
    return (0, $jd0t2.clamp)(b, 0, 255) + ((0, $jd0t2.clamp)(g, 0, 255) << 8) + ((0, $jd0t2.clamp)(r, 0, 255) << 16);
}
function $913afda613ebf2cb$export$5a544e13ad4e1fa5(hex) {
    return {
        r: hex >> 16,
        g: hex >> 8 & 0x0000ff,
        b: hex & 0x0000ff
    };
}
function $913afda613ebf2cb$export$5c92949fcbf60b21(hsv) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$210753cfeec758a5(hsv));
}
function $913afda613ebf2cb$export$abda8a295d582d9f(hsl) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$29fb7152bd3f781a(hsl));
}
function $913afda613ebf2cb$export$2077f6edbb2fafb8(hex) {
    return $913afda613ebf2cb$export$c85ca4f4753af384($913afda613ebf2cb$export$5a544e13ad4e1fa5(hex));
}
function $913afda613ebf2cb$export$54b4a3c46816d611(hex) {
    return $913afda613ebf2cb$export$f76e85ca00a47f5c($913afda613ebf2cb$export$5a544e13ad4e1fa5(hex));
}
function $913afda613ebf2cb$export$c2f8695086bb1728(hex) {
    const r = hex >> 16;
    const g = hex >> 8 & 0x0000ff;
    const b = hex & 0x0000ff;
    return [
        r / 255.0,
        g / 255.0,
        b / 255.0
    ];
}
function $913afda613ebf2cb$export$d7d5a315d4eeef37(from, to, steps) {
    const perStepFade = 1.0 / steps;
    const out = [];
    for(let i = 0; i < steps; i++)out.push($913afda613ebf2cb$export$d150b9d32f0aee0c(from, to, perStepFade * i));
    return out;
}
function $913afda613ebf2cb$export$d150b9d32f0aee0c(from, to, percentTo) {
    const rgbFrom = $913afda613ebf2cb$export$5a544e13ad4e1fa5(from);
    const rgbTo = $913afda613ebf2cb$export$5a544e13ad4e1fa5(to);
    rgbFrom.r = Math.round(rgbFrom.r * (1.0 - percentTo));
    rgbFrom.g = Math.round(rgbFrom.g * (1.0 - percentTo));
    rgbFrom.b = Math.round(rgbFrom.b * (1.0 - percentTo));
    rgbTo.r = Math.round(rgbTo.r * percentTo);
    rgbTo.g = Math.round(rgbTo.g * percentTo);
    rgbTo.b = Math.round(rgbTo.b * percentTo);
    return $913afda613ebf2cb$export$34d09c4a771c46ef(rgbFrom) + $913afda613ebf2cb$export$34d09c4a771c46ef(rgbTo);
}
function $913afda613ebf2cb$export$c0816ed86df316af(from, percent = 0.1) {
    return $913afda613ebf2cb$export$d150b9d32f0aee0c(from, 0xffffff, percent);
}
function $913afda613ebf2cb$export$4b073707ff63303(from, percent = 0.1) {
    return $913afda613ebf2cb$export$d150b9d32f0aee0c(from, (0, $hA6FJ.Colors).BLACK, percent);
}
function $913afda613ebf2cb$export$8e914cb8c2fd9b82(a, b) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$bb033e2093dc55fb($913afda613ebf2cb$export$5a544e13ad4e1fa5(a), $913afda613ebf2cb$export$5a544e13ad4e1fa5(b)));
}
function $913afda613ebf2cb$export$bb033e2093dc55fb(a, b) {
    return {
        r: (0, $jd0t2.clamp)(a.r + b.r, 0, 255),
        g: (0, $jd0t2.clamp)(a.g + b.g, 0, 255),
        b: (0, $jd0t2.clamp)(a.b + b.b, 0, 255)
    };
}
function $913afda613ebf2cb$export$d808461c1e143846(c1, c2) {
    const rgb1 = $913afda613ebf2cb$export$5a544e13ad4e1fa5(c1);
    const rgb2 = $913afda613ebf2cb$export$5a544e13ad4e1fa5(c2);
    return Math.max(Math.abs(rgb1.r - rgb2.r) / 255, Math.abs(rgb1.g - rgb2.g) / 255, Math.abs(rgb1.b - rgb2.b) / 255);
}
function $913afda613ebf2cb$export$29fb7152bd3f781a({ h: h, s: s, l: l }) {
    let r, g, b;
    if (s == 0) r = g = b = l; // achromatic
    else {
        const hueTorgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hueTorgb(p, q, h + 1 / 3);
        g = hueTorgb(p, q, h);
        b = hueTorgb(p, q, h - 1 / 3);
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
function $913afda613ebf2cb$export$c85ca4f4753af384({ r: r, g: g, b: b }) {
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h;
    let s;
    let l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                throw new Error("Unreachable");
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $913afda613ebf2cb$export$210753cfeec758a5({ h: h, s: s, v: v }) {
    var r, g, b, i, f, p, q, t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
        default:
            throw new Error("unreachable");
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
function $913afda613ebf2cb$export$f76e85ca00a47f5c({ r: r, g: g, b: b }) {
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, h, s = max === 0 ? 0 : d / max, v = max / 255;
    switch(max){
        case min:
            h = 0;
            break;
        case r:
            h = g - b + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = b - r + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = r - g + d * 4;
            h /= 6 * d;
            break;
        default:
            throw new Error("unreachable");
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $913afda613ebf2cb$export$f9f18663ca0a4ef4(color) {
    return `#${color.toString(16).padStart(6, "0")}`;
}
function $913afda613ebf2cb$export$1765c55a4a380487(cssColor) {
    if (cssColor.startsWith("#")) return parseInt(cssColor.slice(1), 16);
    throw new Error(`Invalid CSS color format: ${cssColor}`);
}

});


//# sourceMappingURL=path0.daaba8e3.js.map
